import { defineComponent as ie, toRefs as Ba, reactive as W, watch as G, resolveComponent as V, openBlock as S, createElementBlock as N, createElementVNode as p, toDisplayString as E, unref as u, createVNode as C, createTextVNode as ne, withCtx as P, getCurrentInstance as mn, inject as Q, computed as F, onMounted as me, onUnmounted as Lt, ref as re, shallowRef as Ga, h as Xi, Text as qa, Fragment as je, createCommentVNode as x, onBeforeMount as Da, isRef as No, onBeforeUnmount as Ha, provide as ar, isReactive as Ya, isReadonly as Za, nextTick as on, normalizeClass as Le, withModifiers as Wa, withDirectives as He, vShow as Ye, renderList as Mt, createBlock as K, renderSlot as Ka, mergeProps as Ot, withKeys as Ao, createStaticVNode as Qa } from "vue";
function Ie() {
  function e(i, l) {
    const s = Object.keys(l).filter(
      (n) => n in i
    );
    for (const n of s)
      i[n] = l[n];
    return i;
  }
  function t(i, l) {
    return Object.keys(l).some((n) => i[n] !== l[n]);
  }
  function o(i) {
    const l = {};
    for (const s in i)
      s in l && (l[s] = i[s]);
    return l;
  }
  function r(i, l) {
    if (i === l) return !0;
    if (typeof i != "object" || typeof l != "object" || i === null || l === null)
      return !1;
    const s = Object.keys(i), n = Object.keys(l);
    return s.length !== n.length ? !1 : s.every(
      (a) => r(i[a], l[a])
      // Recursively compare values
    );
  }
  function d(i) {
    return new Date(i).toLocaleDateString("he-IL");
  }
  function f(i) {
    const l = document.querySelector(i), s = l == null ? void 0 : l.querySelector(
      ".v-input--error"
    );
    if (s) {
      s.scrollIntoView({ behavior: "smooth", block: "center" }), console.log("[Scrolling] Vuetify error to:", s);
      return;
    }
  }
  return {
    hasSubsetChanged: t,
    pickByInterface: o,
    deepEqual: r,
    copySharedProperties: e,
    getDateCorrectedFormat: d,
    scrollToFirstError: f
  };
}
const Xa = {
  propNumber: 10
}, Ja = {
  propText: "starting text",
  propText123: "star13123123"
}, es = { class: "demo-component" }, ob = /* @__PURE__ */ ie({
  __name: "demo-component",
  props: {
    data: { default: () => ({
      ...Ja
    }) },
    properties: { default: () => ({
      ...Xa
    }) }
  },
  emits: ["update:data"],
  setup(e, { emit: t }) {
    const o = e, r = t, { properties: d } = Ba(o), f = W({ ...o.data });
    G(
      f,
      (l) => {
        r("update:data", l);
      },
      { deep: !0 }
    );
    function i() {
    }
    return (l, s) => {
      const n = V("v-text-field"), a = V("v-btn");
      return S(), N("div", es, [
        p("div", null, "Moj tekst: " + E(l.$t("Components.DemoComponent.MyText")), 1),
        p("div", null, "Prop num: " + E(u(d).propNumber), 1),
        C(n, {
          modelValue: f.propText,
          "onUpdate:modelValue": s[0] || (s[0] = (c) => f.propText = c),
          variant: "outlined"
        }, null, 8, ["modelValue"]),
        s[3] || (s[3] = p("br", null, null, -1)),
        s[4] || (s[4] = ne(" --------------------- ")),
        s[5] || (s[5] = p("br", null, null, -1)),
        C(n, {
          modelValue: f.propText123,
          "onUpdate:modelValue": s[1] || (s[1] = (c) => f.propText123 = c),
          variant: "outlined"
        }, null, 8, ["modelValue"]),
        p("div", null, "Prop string: " + E(f.propText), 1),
        p("div", null, "Prop123 string: " + E(f.propText123), 1),
        p("div", null, "Prop number: " + E(u(d).propNumber), 1),
        C(a, { onClick: i }, {
          default: P(() => s[2] || (s[2] = [
            ne(" Add number ")
          ])),
          _: 1
        })
      ]);
    };
  }
}), Do = (e, t) => {
  const o = e.__vccOpts || e;
  for (const [r, d] of t)
    o[r] = d;
  return o;
}, ts = {};
function ns(e, t) {
  return S(), N("div");
}
const rb = /* @__PURE__ */ Do(ts, [["render", ns]]), os = {
  msisdn: void 0,
  emailVerificationToken: "",
  orderToken: "",
  flowType: void 0,
  headerTitle: "",
  headerSubtitle: "",
  isViewDataLoading: !1,
  processEndTitle: "",
  processEndSubtitle: "",
  processEndIcon: "",
  email: ""
}, rs = {
  isEmailVerified: !1
};
/*!
  * shared v10.0.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function mt(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const sr = {};
function is(e) {
  sr[e] || (sr[e] = !0, mt(e));
}
const ct = typeof window < "u";
let Ke, Rt;
if (process.env.NODE_ENV !== "production") {
  const e = ct && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Ke = (t) => {
    e.mark(t);
  }, Rt = (t, o, r) => {
    e.measure(t, o, r), e.clearMarks(o), e.clearMarks(r);
  });
}
const as = /\{([0-9a-zA-Z]+)\}/g;
function co(e, ...t) {
  return t.length === 1 && ge(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(as, (o, r) => t.hasOwnProperty(r) ? t[r] : "");
}
const ft = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), ss = (e, t, o) => ls({ l: e, k: t, s: o }), ls = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Ve = (e) => typeof e == "number" && isFinite(e), us = (e) => Ho(e) === "[object Date]", ro = (e) => Ho(e) === "[object RegExp]", mo = (e) => _e(e) && Object.keys(e).length === 0, Fe = Object.assign, ds = Object.create, Se = (e = null) => ds(e);
let lr;
const kt = () => lr || (lr = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : Se());
function ur(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function dr(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function cs(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (r, d, f) => `${d}="${dr(f)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (r, d, f) => `${d}='${dr(f)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && mt("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((r) => {
    e = e.replace(r, "$1javascript&#58;");
  }), e;
}
const ms = Object.prototype.hasOwnProperty;
function tt(e, t) {
  return ms.call(e, t);
}
const xe = Array.isArray, we = (e) => typeof e == "function", ee = (e) => typeof e == "string", Oe = (e) => typeof e == "boolean", ge = (e) => e !== null && typeof e == "object", fs = (e) => ge(e) && we(e.then) && we(e.catch), Ji = Object.prototype.toString, Ho = (e) => Ji.call(e), _e = (e) => Ho(e) === "[object Object]", ps = (e) => e == null ? "" : xe(e) || _e(e) && e.toString === Ji ? JSON.stringify(e, null, 2) : String(e);
function Yo(e, t = "") {
  return e.reduce((o, r, d) => d === 0 ? o + r : o + t + r, "");
}
const cr = 2;
function vs(e, t = 0, o = e.length) {
  const r = e.split(/\r?\n/);
  let d = 0;
  const f = [];
  for (let i = 0; i < r.length; i++)
    if (d += r[i].length + 1, d >= t) {
      for (let l = i - cr; l <= i + cr || o > d; l++) {
        if (l < 0 || l >= r.length)
          continue;
        const s = l + 1;
        f.push(`${s}${" ".repeat(3 - String(s).length)}|  ${r[l]}`);
        const n = r[l].length;
        if (l === i) {
          const a = t - (d - n) + 1, c = Math.max(1, o > d ? n - a : o - t);
          f.push("   |  " + " ".repeat(a) + "^".repeat(c));
        } else if (l > i) {
          if (o > d) {
            const a = Math.max(Math.min(o - d, n), 1);
            f.push("   |  " + "^".repeat(a));
          }
          d += n + 1;
        }
      }
      break;
    }
  return f.join(`
`);
}
function hs() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(o, r) {
      const d = e.get(o);
      d && d.push(r) || e.set(o, [r]);
    },
    off(o, r) {
      const d = e.get(o);
      d && d.splice(d.indexOf(r) >>> 0, 1);
    },
    emit(o, r) {
      (e.get(o) || []).slice().map((d) => d(r)), (e.get("*") || []).slice().map((d) => d(o, r));
    }
  };
}
const gn = (e) => !ge(e) || xe(e);
function no(e, t) {
  if (gn(e) || gn(t))
    throw new Error("Invalid value");
  const o = [{ src: e, des: t }];
  for (; o.length; ) {
    const { src: r, des: d } = o.pop();
    Object.keys(r).forEach((f) => {
      f !== "__proto__" && (ge(r[f]) && !ge(d[f]) && (d[f] = Array.isArray(r[f]) ? [] : Se()), gn(d[f]) || gn(r[f]) ? d[f] = r[f] : o.push({ src: r[f], des: d[f] }));
    });
  }
}
/*!
  * message-compiler v10.0.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function ys(e, t, o) {
  return { line: e, column: t, offset: o };
}
function Mo(e, t, o) {
  return { start: e, end: t };
}
const ce = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, _s = 17, gs = {
  // tokenizer error messages
  [ce.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [ce.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [ce.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [ce.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [ce.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [ce.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [ce.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [ce.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [ce.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [ce.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [ce.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [ce.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [ce.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [ce.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [ce.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [ce.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Dt(e, t, o = {}) {
  const { domain: r, messages: d, args: f } = o, i = process.env.NODE_ENV !== "production" ? co((d || gs)[e] || "", ...f || []) : e, l = new SyntaxError(String(i));
  return l.code = e, t && (l.location = t), l.domain = r, l;
}
function bs(e) {
  throw e;
}
const Cs = /<\/?[\w\s="/.':;#-\/]+>/, Is = (e) => Cs.test(e), at = " ", Es = "\r", qe = `
`, Ss = "\u2028", Ps = "\u2029";
function Ts(e) {
  const t = e;
  let o = 0, r = 1, d = 1, f = 0;
  const i = (k) => t[k] === Es && t[k + 1] === qe, l = (k) => t[k] === qe, s = (k) => t[k] === Ps, n = (k) => t[k] === Ss, a = (k) => i(k) || l(k) || s(k) || n(k), c = () => o, m = () => r, v = () => d, h = () => f, _ = (k) => i(k) || s(k) || n(k) ? qe : t[k], b = () => _(o), y = () => _(o + f);
  function g() {
    return f = 0, a(o) && (r++, d = 0), i(o) && o++, o++, d++, t[o];
  }
  function I() {
    return i(o + f) && f++, f++, t[o + f];
  }
  function T() {
    o = 0, r = 1, d = 1, f = 0;
  }
  function w(k = 0) {
    f = k;
  }
  function M() {
    const k = o + f;
    for (; k !== o; )
      g();
    f = 0;
  }
  return {
    index: c,
    line: m,
    column: v,
    peekOffset: h,
    charAt: _,
    currentChar: b,
    currentPeek: y,
    next: g,
    peek: I,
    reset: T,
    resetPeek: w,
    skipToPeek: M
  };
}
const vt = void 0, ws = ".", mr = "'", ks = "tokenizer";
function Ns(e, t = {}) {
  const o = t.location !== !1, r = Ts(e), d = () => r.index(), f = () => ys(r.line(), r.column(), r.index()), i = f(), l = d(), s = {
    currentType: 13,
    offset: l,
    startLoc: i,
    endLoc: i,
    lastType: 13,
    lastOffset: l,
    lastStartLoc: i,
    lastEndLoc: i,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, n = () => s, { onError: a } = t;
  function c(A, O, D, ...ue) {
    const Ne = n();
    if (O.column += D, O.offset += D, a) {
      const Ae = o ? Mo(Ne.startLoc, O) : null, ye = Dt(A, Ae, {
        domain: ks,
        args: ue
      });
      a(ye);
    }
  }
  function m(A, O, D) {
    A.endLoc = f(), A.currentType = O;
    const ue = { type: O };
    return o && (ue.loc = Mo(A.startLoc, A.endLoc)), D != null && (ue.value = D), ue;
  }
  const v = (A) => m(
    A,
    13
    /* TokenTypes.EOF */
  );
  function h(A, O) {
    return A.currentChar() === O ? (A.next(), O) : (c(ce.EXPECTED_TOKEN, f(), 0, O), "");
  }
  function _(A) {
    let O = "";
    for (; A.currentPeek() === at || A.currentPeek() === qe; )
      O += A.currentPeek(), A.peek();
    return O;
  }
  function b(A) {
    const O = _(A);
    return A.skipToPeek(), O;
  }
  function y(A) {
    if (A === vt)
      return !1;
    const O = A.charCodeAt(0);
    return O >= 97 && O <= 122 || // a-z
    O >= 65 && O <= 90 || // A-Z
    O === 95;
  }
  function g(A) {
    if (A === vt)
      return !1;
    const O = A.charCodeAt(0);
    return O >= 48 && O <= 57;
  }
  function I(A, O) {
    const { currentType: D } = O;
    if (D !== 2)
      return !1;
    _(A);
    const ue = y(A.currentPeek());
    return A.resetPeek(), ue;
  }
  function T(A, O) {
    const { currentType: D } = O;
    if (D !== 2)
      return !1;
    _(A);
    const ue = A.currentPeek() === "-" ? A.peek() : A.currentPeek(), Ne = g(ue);
    return A.resetPeek(), Ne;
  }
  function w(A, O) {
    const { currentType: D } = O;
    if (D !== 2)
      return !1;
    _(A);
    const ue = A.currentPeek() === mr;
    return A.resetPeek(), ue;
  }
  function M(A, O) {
    const { currentType: D } = O;
    if (D !== 7)
      return !1;
    _(A);
    const ue = A.currentPeek() === ".";
    return A.resetPeek(), ue;
  }
  function k(A, O) {
    const { currentType: D } = O;
    if (D !== 8)
      return !1;
    _(A);
    const ue = y(A.currentPeek());
    return A.resetPeek(), ue;
  }
  function L(A, O) {
    const { currentType: D } = O;
    if (!(D === 7 || D === 11))
      return !1;
    _(A);
    const ue = A.currentPeek() === ":";
    return A.resetPeek(), ue;
  }
  function $(A, O) {
    const { currentType: D } = O;
    if (D !== 9)
      return !1;
    const ue = () => {
      const Ae = A.currentPeek();
      return Ae === "{" ? y(A.peek()) : Ae === "@" || Ae === "|" || Ae === ":" || Ae === "." || Ae === at || !Ae ? !1 : Ae === qe ? (A.peek(), ue()) : J(A, !1);
    }, Ne = ue();
    return A.resetPeek(), Ne;
  }
  function q(A) {
    _(A);
    const O = A.currentPeek() === "|";
    return A.resetPeek(), O;
  }
  function J(A, O = !0) {
    const D = (Ne = !1, Ae = "") => {
      const ye = A.currentPeek();
      return ye === "{" || ye === "@" || !ye ? Ne : ye === "|" ? !(Ae === at || Ae === qe) : ye === at ? (A.peek(), D(!0, at)) : ye === qe ? (A.peek(), D(!0, qe)) : !0;
    }, ue = D();
    return O && A.resetPeek(), ue;
  }
  function X(A, O) {
    const D = A.currentChar();
    return D === vt ? vt : O(D) ? (A.next(), D) : null;
  }
  function U(A) {
    const O = A.charCodeAt(0);
    return O >= 97 && O <= 122 || // a-z
    O >= 65 && O <= 90 || // A-Z
    O >= 48 && O <= 57 || // 0-9
    O === 95 || // _
    O === 36;
  }
  function oe(A) {
    return X(A, U);
  }
  function fe(A) {
    const O = A.charCodeAt(0);
    return O >= 97 && O <= 122 || // a-z
    O >= 65 && O <= 90 || // A-Z
    O >= 48 && O <= 57 || // 0-9
    O === 95 || // _
    O === 36 || // $
    O === 45;
  }
  function ve(A) {
    return X(A, fe);
  }
  function Re(A) {
    const O = A.charCodeAt(0);
    return O >= 48 && O <= 57;
  }
  function ae(A) {
    return X(A, Re);
  }
  function se(A) {
    const O = A.charCodeAt(0);
    return O >= 48 && O <= 57 || // 0-9
    O >= 65 && O <= 70 || // A-F
    O >= 97 && O <= 102;
  }
  function pe(A) {
    return X(A, se);
  }
  function $e(A) {
    let O = "", D = "";
    for (; O = ae(A); )
      D += O;
    return D;
  }
  function ze(A) {
    let O = "";
    for (; ; ) {
      const D = A.currentChar();
      if (D === "{" || D === "}" || D === "@" || D === "|" || !D)
        break;
      if (D === at || D === qe)
        if (J(A))
          O += D, A.next();
        else {
          if (q(A))
            break;
          O += D, A.next();
        }
      else
        O += D, A.next();
    }
    return O;
  }
  function Qe(A) {
    b(A);
    let O = "", D = "";
    for (; O = ve(A); )
      D += O;
    return A.currentChar() === vt && c(ce.UNTERMINATED_CLOSING_BRACE, f(), 0), D;
  }
  function ot(A) {
    b(A);
    let O = "";
    return A.currentChar() === "-" ? (A.next(), O += `-${$e(A)}`) : O += $e(A), A.currentChar() === vt && c(ce.UNTERMINATED_CLOSING_BRACE, f(), 0), O;
  }
  function It(A) {
    return A !== mr && A !== qe;
  }
  function B(A) {
    b(A), h(A, "'");
    let O = "", D = "";
    for (; O = X(A, It); )
      O === "\\" ? D += te(A) : D += O;
    const ue = A.currentChar();
    return ue === qe || ue === vt ? (c(ce.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, f(), 0), ue === qe && (A.next(), h(A, "'")), D) : (h(A, "'"), D);
  }
  function te(A) {
    const O = A.currentChar();
    switch (O) {
      case "\\":
      case "'":
        return A.next(), `\\${O}`;
      case "u":
        return Ee(A, O, 4);
      case "U":
        return Ee(A, O, 6);
      default:
        return c(ce.UNKNOWN_ESCAPE_SEQUENCE, f(), 0, O), "";
    }
  }
  function Ee(A, O, D) {
    h(A, O);
    let ue = "";
    for (let Ne = 0; Ne < D; Ne++) {
      const Ae = pe(A);
      if (!Ae) {
        c(ce.INVALID_UNICODE_ESCAPE_SEQUENCE, f(), 0, `\\${O}${ue}${A.currentChar()}`);
        break;
      }
      ue += Ae;
    }
    return `\\${O}${ue}`;
  }
  function Z(A) {
    return A !== "{" && A !== "}" && A !== at && A !== qe;
  }
  function Et(A) {
    b(A);
    let O = "", D = "";
    for (; O = X(A, Z); )
      D += O;
    return D;
  }
  function Co(A) {
    let O = "", D = "";
    for (; O = oe(A); )
      D += O;
    return D;
  }
  function Io(A) {
    const O = (D) => {
      const ue = A.currentChar();
      return ue === "{" || ue === "@" || ue === "|" || ue === "(" || ue === ")" || !ue || ue === at ? D : (D += ue, A.next(), O(D));
    };
    return O("");
  }
  function Ht(A) {
    b(A);
    const O = h(
      A,
      "|"
      /* TokenChars.Pipe */
    );
    return b(A), O;
  }
  function Yt(A, O) {
    let D = null;
    switch (A.currentChar()) {
      case "{":
        return O.braceNest >= 1 && c(ce.NOT_ALLOW_NEST_PLACEHOLDER, f(), 0), A.next(), D = m(
          O,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), b(A), O.braceNest++, D;
      case "}":
        return O.braceNest > 0 && O.currentType === 2 && c(ce.EMPTY_PLACEHOLDER, f(), 0), A.next(), D = m(
          O,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), O.braceNest--, O.braceNest > 0 && b(A), O.inLinked && O.braceNest === 0 && (O.inLinked = !1), D;
      case "@":
        return O.braceNest > 0 && c(ce.UNTERMINATED_CLOSING_BRACE, f(), 0), D = St(A, O) || v(O), O.braceNest = 0, D;
      default: {
        let Ne = !0, Ae = !0, ye = !0;
        if (q(A))
          return O.braceNest > 0 && c(ce.UNTERMINATED_CLOSING_BRACE, f(), 0), D = m(O, 1, Ht(A)), O.braceNest = 0, O.inLinked = !1, D;
        if (O.braceNest > 0 && (O.currentType === 4 || O.currentType === 5 || O.currentType === 6))
          return c(ce.UNTERMINATED_CLOSING_BRACE, f(), 0), O.braceNest = 0, Zt(A, O);
        if (Ne = I(A, O))
          return D = m(O, 4, Qe(A)), b(A), D;
        if (Ae = T(A, O))
          return D = m(O, 5, ot(A)), b(A), D;
        if (ye = w(A, O))
          return D = m(O, 6, B(A)), b(A), D;
        if (!Ne && !Ae && !ye)
          return D = m(O, 12, Et(A)), c(ce.INVALID_TOKEN_IN_PLACEHOLDER, f(), 0, D.value), b(A), D;
        break;
      }
    }
    return D;
  }
  function St(A, O) {
    const { currentType: D } = O;
    let ue = null;
    const Ne = A.currentChar();
    switch ((D === 7 || D === 8 || D === 11 || D === 9) && (Ne === qe || Ne === at) && c(ce.INVALID_LINKED_FORMAT, f(), 0), Ne) {
      case "@":
        return A.next(), ue = m(
          O,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), O.inLinked = !0, ue;
      case ".":
        return b(A), A.next(), m(
          O,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return b(A), A.next(), m(
          O,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return q(A) ? (ue = m(O, 1, Ht(A)), O.braceNest = 0, O.inLinked = !1, ue) : M(A, O) || L(A, O) ? (b(A), St(A, O)) : k(A, O) ? (b(A), m(O, 11, Co(A))) : $(A, O) ? (b(A), Ne === "{" ? Yt(A, O) || ue : m(O, 10, Io(A))) : (D === 7 && c(ce.INVALID_LINKED_FORMAT, f(), 0), O.braceNest = 0, O.inLinked = !1, Zt(A, O));
    }
  }
  function Zt(A, O) {
    let D = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (O.braceNest > 0)
      return Yt(A, O) || v(O);
    if (O.inLinked)
      return St(A, O) || v(O);
    switch (A.currentChar()) {
      case "{":
        return Yt(A, O) || v(O);
      case "}":
        return c(ce.UNBALANCED_CLOSING_BRACE, f(), 0), A.next(), m(
          O,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return St(A, O) || v(O);
      default: {
        if (q(A))
          return D = m(O, 1, Ht(A)), O.braceNest = 0, O.inLinked = !1, D;
        if (J(A))
          return m(O, 0, ze(A));
        break;
      }
    }
    return D;
  }
  function Eo() {
    const { currentType: A, offset: O, startLoc: D, endLoc: ue } = s;
    return s.lastType = A, s.lastOffset = O, s.lastStartLoc = D, s.lastEndLoc = ue, s.offset = d(), s.startLoc = f(), r.currentChar() === vt ? m(
      s,
      13
      /* TokenTypes.EOF */
    ) : Zt(r, s);
  }
  return {
    nextToken: Eo,
    currentOffset: d,
    currentPosition: f,
    context: n
  };
}
const As = "parser", Ms = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function Os(e, t, o) {
  switch (e) {
    case "\\\\":
      return "\\";
    // eslint-disable-next-line no-useless-escape
    case "\\'":
      return "'";
    default: {
      const r = parseInt(t || o, 16);
      return r <= 55295 || r >= 57344 ? String.fromCodePoint(r) : "�";
    }
  }
}
function Rs(e = {}) {
  const t = e.location !== !1, { onError: o } = e;
  function r(y, g, I, T, ...w) {
    const M = y.currentPosition();
    if (M.offset += T, M.column += T, o) {
      const k = t ? Mo(I, M) : null, L = Dt(g, k, {
        domain: As,
        args: w
      });
      o(L);
    }
  }
  function d(y, g, I) {
    const T = { type: y };
    return t && (T.start = g, T.end = g, T.loc = { start: I, end: I }), T;
  }
  function f(y, g, I, T) {
    t && (y.end = g, y.loc && (y.loc.end = I));
  }
  function i(y, g) {
    const I = y.context(), T = d(3, I.offset, I.startLoc);
    return T.value = g, f(T, y.currentOffset(), y.currentPosition()), T;
  }
  function l(y, g) {
    const I = y.context(), { lastOffset: T, lastStartLoc: w } = I, M = d(5, T, w);
    return M.index = parseInt(g, 10), y.nextToken(), f(M, y.currentOffset(), y.currentPosition()), M;
  }
  function s(y, g) {
    const I = y.context(), { lastOffset: T, lastStartLoc: w } = I, M = d(4, T, w);
    return M.key = g, y.nextToken(), f(M, y.currentOffset(), y.currentPosition()), M;
  }
  function n(y, g) {
    const I = y.context(), { lastOffset: T, lastStartLoc: w } = I, M = d(9, T, w);
    return M.value = g.replace(Ms, Os), y.nextToken(), f(M, y.currentOffset(), y.currentPosition()), M;
  }
  function a(y) {
    const g = y.nextToken(), I = y.context(), { lastOffset: T, lastStartLoc: w } = I, M = d(8, T, w);
    return g.type !== 11 ? (r(y, ce.UNEXPECTED_EMPTY_LINKED_MODIFIER, I.lastStartLoc, 0), M.value = "", f(M, T, w), {
      nextConsumeToken: g,
      node: M
    }) : (g.value == null && r(y, ce.UNEXPECTED_LEXICAL_ANALYSIS, I.lastStartLoc, 0, rt(g)), M.value = g.value || "", f(M, y.currentOffset(), y.currentPosition()), {
      node: M
    });
  }
  function c(y, g) {
    const I = y.context(), T = d(7, I.offset, I.startLoc);
    return T.value = g, f(T, y.currentOffset(), y.currentPosition()), T;
  }
  function m(y) {
    const g = y.context(), I = d(6, g.offset, g.startLoc);
    let T = y.nextToken();
    if (T.type === 8) {
      const w = a(y);
      I.modifier = w.node, T = w.nextConsumeToken || y.nextToken();
    }
    switch (T.type !== 9 && r(y, ce.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, rt(T)), T = y.nextToken(), T.type === 2 && (T = y.nextToken()), T.type) {
      case 10:
        T.value == null && r(y, ce.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, rt(T)), I.key = c(y, T.value || "");
        break;
      case 4:
        T.value == null && r(y, ce.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, rt(T)), I.key = s(y, T.value || "");
        break;
      case 5:
        T.value == null && r(y, ce.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, rt(T)), I.key = l(y, T.value || "");
        break;
      case 6:
        T.value == null && r(y, ce.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, rt(T)), I.key = n(y, T.value || "");
        break;
      default: {
        r(y, ce.UNEXPECTED_EMPTY_LINKED_KEY, g.lastStartLoc, 0);
        const w = y.context(), M = d(7, w.offset, w.startLoc);
        return M.value = "", f(M, w.offset, w.startLoc), I.key = M, f(I, w.offset, w.startLoc), {
          nextConsumeToken: T,
          node: I
        };
      }
    }
    return f(I, y.currentOffset(), y.currentPosition()), {
      node: I
    };
  }
  function v(y) {
    const g = y.context(), I = g.currentType === 1 ? y.currentOffset() : g.offset, T = g.currentType === 1 ? g.endLoc : g.startLoc, w = d(2, I, T);
    w.items = [];
    let M = null;
    do {
      const $ = M || y.nextToken();
      switch (M = null, $.type) {
        case 0:
          $.value == null && r(y, ce.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, rt($)), w.items.push(i(y, $.value || ""));
          break;
        case 5:
          $.value == null && r(y, ce.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, rt($)), w.items.push(l(y, $.value || ""));
          break;
        case 4:
          $.value == null && r(y, ce.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, rt($)), w.items.push(s(y, $.value || ""));
          break;
        case 6:
          $.value == null && r(y, ce.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, rt($)), w.items.push(n(y, $.value || ""));
          break;
        case 7: {
          const q = m(y);
          w.items.push(q.node), M = q.nextConsumeToken || null;
          break;
        }
      }
    } while (g.currentType !== 13 && g.currentType !== 1);
    const k = g.currentType === 1 ? g.lastOffset : y.currentOffset(), L = g.currentType === 1 ? g.lastEndLoc : y.currentPosition();
    return f(w, k, L), w;
  }
  function h(y, g, I, T) {
    const w = y.context();
    let M = T.items.length === 0;
    const k = d(1, g, I);
    k.cases = [], k.cases.push(T);
    do {
      const L = v(y);
      M || (M = L.items.length === 0), k.cases.push(L);
    } while (w.currentType !== 13);
    return M && r(y, ce.MUST_HAVE_MESSAGES_IN_PLURAL, I, 0), f(k, y.currentOffset(), y.currentPosition()), k;
  }
  function _(y) {
    const g = y.context(), { offset: I, startLoc: T } = g, w = v(y);
    return g.currentType === 13 ? w : h(y, I, T, w);
  }
  function b(y) {
    const g = Ns(y, Fe({}, e)), I = g.context(), T = d(0, I.offset, I.startLoc);
    return t && T.loc && (T.loc.source = y), T.body = _(g), e.onCacheKey && (T.cacheKey = e.onCacheKey(y)), I.currentType !== 13 && r(g, ce.UNEXPECTED_LEXICAL_ANALYSIS, I.lastStartLoc, 0, y[I.offset] || ""), f(T, g.currentOffset(), g.currentPosition()), T;
  }
  return { parse: b };
}
function rt(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function $s(e, t = {}) {
  const o = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => o, helper: (f) => (o.helpers.add(f), f) };
}
function fr(e, t) {
  for (let o = 0; o < e.length; o++)
    Zo(e[o], t);
}
function Zo(e, t) {
  switch (e.type) {
    case 1:
      fr(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      fr(e.items, t);
      break;
    case 6: {
      Zo(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function xs(e, t = {}) {
  const o = $s(e);
  o.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Zo(e.body, o);
  const r = o.context();
  e.helpers = Array.from(r.helpers);
}
function Ls(e) {
  const t = e.body;
  return t.type === 2 ? pr(t) : t.cases.forEach((o) => pr(o)), e;
}
function pr(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let o = 0; o < e.items.length; o++) {
      const r = e.items[o];
      if (!(r.type === 3 || r.type === 9) || r.value == null)
        break;
      t.push(r.value);
    }
    if (t.length === e.items.length) {
      e.static = Yo(t);
      for (let o = 0; o < e.items.length; o++) {
        const r = e.items[o];
        (r.type === 3 || r.type === 9) && delete r.value;
      }
    }
  }
}
const Vs = "minifier";
function Bt(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      Bt(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, o = t.cases;
      for (let r = 0; r < o.length; r++)
        Bt(o[r]);
      t.c = o, delete t.cases;
      break;
    }
    case 2: {
      const t = e, o = t.items;
      for (let r = 0; r < o.length; r++)
        Bt(o[r]);
      t.i = o, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      Bt(t.key), t.k = t.key, delete t.key, t.modifier && (Bt(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw Dt(ce.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: Vs,
          args: [e.type]
        });
  }
  delete e.type;
}
const Fs = "parser";
function js(e, t) {
  const { filename: o, breakLineCode: r, needIndent: d } = t, f = t.location !== !1, i = {
    filename: o,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: r,
    needIndent: d,
    indentLevel: 0
  };
  f && e.loc && (i.source = e.loc.source);
  const l = () => i;
  function s(_, b) {
    i.code += _;
  }
  function n(_, b = !0) {
    const y = b ? r : "";
    s(d ? y + "  ".repeat(_) : y);
  }
  function a(_ = !0) {
    const b = ++i.indentLevel;
    _ && n(b);
  }
  function c(_ = !0) {
    const b = --i.indentLevel;
    _ && n(b);
  }
  function m() {
    n(i.indentLevel);
  }
  return {
    context: l,
    push: s,
    indent: a,
    deindent: c,
    newline: m,
    helper: (_) => `_${_}`,
    needIndent: () => i.needIndent
  };
}
function zs(e, t) {
  const { helper: o } = e;
  e.push(`${o(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Gt(e, t.key), t.modifier ? (e.push(", "), Gt(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Us(e, t) {
  const { helper: o, needIndent: r } = e;
  e.push(`${o(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(r());
  const d = t.items.length;
  for (let f = 0; f < d && (Gt(e, t.items[f]), f !== d - 1); f++)
    e.push(", ");
  e.deindent(r()), e.push("])");
}
function Bs(e, t) {
  const { helper: o, needIndent: r } = e;
  if (t.cases.length > 1) {
    e.push(`${o(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(r());
    const d = t.cases.length;
    for (let f = 0; f < d && (Gt(e, t.cases[f]), f !== d - 1); f++)
      e.push(", ");
    e.deindent(r()), e.push("])");
  }
}
function Gs(e, t) {
  t.body ? Gt(e, t.body) : e.push("null");
}
function Gt(e, t) {
  const { helper: o } = e;
  switch (t.type) {
    case 0:
      Gs(e, t);
      break;
    case 1:
      Bs(e, t);
      break;
    case 2:
      Us(e, t);
      break;
    case 6:
      zs(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${o(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${o(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${o(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${o(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw Dt(ce.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: Fs,
          args: [t.type]
        });
  }
}
const qs = (e, t = {}) => {
  const o = ee(t.mode) ? t.mode : "normal", r = ee(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const d = t.breakLineCode != null ? t.breakLineCode : o === "arrow" ? ";" : `
`, f = t.needIndent ? t.needIndent : o !== "arrow", i = e.helpers || [], l = js(e, {
    filename: r,
    breakLineCode: d,
    needIndent: f
  });
  l.push(o === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(f), i.length > 0 && (l.push(`const { ${Yo(i.map((a) => `${a}: _${a}`), ", ")} } = ctx`), l.newline()), l.push("return "), Gt(l, e), l.deindent(f), l.push("}"), delete e.helpers;
  const { code: s, map: n } = l.context();
  return {
    ast: e,
    code: s,
    map: n ? n.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Ds(e, t = {}) {
  const o = Fe({}, t), r = !!o.jit, d = !!o.minify, f = o.optimize == null ? !0 : o.optimize, l = Rs(o).parse(e);
  return r ? (f && Ls(l), d && Bt(l), { ast: l, code: "" }) : (xs(l, o), qs(l, o));
}
/*!
  * core-base v10.0.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Hs() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (kt().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (kt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function nt(e) {
  return ge(e) && Wo(e) === 0 && (tt(e, "b") || tt(e, "body"));
}
const ea = ["b", "body"];
function Ys(e) {
  return _t(e, ea);
}
const ta = ["c", "cases"];
function Zs(e) {
  return _t(e, ta, []);
}
const na = ["s", "static"];
function Ws(e) {
  return _t(e, na);
}
const oa = ["i", "items"];
function Ks(e) {
  return _t(e, oa, []);
}
const ra = ["t", "type"];
function Wo(e) {
  return _t(e, ra);
}
const ia = ["v", "value"];
function bn(e, t) {
  const o = _t(e, ia);
  if (o != null)
    return o;
  throw rn(t);
}
const aa = ["m", "modifier"];
function Qs(e) {
  return _t(e, aa);
}
const sa = ["k", "key"];
function Xs(e) {
  const t = _t(e, sa);
  if (t)
    return t;
  throw rn(
    6
    /* NodeTypes.Linked */
  );
}
function _t(e, t, o) {
  for (let r = 0; r < t.length; r++) {
    const d = t[r];
    if (tt(e, d) && e[d] != null)
      return e[d];
  }
  return o;
}
const la = [
  ...ea,
  ...ta,
  ...na,
  ...oa,
  ...sa,
  ...aa,
  ...ia,
  ...ra
];
function rn(e) {
  return new Error(`unhandled node type: ${e}`);
}
function So(e) {
  return (o) => Js(o, e);
}
function Js(e, t) {
  const o = Ys(t);
  if (o == null)
    throw rn(
      0
      /* NodeTypes.Resource */
    );
  if (Wo(o) === 1) {
    const f = Zs(o);
    return e.plural(f.reduce((i, l) => [
      ...i,
      vr(e, l)
    ], []));
  } else
    return vr(e, o);
}
function vr(e, t) {
  const o = Ws(t);
  if (o != null)
    return e.type === "text" ? o : e.normalize([o]);
  {
    const r = Ks(t).reduce((d, f) => [...d, Oo(e, f)], []);
    return e.normalize(r);
  }
}
function Oo(e, t) {
  const o = Wo(t);
  switch (o) {
    case 3:
      return bn(t, o);
    case 9:
      return bn(t, o);
    case 4: {
      const r = t;
      if (tt(r, "k") && r.k)
        return e.interpolate(e.named(r.k));
      if (tt(r, "key") && r.key)
        return e.interpolate(e.named(r.key));
      throw rn(o);
    }
    case 5: {
      const r = t;
      if (tt(r, "i") && Ve(r.i))
        return e.interpolate(e.list(r.i));
      if (tt(r, "index") && Ve(r.index))
        return e.interpolate(e.list(r.index));
      throw rn(o);
    }
    case 6: {
      const r = t, d = Qs(r), f = Xs(r);
      return e.linked(Oo(e, f), d ? Oo(e, d) : void 0, e.type);
    }
    case 7:
      return bn(t, o);
    case 8:
      return bn(t, o);
    default:
      throw new Error(`unhandled node on format message part: ${o}`);
  }
}
const el = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function tl(e, t) {
  t && Is(e) && mt(co(el, { source: e }));
}
const nl = (e) => e;
let Cn = Se();
function ol(e, t = {}) {
  let o = !1;
  const r = t.onError || bs;
  return t.onError = (d) => {
    o = !0, r(d);
  }, { ...Ds(e, t), detectError: o };
}
// @__NO_SIDE_EFFECTS__
function rl(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && ee(e)) {
    const o = Oe(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && tl(e, o);
    const d = (t.onCacheKey || nl)(e), f = Cn[d];
    if (f)
      return f;
    const { ast: i, detectError: l } = ol(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), s = So(i);
    return l ? s : Cn[d] = s;
  } else {
    if (process.env.NODE_ENV !== "production" && !nt(e))
      return mt(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const o = e.cacheKey;
    if (o) {
      const r = Cn[o];
      return r || (Cn[o] = So(e));
    } else
      return So(e);
  }
}
let an = null;
function il(e) {
  an = e;
}
function al(e, t, o) {
  an && an.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: o
  });
}
const sl = /* @__PURE__ */ ll("function:translate");
function ll(e) {
  return (t) => an && an.emit(e, t);
}
const Be = {
  INVALID_ARGUMENT: _s,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, ul = 24;
function dt(e) {
  return Dt(e, null, process.env.NODE_ENV !== "production" ? { messages: dl } : void 0);
}
const dl = {
  [Be.INVALID_ARGUMENT]: "Invalid arguments",
  [Be.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Be.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Be.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Be.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Be.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Be.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Ko(e, t) {
  return t.locale != null ? hr(t.locale) : hr(e.locale);
}
let Po;
function hr(e) {
  if (ee(e))
    return e;
  if (we(e)) {
    if (e.resolvedOnce && Po != null)
      return Po;
    if (e.constructor.name === "Function") {
      const t = e();
      if (fs(t))
        throw dt(Be.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Po = t;
    } else
      throw dt(Be.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw dt(Be.NOT_SUPPORT_LOCALE_TYPE);
}
function cl(e, t, o) {
  return [.../* @__PURE__ */ new Set([
    o,
    ...xe(t) ? t : ge(t) ? Object.keys(t) : ee(t) ? [t] : [o]
  ])];
}
function ua(e, t, o) {
  const r = ee(o) ? o : io, d = e;
  d.__localeChainCache || (d.__localeChainCache = /* @__PURE__ */ new Map());
  let f = d.__localeChainCache.get(r);
  if (!f) {
    f = [];
    let i = [o];
    for (; xe(i); )
      i = yr(f, i, t);
    const l = xe(t) || !_e(t) ? t : t.default ? t.default : null;
    i = ee(l) ? [l] : l, xe(i) && yr(f, i, !1), d.__localeChainCache.set(r, f);
  }
  return f;
}
function yr(e, t, o) {
  let r = !0;
  for (let d = 0; d < t.length && Oe(r); d++) {
    const f = t[d];
    ee(f) && (r = ml(e, t[d], o));
  }
  return r;
}
function ml(e, t, o) {
  let r;
  const d = t.split("-");
  do {
    const f = d.join("-");
    r = fl(e, f, o), d.splice(-1, 1);
  } while (d.length && r === !0);
  return r;
}
function fl(e, t, o) {
  let r = !1;
  if (!e.includes(t) && (r = !0, t)) {
    r = t[t.length - 1] !== "!";
    const d = t.replace(/!/g, "");
    e.push(d), (xe(o) || _e(o)) && o[d] && (r = o[d]);
  }
  return r;
}
const gt = [];
gt[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
gt[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
gt[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
gt[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
gt[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
gt[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
gt[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const pl = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function vl(e) {
  return pl.test(e);
}
function hl(e) {
  const t = e.charCodeAt(0), o = e.charCodeAt(e.length - 1);
  return t === o && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function yl(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return e;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function _l(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : vl(t) ? hl(t) : "*" + t;
}
function gl(e) {
  const t = [];
  let o = -1, r = 0, d = 0, f, i, l, s, n, a, c;
  const m = [];
  m[
    0
    /* Actions.APPEND */
  ] = () => {
    i === void 0 ? i = l : i += l;
  }, m[
    1
    /* Actions.PUSH */
  ] = () => {
    i !== void 0 && (t.push(i), i = void 0);
  }, m[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    m[
      0
      /* Actions.APPEND */
    ](), d++;
  }, m[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (d > 0)
      d--, r = 4, m[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (d = 0, i === void 0 || (i = _l(i), i === !1))
        return !1;
      m[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function v() {
    const h = e[o + 1];
    if (r === 5 && h === "'" || r === 6 && h === '"')
      return o++, l = "\\" + h, m[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; r !== null; )
    if (o++, f = e[o], !(f === "\\" && v())) {
      if (s = yl(f), c = gt[r], n = c[s] || c.l || 8, n === 8 || (r = n[0], n[1] !== void 0 && (a = m[n[1]], a && (l = f, a() === !1))))
        return;
      if (r === 7)
        return t;
    }
}
const _r = /* @__PURE__ */ new Map();
function bl(e, t) {
  return ge(e) ? e[t] : null;
}
function Cl(e, t) {
  if (!ge(e))
    return null;
  let o = _r.get(t);
  if (o || (o = gl(t), o && _r.set(t, o)), !o)
    return null;
  const r = o.length;
  let d = e, f = 0;
  for (; f < r; ) {
    const i = o[f];
    if (la.includes(i) && nt(d))
      return null;
    const l = d[i];
    if (l === void 0 || we(d))
      return null;
    d = l, f++;
  }
  return d;
}
const De = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, Il = 8, El = {
  [De.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [De.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [De.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [De.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [De.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [De.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [De.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function $t(e, ...t) {
  return co(El[e], ...t);
}
const Sl = "10.0.8", fo = -1, io = "en-US", ao = "", gr = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Pl() {
  return {
    upper: (e, t) => t === "text" && ee(e) ? e.toUpperCase() : t === "vnode" && ge(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && ee(e) ? e.toLowerCase() : t === "vnode" && ge(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && ee(e) ? gr(e) : t === "vnode" && ge(e) && "__v_isVNode" in e ? gr(e.children) : e
  };
}
let da;
function Tl(e) {
  da = e;
}
let ca;
function wl(e) {
  ca = e;
}
let ma;
function kl(e) {
  ma = e;
}
let fa = null;
const Nl = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  fa = e;
}, Al = /* @__NO_SIDE_EFFECTS__ */ () => fa;
let pa = null;
const br = (e) => {
  pa = e;
}, Ml = () => pa;
let Cr = 0;
function Ol(e = {}) {
  const t = we(e.onWarn) ? e.onWarn : mt, o = ee(e.version) ? e.version : Sl, r = ee(e.locale) || we(e.locale) ? e.locale : io, d = we(r) ? io : r, f = xe(e.fallbackLocale) || _e(e.fallbackLocale) || ee(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : d, i = _e(e.messages) ? e.messages : To(d), l = _e(e.datetimeFormats) ? e.datetimeFormats : To(d), s = _e(e.numberFormats) ? e.numberFormats : To(d), n = Fe(Se(), e.modifiers, Pl()), a = e.pluralRules || Se(), c = we(e.missing) ? e.missing : null, m = Oe(e.missingWarn) || ro(e.missingWarn) ? e.missingWarn : !0, v = Oe(e.fallbackWarn) || ro(e.fallbackWarn) ? e.fallbackWarn : !0, h = !!e.fallbackFormat, _ = !!e.unresolving, b = we(e.postTranslation) ? e.postTranslation : null, y = _e(e.processor) ? e.processor : null, g = Oe(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, I = !!e.escapeParameter, T = we(e.messageCompiler) ? e.messageCompiler : da;
  process.env.NODE_ENV !== "production" && we(e.messageCompiler) && is($t(De.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const w = we(e.messageResolver) ? e.messageResolver : ca || bl, M = we(e.localeFallbacker) ? e.localeFallbacker : ma || cl, k = ge(e.fallbackContext) ? e.fallbackContext : void 0, L = e, $ = ge(L.__datetimeFormatters) ? L.__datetimeFormatters : /* @__PURE__ */ new Map(), q = ge(L.__numberFormatters) ? L.__numberFormatters : /* @__PURE__ */ new Map(), J = ge(L.__meta) ? L.__meta : {};
  Cr++;
  const X = {
    version: o,
    cid: Cr,
    locale: r,
    fallbackLocale: f,
    messages: i,
    modifiers: n,
    pluralRules: a,
    missing: c,
    missingWarn: m,
    fallbackWarn: v,
    fallbackFormat: h,
    unresolving: _,
    postTranslation: b,
    processor: y,
    warnHtmlMessage: g,
    escapeParameter: I,
    messageCompiler: T,
    messageResolver: w,
    localeFallbacker: M,
    fallbackContext: k,
    onWarn: t,
    __meta: J
  };
  return X.datetimeFormats = l, X.numberFormats = s, X.__datetimeFormatters = $, X.__numberFormatters = q, process.env.NODE_ENV !== "production" && (X.__v_emitter = L.__v_emitter != null ? L.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && al(X, o, J), X;
}
const To = (e) => ({ [e]: Se() });
function po(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function va(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Qo(e, t, o, r, d) {
  const { missing: f, onWarn: i } = e;
  if (process.env.NODE_ENV !== "production") {
    const l = e.__v_emitter;
    l && l.emit("missing", {
      locale: o,
      key: t,
      type: d,
      groupId: `${d}:${t}`
    });
  }
  if (f !== null) {
    const l = f(e, o, t, d);
    return ee(l) ? l : t;
  } else
    return process.env.NODE_ENV !== "production" && va(r, t) && i($t(De.NOT_FOUND_KEY, { key: t, locale: o })), t;
}
function Wt(e, t, o) {
  const r = e;
  r.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, o, t);
}
function ha(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function Rl(e, t) {
  const o = t.indexOf(e);
  if (o === -1)
    return !1;
  for (let r = o + 1; r < t.length; r++)
    if (ha(e, t[r]))
      return !0;
  return !1;
}
const Ir = typeof Intl < "u", ya = {
  dateTimeFormat: Ir && typeof Intl.DateTimeFormat < "u",
  numberFormat: Ir && typeof Intl.NumberFormat < "u"
};
function Er(e, ...t) {
  const { datetimeFormats: o, unresolving: r, fallbackLocale: d, onWarn: f, localeFallbacker: i } = e, { __datetimeFormatters: l } = e;
  if (process.env.NODE_ENV !== "production" && !ya.dateTimeFormat)
    return f($t(De.CANNOT_FORMAT_DATE)), ao;
  const [s, n, a, c] = Ro(...t), m = Oe(a.missingWarn) ? a.missingWarn : e.missingWarn, v = Oe(a.fallbackWarn) ? a.fallbackWarn : e.fallbackWarn, h = !!a.part, _ = Ko(e, a), b = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    d,
    _
  );
  if (!ee(s) || s === "")
    return new Intl.DateTimeFormat(_, c).format(n);
  let y = {}, g, I = null, T = _, w = null;
  const M = "datetime format";
  for (let $ = 0; $ < b.length; $++) {
    if (g = w = b[$], process.env.NODE_ENV !== "production" && _ !== g && po(v, s) && f($t(De.FALLBACK_TO_DATE_FORMAT, {
      key: s,
      target: g
    })), process.env.NODE_ENV !== "production" && _ !== g) {
      const q = e.__v_emitter;
      q && q.emit("fallback", {
        type: M,
        key: s,
        from: T,
        to: w,
        groupId: `${M}:${s}`
      });
    }
    if (y = o[g] || {}, I = y[s], _e(I))
      break;
    Qo(e, s, g, m, M), T = w;
  }
  if (!_e(I) || !ee(g))
    return r ? fo : s;
  let k = `${g}__${s}`;
  mo(c) || (k = `${k}__${JSON.stringify(c)}`);
  let L = l.get(k);
  return L || (L = new Intl.DateTimeFormat(g, Fe({}, I, c)), l.set(k, L)), h ? L.formatToParts(n) : L.format(n);
}
const _a = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Ro(...e) {
  const [t, o, r, d] = e, f = Se();
  let i = Se(), l;
  if (ee(t)) {
    const s = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!s)
      throw dt(Be.INVALID_ISO_DATE_ARGUMENT);
    const n = s[3] ? s[3].trim().startsWith("T") ? `${s[1].trim()}${s[3].trim()}` : `${s[1].trim()}T${s[3].trim()}` : s[1].trim();
    l = new Date(n);
    try {
      l.toISOString();
    } catch {
      throw dt(Be.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (us(t)) {
    if (isNaN(t.getTime()))
      throw dt(Be.INVALID_DATE_ARGUMENT);
    l = t;
  } else if (Ve(t))
    l = t;
  else
    throw dt(Be.INVALID_ARGUMENT);
  return ee(o) ? f.key = o : _e(o) && Object.keys(o).forEach((s) => {
    _a.includes(s) ? i[s] = o[s] : f[s] = o[s];
  }), ee(r) ? f.locale = r : _e(r) && (i = r), _e(d) && (i = d), [f.key || "", l, f, i];
}
function Sr(e, t, o) {
  const r = e;
  for (const d in o) {
    const f = `${t}__${d}`;
    r.__datetimeFormatters.has(f) && r.__datetimeFormatters.delete(f);
  }
}
function Pr(e, ...t) {
  const { numberFormats: o, unresolving: r, fallbackLocale: d, onWarn: f, localeFallbacker: i } = e, { __numberFormatters: l } = e;
  if (process.env.NODE_ENV !== "production" && !ya.numberFormat)
    return f($t(De.CANNOT_FORMAT_NUMBER)), ao;
  const [s, n, a, c] = $o(...t), m = Oe(a.missingWarn) ? a.missingWarn : e.missingWarn, v = Oe(a.fallbackWarn) ? a.fallbackWarn : e.fallbackWarn, h = !!a.part, _ = Ko(e, a), b = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    d,
    _
  );
  if (!ee(s) || s === "")
    return new Intl.NumberFormat(_, c).format(n);
  let y = {}, g, I = null, T = _, w = null;
  const M = "number format";
  for (let $ = 0; $ < b.length; $++) {
    if (g = w = b[$], process.env.NODE_ENV !== "production" && _ !== g && po(v, s) && f($t(De.FALLBACK_TO_NUMBER_FORMAT, {
      key: s,
      target: g
    })), process.env.NODE_ENV !== "production" && _ !== g) {
      const q = e.__v_emitter;
      q && q.emit("fallback", {
        type: M,
        key: s,
        from: T,
        to: w,
        groupId: `${M}:${s}`
      });
    }
    if (y = o[g] || {}, I = y[s], _e(I))
      break;
    Qo(e, s, g, m, M), T = w;
  }
  if (!_e(I) || !ee(g))
    return r ? fo : s;
  let k = `${g}__${s}`;
  mo(c) || (k = `${k}__${JSON.stringify(c)}`);
  let L = l.get(k);
  return L || (L = new Intl.NumberFormat(g, Fe({}, I, c)), l.set(k, L)), h ? L.formatToParts(n) : L.format(n);
}
const ga = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function $o(...e) {
  const [t, o, r, d] = e, f = Se();
  let i = Se();
  if (!Ve(t))
    throw dt(Be.INVALID_ARGUMENT);
  const l = t;
  return ee(o) ? f.key = o : _e(o) && Object.keys(o).forEach((s) => {
    ga.includes(s) ? i[s] = o[s] : f[s] = o[s];
  }), ee(r) ? f.locale = r : _e(r) && (i = r), _e(d) && (i = d), [f.key || "", l, f, i];
}
function Tr(e, t, o) {
  const r = e;
  for (const d in o) {
    const f = `${t}__${d}`;
    r.__numberFormatters.has(f) && r.__numberFormatters.delete(f);
  }
}
const $l = (e) => e, xl = (e) => "", Ll = "text", Vl = (e) => e.length === 0 ? "" : Yo(e), Fl = ps;
function wr(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function jl(e) {
  const t = Ve(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (Ve(e.named.count) || Ve(e.named.n)) ? Ve(e.named.count) ? e.named.count : Ve(e.named.n) ? e.named.n : t : t;
}
function zl(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function Ul(e = {}) {
  const t = e.locale, o = jl(e), r = ge(e.pluralRules) && ee(t) && we(e.pluralRules[t]) ? e.pluralRules[t] : wr, d = ge(e.pluralRules) && ee(t) && we(e.pluralRules[t]) ? wr : void 0, f = (y) => y[r(o, y.length, d)], i = e.list || [], l = (y) => i[y], s = e.named || Se();
  Ve(e.pluralIndex) && zl(o, s);
  const n = (y) => s[y];
  function a(y, g) {
    const I = we(e.messages) ? e.messages(y, !!g) : ge(e.messages) ? e.messages[y] : !1;
    return I || (e.parent ? e.parent.message(y) : xl);
  }
  const c = (y) => e.modifiers ? e.modifiers[y] : $l, m = _e(e.processor) && we(e.processor.normalize) ? e.processor.normalize : Vl, v = _e(e.processor) && we(e.processor.interpolate) ? e.processor.interpolate : Fl, h = _e(e.processor) && ee(e.processor.type) ? e.processor.type : Ll, b = {
    list: l,
    named: n,
    plural: f,
    linked: (y, ...g) => {
      const [I, T] = g;
      let w = "text", M = "";
      g.length === 1 ? ge(I) ? (M = I.modifier || M, w = I.type || w) : ee(I) && (M = I || M) : g.length === 2 && (ee(I) && (M = I || M), ee(T) && (w = T || w));
      const k = a(y, !0)(b), L = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        w === "vnode" && xe(k) && M ? k[0] : k
      );
      return M ? c(M)(L, w) : L;
    },
    message: a,
    type: h,
    interpolate: v,
    normalize: m,
    values: Fe(Se(), i, s)
  };
  return b;
}
const kr = () => "", Xe = (e) => we(e);
function Nr(e, ...t) {
  const { fallbackFormat: o, postTranslation: r, unresolving: d, messageCompiler: f, fallbackLocale: i, messages: l } = e, [s, n] = xo(...t), a = Oe(n.missingWarn) ? n.missingWarn : e.missingWarn, c = Oe(n.fallbackWarn) ? n.fallbackWarn : e.fallbackWarn, m = Oe(n.escapeParameter) ? n.escapeParameter : e.escapeParameter, v = !!n.resolvedMessage, h = ee(n.default) || Oe(n.default) ? Oe(n.default) ? f ? s : () => s : n.default : o ? f ? s : () => s : null, _ = o || h != null && (ee(h) || we(h)), b = Ko(e, n);
  m && Bl(n);
  let [y, g, I] = v ? [
    s,
    b,
    l[b] || Se()
  ] : ba(e, s, b, i, c, a), T = y, w = s;
  if (!v && !(ee(T) || nt(T) || Xe(T)) && _ && (T = h, w = T), !v && (!(ee(T) || nt(T) || Xe(T)) || !ee(g)))
    return d ? fo : s;
  if (process.env.NODE_ENV !== "production" && ee(T) && e.messageCompiler == null)
    return mt(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${s}'.`), s;
  let M = !1;
  const k = () => {
    M = !0;
  }, L = Xe(T) ? T : Ca(e, s, g, T, w, k);
  if (M)
    return T;
  const $ = Hl(e, g, I, n), q = Ul($), J = Gl(e, L, q);
  let X = r ? r(J, s) : J;
  if (m && ee(X) && (X = cs(X)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const U = {
      timestamp: Date.now(),
      key: ee(s) ? s : Xe(T) ? T.key : "",
      locale: g || (Xe(T) ? T.locale : ""),
      format: ee(T) ? T : Xe(T) ? T.source : "",
      message: X
    };
    U.meta = Fe({}, e.__meta, /* @__PURE__ */ Al() || {}), sl(U);
  }
  return X;
}
function Bl(e) {
  xe(e.list) ? e.list = e.list.map((t) => ee(t) ? ur(t) : t) : ge(e.named) && Object.keys(e.named).forEach((t) => {
    ee(e.named[t]) && (e.named[t] = ur(e.named[t]));
  });
}
function ba(e, t, o, r, d, f) {
  const { messages: i, onWarn: l, messageResolver: s, localeFallbacker: n } = e, a = n(e, r, o);
  let c = Se(), m, v = null, h = o, _ = null;
  const b = "translate";
  for (let y = 0; y < a.length; y++) {
    if (m = _ = a[y], process.env.NODE_ENV !== "production" && o !== m && !ha(o, m) && po(d, t) && l($t(De.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: m
    })), process.env.NODE_ENV !== "production" && o !== m) {
      const w = e.__v_emitter;
      w && w.emit("fallback", {
        type: b,
        key: t,
        from: h,
        to: _,
        groupId: `${b}:${t}`
      });
    }
    c = i[m] || Se();
    let g = null, I, T;
    if (process.env.NODE_ENV !== "production" && ct && (g = window.performance.now(), I = "intlify-message-resolve-start", T = "intlify-message-resolve-end", Ke && Ke(I)), (v = s(c, t)) === null && (v = c[t]), process.env.NODE_ENV !== "production" && ct) {
      const w = window.performance.now(), M = e.__v_emitter;
      M && g && v && M.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: v,
        time: w - g,
        groupId: `${b}:${t}`
      }), I && T && Ke && Rt && (Ke(T), Rt("intlify message resolve", I, T));
    }
    if (ee(v) || nt(v) || Xe(v))
      break;
    if (!Rl(m, a)) {
      const w = Qo(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        m,
        f,
        b
      );
      w !== t && (v = w);
    }
    h = _;
  }
  return [v, m, c];
}
function Ca(e, t, o, r, d, f) {
  const { messageCompiler: i, warnHtmlMessage: l } = e;
  if (Xe(r)) {
    const m = r;
    return m.locale = m.locale || o, m.key = m.key || t, m;
  }
  if (i == null) {
    const m = () => r;
    return m.locale = o, m.key = t, m;
  }
  let s = null, n, a;
  process.env.NODE_ENV !== "production" && ct && (s = window.performance.now(), n = "intlify-message-compilation-start", a = "intlify-message-compilation-end", Ke && Ke(n));
  const c = i(r, ql(e, o, d, r, l, f));
  if (process.env.NODE_ENV !== "production" && ct) {
    const m = window.performance.now(), v = e.__v_emitter;
    v && s && v.emit("message-compilation", {
      type: "message-compilation",
      message: r,
      time: m - s,
      groupId: `translate:${t}`
    }), n && a && Ke && Rt && (Ke(a), Rt("intlify message compilation", n, a));
  }
  return c.locale = o, c.key = t, c.source = r, c;
}
function Gl(e, t, o) {
  let r = null, d, f;
  process.env.NODE_ENV !== "production" && ct && (r = window.performance.now(), d = "intlify-message-evaluation-start", f = "intlify-message-evaluation-end", Ke && Ke(d));
  const i = t(o);
  if (process.env.NODE_ENV !== "production" && ct) {
    const l = window.performance.now(), s = e.__v_emitter;
    s && r && s.emit("message-evaluation", {
      type: "message-evaluation",
      value: i,
      time: l - r,
      groupId: `translate:${t.key}`
    }), d && f && Ke && Rt && (Ke(f), Rt("intlify message evaluation", d, f));
  }
  return i;
}
function xo(...e) {
  const [t, o, r] = e, d = Se();
  if (!ee(t) && !Ve(t) && !Xe(t) && !nt(t))
    throw dt(Be.INVALID_ARGUMENT);
  const f = Ve(t) ? String(t) : (Xe(t), t);
  return Ve(o) ? d.plural = o : ee(o) ? d.default = o : _e(o) && !mo(o) ? d.named = o : xe(o) && (d.list = o), Ve(r) ? d.plural = r : ee(r) ? d.default = r : _e(r) && Fe(d, r), [f, d];
}
function ql(e, t, o, r, d, f) {
  return {
    locale: t,
    key: o,
    warnHtmlMessage: d,
    onError: (i) => {
      if (f && f(i), process.env.NODE_ENV !== "production") {
        const l = Dl(r), s = `Message compilation error: ${i.message}`, n = i.location && l && vs(l, i.location.start.offset, i.location.end.offset), a = e.__v_emitter;
        a && l && a.emit("compile-error", {
          message: l,
          error: i.message,
          start: i.location && i.location.start.offset,
          end: i.location && i.location.end.offset,
          groupId: `translate:${o}`
        }), console.error(n ? `${s}
${n}` : s);
      } else
        throw i;
    },
    onCacheKey: (i) => ss(t, o, i)
  };
}
function Dl(e) {
  if (ee(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function Hl(e, t, o, r) {
  const { modifiers: d, pluralRules: f, messageResolver: i, fallbackLocale: l, fallbackWarn: s, missingWarn: n, fallbackContext: a } = e, m = {
    locale: t,
    modifiers: d,
    pluralRules: f,
    messages: (v, h) => {
      let _ = i(o, v);
      if (_ == null && (a || h)) {
        const [, , b] = ba(
          a || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          v,
          t,
          l,
          s,
          n
        );
        _ = i(b, v);
      }
      if (ee(_) || nt(_)) {
        let b = !1;
        const g = Ca(e, v, t, _, v, () => {
          b = !0;
        });
        return b ? kr : g;
      } else return Xe(_) ? _ : kr;
    }
  };
  return e.processor && (m.processor = e.processor), r.list && (m.list = r.list), r.named && (m.named = r.named), Ve(r.plural) && (m.pluralIndex = r.plural), m;
}
Hs();
/*!
  * vue-i18n v10.0.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const Yl = "10.0.8";
function Zl() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (kt().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (kt().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (kt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (kt().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Nt = {
  FALLBACK_TO_ROOT: Il,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  DEPRECATE_TC: 11
}, Wl = {
  [Nt.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Nt.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Nt.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [Nt.DEPRECATE_TC]: "'tc' and '$tc' has been deprecated in v10. Use 't' or '$t' instead. 'tc' and '$tc’ are going to remove in v11."
};
function Xo(e, ...t) {
  return co(Wl[e], ...t);
}
const Ue = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: ul,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function sn(e, ...t) {
  return Dt(e, null, process.env.NODE_ENV !== "production" ? { messages: Kl, args: t } : void 0);
}
const Kl = {
  [Ue.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Ue.INVALID_ARGUMENT]: "Invalid argument",
  [Ue.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Ue.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Ue.UNEXPECTED_ERROR]: "Unexpected error",
  [Ue.REQUIRED_VALUE]: "Required in value: {0}",
  [Ue.INVALID_VALUE]: "Invalid value",
  [Ue.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Ue.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Ue.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Ue.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Lo = /* @__PURE__ */ ft("__translateVNode"), Vo = /* @__PURE__ */ ft("__datetimeParts"), Fo = /* @__PURE__ */ ft("__numberParts"), jo = /* @__PURE__ */ ft("__enableEmitter"), zo = /* @__PURE__ */ ft("__disableEmitter"), Ql = ft("__setPluralRules"), Ia = /* @__PURE__ */ ft("__injectWithOption"), Uo = /* @__PURE__ */ ft("__dispose");
function ln(e) {
  if (!ge(e) || nt(e))
    return e;
  for (const t in e)
    if (tt(e, t))
      if (!t.includes("."))
        ge(e[t]) && ln(e[t]);
      else {
        const o = t.split("."), r = o.length - 1;
        let d = e, f = !1;
        for (let i = 0; i < r; i++) {
          if (o[i] === "__proto__")
            throw new Error(`unsafe key: ${o[i]}`);
          if (o[i] in d || (d[o[i]] = Se()), !ge(d[o[i]])) {
            process.env.NODE_ENV !== "production" && mt(Xo(Nt.IGNORE_OBJ_FLATTEN, {
              key: o[i]
            })), f = !0;
            break;
          }
          d = d[o[i]];
        }
        if (f || (nt(d) ? la.includes(o[r]) || delete e[t] : (d[o[r]] = e[t], delete e[t])), !nt(d)) {
          const i = d[o[r]];
          ge(i) && ln(i);
        }
      }
  return e;
}
function Ea(e, t) {
  const { messages: o, __i18n: r, messageResolver: d, flatJson: f } = t, i = _e(o) ? o : xe(r) ? Se() : { [e]: Se() };
  if (xe(r) && r.forEach((l) => {
    if ("locale" in l && "resource" in l) {
      const { locale: s, resource: n } = l;
      s ? (i[s] = i[s] || Se(), no(n, i[s])) : no(n, i);
    } else
      ee(l) && no(JSON.parse(l), i);
  }), d == null && f)
    for (const l in i)
      tt(i, l) && ln(i[l]);
  return i;
}
function Sa(e) {
  return e.type;
}
function Xl(e, t, o) {
  let r = ge(t.messages) ? t.messages : Se();
  "__i18nGlobal" in o && (r = Ea(e.locale.value, {
    messages: r,
    __i18n: o.__i18nGlobal
  }));
  const d = Object.keys(r);
  d.length && d.forEach((f) => {
    e.mergeLocaleMessage(f, r[f]);
  });
  {
    if (ge(t.datetimeFormats)) {
      const f = Object.keys(t.datetimeFormats);
      f.length && f.forEach((i) => {
        e.mergeDateTimeFormat(i, t.datetimeFormats[i]);
      });
    }
    if (ge(t.numberFormats)) {
      const f = Object.keys(t.numberFormats);
      f.length && f.forEach((i) => {
        e.mergeNumberFormat(i, t.numberFormats[i]);
      });
    }
  }
}
function Ar(e) {
  return C(qa, null, e, 0);
}
const Mr = "__INTLIFY_META__", Or = () => [], Jl = () => !1;
let Rr = 0;
function $r(e) {
  return (t, o, r, d) => e(o, r, mn() || void 0, d);
}
const eu = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = mn();
  let t = null;
  return e && (t = Sa(e)[Mr]) ? { [Mr]: t } : null;
};
function tu(e = {}) {
  const { __root: t, __injectWithOption: o } = e, r = t === void 0, d = e.flatJson, f = ct ? re : Ga;
  let i = Oe(e.inheritLocale) ? e.inheritLocale : !0;
  const l = f(
    // prettier-ignore
    t && i ? t.locale.value : ee(e.locale) ? e.locale : io
  ), s = f(
    // prettier-ignore
    t && i ? t.fallbackLocale.value : ee(e.fallbackLocale) || xe(e.fallbackLocale) || _e(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : l.value
  ), n = f(Ea(l.value, e)), a = f(_e(e.datetimeFormats) ? e.datetimeFormats : { [l.value]: {} }), c = f(_e(e.numberFormats) ? e.numberFormats : { [l.value]: {} });
  let m = t ? t.missingWarn : Oe(e.missingWarn) || ro(e.missingWarn) ? e.missingWarn : !0, v = t ? t.fallbackWarn : Oe(e.fallbackWarn) || ro(e.fallbackWarn) ? e.fallbackWarn : !0, h = t ? t.fallbackRoot : Oe(e.fallbackRoot) ? e.fallbackRoot : !0, _ = !!e.fallbackFormat, b = we(e.missing) ? e.missing : null, y = we(e.missing) ? $r(e.missing) : null, g = we(e.postTranslation) ? e.postTranslation : null, I = t ? t.warnHtmlMessage : Oe(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, T = !!e.escapeParameter;
  const w = t ? t.modifiers : _e(e.modifiers) ? e.modifiers : {};
  let M = e.pluralRules || t && t.pluralRules, k;
  k = (() => {
    r && br(null);
    const z = {
      version: Yl,
      locale: l.value,
      fallbackLocale: s.value,
      messages: n.value,
      modifiers: w,
      pluralRules: M,
      missing: y === null ? void 0 : y,
      missingWarn: m,
      fallbackWarn: v,
      fallbackFormat: _,
      unresolving: !0,
      postTranslation: g === null ? void 0 : g,
      warnHtmlMessage: I,
      escapeParameter: T,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    z.datetimeFormats = a.value, z.numberFormats = c.value, z.__datetimeFormatters = _e(k) ? k.__datetimeFormatters : void 0, z.__numberFormatters = _e(k) ? k.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (z.__v_emitter = _e(k) ? k.__v_emitter : void 0);
    const Y = Ol(z);
    return r && br(Y), Y;
  })(), Wt(k, l.value, s.value);
  function $() {
    return [
      l.value,
      s.value,
      n.value,
      a.value,
      c.value
    ];
  }
  const q = F({
    get: () => l.value,
    set: (z) => {
      l.value = z, k.locale = l.value;
    }
  }), J = F({
    get: () => s.value,
    set: (z) => {
      s.value = z, k.fallbackLocale = s.value, Wt(k, l.value, z);
    }
  }), X = F(() => n.value), U = /* @__PURE__ */ F(() => a.value), oe = /* @__PURE__ */ F(() => c.value);
  function fe() {
    return we(g) ? g : null;
  }
  function ve(z) {
    g = z, k.postTranslation = z;
  }
  function Re() {
    return b;
  }
  function ae(z) {
    z !== null && (y = $r(z)), b = z, k.missing = y;
  }
  function se(z, Y) {
    return z !== "translate" || !Y.resolvedMessage;
  }
  const pe = (z, Y, Ce, Me, Pt, _n) => {
    $();
    let jt;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, r || (k.fallbackContext = t ? Ml() : void 0), jt = z(k);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, r || (k.fallbackContext = void 0);
    }
    if (Ce !== "translate exists" && // for not `te` (e.g `t`)
    Ve(jt) && jt === fo || Ce === "translate exists" && !jt) {
      const [Tt, Ua] = Y();
      if (process.env.NODE_ENV !== "production" && t && ee(Tt) && se(Ce, Ua) && (h && (po(v, Tt) || va(m, Tt)) && mt(Xo(Nt.FALLBACK_TO_ROOT, {
        key: Tt,
        type: Ce
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: ir } = k;
        ir && h && ir.emit("fallback", {
          type: Ce,
          key: Tt,
          to: "global",
          groupId: `${Ce}:${Tt}`
        });
      }
      return t && h ? Me(t) : Pt(Tt);
    } else {
      if (_n(jt))
        return jt;
      throw sn(Ue.UNEXPECTED_RETURN_TYPE);
    }
  };
  function $e(...z) {
    return pe((Y) => Reflect.apply(Nr, null, [Y, ...z]), () => xo(...z), "translate", (Y) => Reflect.apply(Y.t, Y, [...z]), (Y) => Y, (Y) => ee(Y));
  }
  function ze(...z) {
    const [Y, Ce, Me] = z;
    if (Me && !ge(Me))
      throw sn(Ue.INVALID_ARGUMENT);
    return $e(Y, Ce, Fe({ resolvedMessage: !0 }, Me || {}));
  }
  function Qe(...z) {
    return pe((Y) => Reflect.apply(Er, null, [Y, ...z]), () => Ro(...z), "datetime format", (Y) => Reflect.apply(Y.d, Y, [...z]), () => ao, (Y) => ee(Y));
  }
  function ot(...z) {
    return pe((Y) => Reflect.apply(Pr, null, [Y, ...z]), () => $o(...z), "number format", (Y) => Reflect.apply(Y.n, Y, [...z]), () => ao, (Y) => ee(Y));
  }
  function It(z) {
    return z.map((Y) => ee(Y) || Ve(Y) || Oe(Y) ? Ar(String(Y)) : Y);
  }
  const te = {
    normalize: It,
    interpolate: (z) => z,
    type: "vnode"
  };
  function Ee(...z) {
    return pe((Y) => {
      let Ce;
      const Me = Y;
      try {
        Me.processor = te, Ce = Reflect.apply(Nr, null, [Me, ...z]);
      } finally {
        Me.processor = null;
      }
      return Ce;
    }, () => xo(...z), "translate", (Y) => Y[Lo](...z), (Y) => [Ar(Y)], (Y) => xe(Y));
  }
  function Z(...z) {
    return pe((Y) => Reflect.apply(Pr, null, [Y, ...z]), () => $o(...z), "number format", (Y) => Y[Fo](...z), Or, (Y) => ee(Y) || xe(Y));
  }
  function Et(...z) {
    return pe((Y) => Reflect.apply(Er, null, [Y, ...z]), () => Ro(...z), "datetime format", (Y) => Y[Vo](...z), Or, (Y) => ee(Y) || xe(Y));
  }
  function Co(z) {
    M = z, k.pluralRules = M;
  }
  function Io(z, Y) {
    return pe(() => {
      if (!z)
        return !1;
      const Ce = ee(Y) ? Y : l.value, Me = St(Ce), Pt = k.messageResolver(Me, z);
      return nt(Pt) || Xe(Pt) || ee(Pt);
    }, () => [z], "translate exists", (Ce) => Reflect.apply(Ce.te, Ce, [z, Y]), Jl, (Ce) => Oe(Ce));
  }
  function Ht(z) {
    let Y = null;
    const Ce = ua(k, s.value, l.value);
    for (let Me = 0; Me < Ce.length; Me++) {
      const Pt = n.value[Ce[Me]] || {}, _n = k.messageResolver(Pt, z);
      if (_n != null) {
        Y = _n;
        break;
      }
    }
    return Y;
  }
  function Yt(z) {
    const Y = Ht(z);
    return Y ?? (t ? t.tm(z) || {} : {});
  }
  function St(z) {
    return n.value[z] || {};
  }
  function Zt(z, Y) {
    if (d) {
      const Ce = { [z]: Y };
      for (const Me in Ce)
        tt(Ce, Me) && ln(Ce[Me]);
      Y = Ce[z];
    }
    n.value[z] = Y, k.messages = n.value;
  }
  function Eo(z, Y) {
    n.value[z] = n.value[z] || {};
    const Ce = { [z]: Y };
    if (d)
      for (const Me in Ce)
        tt(Ce, Me) && ln(Ce[Me]);
    Y = Ce[z], no(Y, n.value[z]), k.messages = n.value;
  }
  function A(z) {
    return a.value[z] || {};
  }
  function O(z, Y) {
    a.value[z] = Y, k.datetimeFormats = a.value, Sr(k, z, Y);
  }
  function D(z, Y) {
    a.value[z] = Fe(a.value[z] || {}, Y), k.datetimeFormats = a.value, Sr(k, z, Y);
  }
  function ue(z) {
    return c.value[z] || {};
  }
  function Ne(z, Y) {
    c.value[z] = Y, k.numberFormats = c.value, Tr(k, z, Y);
  }
  function Ae(z, Y) {
    c.value[z] = Fe(c.value[z] || {}, Y), k.numberFormats = c.value, Tr(k, z, Y);
  }
  Rr++, t && ct && (G(t.locale, (z) => {
    i && (l.value = z, k.locale = z, Wt(k, l.value, s.value));
  }), G(t.fallbackLocale, (z) => {
    i && (s.value = z, k.fallbackLocale = z, Wt(k, l.value, s.value));
  }));
  const ye = {
    id: Rr,
    locale: q,
    fallbackLocale: J,
    get inheritLocale() {
      return i;
    },
    set inheritLocale(z) {
      i = z, z && t && (l.value = t.locale.value, s.value = t.fallbackLocale.value, Wt(k, l.value, s.value));
    },
    get availableLocales() {
      return Object.keys(n.value).sort();
    },
    messages: X,
    get modifiers() {
      return w;
    },
    get pluralRules() {
      return M || {};
    },
    get isGlobal() {
      return r;
    },
    get missingWarn() {
      return m;
    },
    set missingWarn(z) {
      m = z, k.missingWarn = m;
    },
    get fallbackWarn() {
      return v;
    },
    set fallbackWarn(z) {
      v = z, k.fallbackWarn = v;
    },
    get fallbackRoot() {
      return h;
    },
    set fallbackRoot(z) {
      h = z;
    },
    get fallbackFormat() {
      return _;
    },
    set fallbackFormat(z) {
      _ = z, k.fallbackFormat = _;
    },
    get warnHtmlMessage() {
      return I;
    },
    set warnHtmlMessage(z) {
      I = z, k.warnHtmlMessage = z;
    },
    get escapeParameter() {
      return T;
    },
    set escapeParameter(z) {
      T = z, k.escapeParameter = z;
    },
    t: $e,
    getLocaleMessage: St,
    setLocaleMessage: Zt,
    mergeLocaleMessage: Eo,
    getPostTranslationHandler: fe,
    setPostTranslationHandler: ve,
    getMissingHandler: Re,
    setMissingHandler: ae,
    [Ql]: Co
  };
  return ye.datetimeFormats = U, ye.numberFormats = oe, ye.rt = ze, ye.te = Io, ye.tm = Yt, ye.d = Qe, ye.n = ot, ye.getDateTimeFormat = A, ye.setDateTimeFormat = O, ye.mergeDateTimeFormat = D, ye.getNumberFormat = ue, ye.setNumberFormat = Ne, ye.mergeNumberFormat = Ae, ye[Ia] = o, ye[Lo] = Ee, ye[Vo] = Et, ye[Fo] = Z, process.env.NODE_ENV !== "production" && (ye[jo] = (z) => {
    k.__v_emitter = z;
  }, ye[zo] = () => {
    k.__v_emitter = void 0;
  }), ye;
}
function xr(e, t) {
}
const Jo = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function nu({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((r, d) => [
    ...r,
    // prettier-ignore
    ...d.type === je ? d.children : [d]
  ], []) : t.reduce((o, r) => {
    const d = e[r];
    return d && (o[r] = d()), o;
  }, Se());
}
function Pa() {
  return je;
}
Fe({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => Ve(e) || !isNaN(e)
  }
}, Jo);
function ou(e) {
  return xe(e) && !ee(e[0]);
}
function Ta(e, t, o, r) {
  const { slots: d, attrs: f } = t;
  return () => {
    const i = { part: !0 };
    let l = Se();
    e.locale && (i.locale = e.locale), ee(e.format) ? i.key = e.format : ge(e.format) && (ee(e.format.key) && (i.key = e.format.key), l = Object.keys(e.format).reduce((m, v) => o.includes(v) ? Fe(Se(), m, { [v]: e.format[v] }) : m, Se()));
    const s = r(e.value, i, l);
    let n = [i.key];
    xe(s) ? n = s.map((m, v) => {
      const h = d[m.type], _ = h ? h({ [m.type]: m.value, index: v, parts: s }) : [m.value];
      return ou(_) && (_[0].key = `${m.type}-${v}`), _;
    }) : ee(s) && (n = [s]);
    const a = Fe(Se(), f), c = ee(e.tag) || ge(e.tag) ? e.tag : Pa();
    return Xi(c, a, n);
  };
}
Fe({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Jo);
Fe({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Jo);
const ru = /* @__PURE__ */ ft("global-vue-i18n");
function H(e = {}) {
  const t = mn();
  if (t == null)
    throw sn(Ue.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw sn(Ue.NOT_INSTALLED);
  const o = iu(t), r = su(o), d = Sa(t), f = au(e, d);
  if (f === "global")
    return Xl(r, e, d), r;
  if (f === "parent") {
    let s = lu(o, t, e.__useComponent);
    return s == null && (process.env.NODE_ENV !== "production" && mt(Xo(Nt.NOT_FOUND_PARENT_SCOPE)), s = r), s;
  }
  const i = o;
  let l = i.__getInstance(t);
  if (l == null) {
    const s = Fe({}, e);
    "__i18n" in d && (s.__i18n = d.__i18n), r && (s.__root = r), l = tu(s), i.__composerExtend && (l[Uo] = i.__composerExtend(l)), du(i, t, l), i.__setInstance(t, l);
  }
  return l;
}
function iu(e) {
  const t = Q(e.isCE ? ru : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw sn(e.isCE ? Ue.NOT_INSTALLED_WITH_PROVIDE : Ue.UNEXPECTED_ERROR);
  return t;
}
function au(e, t) {
  return mo(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function su(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function lu(e, t, o = !1) {
  let r = null;
  const d = t.root;
  let f = uu(t, o);
  for (; f != null; ) {
    const i = e;
    if (e.mode === "composition")
      r = i.__getInstance(f);
    else if (__VUE_I18N_LEGACY_API__) {
      const l = i.__getInstance(f);
      l != null && (r = l.__composer, o && r && !r[Ia] && (r = null));
    }
    if (r != null || d === f)
      break;
    f = f.parent;
  }
  return r;
}
function uu(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function du(e, t, o) {
  let r = null;
  me(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = o, r = hs();
      const d = o;
      d[jo] && d[jo](r), r.on("*", xr);
    }
  }, t), Lt(() => {
    const d = o;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (r && r.off("*", xr), d[zo] && d[zo](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const f = d[Uo];
    f && (f(), delete d[Uo]);
  }, t);
}
Zl();
Tl(rl);
wl(Cl);
kl(ua);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = kt();
  e.__INTLIFY__ = !0, il(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
var R = /* @__PURE__ */ ((e) => (e.POS = "pos", e.WEB = "web", e.POS_STRANKA = "diypos", e.POS_MOBILE = "diycc", e.SKLENI_SAM = "dob", e.VLOGA = "vloga", e.INFOCALC = "infocalc", e.WEB_INFOCALC = "infocalcweb", e.PORTAL_INFOCALC = "infocalcportal", e.DOKUMENTACIJA = "doc", e.LIMIT = "limit", e))(R || {}), cu = /* @__PURE__ */ ((e) => (e.PRODAJALEC = "user", e.PARTNER = "partner", e.SPLOSNO = "custom", e))(cu || {}), xt = /* @__PURE__ */ ((e) => (e.NONE = "NONE", e.POS_STRANKA = "POS", e.POS_MOBILE = "CC", e))(xt || {}), le = /* @__PURE__ */ ((e) => (e.Zaposlen = "Z", e.Upokojenec = "U", e.SP = "SP", e))(le || {}), ut = /* @__PURE__ */ ((e) => (e.AfternoonSP = "AS", e.SP = "SP", e))(ut || {}), Bo = /* @__PURE__ */ ((e) => (e.PermanentResidence = "S", e.TemporaryResidence = "Z", e))(Bo || {}), At = /* @__PURE__ */ ((e) => (e.PersonalId = "OS", e.Passport = "PL", e))(At || {}), mu = /* @__PURE__ */ ((e) => (e.OBR = "Obrestni", e.BREZOBR = "Brezobrestni", e.EOM0 = "EOM0", e))(mu || {}), yt = /* @__PURE__ */ ((e) => (e.pi = "SL", e.stalni = "DOM", e.posta = "PS", e.zacasni = "ZAC", e.drugi = "DRG", e.sls = "SLS", e.trgovec = "TRG", e.petrol = "PETROL", e))(yt || {}), lt = /* @__PURE__ */ ((e) => (e.prevzemTrgovec = "P", e.dostava = "D", e))(lt || {}), wa = /* @__PURE__ */ ((e) => (e[e.Success = 1] = "Success", e[e.Error = 2] = "Error", e[e.Undefined = 3] = "Undefined", e))(wa || {}), it = /* @__PURE__ */ ((e) => (e.Elektronsko = "elektronsko", e.Posta = "posta", e))(it || {}), qt = /* @__PURE__ */ ((e) => (e.SMS = "sms", e.PodpisnaTablica = "podpisna", e))(qt || {}), fu = /* @__PURE__ */ ((e) => (e.aktivna = "A", e.caka_potrditev = "P", e.brez_predodobren = "B", e))(fu || {}), pu = /* @__PURE__ */ ((e) => (e[e.Undefined = 0] = "Undefined", e[e.WEB_verification = 1] = "WEB_verification", e[e.WEB_verification_email = 2] = "WEB_verification_email", e[e.WEB_login = 3] = "WEB_login", e[e.WEB_pass_reset_tax = 4] = "WEB_pass_reset_tax", e[e.WEB_precheck = 5] = "WEB_precheck", e[e.WEB_installment_plan_Select = 6] = "WEB_installment_plan_Select", e[e.WEB_installment_plan_Select_Multi = 7] = "WEB_installment_plan_Select_Multi", e[e.WEB_personal_info = 8] = "WEB_personal_info", e[e.WEB_identification_data_confirm = 9] = "WEB_identification_data_confirm", e[e.WEB_identification_info = 10] = "WEB_identification_info", e[e.WEB_additional_contact = 11] = "WEB_additional_contact", e[e.WEB_employment_financial = 12] = "WEB_employment_financial", e[e.WEB_contract_fail = 13] = "WEB_contract_fail", e[e.WEB_contract_success = 14] = "WEB_contract_success", e[e.LIMIT_start = 15] = "LIMIT_start", e[e.LIMIT_verification_phone = 16] = "LIMIT_verification_phone", e[e.LIMIT_verification_email = 17] = "LIMIT_verification_email", e[e.LIMIT_pass_reset_tax = 18] = "LIMIT_pass_reset_tax", e[e.LIMIT_login = 19] = "LIMIT_login", e[e.LIMIT_precheck = 20] = "LIMIT_precheck", e[e.LIMIT_personal_info = 21] = "LIMIT_personal_info", e[e.LIMIT_identification_info = 22] = "LIMIT_identification_info", e[e.LIMIT_employment_info = 23] = "LIMIT_employment_info", e[e.LIMIT_financial_info = 24] = "LIMIT_financial_info", e[e.LIMIT_calculation_result = 25] = "LIMIT_calculation_result", e[e.LIMIT_calculation_fail = 26] = "LIMIT_calculation_fail", e[e.LIMIT_preapproved_decline = 27] = "LIMIT_preapproved_decline", e[e.LIMIT_preapproved_start = 28] = "LIMIT_preapproved_start", e[e.LIMIT_preapproved_fail = 29] = "LIMIT_preapproved_fail", e[e.LIMIT_preapproved_success = 30] = "LIMIT_preapproved_success", e))(pu || {});
function vu(e, t) {
  const o = Q(
    "navigationButtonsApi",
    void 0
  ), r = Q("commClient"), { t: d } = H();
  async function f() {
    return e.flowType == R.POS ? await l() : await i();
  }
  async function i() {
    return new Promise(async (n) => {
      e.isViewDataLoading = !0, await r.executeMethodAsync("sw.EmailVerify", {
        EmailVerificationId: e.emailVerificationToken
      }).then(async (a) => {
        a.Success ? (t.isEmailVerified = !0, e.orderToken = a.OrderToken, e.msisdn = a.Msisdn, e.email = a.Email, e.isViewDataLoading = !1, n("")) : (e.processEndTitle = d("GlobalErrors.Error"), e.processEndSubtitle = d("GlobalErrors.EmailLinkExpired"), e.isViewDataLoading = !1, n("end"));
      }).catch((a) => console.log(a)), e.isViewDataLoading = !1;
    });
  }
  async function l() {
    return new Promise(async (n) => {
      e.isViewDataLoading = !0, await r.executeMethodAsync("EmailVerify", {
        EmailVerificationId: e.emailVerificationToken
      }).then(async (a) => {
        a.Success ? (t.isEmailVerified = !0, e.processEndTitle = d("Components.ProcessEnd.EmailVerification.Title"), e.processEndSubtitle = d("Components.ProcessEnd.EmailVerification.Subtitle"), e.processEndIcon = "custom:iconSuccess", o == null || o.setButtonVisible("Next", !1), e.isViewDataLoading = !1, n("end")) : (e.processEndTitle = d("GlobalErrors.Error"), e.processEndSubtitle = d("GlobalErrors.EmailLinkExpired"), e.isViewDataLoading = !1, n("end"));
      }).catch((a) => console.log(a)), e.isViewDataLoading = !1;
    });
  }
  async function s(n) {
    return n == "nextStep" && t.isEmailVerified === !0 && e.orderToken !== "" ? e.flowType == R.LIMIT ? { name: "limitStart", params: { id: e.orderToken } } : { name: "webStart", params: { id: e.orderToken } } : null;
  }
  return {
    VerifyEmail: f,
    navigationAction: s
  };
}
const ib = /* @__PURE__ */ ie({
  __name: "email-verification-component",
  props: {
    data: { default: () => ({
      ...os
    }) }
  },
  emits: ["update:data", "navigation-event", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o, f = W({ ...r.data }), i = W({ ...rs });
    let l = re(!1);
    const { navigationAction: s, VerifyEmail: n } = vu(f, i);
    return G(
      () => r.data,
      // Watch for changes in the data
      (a) => {
        Object.assign(f, a);
      },
      { deep: !0 }
    ), G(
      f,
      (a) => {
        d("update:data", a);
      },
      { deep: !0 }
    ), me(async () => {
      await n().then((a) => {
        d("navigation-event", a);
      }), l.value = !0, d("componentReady");
    }), t({
      navigationAction: s,
      componentReady: l
    }), (a, c) => (S(), N("div"));
  }
}), hu = {
  identificationId: ""
}, yu = {
  taxNumber: void 0,
  alreadyIdentified: !1,
  petrolId: void 0,
  partnerHasPickup: !1,
  isRekonoAvailable: !1
};
function _u(e, t, o) {
  const r = Q("exportData"), d = Q("commClient"), { copySharedProperties: f } = Ie();
  async function i() {
    return await r(
      {
        MethodName: "IdentifikacijskiListPosta",
        Parameters: { IdentificationId: e.identificationId },
        FileName: "IdentifikacijskiListPosta.pdf"
      }
    );
  }
  async function l() {
    return new Promise(async (n) => {
      await d.executeMethodAsync("sw.LoadIdentificationData", {
        IdentificationId: e.identificationId
      }).then(async (a) => {
        a && (a.Success && f(t, a), n(a.Success));
      });
    });
  }
  async function s() {
    o("navigation-event", "rekonoStart");
  }
  return {
    LoadIdentificationData: l,
    StartRekono: s,
    IdentifikacijskiListPosta: i
  };
}
const gu = {
  class: "identification-selection-component",
  ref: "rootRef"
}, bu = {
  key: 0,
  class: "card card--default mb-8"
}, Cu = { class: "card card--default mb-8" }, Iu = { class: "identification-code" }, Eu = { class: "card card--default mb-8" }, Su = { class: "identification-code" }, Pu = {
  key: 1,
  class: "card card--default mb-8"
}, ab = /* @__PURE__ */ ie({
  __name: "identification-selection-component",
  props: {
    data: { default: () => ({
      ...hu
    }) }
  },
  emits: ["update:data", "navigation-event", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = W({ ...d.data }), i = o;
    let l = re(!1);
    G(
      () => d.data,
      // Watch for changes in the data
      (c) => {
        Object.assign(f, c);
      },
      { deep: !0 }
    ), G(f, async (c) => {
      i("update:data", c);
    }, { deep: !0 });
    const s = W({ ...yu }), { StartRekono: n, LoadIdentificationData: a } = _u(f, s, i);
    return me(async () => {
      if (await a(), s.alreadyIdentified) {
        i("navigation-event", "rekonoSuccess");
        return;
      }
      l.value = !0, i("componentReady");
    }), t({
      componentReady: l
    }), (c, m) => {
      const v = V("v-btn"), h = V("v-col"), _ = V("v-row");
      return S(), N("div", gu, [
        m[11] || (m[11] = p("div", { class: "mb-8 notification notification--info" }, "Na osnovi uspešne identifikacije bomo izvedli vpogled v informacijski sistem za izmenjavo informacij o zadolženosti fizičnih oseb SISBON in vam poslali informacijo o odobritvi ali zavrnitvi zahtevka.", -1)),
        C(_, null, {
          default: P(() => [
            C(h, { class: "v-col-12" }, {
              default: P(() => [
                s.isRekonoAvailable ? (S(), N("div", bu, [
                  m[2] || (m[2] = p("span", { class: "tag tag--green" }, "Digitalno", -1)),
                  m[3] || (m[3] = p("h1", { class: "subsection-heading mt-4" }, "Identifikacija z Rekono", -1)),
                  m[4] || (m[4] = p("div", { class: "mb-8" }, [
                    ne("Z uporabniškim računom Rekono lahko opravite identifikacijo po digitalni poti. Če računa Rekono še nimate, ga boste ustvarili med postopkom vpisa. "),
                    p("br"),
                    p("br"),
                    ne(" Priporočamo za: "),
                    p("ul", { class: "pl-8" }, [
                      p("li", null, "obstoječe uporabnike Rekono"),
                      p("li", null, "imetnike večine slovenskih bančnih kartic"),
                      p("li", null, "uporabnike z digitalnim certifikatom")
                    ])
                  ], -1)),
                  C(v, {
                    class: "btn btn--primary-fill mb-4",
                    onClick: m[0] || (m[0] = (b) => u(n)())
                  }, {
                    default: P(() => m[1] || (m[1] = [
                      ne("Identificiraj se z Rekono")
                    ])),
                    _: 1
                  }),
                  m[5] || (m[5] = p("div", { class: "font-size-75" }, [
                    ne("Rekono je rešitev za zanesljivo in varno preverjanje ter centralno upravljanje elektronske identitete posameznika. Več o storitvi Rekono na "),
                    p("a", {
                      href: "https://www.rekono.si",
                      target: "_blank"
                    }, "https://www.rekono.si/"),
                    ne(".")
                  ], -1))
                ])) : x("", !0),
                p("div", Cu, [
                  m[6] || (m[6] = p("h1", { class: "subsection-heading mt-0" }, "Identifikacija na Petrolu", -1)),
                  m[7] || (m[7] = p("div", { class: "mb-8" }, " Osebno identifikacijo lahko opravite na kateremkoli bencinskem servisu Petrol. Identifikacijo opravite tako, da zaposlenemu na Petrolu predložite osebni dokument in mu poveste spodnjo kodo. ", -1)),
                  p("div", Iu, E(s.petrolId), 1)
                ]),
                p("div", Eu, [
                  m[8] || (m[8] = p("h1", { class: "subsection-heading mt-0" }, "Identifikacija na Pošti Slovenije", -1)),
                  m[9] || (m[9] = p("div", { class: "mb-8" }, " Osebno identifikacijo lahko opravite v poslovalnicah Pošte Slovenije. Identifikacijo opravite tako, da zaposlenemu na Pošti Slovenije predložite osebni dokument in mu poveste spodnjo kodo. ", -1)),
                  p("div", Su, E(s.petrolId), 1)
                ]),
                s.partnerHasPickup ? (S(), N("div", Pu, m[10] || (m[10] = [
                  p("h1", { class: "subsection-heading mt-0" }, "Identifikacija ob prevzemu blaga", -1),
                  p("div", { class: "mb-8" }, " Identifikacijo lahko izvedete tudi na prodajnem mestu, kjer boste osebno prevzeli blago. Identifikacijo opravite tako, da osebi na prodajnem mestu predložite osebni dokument in davčno številko. ", -1)
                ]))) : x("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 512);
    };
  }
}), Tu = {
  documentationId: void 0,
  identificationType: void 0,
  identificationId: void 0,
  errorText: void 0,
  isDocumentationNeeded: !1,
  isDocumentationUploaded: !1,
  isPreapproved: !1
}, wu = {
  taxNumber: void 0
};
function ku(e, t) {
  const o = Q("commClient"), { copySharedProperties: r } = Ie();
  async function d() {
    return new Promise(async (f) => {
      const l = new URLSearchParams(window.location.search).get("code");
      e.errorText = "ID_FAIL", await o.executeMethodAsync("RekonoAuthorize", {
        IdentificationId: e.identificationId,
        Code: l
      }).then(async (s) => {
        s && (r(e, s), s.Success && f("rekonoSuccess"));
      }), f("rekonoFail");
    });
  }
  return {
    RekonoAuthorize: d
  };
}
const sb = /* @__PURE__ */ ie({
  __name: "rekono-identification-component",
  props: {
    data: { default: () => ({
      ...Tu
    }) }
  },
  emits: ["update:data", "navigation-event", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = o;
    let f = re(!1);
    const i = e, l = W({ ...i.data });
    W({ ...wu });
    const { RekonoAuthorize: s } = ku(l);
    return G(
      () => i.data,
      // Watch for changes in the data
      (n) => {
        Object.assign(l, n);
      },
      { deep: !0 }
    ), G(l, async (n) => {
      d("update:data", n);
    }, { deep: !0 }), me(async () => {
      await s().then(
        (n) => {
          d("navigation-event", n);
        }
      ), f.value = !0, d("componentReady");
    }), t({
      componentReady: f
    }), (n, a) => null;
  }
}), Nu = {
  identificationId: void 0,
  idDocumentImage: []
};
function Lr(e, t) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(d) {
      return Object.getOwnPropertyDescriptor(e, d).enumerable;
    })), o.push.apply(o, r);
  }
  return o;
}
function ht(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Lr(Object(o), !0).forEach(function(r) {
      Au(e, r, o[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : Lr(Object(o)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(o, r));
    });
  }
  return e;
}
function Au(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}
function Vr(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return Object.keys(e).reduce((o, r) => (t.includes(r) || (o[r] = u(e[r])), o), {});
}
function so(e) {
  return typeof e == "function";
}
function Mu(e) {
  return Ya(e) || Za(e);
}
function ka(e, t, o) {
  let r = e;
  const d = t.split(".");
  for (let f = 0; f < d.length; f++) {
    if (!r[d[f]]) return o;
    r = r[d[f]];
  }
  return r;
}
function wo(e, t, o) {
  return F(() => e.some((r) => ka(t, r, {
    [o]: !1
  })[o]));
}
function Fr(e, t, o) {
  return F(() => e.reduce((r, d) => {
    const f = ka(t, d, {
      [o]: !1
    })[o] || [];
    return r.concat(f);
  }, []));
}
function Na(e, t, o, r) {
  return e.call(r, u(t), u(o), r);
}
function Aa(e) {
  return e.$valid !== void 0 ? !e.$valid : !e;
}
function Ou(e, t, o, r, d, f, i) {
  let {
    $lazy: l,
    $rewardEarly: s
  } = d, n = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [], a = arguments.length > 8 ? arguments[8] : void 0, c = arguments.length > 9 ? arguments[9] : void 0, m = arguments.length > 10 ? arguments[10] : void 0;
  const v = re(!!r.value), h = re(0);
  o.value = !1;
  const _ = G([t, r].concat(n, m), () => {
    if (l && !r.value || s && !c.value && !o.value)
      return;
    let b;
    try {
      b = Na(e, t, a, i);
    } catch (y) {
      b = Promise.reject(y);
    }
    h.value++, o.value = !!h.value, v.value = !1, Promise.resolve(b).then((y) => {
      h.value--, o.value = !!h.value, f.value = y, v.value = Aa(y);
    }).catch((y) => {
      h.value--, o.value = !!h.value, f.value = y, v.value = !0;
    });
  }, {
    immediate: !0,
    deep: typeof t == "object"
  });
  return {
    $invalid: v,
    $unwatch: _
  };
}
function Ru(e, t, o, r, d, f, i, l) {
  let {
    $lazy: s,
    $rewardEarly: n
  } = r;
  const a = () => ({}), c = F(() => {
    if (s && !o.value || n && !l.value)
      return !1;
    let m = !0;
    try {
      const v = Na(e, t, i, f);
      d.value = v, m = Aa(v);
    } catch (v) {
      d.value = v;
    }
    return m;
  });
  return {
    $unwatch: a,
    $invalid: c
  };
}
function $u(e, t, o, r, d, f, i, l, s, n, a) {
  const c = re(!1), m = e.$params || {}, v = re(null);
  let h, _;
  e.$async ? {
    $invalid: h,
    $unwatch: _
  } = Ou(e.$validator, t, c, o, r, v, d, e.$watchTargets, s, n, a) : {
    $invalid: h,
    $unwatch: _
  } = Ru(e.$validator, t, o, r, v, d, s, n);
  const b = e.$message;
  return {
    $message: so(b) ? F(() => b(Vr({
      $pending: c,
      $invalid: h,
      $params: Vr(m),
      $model: t,
      $response: v,
      $validator: f,
      $propertyPath: l,
      $property: i
    }))) : b || "",
    $params: m,
    $pending: c,
    $invalid: h,
    $response: v,
    $unwatch: _
  };
}
function xu() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const t = u(e), o = Object.keys(t), r = {}, d = {}, f = {};
  let i = null;
  return o.forEach((l) => {
    const s = t[l];
    switch (!0) {
      case so(s.$validator):
        r[l] = s;
        break;
      case so(s):
        r[l] = {
          $validator: s
        };
        break;
      case l === "$validationGroups":
        i = s;
        break;
      case l.startsWith("$"):
        f[l] = s;
        break;
      default:
        d[l] = s;
    }
  }), {
    rules: r,
    nestedValidators: d,
    config: f,
    validationGroups: i
  };
}
const Lu = "__root";
function Vu(e, t, o, r, d, f, i, l, s) {
  const n = Object.keys(e), a = r.get(d, e), c = re(!1), m = re(!1), v = re(0);
  if (a) {
    if (!a.$partial) return a;
    a.$unwatch(), c.value = a.$dirty.value;
  }
  const h = {
    $dirty: c,
    $path: d,
    $touch: () => {
      c.value || (c.value = !0);
    },
    $reset: () => {
      c.value && (c.value = !1);
    },
    $commit: () => {
    }
  };
  return n.length ? (n.forEach((_) => {
    h[_] = $u(e[_], t, h.$dirty, f, i, _, o, d, s, m, v);
  }), h.$externalResults = F(() => l.value ? [].concat(l.value).map((_, b) => ({
    $propertyPath: d,
    $property: o,
    $validator: "$externalResults",
    $uid: `${d}-externalResult-${b}`,
    $message: _,
    $params: {},
    $response: null,
    $pending: !1
  })) : []), h.$invalid = F(() => {
    const _ = n.some((b) => u(h[b].$invalid));
    return m.value = _, !!h.$externalResults.value.length || _;
  }), h.$pending = F(() => n.some((_) => u(h[_].$pending))), h.$error = F(() => h.$dirty.value ? h.$pending.value || h.$invalid.value : !1), h.$silentErrors = F(() => n.filter((_) => u(h[_].$invalid)).map((_) => {
    const b = h[_];
    return W({
      $propertyPath: d,
      $property: o,
      $validator: _,
      $uid: `${d}-${_}`,
      $message: b.$message,
      $params: b.$params,
      $response: b.$response,
      $pending: b.$pending
    });
  }).concat(h.$externalResults.value)), h.$errors = F(() => h.$dirty.value ? h.$silentErrors.value : []), h.$unwatch = () => n.forEach((_) => {
    h[_].$unwatch();
  }), h.$commit = () => {
    m.value = !0, v.value = Date.now();
  }, r.set(d, e, h), h) : (a && r.set(d, e, h), h);
}
function Fu(e, t, o, r, d, f, i) {
  const l = Object.keys(e);
  return l.length ? l.reduce((s, n) => (s[n] = Go({
    validations: e[n],
    state: t,
    key: n,
    parentKey: o,
    resultsCache: r,
    globalConfig: d,
    instance: f,
    externalResults: i
  }), s), {}) : {};
}
function ju(e, t, o) {
  const r = F(() => [t, o].filter((h) => h).reduce((h, _) => h.concat(Object.values(u(_))), [])), d = F({
    get() {
      return e.$dirty.value || (r.value.length ? r.value.every((h) => h.$dirty) : !1);
    },
    set(h) {
      e.$dirty.value = h;
    }
  }), f = F(() => {
    const h = u(e.$silentErrors) || [], _ = r.value.filter((b) => (u(b).$silentErrors || []).length).reduce((b, y) => b.concat(...y.$silentErrors), []);
    return h.concat(_);
  }), i = F(() => {
    const h = u(e.$errors) || [], _ = r.value.filter((b) => (u(b).$errors || []).length).reduce((b, y) => b.concat(...y.$errors), []);
    return h.concat(_);
  }), l = F(() => r.value.some((h) => h.$invalid) || u(e.$invalid) || !1), s = F(() => r.value.some((h) => u(h.$pending)) || u(e.$pending) || !1), n = F(() => r.value.some((h) => h.$dirty) || r.value.some((h) => h.$anyDirty) || d.value), a = F(() => d.value ? s.value || l.value : !1), c = () => {
    e.$touch(), r.value.forEach((h) => {
      h.$touch();
    });
  }, m = () => {
    e.$commit(), r.value.forEach((h) => {
      h.$commit();
    });
  }, v = () => {
    e.$reset(), r.value.forEach((h) => {
      h.$reset();
    });
  };
  return r.value.length && r.value.every((h) => h.$dirty) && c(), {
    $dirty: d,
    $errors: i,
    $invalid: l,
    $anyDirty: n,
    $error: a,
    $pending: s,
    $touch: c,
    $reset: v,
    $silentErrors: f,
    $commit: m
  };
}
function Go(e) {
  let {
    validations: t,
    state: o,
    key: r,
    parentKey: d,
    childResults: f,
    resultsCache: i,
    globalConfig: l = {},
    instance: s,
    externalResults: n
  } = e;
  const a = d ? `${d}.${r}` : r, {
    rules: c,
    nestedValidators: m,
    config: v,
    validationGroups: h
  } = xu(t), _ = ht(ht({}, l), v), b = r ? F(() => {
    const pe = u(o);
    return pe ? u(pe[r]) : void 0;
  }) : o, y = ht({}, u(n) || {}), g = F(() => {
    const pe = u(n);
    return r ? pe ? u(pe[r]) : void 0 : pe;
  }), I = Vu(c, b, r, i, a, _, s, g, o), T = Fu(m, b, a, i, _, s, g), w = {};
  h && Object.entries(h).forEach((pe) => {
    let [$e, ze] = pe;
    w[$e] = {
      $invalid: wo(ze, T, "$invalid"),
      $error: wo(ze, T, "$error"),
      $pending: wo(ze, T, "$pending"),
      $errors: Fr(ze, T, "$errors"),
      $silentErrors: Fr(ze, T, "$silentErrors")
    };
  });
  const {
    $dirty: M,
    $errors: k,
    $invalid: L,
    $anyDirty: $,
    $error: q,
    $pending: J,
    $touch: X,
    $reset: U,
    $silentErrors: oe,
    $commit: fe
  } = ju(I, T, f), ve = r ? F({
    get: () => u(b),
    set: (pe) => {
      M.value = !0;
      const $e = u(o), ze = u(n);
      ze && (ze[r] = y[r]), No($e[r]) ? $e[r].value = pe : $e[r] = pe;
    }
  }) : null;
  r && _.$autoDirty && G(b, () => {
    M.value || X();
    const pe = u(n);
    pe && (pe[r] = y[r]);
  }, {
    flush: "sync"
  });
  async function Re() {
    return X(), _.$rewardEarly && (fe(), await on()), await on(), new Promise((pe) => {
      if (!J.value) return pe(!L.value);
      const $e = G(J, () => {
        pe(!L.value), $e();
      });
    });
  }
  function ae(pe) {
    return (f.value || {})[pe];
  }
  function se() {
    No(n) ? n.value = y : Object.keys(y).length === 0 ? Object.keys(n).forEach((pe) => {
      delete n[pe];
    }) : Object.assign(n, y);
  }
  return W(ht(ht(ht({}, I), {}, {
    $model: ve,
    $dirty: M,
    $error: q,
    $errors: k,
    $invalid: L,
    $anyDirty: $,
    $pending: J,
    $touch: X,
    $reset: U,
    $path: a || Lu,
    $silentErrors: oe,
    $validate: Re,
    $commit: fe
  }, f && {
    $getResultsForChild: ae,
    $clearExternalResults: se,
    $validationGroups: w
  }), T));
}
class zu {
  constructor() {
    this.storage = /* @__PURE__ */ new Map();
  }
  set(t, o, r) {
    this.storage.set(t, {
      rules: o,
      result: r
    });
  }
  checkRulesValidity(t, o, r) {
    const d = Object.keys(r), f = Object.keys(o);
    return f.length !== d.length || !f.every((l) => d.includes(l)) ? !1 : f.every((l) => o[l].$params ? Object.keys(o[l].$params).every((s) => u(r[l].$params[s]) === u(o[l].$params[s])) : !0);
  }
  get(t, o) {
    const r = this.storage.get(t);
    if (!r) return;
    const {
      rules: d,
      result: f
    } = r, i = this.checkRulesValidity(t, o, d), l = f.$unwatch ? f.$unwatch : () => ({});
    return i ? f : {
      $dirty: f.$dirty,
      $partial: !0,
      $unwatch: l
    };
  }
}
const oo = {
  COLLECT_ALL: !0,
  COLLECT_NONE: !1
}, jr = Symbol("vuelidate#injectChildResults"), zr = Symbol("vuelidate#removeChildResults");
function Uu(e) {
  let {
    $scope: t,
    instance: o
  } = e;
  const r = {}, d = re([]), f = F(() => d.value.reduce((a, c) => (a[c] = u(r[c]), a), {}));
  function i(a, c) {
    let {
      $registerAs: m,
      $scope: v,
      $stopPropagation: h
    } = c;
    h || t === oo.COLLECT_NONE || v === oo.COLLECT_NONE || t !== oo.COLLECT_ALL && t !== v || (r[m] = a, d.value.push(m));
  }
  o.__vuelidateInjectInstances = [].concat(o.__vuelidateInjectInstances || [], i);
  function l(a) {
    d.value = d.value.filter((c) => c !== a), delete r[a];
  }
  o.__vuelidateRemoveInstances = [].concat(o.__vuelidateRemoveInstances || [], l);
  const s = Q(jr, []);
  ar(jr, o.__vuelidateInjectInstances);
  const n = Q(zr, []);
  return ar(zr, o.__vuelidateRemoveInstances), {
    childResults: f,
    sendValidationResultsToParent: s,
    removeValidationResultsFromParent: n
  };
}
function Ma(e) {
  return new Proxy(e, {
    get(t, o) {
      return typeof t[o] == "object" ? Ma(t[o]) : F(() => t[o]);
    }
  });
}
let Ur = 0;
function be(e, t) {
  var o;
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  arguments.length === 1 && (r = e, e = void 0, t = void 0);
  let {
    $registerAs: d,
    $scope: f = oo.COLLECT_ALL,
    $stopPropagation: i,
    $externalResults: l,
    currentVueInstance: s
  } = r;
  const n = s || ((o = mn()) === null || o === void 0 ? void 0 : o.proxy), a = n ? n.$options : {};
  d || (Ur += 1, d = `_vuelidate_${Ur}`);
  const c = re({}), m = new zu(), {
    childResults: v,
    sendValidationResultsToParent: h,
    removeValidationResultsFromParent: _
  } = n ? Uu({
    $scope: f,
    instance: n
  }) : {
    childResults: re({})
  };
  if (!e && a.validations) {
    const b = a.validations;
    t = re({}), Da(() => {
      t.value = n, G(() => so(b) ? b.call(t.value, new Ma(t.value)) : b, (y) => {
        c.value = Go({
          validations: y,
          state: t,
          childResults: v,
          resultsCache: m,
          globalConfig: r,
          instance: n,
          externalResults: l || n.vuelidateExternalResults
        });
      }, {
        immediate: !0
      });
    }), r = a.validationsConfig || r;
  } else {
    const b = No(e) || Mu(e) ? e : W(e || {});
    G(b, (y) => {
      c.value = Go({
        validations: y,
        state: t,
        childResults: v,
        resultsCache: m,
        globalConfig: r,
        instance: n ?? {},
        externalResults: l
      });
    }, {
      immediate: !0
    });
  }
  return n && (h.forEach((b) => b(c, {
    $registerAs: d,
    $scope: f,
    $stopPropagation: i
  })), Ha(() => _.forEach((b) => b(d)))), F(() => ht(ht({}, u(c.value)), v.value));
}
function Br(e, t) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(d) {
      return Object.getOwnPropertyDescriptor(e, d).enumerable;
    })), o.push.apply(o, r);
  }
  return o;
}
function un(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Br(Object(o), !0).forEach(function(r) {
      Bu(e, r, o[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : Br(Object(o)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(o, r));
    });
  }
  return e;
}
function Bu(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}
function dn(e) {
  return typeof e == "function";
}
function lo(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function vo(e) {
  return dn(e.$validator) ? un({}, e) : {
    $validator: e
  };
}
function Gu(e) {
  return lo(e) && dn(e.then);
}
function uo(e) {
  return typeof e == "object" ? e.$valid : e;
}
function er(e) {
  return e.$validator || e;
}
function qu(e, t) {
  if (!lo(e)) throw new Error(`[@vuelidate/validators]: First parameter to "withParams" should be an object, provided ${typeof e}`);
  if (!lo(t) && !dn(t)) throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const o = vo(t);
  return o.$params = un(un({}, o.$params || {}), e), o;
}
function Du(e, t) {
  if (!dn(e) && typeof u(e) != "string") throw new Error(`[@vuelidate/validators]: First parameter to "withMessage" should be string or a function returning a string, provided ${typeof e}`);
  if (!lo(t) && !dn(t)) throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const o = vo(t);
  return o.$message = e, o;
}
function Hu(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  const o = vo(e);
  return un(un({}, o), {}, {
    $async: !0,
    $watchTargets: t
  });
}
function Yu(e) {
  return {
    $validator(t) {
      for (var o = arguments.length, r = new Array(o > 1 ? o - 1 : 0), d = 1; d < o; d++)
        r[d - 1] = arguments[d];
      return u(t).reduce((f, i, l) => {
        const s = Object.entries(i).reduce((n, a) => {
          let [c, m] = a;
          const v = e[c] || {}, h = Object.entries(v).reduce((_, b) => {
            let [y, g] = b;
            const T = er(g).call(this, m, i, l, ...r), w = uo(T);
            if (_.$data[y] = T, _.$data.$invalid = !w || !!_.$data.$invalid, _.$data.$error = _.$data.$invalid, !w) {
              let M = g.$message || "";
              const k = g.$params || {};
              typeof M == "function" && (M = M({
                $pending: !1,
                $invalid: !w,
                $params: k,
                $model: m,
                $response: T
              })), _.$errors.push({
                $property: c,
                $message: M,
                $params: k,
                $response: T,
                $model: m,
                $pending: !1,
                $validator: y
              });
            }
            return {
              $valid: _.$valid && w,
              $data: _.$data,
              $errors: _.$errors
            };
          }, {
            $valid: !0,
            $data: {},
            $errors: []
          });
          return n.$data[c] = h.$data, n.$errors[c] = h.$errors, {
            $valid: n.$valid && h.$valid,
            $data: n.$data,
            $errors: n.$errors
          };
        }, {
          $valid: !0,
          $data: {},
          $errors: {}
        });
        return {
          $valid: f.$valid && s.$valid,
          $data: f.$data.concat(s.$data),
          $errors: f.$errors.concat(s.$errors)
        };
      }, {
        $valid: !0,
        $data: [],
        $errors: []
      });
    },
    $message: (t) => {
      let {
        $response: o
      } = t;
      return o ? o.$errors.map((r) => Object.values(r).map((d) => d.map((f) => f.$message)).reduce((d, f) => d.concat(f), [])) : [];
    }
  };
}
const pt = (e) => {
  if (e = u(e), Array.isArray(e)) return !!e.length;
  if (e == null)
    return !1;
  if (e === !1)
    return !0;
  if (e instanceof Date)
    return !isNaN(e.getTime());
  if (typeof e == "object") {
    for (let t in e) return !0;
    return !1;
  }
  return !!String(e).length;
}, tr = (e) => (e = u(e), Array.isArray(e) ? e.length : typeof e == "object" ? Object.keys(e).length : String(e).length);
function bt() {
  for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++)
    t[o] = arguments[o];
  return (r) => (r = u(r), !pt(r) || t.every((d) => (d.lastIndex = 0, d.test(r))));
}
var j = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  forEach: Yu,
  len: tr,
  normalizeValidatorObject: vo,
  regex: bt,
  req: pt,
  unwrap: u,
  unwrapNormalizedValidator: er,
  unwrapValidatorResponse: uo,
  withAsync: Hu,
  withMessage: Du,
  withParams: qu
});
bt(/^[a-zA-Z]*$/);
bt(/^[a-zA-Z0-9]*$/);
bt(/^\d*(\.\d+)?$/);
const Zu = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var Wu = bt(Zu), nr = {
  $validator: Wu,
  $message: "Value is not a valid email address",
  $params: {
    type: "email"
  }
};
function Ku(e) {
  return (t) => !pt(t) || tr(t) <= u(e);
}
function Vt(e) {
  return {
    $validator: Ku(e),
    $message: (t) => {
      let {
        $params: o
      } = t;
      return `The maximum length allowed is ${o.max}`;
    },
    $params: {
      max: e,
      type: "maxLength"
    }
  };
}
function Qu(e) {
  return (t) => !pt(t) || tr(t) >= u(e);
}
function Ft(e) {
  return {
    $validator: Qu(e),
    $message: (t) => {
      let {
        $params: o
      } = t;
      return `This field should be at least ${o.min} characters long`;
    },
    $params: {
      min: e,
      type: "minLength"
    }
  };
}
function Xu(e) {
  return typeof e == "string" && (e = e.trim()), pt(e);
}
var he = {
  $validator: Xu,
  $message: "Value is required",
  $params: {
    type: "required"
  }
};
const Gr = (e, t) => e ? pt(typeof t == "string" ? t.trim() : t) : !0;
function Ju(e) {
  return function(t, o) {
    if (typeof e != "function")
      return Gr(u(e), t);
    const r = e.call(this, t, o);
    return Gr(r, t);
  };
}
function de(e) {
  return {
    $validator: Ju(e),
    $message: "The value is required",
    $params: {
      type: "requiredIf",
      prop: e
    }
  };
}
function ed(e) {
  return (t) => u(t) === u(e);
}
function ho(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "other";
  return {
    $validator: ed(e),
    $message: (o) => `The value must be equal to the ${t} value`,
    $params: {
      equalTo: e,
      otherName: t,
      type: "sameAs"
    }
  };
}
const td = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
bt(td);
function nd(e) {
  return function(t, o) {
    if (!pt(t)) return !0;
    const r = er(e).call(this, t, o);
    return Gu(r) ? r.then((d) => !uo(d)) : !uo(r);
  };
}
function od(e) {
  return {
    $validator: nd(e),
    $message: "The value does not match the provided validator",
    $params: {
      type: "not"
    }
  };
}
function rd(e) {
  return (t) => !pt(t) || (!/\s/.test(t) || t instanceof Date) && +t >= +u(e);
}
function id(e) {
  return {
    $validator: rd(e),
    $message: (t) => {
      let {
        $params: o
      } = t;
      return `The minimum value allowed is ${o.min}`;
    },
    $params: {
      min: e,
      type: "minValue"
    }
  };
}
function ad(e) {
  return (t) => !pt(t) || (!/\s/.test(t) || t instanceof Date) && +t <= +u(e);
}
var sd = (e) => ({
  $validator: ad(e),
  $message: (t) => {
    let {
      $params: o
    } = t;
    return `The maximum value allowed is ${o.max}`;
  },
  $params: {
    max: e,
    type: "maxValue"
  }
});
bt(/(^[0-9]*$)|(^-[0-9]+$)/);
bt(/^[-]?\d*(\.\d+)?$/);
function ld(e) {
  const { t } = H();
  return F(() => ({
    idDocumentImage: {
      required: j.withMessage(t("GlobalErrors.FileAdd"), () => e.idDocumentImage.length > 0)
    }
  }));
}
function ud(e) {
  const t = Q("commClient"), o = be(ld(e), F(() => e), { $autoDirty: !0 });
  async function r() {
    return o.value.$touch(), await o.value.$validate();
  }
  async function d() {
    return new Promise(async (f) => {
      let i = e.idDocumentImage.map((s) => s.FileId).join(";");
      await r() && (await t.executeMethodAsync("GetRekonoRedirectString", {
        IdentificationId: e.identificationId,
        ImageFileId: i
      }).then(async (s) => {
        if (s) {
          s.Success && (window.location.href = s.RedirectUrl), f(s.Success);
          return;
        }
      }), f(!1));
    });
  }
  return {
    v$: o,
    RekonoNextStep: d
  };
}
const cn = "data:image/svg+xml;base64,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", dd = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12%204L4%2012'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M4%204L12%2012'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", cd = { class: "file-upload" }, md = { class: "d-flex align-center" }, fd = ["accept"], pd = {
  key: 0,
  class: "file-upload__no-file-text"
}, vd = { class: "loader-small" }, hd = {
  key: 0,
  class: "file-upload__files"
}, yd = ["onClick"], _d = {
  key: 0,
  class: "v-input__details"
}, gd = { class: "v-messages" }, bd = { class: "v-messages__message" }, Cd = {
  key: 1,
  class: "v-input__details"
}, Id = { class: "v-messages" }, Ed = { class: "v-messages__message" }, Sd = {
  key: 2,
  class: "v-input__details"
}, Pd = { class: "v-messages" }, Td = { class: "v-messages__message" }, yo = /* @__PURE__ */ ie({
  __name: "FileUpload",
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    uploadMethod: {
      type: String,
      default: null
    },
    uploadMethodParams: {
      type: Object,
      default: {}
    },
    extensions: {
      type: [String, Array],
      default: ".pdf,.jpg,.jpeg,.png"
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorText: {
      type: Object,
      default: []
    },
    infoText: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const o = Q("commClient"), { t: r } = H(), d = e, f = t, i = re(null);
    var l = re(!1);
    let s = re(!1), n = re("");
    const a = F(() => Array.isArray(d.extensions) ? d.extensions.join(",") : d.extensions);
    function c() {
      i.value.value = "", i.value.click(), s.value = !1;
    }
    function m(_) {
      l.value = !1, _.Success === !0 ? f("update:modelValue", [...d.modelValue, ..._.FileData]) : (s.value = !0, n.value = _.ErrorMsg ? r("form_upload." + _.ErrorMsg) : r("form_upload.error_uploading"));
    }
    function v(_) {
      _.target.files.length > 0 && (l.value = !0, o.executeMethodUpload(_.target.files, m, d.uploadMethod, d.uploadMethodParams));
    }
    async function h(_, b) {
      await o.executeMethodAsync("fw4.DeleteFile", {
        FileId: _
      }).then(async (y) => {
        if (y.Success == !0) {
          let g = JSON.parse(JSON.stringify(d.modelValue));
          g.splice(b, 1), f("update:modelValue", g);
        }
      });
    }
    return (_, b) => {
      const y = V("v-btn");
      return S(), N("div", {
        class: Le(e.error ? "v-input--error" : "")
      }, [
        p("div", cd, [
          p("div", md, [
            p("div", null, [
              p("input", {
                type: "file",
                ref_key: "fileUpload",
                ref: i,
                style: { display: "none" },
                accept: a.value,
                multiple: "",
                onChange: v
              }, null, 40, fd),
              C(y, {
                onClick: Wa(c, ["stop"]),
                disabled: u(l),
                flat: "",
                class: "btn btn--default-fill btn--sm mr-4"
              }, {
                default: P(() => b[0] || (b[0] = [
                  ne(" Prebrskaj ")
                ])),
                _: 1
              }, 8, ["disabled"])
            ]),
            e.modelValue != null ? He((S(), N("div", pd, " Ni izbranih datotek. ", 512)), [
              [Ye, e.modelValue.length == 0 && u(l) == !1]
            ]) : x("", !0),
            He(p("div", vd, b[1] || (b[1] = [
              p("img", {
                src: cn,
                alt: "Loader"
              }, null, -1),
              p("div", null, "Nalagam", -1)
            ]), 512), [
              [Ye, u(l)]
            ])
          ]),
          e.modelValue != null && e.modelValue.length ? (S(), N("div", hd, [
            (S(!0), N(je, null, Mt(e.modelValue, (g, I) => (S(), N("div", null, [
              C(y, {
                class: "file-upload__file btn btn--default-outline btn--sm",
                flat: ""
              }, {
                default: P(() => [
                  ne(E(g.FileName) + " ", 1),
                  p("img", {
                    onClick: (T) => h(g.FileId, I),
                    class: "file-upload__icon-delete",
                    src: dd
                  }, null, 8, yd)
                ]),
                _: 2
              }, 1024)
            ]))), 256))
          ])) : x("", !0)
        ]),
        e.error ? (S(), N("div", _d, [
          p("div", gd, [
            p("div", bd, E(e.errorText[0].$message), 1)
          ])
        ])) : u(s) ? (S(), N("div", Cd, [
          p("div", Id, [
            p("div", Ed, E(u(n)), 1)
          ])
        ])) : e.infoText != "" && !e.error ? (S(), N("div", Sd, [
          p("div", Pd, [
            p("div", Td, E(e.infoText), 1)
          ])
        ])) : x("", !0)
      ], 2);
    };
  }
}), wd = {
  class: "rekono-identification-start-component",
  ref: "rootRef"
}, kd = { class: "form-label" }, Nd = { class: "d-flex justify-space-between align-end my-8 my-md-14" }, lb = /* @__PURE__ */ ie({
  __name: "rekono-identification-start-component",
  props: {
    data: { default: () => ({
      ...Nu
    }) }
  },
  emits: ["update:data", "navigation-event", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = o;
    let f = re(!1);
    const i = e, l = W({ ...i.data }), { v$: s, RekonoNextStep: n } = ud(l);
    return G(
      () => i.data,
      // Watch for changes in the data
      (a) => {
        Object.assign(l, a);
      },
      { deep: !0 }
    ), G(l, async (a) => {
      d("update:data", a);
    }, { deep: !0 }), me(async () => {
      f.value = !0, d("componentReady");
    }), t({
      componentReady: f
    }), (a, c) => {
      const m = V("v-col"), v = V("v-row"), h = V("v-btn");
      return S(), N("div", wd, [
        C(v, null, {
          default: P(() => [
            C(m, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", kd, E(u(r)("Components.RekonoIdentificationStart.FileUpload")), 1),
                C(yo, {
                  modelValue: l.idDocumentImage,
                  "onUpdate:modelValue": c[0] || (c[0] = (_) => l.idDocumentImage = _),
                  error: u(s).idDocumentImage.$error,
                  errorText: u(s).idDocumentImage.$errors[0] != null ? u(s).idDocumentImage.$errors : [],
                  extensions: ".jpg,.jpeg,.png",
                  infoText: a.$t("Components.RekonoIdentificationStart.Files")
                }, null, 8, ["modelValue", "error", "errorText", "infoText"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        p("div", Nd, [
          C(h, {
            class: "btn btn--primary-fill",
            onClick: c[1] || (c[1] = (_) => u(n)())
          }, {
            default: P(() => c[2] || (c[2] = [
              ne("Nadaljuj")
            ])),
            _: 1
          })
        ])
      ], 512);
    };
  }
}), Ad = {
  identificationPlace: void 0,
  collectionPoint: void 0,
  identificationAddress: "",
  identificationPostalCode: void 0,
  flowType: void 0,
  hasPersonalPickUp: !1,
  hasHomeDelivery: !1,
  isIdentified: !1,
  collectionPointLocked: !1,
  isExistingUser: !1,
  prefilledData: !1
};
function Md(e) {
  const { t } = H();
  return F(() => ({
    identificationPlace: {
      required: j.withMessage(t("GlobalErrors.CHOICE_REQUIRED"), () => e.isIdentified === !1 && e.identificationPlace != null || e.isIdentified === !0)
    },
    identificationAddress: {
      required: j.withMessage(t("GlobalErrors.FIELD_REQUIRED"), de(() => e.identificationPlace == yt.drugi))
    },
    identificationPostalCode: {
      required: j.withMessage(t("GlobalErrors.CHOICE_REQUIRED"), de(() => e.identificationPlace == yt.drugi))
    },
    collectionPoint: {
      customRequired: j.withMessage(t("GlobalErrors.CHOICE_REQUIRED"), de(
        e.isIdentified == !1 && e.collectionPoint == null && e.flowType != R.SKLENI_SAM && e.flowType != R.LIMIT && e.hasHomeDelivery && e.hasPersonalPickUp
      ))
    }
  }));
}
function Od(e) {
  const { scrollToFirstError: t } = Ie(), o = be(Md(e), F(() => e), { $autoDirty: !0 });
  async function r() {
    return o.value.$touch(), o.value.$validate();
  }
  function d() {
    e.identificationAddress = "", e.identificationPostalCode = void 0, e.collectionPoint == lt.prevzemTrgovec ? e.identificationPlace = yt.trgovec : e.collectionPoint == lt.dostava && (e.identificationPlace = void 0);
  }
  const f = F(() => ![
    e.flowType !== R.SKLENI_SAM,
    R.LIMIT
  ].includes(e.flowType));
  function i() {
    t(".identification-place-component");
  }
  async function l(s) {
    let n = !1, a = null;
    switch (s) {
      case "validate":
        n = await r(), n && (a = { name: "valid" });
        break;
    }
    return a;
  }
  return {
    v$: o,
    ClearOptions: d,
    navigationAction: l,
    scrollToFirstErrorWrapper: i,
    showCollectionPoint: f
  };
}
const Pe = /* @__PURE__ */ ie({
  __name: "TextInputUppercase",
  props: {
    notPrefilled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e) {
    return (t, o) => {
      const r = V("v-text-field");
      return S(), K(r, {
        class: Le([e.notPrefilled ? "v-input--warning" : null]),
        "onUpdate:modelValue": o[0] || (o[0] = (d) => t.$emit("update:modelValue", d.toString().toUpperCase()))
      }, null, 8, ["class"]);
    };
  }
}), Rd = {
  class: "identification-place-component",
  ref: "rootRef"
}, $d = { key: 0 }, xd = { class: "section-heading mb-4" }, Ld = { class: "section-heading__text" }, Vd = { key: 0 }, Fd = { class: "form-label" }, jd = {
  key: 0,
  class: "form-label"
}, zd = { key: 1 }, Ud = {
  key: 2,
  class: "mb-6"
}, Bd = { key: 0 }, Gd = { class: "form-label" }, qd = { class: "form-label" }, ub = /* @__PURE__ */ ie({
  __name: "identification-place-component",
  props: {
    data: { default: () => ({
      ...Ad
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o, i = W({ ...d.data });
    let l = re(!1);
    const { v$: s, ClearOptions: n, navigationAction: a, scrollToFirstErrorWrapper: c, showCollectionPoint: m } = Od(i);
    return G(
      () => d.data,
      // Watch for changes in the data
      (v) => {
        Object.assign(i, v);
      },
      { deep: !0 }
    ), G(
      i,
      (v) => {
        f("update:data", v);
      },
      { deep: !0 }
    ), me(async () => {
      l.value = !0, f("componentReady");
    }), t({
      navigationAction: a,
      scrollToFirstErrorWrapper: c,
      componentReady: l
    }), (v, h) => {
      const _ = V("v-radio"), b = V("v-radio-group"), y = V("v-col"), g = V("v-row"), I = V("v-autocomplete");
      return S(), N("div", Rd, [
        i.isIdentified === !1 ? (S(), N("div", $d, [
          p("h2", xd, E(u(r)("Components.IdentificationPlaceComponent.Title")), 1),
          p("div", Ld, E(i.flowType !== u(R).LIMIT ? u(r)("Components.IdentificationPlaceComponent.Info") : u(r)("Components.IdentificationPlaceComponent.InfoLimit")), 1),
          C(g, null, {
            default: P(() => [
              u(m) ? (S(), K(y, {
                key: 0,
                class: "v-col-12 v-col-md-6"
              }, {
                default: P(() => [
                  i.hasHomeDelivery && i.hasPersonalPickUp ? (S(), N("div", Vd, [
                    p("label", Fd, E(u(r)("Components.IdentificationPlaceComponent.CollectionPoint")), 1),
                    C(b, {
                      modelValue: i.collectionPoint,
                      "onUpdate:modelValue": [
                        h[0] || (h[0] = (T) => i.collectionPoint = T),
                        h[1] || (h[1] = (T) => u(n)())
                      ],
                      error: u(s).collectionPoint.error,
                      "error-messages": u(s).collectionPoint.$errors[0] != null ? u(s).collectionPoint.$errors[0].$message : "",
                      onFocus: u(s).collectionPoint.$reset,
                      hint: "Izberite Da, če ste pri naročilu izbrali dostavo na dom ali drug naslov.",
                      "persistent-hint": "",
                      disabled: i.collectionPointLocked
                    }, {
                      default: P(() => [
                        i.hasHomeDelivery ? (S(), K(_, {
                          key: 0,
                          label: "Da",
                          value: u(lt).dostava
                        }, null, 8, ["value"])) : x("", !0),
                        i.hasPersonalPickUp ? (S(), K(_, {
                          key: 1,
                          label: "Ne, naročilo bom prevzel pri trgovcu",
                          value: u(lt).prevzemTrgovec
                        }, null, 8, ["value"])) : x("", !0)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "error", "error-messages", "onFocus", "disabled"])
                  ])) : x("", !0)
                ]),
                _: 1
              })) : x("", !0),
              C(y, { class: "v-col-12 v-col-md-6" }, {
                default: P(() => [
                  i.flowType === u(R).SKLENI_SAM || i.isIdentified == !1 && i.collectionPoint == u(lt).dostava || i.isIdentified == !1 && i.collectionPoint == u(lt).prevzemTrgovec ? (S(), N("label", jd, E(u(r)("Components.IdentificationPlaceComponent.IdentificationPlace")), 1)) : x("", !0),
                  i.flowType === u(R).SKLENI_SAM || i.isIdentified == !1 && i.collectionPoint == u(lt).dostava || i.flowType === u(R).LIMIT ? (S(), N("div", zd, [
                    C(b, {
                      modelValue: i.identificationPlace,
                      "onUpdate:modelValue": h[2] || (h[2] = (T) => i.identificationPlace = T),
                      error: u(s).identificationPlace.error,
                      "error-messages": u(s).identificationPlace.$errors[0] != null ? u(s).identificationPlace.$errors[0].$message : "",
                      onFocus: u(s).identificationPlace.$reset,
                      class: Le([
                        (i.isExistingUser || i.prefilledData) && i.identificationPlace == null && u(s).identificationPlace.$dirty ? "v-input--error" : null
                      ])
                    }, {
                      default: P(() => [
                        C(_, {
                          label: u(r)("Components.IdentificationPlaceComponent.Petrol"),
                          value: u(yt).petrol
                        }, null, 8, ["label", "value"]),
                        C(_, {
                          label: u(r)("Components.IdentificationPlaceComponent.PostaSlovenije"),
                          value: u(yt).posta
                        }, null, 8, ["label", "value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "error", "error-messages", "onFocus", "class"])
                  ])) : x("", !0),
                  i.flowType !== u(R).SKLENI_SAM && i.isIdentified == !1 && i.collectionPoint == u(lt).prevzemTrgovec ? (S(), N("div", Ud, [
                    C(b, {
                      modelValue: i.identificationPlace,
                      "onUpdate:modelValue": h[3] || (h[3] = (T) => i.identificationPlace = T)
                    }, {
                      default: P(() => [
                        C(_, {
                          disabled: !0,
                          label: u(r)("Components.IdentificationPlaceComponent.OnlyAtMerchant"),
                          value: u(yt).trgovec
                        }, null, 8, ["label", "value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])) : x("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          i.identificationPlace == u(yt).drugi ? (S(), N("div", Bd, [
            C(g, null, {
              default: P(() => [
                C(y, { class: "v-col-12 v-col-md-6" }, {
                  default: P(() => [
                    p("label", Gd, E(u(r)("Components.IdentificationPlaceComponent.IdentificationAddress")), 1),
                    C(Pe, {
                      ref: "identificationAddressRef",
                      modelValue: i.identificationAddress,
                      "onUpdate:modelValue": h[4] || (h[4] = (T) => i.identificationAddress = T),
                      "error-messages": u(s).identificationAddress.$errors[0] != null ? u(s).identificationAddress.$errors[0].$message : "",
                      onFocus: u(s).identificationAddress.$reset,
                      variant: "outlined"
                    }, null, 8, ["modelValue", "error-messages", "onFocus"])
                  ]),
                  _: 1
                }),
                C(y, { class: "v-col-12 v-col-md-6" }, {
                  default: P(() => [
                    p("label", qd, E(u(r)("Components.IdentificationPlaceComponent.IdentificationPostalCode")), 1),
                    C(I, {
                      modelValue: i.identificationPostalCode,
                      "onUpdate:modelValue": h[5] || (h[5] = (T) => i.identificationPostalCode = T),
                      "error-messages": u(s).identificationPostalCode.$errors[0] != null ? u(s).identificationPostalCode.$errors[0].$message : "",
                      onFocus: u(s).identificationPostalCode.$reset,
                      "item-title": "Value",
                      "item-value": "Key",
                      variant: "outlined"
                    }, null, 8, ["modelValue", "error-messages", "onFocus"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])) : x("", !0)
        ])) : x("", !0)
      ], 512);
    };
  }
}), qr = {
  identificationCode: "",
  operaterId: "",
  identificationLoaded: !1,
  DavcnaSt: "",
  Telefon: "",
  Email: "",
  Ime: "",
  Priimek: "",
  RojstniDatum: null,
  Naslov: "",
  Kraj: "",
  Drzavljanstvo: "",
  VrstaOsDok: "",
  IzdajateljDok: "",
  DatumIzdajeDok: null,
  DatumZapadlostiDok: null,
  documentNumber: "",
  confirmations: {
    Ime: void 0,
    Priimek: void 0,
    RojstniDatum: void 0,
    Naslov: void 0,
    Kraj: void 0,
    Drzavljanstvo: void 0,
    VrstaOsDok: void 0,
    IzdajateljDok: void 0,
    DatumIzdajeDok: void 0,
    DatumZapadlostiDok: void 0
  }
}, Dd = {
  isIdentificationError: !1,
  isLoadingIdentificationData: !1,
  identificationDataError: "",
  isProcessingIdentification: !1,
  identificationError: "",
  showPodpisUrl: !1,
  podpisUrl: "",
  identificationSuccess: !1
};
function Hd(e, t) {
  const { t: o } = H();
  return F(() => ({
    identificationCode: {
      required: j.withMessage(o("GlobalErrors.FieldRequired"), he),
      minLength: j.withMessage(o("GlobalErrors.MinLength", { value: "6" }), Ft(6)),
      maxLength: j.withMessage(o("GlobalErrors.MaxLength", { value: "6" }), Vt(6)),
      numeric: j.withMessage(
        o("GlobalErrors.InvalidValue"),
        (r) => /^\d+$/.test(r || "")
      )
    },
    documentNumber: {
      required: j.withMessage(
        o("GlobalErrors.FieldRequired"),
        (r) => r.trim().length > 0
      )
    },
    confirmations: {
      allSelected: j.withMessage(
        o("Components.PostIdentification.AllFieldsMustBeSelected"),
        () => Object.values(e.confirmations).every((r) => r !== void 0)
      )
    }
  }));
}
function Yd(e, t, o) {
  const { t: r } = H(), d = Q("commClient");
  Q("generalStore");
  const f = be(Hd(e), F(() => e), { $autoDirty: !0 });
  async function i() {
    return f.value.$touch(), await f.value.$validate(), f.value.identificationCode.$invalid || f.value.documentNumber.$invalid ? Promise.resolve(!1) : (t.isLoadingIdentificationData = !0, t.identificationDataError = "", new Promise((a) => {
      d.executeMethodAsync("PostIdentificationDataGet", {
        IdentificationCode: e.identificationCode,
        DocumentNumber: e.documentNumber
      }).then((c) => {
        c && c.Success > 0 ? (e.DavcnaSt = c.DavcnaSt || "", e.Telefon = c.Telefon || "", e.Email = c.Email || "", e.Ime = c.Ime || "", e.Priimek = c.Priimek || "", e.RojstniDatum = c.RojstniDatum ? new Date(c.RojstniDatum) : null, e.Naslov = c.Naslov || "", e.Kraj = c.Kraj || "", e.Drzavljanstvo = c.Drzavljanstvo || "", e.VrstaOsDok = c.VrstaOsDok || "", e.IzdajateljDok = c.IzdajateljDok || "", e.DatumIzdajeDok = c.DatumIzdajeDok ? new Date(c.DatumIzdajeDok) : null, e.DatumZapadlostiDok = c.DatumZapadlostiDok ? new Date(c.DatumZapadlostiDok) : null, Object.keys(e.confirmations).forEach((m) => {
          e.confirmations[m] = void 0;
        }), e.identificationLoaded = !0, t.isLoadingIdentificationData = !1, a(!0)) : c.Success === 0 ? (t.identificationDataError = r("Components.PostIdentification.DataNotFound"), e.identificationLoaded = !1, t.isLoadingIdentificationData = !1, a(!1)) : (t.identificationDataError = r("Components.PostIdentification.AccessDenied"), e.identificationLoaded = !1, t.isLoadingIdentificationData = !1, a(!1));
      }).catch(() => {
        t.identificationDataError = r("GlobalErrors.RequestFailed"), e.identificationLoaded = !1, t.isLoadingIdentificationData = !1, a(!1);
      });
    }));
  }
  async function l() {
    var a;
    return f.value.$touch(), await f.value.$validate(), f.value.confirmations.$invalid ? (t.identificationError = ((a = f.value.confirmations.$errors[0]) == null ? void 0 : a.$message) || r("Components.PostIdentification.AllFieldsMustBeSelected"), Promise.resolve(!1)) : (t.isProcessingIdentification = !0, t.identificationError = "", new Promise(async (c) => {
      const m = await d.executeMethodAsync("PostIdentification", {
        IdentificationCode: e.identificationCode,
        DocumentNumber: e.documentNumber,
        Confirmations: JSON.stringify(e.confirmations)
      });
      if (m && m.Success > 0) {
        t.identificationSuccess = !0, t.showPodpisUrl = !0, t.podpisUrl = "/StaticLoaders/upload_wait.html";
        const v = await d.executeMethodAsync("UploadVlogaForIdentificationOnly", {
          IdentificationCode: e.identificationCode,
          OperaterId: e.operaterId,
          IdentificationPlace: "POSTA",
          Ime: e.Ime,
          Priimek: e.Priimek,
          DavcnaSt: e.DavcnaSt,
          Telefon: e.Telefon,
          Ulica: e.Naslov,
          Posta: e.Kraj,
          DatumRojstva: e.RojstniDatum,
          VrstaOsDok: e.VrstaOsDok,
          StOsDok: e.documentNumber,
          IzdajateljOsDok: e.IzdajateljDok,
          DatumIzdajeOsDok: e.DatumIzdajeDok,
          DatumVeljavnostiOsDok: e.DatumZapadlostiDok,
          Drzava: e.Drzavljanstvo,
          Email: e.Email
        });
        v && v.Success && v.Url ? t.podpisUrl = v.Url : t.showPodpisUrl = !1, t.isProcessingIdentification = !1, c(!0);
      } else
        o("navigationEvent", "endFail"), t.isProcessingIdentification = !1, c(!1);
    }));
  }
  function s(a) {
    return a ? new Intl.DateTimeFormat("sl-SI", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).format(new Date(a)) : "";
  }
  async function n(a) {
    if (a && a[0] && a[0].CallbackType == "SIGN" && a[0].Success)
      switch (a[0].Type) {
        case "ident":
          a[0].Status == "complete" && (t.showPodpisUrl = !1, o("navigationEvent", "endSuccess"));
          break;
      }
  }
  return {
    v$: f,
    getIdentificationData: i,
    submitIdentification: l,
    formatDate: s,
    signComplete: n
  };
}
const Zd = ["src"], fn = /* @__PURE__ */ ie({
  __name: "document-signer",
  props: {
    url: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, o) => (S(), N("iframe", {
      src: e.url,
      allow: "local-network-access https://app-qa.betrsign.com https://app-test.betrsign.com https://app.betrsign.com"
    }, null, 8, Zd));
  }
}), Oa = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Icon'%3e%3cpath%20id='Vector'%20d='M12%204L4%2012'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20id='Vector_2'%20d='M4%204L12%2012'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e", Wd = { class: "dialog__heading" }, Kd = { class: "dialog__body" }, Qd = /* @__PURE__ */ ie({
  __name: "modal",
  props: {
    display: {
      type: Boolean,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    closeText: {
      type: String,
      default: ""
    },
    acceptText: {
      type: String,
      default: ""
    },
    showCloseXButton: {
      type: Boolean,
      default: !1
    },
    showAcceptButton: {
      type: Boolean,
      default: !0
    },
    showDeclineButton: {
      type: Boolean,
      default: !0
    },
    btnCenter: {
      type: Boolean,
      default: !1
    },
    disabledAccept: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["modalClosed", "accept"],
  setup(e) {
    return (t, o) => {
      const r = V("v-btn"), d = V("v-dialog");
      return S(), K(d, {
        persistent: "",
        modelValue: e.display
      }, {
        default: P(() => [
          e.showCloseXButton ? (S(), K(r, {
            key: 0,
            class: "btn btn--default-fill btn--round btn--sm ml-auto",
            onClick: o[0] || (o[0] = (f) => t.$emit("modalClosed"))
          }, {
            default: P(() => o[3] || (o[3] = [
              p("img", {
                src: Oa,
                alt: "Close"
              }, null, -1)
            ])),
            _: 1
          })) : x("", !0),
          p("div", Wd, E(e.title), 1),
          p("div", Kd, [
            Ka(t.$slots, "default", {}, void 0, !0)
          ]),
          o[4] || (o[4] = p("hr", { class: "hr mb-8" }, null, -1)),
          p("div", {
            class: Le(["dialog__footer", [e.btnCenter ? t.$style.moveCenter : null]])
          }, [
            e.showDeclineButton ? (S(), K(r, {
              key: 0,
              flat: "",
              class: "btn btn--default-fill",
              onClick: o[1] || (o[1] = (f) => t.$emit("modalClosed"))
            }, {
              default: P(() => [
                ne(E(e.closeText), 1)
              ]),
              _: 1
            })) : x("", !0),
            e.showAcceptButton ? (S(), K(r, {
              key: 1,
              flat: "",
              class: "btn btn--primary-fill",
              onClick: o[2] || (o[2] = (f) => t.$emit("accept")),
              disabled: e.disabledAccept
            }, {
              default: P(() => [
                ne(E(e.acceptText), 1)
              ]),
              _: 1
            }, 8, ["disabled"])) : x("", !0)
          ], 2)
        ]),
        _: 3
      }, 8, ["modelValue"]);
    };
  }
}), Xd = "_moveCenter_38vq5_3", Jd = {
  moveCenter: Xd
}, ec = {
  $style: Jd
}, Ct = /* @__PURE__ */ Do(Qd, [["__cssModules", ec], ["__scopeId", "data-v-f755827e"]]), tc = { class: "post-identification-component" }, nc = { key: 0 }, oc = { class: "section-heading mb-2" }, rc = {
  key: 0,
  class: "v-input--error"
}, ic = { class: "v-input__details" }, ac = { class: "v-messages" }, sc = { class: "v-messages__message" }, lc = { class: "section-heading mb-2" }, uc = {
  key: 0,
  class: "notification notification--warning mb-4 mt-6"
}, dc = { class: "d-flex justify-space-between align-end my-8 my-md-14" }, cc = {
  key: 1,
  class: "post-identification-component__data"
}, mc = { class: "section-heading mb-6" }, fc = { class: "card card--white mb-6" }, pc = { class: "v-col" }, vc = { class: "form-label mb-3" }, hc = { class: "post-identification-component__field-value" }, yc = { class: "v-col" }, _c = { class: "form-label" }, gc = { class: "v-col" }, bc = { class: "form-label mb-4" }, Cc = { class: "post-identification-component__field-value" }, Ic = { class: "v-col" }, Ec = { class: "form-label" }, Sc = { class: "v-col" }, Pc = { class: "form-label mb-4" }, Tc = { class: "post-identification-component__field-value" }, wc = { class: "v-col" }, kc = { class: "form-label" }, Nc = { class: "v-col" }, Ac = { class: "form-label mb-4" }, Mc = { class: "post-identification-component__field-value" }, Oc = { class: "v-col" }, Rc = { class: "form-label" }, $c = { class: "v-col" }, xc = { class: "form-label mb-4" }, Lc = { class: "post-identification-component__field-value" }, Vc = { class: "v-col" }, Fc = { class: "form-label" }, jc = { class: "v-col" }, zc = { class: "form-label mb-4" }, Uc = { class: "post-identification-component__field-value" }, Bc = { class: "v-col" }, Gc = { class: "form-label" }, qc = { class: "v-col" }, Dc = { class: "form-label mb-4" }, Hc = { class: "post-identification-component__field-value" }, Yc = { class: "v-col" }, Zc = { class: "form-label" }, Wc = { class: "v-col" }, Kc = { class: "form-label mb-4" }, Qc = { class: "post-identification-component__field-value" }, Xc = { class: "v-col" }, Jc = { class: "form-label" }, em = { class: "v-col" }, tm = { class: "form-label mb-4" }, nm = { class: "post-identification-component__field-value" }, om = { class: "v-col" }, rm = { class: "form-label" }, im = { class: "v-col" }, am = { class: "form-label mb-4" }, sm = { class: "post-identification-component__field-value" }, lm = { class: "v-col" }, um = { class: "form-label" }, dm = {
  key: 0,
  class: "notification notification--warning mb-4"
}, cm = { class: "d-flex justify-space-between align-end my-8 my-md-14" }, mm = {
  key: 2,
  class: "post-identification-component__data"
}, fm = {
  key: 0,
  class: "notification notification--warning mb-4"
}, db = /* @__PURE__ */ ie({
  __name: "post-identification-component",
  props: {
    data: { default: () => ({
      ...qr
    }) }
  },
  emits: ["update:data", "navigationEvent"],
  setup(e, { emit: t }) {
    const { t: o } = H(), r = e, d = W({ ...qr, ...r.data }), f = W({ ...Dd }), i = Q("commClient"), l = t, { v$: s, getIdentificationData: n, submitIdentification: a, formatDate: c, signComplete: m } = Yd(d, f, l);
    return G(() => r.data, (v) => {
      Object.assign(d, v);
    }, { deep: !0 }), G(d, (v) => {
      l("update:data", v);
    }, { deep: !0 }), me(async () => {
      i.OnStreamDataReceived.AddCallback(m);
    }), Lt(() => {
      i.OnStreamDataReceived.RemoveCallback(m);
    }), (v, h) => {
      const _ = V("v-otp-input"), b = V("v-col"), y = V("v-row"), g = V("v-text-field"), I = V("v-btn"), T = V("v-radio"), w = V("v-radio-group");
      return S(), N(je, null, [
        C(Ct, {
          display: f.showPodpisUrl,
          onModalClosed: h[0] || (h[0] = (M) => f.showPodpisUrl = !1),
          showAcceptButton: !1,
          showDeclineButton: !1,
          class: "dialog-preview"
        }, {
          default: P(() => [
            C(fn, {
              url: f.podpisUrl,
              frameBorder: "0"
            }, null, 8, ["url"])
          ]),
          _: 1
        }, 8, ["display"]),
        p("div", tc, [
          d.identificationLoaded ? x("", !0) : (S(), N("div", nc, [
            p("div", null, [
              p("h2", oc, E(u(o)("Components.PostIdentification.EnterIdentificationCode")), 1),
              h[13] || (h[13] = p("div", { class: "section-heading__text" }, "Vnesite identifikacijsko kodo stranke.", -1)),
              C(y, null, {
                default: P(() => [
                  C(b, { class: "v-col-12 v-col-md-6" }, {
                    default: P(() => [
                      p("div", {
                        class: Le(u(s).identificationCode.$errors[0] ? "v-input--error" : "")
                      }, [
                        C(_, {
                          modelValue: d.identificationCode,
                          "onUpdate:modelValue": h[1] || (h[1] = (M) => d.identificationCode = M),
                          length: 6,
                          autofocus: ""
                        }, null, 8, ["modelValue"])
                      ], 2),
                      u(s).identificationCode.$errors[0] ? (S(), N("div", rc, [
                        p("div", ic, [
                          p("div", ac, [
                            p("div", sc, E(u(s).identificationCode.$errors[0].$message), 1)
                          ])
                        ])
                      ])) : x("", !0)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            p("div", null, [
              p("h2", lc, E(u(o)("Components.PostIdentification.DocumentNumber")), 1),
              h[14] || (h[14] = p("div", { class: "section-heading__text" }, "Vnesite številko osebne izkaznice ali potnega lista stranke.", -1)),
              C(y, null, {
                default: P(() => [
                  C(b, { class: "v-col-12 v-col-md-6" }, {
                    default: P(() => [
                      C(g, {
                        modelValue: d.documentNumber,
                        "onUpdate:modelValue": h[2] || (h[2] = (M) => d.documentNumber = M),
                        "error-messages": u(s).documentNumber.$errors[0] != null ? u(s).documentNumber.$errors[0].$message : "",
                        variant: "outlined",
                        onFocus: u(s).documentNumber.$reset
                      }, null, 8, ["modelValue", "error-messages", "onFocus"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            f.identificationDataError ? (S(), N("div", uc, E(f.identificationDataError), 1)) : x("", !0),
            p("div", dc, [
              C(I, {
                onClick: u(n),
                flat: "",
                class: "btn btn--primary-fill"
              }, {
                default: P(() => [
                  ne(E(u(o)("Components.PostIdentification.GetIdentificationData")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])),
          d.identificationLoaded && !f.isIdentificationError ? (S(), N("div", cc, [
            p("h2", mc, E(u(o)("Components.PostIdentification.PleaseConfirmData")), 1),
            p("div", fc, [
              C(y, null, {
                default: P(() => [
                  p("div", pc, [
                    p("label", vc, E(u(o)("Components.PostIdentification.Ime")), 1),
                    p("span", hc, E(d.Ime), 1)
                  ]),
                  p("div", yc, [
                    p("label", _c, E(u(o)("Components.PostIdentification.ConfirmField")), 1),
                    C(w, {
                      modelValue: d.confirmations.Ime,
                      "onUpdate:modelValue": h[3] || (h[3] = (M) => d.confirmations.Ime = M),
                      inline: "",
                      class: "no-input-details"
                    }, {
                      default: P(() => [
                        C(T, {
                          label: u(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        C(T, {
                          label: u(o)("GeneralButtons.No"),
                          value: !1,
                          class: "ml-6"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              h[15] || (h[15] = p("div", { class: "divider-sm divider--horizontal mb-4 mt-5" }, null, -1)),
              C(y, null, {
                default: P(() => [
                  p("div", gc, [
                    p("label", bc, E(u(o)("Components.PostIdentification.Priimek")), 1),
                    p("span", Cc, E(d.Priimek), 1)
                  ]),
                  p("div", Ic, [
                    p("label", Ec, E(u(o)("Components.PostIdentification.ConfirmField")), 1),
                    C(w, {
                      modelValue: d.confirmations.Priimek,
                      "onUpdate:modelValue": h[4] || (h[4] = (M) => d.confirmations.Priimek = M),
                      inline: "",
                      class: "no-input-details"
                    }, {
                      default: P(() => [
                        C(T, {
                          label: u(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        C(T, {
                          label: u(o)("GeneralButtons.No"),
                          value: !1,
                          class: "ml-6"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              h[16] || (h[16] = p("div", { class: "divider-sm divider--horizontal mb-4 mt-5" }, null, -1)),
              C(y, null, {
                default: P(() => [
                  p("div", Sc, [
                    p("label", Pc, E(u(o)("Components.PostIdentification.RojstniDatum")), 1),
                    p("span", Tc, E(u(c)(d.RojstniDatum)), 1)
                  ]),
                  p("div", wc, [
                    p("label", kc, E(u(o)("Components.PostIdentification.ConfirmField")), 1),
                    C(w, {
                      modelValue: d.confirmations.RojstniDatum,
                      "onUpdate:modelValue": h[5] || (h[5] = (M) => d.confirmations.RojstniDatum = M),
                      inline: "",
                      class: "no-input-details"
                    }, {
                      default: P(() => [
                        C(T, {
                          label: u(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        C(T, {
                          label: u(o)("GeneralButtons.No"),
                          value: !1,
                          class: "ml-6"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              h[17] || (h[17] = p("div", { class: "divider-sm divider--horizontal mb-4 mt-5" }, null, -1)),
              C(y, null, {
                default: P(() => [
                  p("div", Nc, [
                    p("label", Ac, E(u(o)("Components.PostIdentification.Naslov")), 1),
                    p("span", Mc, E(d.Naslov), 1)
                  ]),
                  p("div", Oc, [
                    p("label", Rc, E(u(o)("Components.PostIdentification.ConfirmField")), 1),
                    C(w, {
                      modelValue: d.confirmations.Naslov,
                      "onUpdate:modelValue": h[6] || (h[6] = (M) => d.confirmations.Naslov = M),
                      inline: "",
                      class: "no-input-details"
                    }, {
                      default: P(() => [
                        C(T, {
                          label: u(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        C(T, {
                          label: u(o)("GeneralButtons.No"),
                          value: !1,
                          class: "ml-6"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              h[18] || (h[18] = p("div", { class: "divider-sm divider--horizontal mb-4 mt-5" }, null, -1)),
              C(y, null, {
                default: P(() => [
                  p("div", $c, [
                    p("label", xc, E(u(o)("Components.PostIdentification.Kraj")), 1),
                    p("span", Lc, E(d.Kraj), 1)
                  ]),
                  p("div", Vc, [
                    p("label", Fc, E(u(o)("Components.PostIdentification.ConfirmField")), 1),
                    C(w, {
                      modelValue: d.confirmations.Kraj,
                      "onUpdate:modelValue": h[7] || (h[7] = (M) => d.confirmations.Kraj = M),
                      inline: "",
                      class: "no-input-details"
                    }, {
                      default: P(() => [
                        C(T, {
                          label: u(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        C(T, {
                          label: u(o)("GeneralButtons.No"),
                          value: !1,
                          class: "ml-6"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              h[19] || (h[19] = p("div", { class: "divider-sm divider--horizontal mb-4 mt-5" }, null, -1)),
              C(y, null, {
                default: P(() => [
                  p("div", jc, [
                    p("label", zc, E(u(o)("Components.PostIdentification.Drzavljanstvo")), 1),
                    p("span", Uc, E(d.Drzavljanstvo), 1)
                  ]),
                  p("div", Bc, [
                    p("label", Gc, E(u(o)("Components.PostIdentification.ConfirmField")), 1),
                    C(w, {
                      modelValue: d.confirmations.Drzavljanstvo,
                      "onUpdate:modelValue": h[8] || (h[8] = (M) => d.confirmations.Drzavljanstvo = M),
                      inline: "",
                      class: "no-input-details"
                    }, {
                      default: P(() => [
                        C(T, {
                          label: u(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        C(T, {
                          label: u(o)("GeneralButtons.No"),
                          value: !1,
                          class: "ml-6"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              h[20] || (h[20] = p("div", { class: "divider-sm divider--horizontal mb-4 mt-5" }, null, -1)),
              C(y, null, {
                default: P(() => [
                  p("div", qc, [
                    p("label", Dc, E(u(o)("Components.PostIdentification.VrstaOsDok")), 1),
                    p("span", Hc, E(d.VrstaOsDok), 1)
                  ]),
                  p("div", Yc, [
                    p("label", Zc, E(u(o)("Components.PostIdentification.ConfirmField")), 1),
                    C(w, {
                      modelValue: d.confirmations.VrstaOsDok,
                      "onUpdate:modelValue": h[9] || (h[9] = (M) => d.confirmations.VrstaOsDok = M),
                      inline: "",
                      class: "no-input-details"
                    }, {
                      default: P(() => [
                        C(T, {
                          label: u(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        C(T, {
                          label: u(o)("GeneralButtons.No"),
                          value: !1,
                          class: "ml-6"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              h[21] || (h[21] = p("div", { class: "divider-sm divider--horizontal mb-4 mt-5" }, null, -1)),
              C(y, null, {
                default: P(() => [
                  p("div", Wc, [
                    p("label", Kc, E(u(o)("Components.PostIdentification.IzdajateljDok")), 1),
                    p("span", Qc, E(d.IzdajateljDok), 1)
                  ]),
                  p("div", Xc, [
                    p("label", Jc, E(u(o)("Components.PostIdentification.ConfirmField")), 1),
                    C(w, {
                      modelValue: d.confirmations.IzdajateljDok,
                      "onUpdate:modelValue": h[10] || (h[10] = (M) => d.confirmations.IzdajateljDok = M),
                      inline: "",
                      class: "no-input-details"
                    }, {
                      default: P(() => [
                        C(T, {
                          label: u(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        C(T, {
                          label: u(o)("GeneralButtons.No"),
                          value: !1,
                          class: "ml-6"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              h[22] || (h[22] = p("div", { class: "divider-sm divider--horizontal mb-4 mt-5" }, null, -1)),
              C(y, null, {
                default: P(() => [
                  p("div", em, [
                    p("label", tm, E(u(o)("Components.PostIdentification.DatumIzdajeDok")), 1),
                    p("span", nm, E(u(c)(d.DatumIzdajeDok)), 1)
                  ]),
                  p("div", om, [
                    p("label", rm, E(u(o)("Components.PostIdentification.ConfirmField")), 1),
                    C(w, {
                      modelValue: d.confirmations.DatumIzdajeDok,
                      "onUpdate:modelValue": h[11] || (h[11] = (M) => d.confirmations.DatumIzdajeDok = M),
                      inline: "",
                      class: "no-input-details"
                    }, {
                      default: P(() => [
                        C(T, {
                          label: u(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        C(T, {
                          label: u(o)("GeneralButtons.No"),
                          value: !1,
                          class: "ml-6"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              h[23] || (h[23] = p("div", { class: "divider-sm divider--horizontal mb-4 mt-5" }, null, -1)),
              C(y, null, {
                default: P(() => [
                  p("div", im, [
                    p("label", am, E(u(o)("Components.PostIdentification.DatumZapadlostiDok")), 1),
                    p("span", sm, E(u(c)(d.DatumZapadlostiDok)), 1)
                  ]),
                  p("div", lm, [
                    p("label", um, E(u(o)("Components.PostIdentification.ConfirmField")), 1),
                    C(w, {
                      modelValue: d.confirmations.DatumZapadlostiDok,
                      "onUpdate:modelValue": h[12] || (h[12] = (M) => d.confirmations.DatumZapadlostiDok = M),
                      inline: "",
                      class: "no-input-details"
                    }, {
                      default: P(() => [
                        C(T, {
                          label: u(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        C(T, {
                          label: u(o)("GeneralButtons.No"),
                          value: !1,
                          class: "ml-6"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            f.identificationError ? (S(), N("div", dm, E(f.identificationError), 1)) : x("", !0),
            p("div", cm, [
              C(I, {
                onClick: u(a),
                flat: "",
                class: "btn btn--primary-fill"
              }, {
                default: P(() => [
                  ne(E(u(o)("Components.PostIdentification.IdentifyCustomer")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])) : x("", !0),
          d.identificationLoaded && f.isIdentificationError ? (S(), N("div", mm, [
            f.identificationError ? (S(), N("div", fm, E(f.identificationError), 1)) : x("", !0)
          ])) : x("", !0)
        ])
      ], 64);
    };
  }
}), pm = {
  flowType: void 0,
  isViewDataLoading: !1,
  orderToken: "",
  installmentNr: 0,
  msisdn: "",
  isMarketingPreselected: !1,
  repeatPassword: "",
  headerTitle: "",
  headerSubtitle: "",
  HTMLBody: "",
  bindingFiles: [],
  documentationFiles: [],
  calculationId: 0,
  firstname: "",
  surname: "",
  taxNumber: null,
  birthdate: null,
  isMale: !0,
  address: "",
  postalCode: void 0,
  hasTemporaryResidence: !1,
  temporaryCitizen: void 0,
  temporaryPostalCode: void 0,
  temporaryForeignPostalCode: "",
  temporaryAddress: "",
  contractSending: void 0,
  documentationSendType: void 0,
  contractSignatureType: void 0,
  prefix: void 0,
  phoneNumber: null,
  email: "",
  TRR: "",
  birthCity: "",
  personalDocumentType: void 0,
  idNumber: "",
  documentIssuer: "",
  issueDate: null,
  validityDate: null,
  permanentValidity: void 0,
  citizen: void 0,
  employmentType: void 0,
  employerName: "",
  employerAddress: "",
  employerPostCode: "",
  documentNumber: "",
  isPoliticallyExposedPerson: void 0,
  politicalFunction: "",
  pioSourceFunds: "",
  pioFundsStatus: "",
  countrySourceFunds: "",
  countryFundsStatus: "",
  hasSlovenianBankAccount: void 0,
  marketingSummit: !1,
  marketingCreditBroker: !1,
  lastMonthsIncome: void 0,
  lastMonthsIncome2: void 0,
  lastMonthsIncome3: void 0,
  willAttachDocumentation: void 0,
  pogodbaId: 0,
  stPogodbe: "",
  isDocumentationNeeded: !1,
  isPreapproved: !1,
  hasMultipleProducts: !1
}, vm = {
  isDataLoading: !1,
  showPodpis: !1,
  podpisUrl: "",
  podpisId: -1,
  urlList: [],
  productsList: []
};
function hm(e, t, o) {
  const { t: r } = H(), d = Q("commClient"), f = Q("generalStore"), i = `<!-- Success with documentation -->
                                <div>
                                    <div class="notification notification--alert">
                                        <span class="font-weight-600">
                                            Pred izdajo blaga preverite status pogodbe na seznamu pogodb.
                                        </span>
                                    </div>
                                </div>`, l = `<!-- Success without documentation -->
                                <div>
                                    <div class="notification notification--success">
                                        <span class="font-weight-600">
                                            Pogodba je odobrena, stranki lahko izdate blago.
                                        </span>
                                    </div>
                                </div>`;
  async function s() {
    return e.isViewDataLoading = !0, new Promise((y) => {
      var T;
      let g = "";
      e.documentationFiles.length > 0 && (g = e.documentationFiles.map((w) => w.FileId).join(";")), e.bindingFiles.length > 0 && (g.length > 0 && (g += ";"), g += e.bindingFiles.map((w) => w.FileId).join(";"));
      let I = 0;
      e.employmentType == le.Upokojenec ? I = 1 : e.employmentType == le.SP && (I = 2), d.executeMethodAsync("ContractCreate", {
        UploadFiles: g,
        IzracunId: e.calculationId,
        txtIme: e.firstname,
        txtPriimek: e.surname,
        txtDavcnaSt: e.taxNumber,
        DatumRojstvaText: e.birthdate.toLocaleDateString("de-De", { day: "2-digit", month: "2-digit", year: "numeric" }),
        jeMoski: e.isMale,
        txtUlica: e.address,
        ddPosta: e.postalCode,
        zacasenNaslov: e.temporaryAddress,
        zacasnaPosta: e.temporaryPostalCode != null ? e.temporaryPostalCode : "",
        zacasnaDrzava: e.temporaryCitizen != null ? e.temporaryCitizen : -1,
        zacasnaPostaTujina: e.temporaryForeignPostalCode,
        naslovPosiljanje: e.hasTemporaryResidence ? "Z" : "S",
        txtTelefon: ((T = e.prefix) == null ? void 0 : T.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString(),
        txtEmail: e.email,
        txtStTR: e.TRR,
        txtKrajRojstva: e.birthCity,
        ddVrstaOsDok: e.personalDocumentType,
        txtIzdajateljOsDok: e.documentIssuer,
        txtStOsDok: e.idNumber,
        dtDatumIzdajeOsDok: e.issueDate,
        dtDatumVeljavnostiOsDok: e.validityDate == null ? new Date(1753, 1, 1) : e.validityDate,
        ddDrzavljan: e.citizen,
        ddZaposlitevStatus: I,
        txtDelodajalecNaziv: e.employerName,
        txtDelodajalecUlica: e.employerAddress,
        ddDelodajalecPosta: e.employerPostCode,
        txtStRacuna: e.documentNumber,
        chkPIO: e.isPoliticallyExposedPerson,
        txtPIOVsebina: e.politicalFunction,
        txtPIOIzvor: e.pioSourceFunds,
        txtPIOPremozenje: e.pioFundsStatus,
        txtTveganIzvor: e.countrySourceFunds,
        txtTveganPremozenje: e.countryFundsStatus,
        chkTujaBanka: !e.hasSlovenianBankAccount,
        ddSoglasjeSLS: e.marketingSummit == !0 ? 1 : 0,
        ddSoglasjePartner: e.marketingCreditBroker == !0 ? 1 : 0,
        numPlacaPokojnina: e.lastMonthsIncome,
        numPlaca2: e.lastMonthsIncome2 ?? 0,
        numPlaca3: e.lastMonthsIncome3 ?? 0,
        intBlagovnaSkupina: 0
      }).then(async (w) => {
        e.isViewDataLoading = !1, w ? w.Success ? (e.pogodbaId = w.PogodbaId, e.stPogodbe = w.StPogodbe, await m() ? y(!0) : (e.headerSubtitle = "EsignContractUploadFailed", y(!1))) : (e.headerSubtitle = w.ResponseText, y(!1)) : (e.headerSubtitle = "INTERNAL_ERROR", y(!1));
      });
    });
  }
  async function n() {
    return e.isViewDataLoading = !0, new Promise((y) => {
      var I;
      let g = "";
      e.bindingFiles.length > 0 && (g += e.bindingFiles.map((T) => T.FileId).join(";")), d.executeMethodAsync("ContractCreatePreapproved", {
        UploadFiles: g,
        IzracunId: e.calculationId,
        txtDavcnaSt: e.taxNumber,
        txtTelefon: ((I = e.prefix) == null ? void 0 : I.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString(),
        txtStRacuna: e.documentNumber,
        Firstname: e.firstname,
        Surname: e.surname,
        DatumRojstvaText: e.birthdate.toLocaleDateString("de-De", { day: "2-digit", month: "2-digit", year: "numeric" }),
        Address: e.address,
        PostalCode: e.postalCode,
        BirthCity: e.birthCity,
        PersonalDocumentType: e.personalDocumentType,
        DocumentIssuer: e.documentIssuer,
        IdNumber: e.idNumber,
        IssueDate: e.issueDate,
        ValidityDate: e.validityDate == null ? new Date(1753, 1, 1) : e.validityDate,
        Citizen: e.citizen
      }).then(async (T) => {
        e.isViewDataLoading = !1, T ? T.Success ? (e.pogodbaId = T.PogodbaId, e.stPogodbe = T.StPogodbe, await m() ? y(!0) : (e.headerSubtitle = "EsignContractUploadFailed", y(!1))) : (e.headerSubtitle = T.ResponseText, y(!1)) : (e.headerSubtitle = "INTERNAL_ERROR", y(!1));
      });
    });
  }
  async function a() {
    e.isViewDataLoading = !0;
    let y = "ContractSaveWebCredit";
    return e.hasMultipleProducts && (y = "ContractSaveWebCreditMultiProduct"), new Promise((g) => {
      d.executeMethodAsync(y, {
        OrderToken: e.orderToken,
        Installments: e.installmentNr,
        FlowId: e.flowType,
        Firstname: e.firstname,
        Surname: e.surname,
        TaxNumber: e.taxNumber,
        Email: e.email,
        Address: e.address,
        PostalCode: e.postalCode != null ? e.postalCode : "",
        BirthCity: e.birthCity,
        // Birthdate: new Date(componentData.Birthdate!.toLocaleDateString('de-De', { day: "2-digit", month: "2-digit", year: "numeric" })),
        Birthdate: e.birthdate,
        // Sex: componentData.Sex,
        Citizen: e.citizen,
        hasTemporaryResidence: e.hasTemporaryResidence,
        TemporaryAddress: e.temporaryAddress,
        TemporaryPostalCode: e.temporaryPostalCode != null ? e.temporaryPostalCode : "",
        TemporaryForeignPostalCode: e.temporaryForeignPostalCode,
        TemporaryCitizen: e.temporaryCitizen != null ? e.temporaryCitizen : -1,
        PersonalDocumentType: e.personalDocumentType,
        IdNumber: e.idNumber,
        DocumentIssuer: e.documentIssuer,
        IssueDate: new Date(e.issueDate.toString()),
        ValidityDate: e.validityDate == null ? new Date(1753, 1, 1) : new Date(e.validityDate),
        EmploymentType: e.employmentType,
        EmployerName: e.employerName,
        EmployerAddress: e.employerAddress,
        EmployerPostalCode: e.employerPostCode,
        IsPIO: e.isPoliticallyExposedPerson,
        PoliticalFunction: e.politicalFunction,
        PIOSourceFunds: e.pioSourceFunds,
        PIOFundsStatus: e.pioFundsStatus,
        CountryRiskSourceFunds: e.countrySourceFunds,
        CountryRiskFundsStatus: e.countryFundsStatus,
        HasThreeSalaries: !1,
        Salary: e.lastMonthsIncome,
        Salary2: e.lastMonthsIncome2 === void 0 ? 0 : e.lastMonthsIncome2,
        Salary3: e.lastMonthsIncome3 === void 0 ? 0 : e.lastMonthsIncome3,
        Msisdn: e.msisdn,
        TRR: e.TRR,
        uploadDatoteke: "",
        gdprSls: e.marketingSummit == !0 ? 1 : 0,
        gdprSlsPreselected: e.isMarketingPreselected == !0 ? 1 : 0,
        HasSlovenianAccount: e.hasSlovenianBankAccount,
        UserPasswordNew: e.repeatPassword
      }).then(async (I) => {
        e.isViewDataLoading = !1, I ? I.Success ? (e.pogodbaId = I.PogodbaId, e.stPogodbe = I.StPogodbe, await m() ? g(!0) : (e.headerSubtitle = "EsignContractUploadFailed", g(!1))) : (e.headerSubtitle = I.ErrorCode, g(!1)) : (e.headerSubtitle = "INTERNAL_ERROR", g(!1));
      });
    });
  }
  async function c() {
    e.isViewDataLoading = !0;
    let y = "ContractSavePreapprovedWebCredit";
    return e.hasMultipleProducts && (y = "ContractSavePreapprovedWebCreditMultiProduct"), new Promise((g) => {
      d.executeMethodAsync(y, {
        OrderToken: e.orderToken,
        Installments: e.installmentNr,
        FlowId: e.flowType,
        Msisdn: e.msisdn,
        SlovenianCitizen: e.citizen == 204
      }).then(async (I) => {
        e.isViewDataLoading = !1, I ? I.Success ? (e.pogodbaId = I.PogodbaId, e.stPogodbe = I.StPogodbe, await m() ? g(!0) : (e.headerSubtitle = "EsignContractUploadFailed", g(!1))) : (e.headerSubtitle = I.ResponseText, g(!1)) : (e.headerSubtitle = "INTERNAL_ERROR", g(!1));
      });
    });
  }
  async function m() {
    return new Promise((y) => {
      e.isViewDataLoading = !1, t.showPodpis = !0, t.podpisUrl = "/StaticLoaders/upload_wait.html", e.flowType === R.POS ? d.executeMethodAsync("UploadDocuments", {
        //PogodbaId: 140620,
        PogodbaId: e.pogodbaId,
        SendType: e.contractSending == it.Elektronsko ? "EMAIL" : "POSTA",
        chkUseSMS: e.contractSignatureType === qt.SMS
      }).then(async (g) => {
        g && (g.Success ? (t.showPodpis = !0, t.podpisUrl = g.Url, y(!0)) : y(!1));
      }) : e.flowType === R.POS_STRANKA ? d.executeMethodAsync("UploadDocumentsDIY", {
        //PogodbaId: 140620,
        OrderToken: e.orderToken,
        PogodbaId: e.pogodbaId,
        SendType: e.contractSending == it.Elektronsko ? "EMAIL" : "POSTA",
        chkUseSMS: e.contractSignatureType === qt.SMS
      }).then(async (g) => {
        g && (g.Success ? (t.showPodpis = !0, t.podpisUrl = g.Url, y(!0)) : y(!1));
      }) : d.executeMethodAsync("UploadDocumentsForWeb", {
        //PogodbaId: 140620,
        OrderToken: e.orderToken
      }).then(async (g) => {
        g && (g.Success ? (t.showPodpis = !0, t.podpisId = 0, t.urlList = g.Urls, t.productsList = g.Products, t.podpisUrl = g.Urls[t.podpisId], console.log("urllist", JSON.stringify(t.urlList)), y(!0)) : y(!1));
      });
    });
  }
  async function v(y) {
    if (y && y[0] && y[0].CallbackType == "SIGN" && y[0].Success)
      switch (y[0].Type) {
        case "pogodba":
          console.log("start"), y[0].Status == "complete" && (console.log("complete"), t.urlList.length > 1 && t.podpisId < t.urlList.length - 1 ? (console.log("next: " + t.podpisId), t.podpisId++, console.log("next2: " + t.urlList[t.podpisId]), t.podpisUrl = t.urlList[t.podpisId]) : (console.log("end"), t.showPodpis = !1, t.podpisId = -1, t.urlList = [], e.isViewDataLoading = !1, e.flowType === R.POS ? !e.isDocumentationNeeded || e.isPreapproved ? (e.headerTitle = r("EndSuccess.POSPartnerNoDoc.Title"), e.headerSubtitle = r("EndSuccess.POSPartnerNoDoc.Subtitle"), e.HTMLBody = l) : (e.headerTitle = r("EndSuccess.POSPartnerDoc.Title"), e.headerSubtitle = r("EndSuccess.POSPartnerDoc.Subtitle"), e.HTMLBody = i) : (e.headerTitle = r("EndSuccess.WEB.Title"), e.flowType === R.POS_STRANKA ? e.headerSubtitle = r("EndSuccess.WEB.SubtitleSMS") : e.headerSubtitle = r("EndSuccess.WEB.Subtitle")), o("navigationEvent", "endSuccess")));
          break;
      }
  }
  const h = F(() => {
    var y;
    return (y = f.state.countryList) == null ? void 0 : y.find((g) => e.temporaryCitizen === g.Key);
  }), _ = F(() => {
    var y, g;
    return ((g = (y = h.value) == null ? void 0 : y.AdditionalData) == null ? void 0 : g.RiskDrzava) == !0;
  });
  async function b(y) {
    let g = null;
    switch (y) {
      case "createContract":
        if (_.value)
          return e.headerSubtitle = r("EndFail.RiskCountry"), g = { name: "endFail" };
        await s().then((I) => {
          if (!I) {
            g = { name: "endFail" };
            return;
          }
        });
        break;
      case "createContractPreapproved":
        await n().then((I) => {
          if (!I) {
            g = { name: "endFail" };
            return;
          }
        });
        break;
      case "webCreateContract":
        await a().then((I) => {
          if (!I) {
            g = { name: "endFail" };
            return;
          }
        });
        break;
      case "webCreateContractPreapproved":
        await c().then((I) => {
          if (!I) {
            g = { name: "endFail" };
            return;
          }
        });
        break;
    }
    return g;
  }
  return {
    contractCreate: s,
    navigationAction: b,
    signComplete: v
  };
}
const ym = {
  key: 0,
  class: "top-info-bar"
}, cb = /* @__PURE__ */ ie({
  __name: "contract-create-component",
  props: {
    data: { default: () => ({
      ...pm
    }) }
  },
  emits: ["update:data", "navigationEvent"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = W({ ...d.data }), i = Q("commClient"), l = o, s = W({ ...vm }), { navigationAction: n, signComplete: a } = hm(f, s, l);
    return G(
      () => d.data,
      // Watch for changes in the data
      (c) => {
        Object.assign(f, c);
      },
      { deep: !0 }
    ), G(f, async (c) => {
      l("update:data", c);
    }, { deep: !0 }), me(async () => {
      i.OnStreamDataReceived.AddCallback(a);
    }), Lt(() => {
      i.OnStreamDataReceived.RemoveCallback(a);
    }), t({
      navigationAction: n
    }), (c, m) => (S(), K(Ct, {
      display: s.showPodpis,
      onModalClosed: m[0] || (m[0] = (v) => s.showPodpis = !1),
      showAcceptButton: !1,
      showDeclineButton: !1,
      class: "dialog-preview"
    }, {
      default: P(() => [
        s.urlList.length > 1 ? (S(), N("div", ym, "Podpisujete dokumentacijo za " + E(s.productsList[s.podpisId]) + ". (" + E((s.podpisId + 1).toString()) + "/" + E(s.urlList.length.toString()) + ")", 1)) : x("", !0),
        C(fn, {
          url: s.podpisUrl,
          frameBorder: "0"
        }, null, 8, ["url"])
      ]),
      _: 1
    }, 8, ["display"]));
  }
}), _m = {
  orderToken: void 0,
  flowType: void 0,
  firstname: "",
  surname: "",
  taxNumber: null,
  birthdate: null,
  msisdn: "",
  email: "",
  preapprovedCreditAmount: void 0,
  preapprovedCreditType: void 0,
  lastMonthsIncome: void 0,
  lastMonthsIncome2: void 0,
  lastMonthsIncome3: void 0,
  sumInstallmentAmount: void 0,
  documentationFiles: []
}, gm = {
  isDataLoading: !1,
  showPodpis: !1,
  podpisUrl: ""
};
function bm(e, t, o) {
  const { t: r } = H(), d = Q("commClient");
  async function f() {
    return new Promise((s) => {
      t.showPodpis = !0, t.podpisUrl = "/StaticLoaders/upload_wait.html", e.documentationFiles.length > 0 && e.documentationFiles.map((n) => n.FileId).join(";"), d.executeMethodAsync("CreateVlogaPredodobrenoWeb", {
        OrderToken: e.orderToken,
        Ime: e.firstname,
        Priimek: e.surname,
        DavcnaSt: e.taxNumber,
        Telefon: e.msisdn,
        Email: e.email,
        CreditType: e.preapprovedCreditType,
        CreditAmount: e.preapprovedCreditAmount,
        Salary1: e.lastMonthsIncome,
        Salary2: e.lastMonthsIncome2,
        Salary3: e.lastMonthsIncome3,
        SumInstallmentAmount: 0,
        Documentation: JSON.stringify(e.documentationFiles.map((n) => n.FileId))
      }).then(async (n) => {
        n && (console.log("MESSAGE V CreateVlogaPredodobreno: ", JSON.stringify(n)), n.Success && (console.log("MESSAGE success V CreateVlogaPredodobreno: ", JSON.stringify(n)), t.showPodpis = !0, t.podpisUrl = n.Url, d.OnStreamDataReceived.AddCallback(i), s(!0))), s(!1);
      });
    });
  }
  async function i(s) {
    s && s[0] && s[0].Success && s[0].Status == "complete" && (window.dataLayer && (console.log("Pushing GTM data: confirmation_3"), window.dataLayer.push({
      event: "confirmation_3",
      funnel_name: "pred_odobritvijo",
      step: 3,
      step_name: "podpis_pogodbe",
      cta_name: "Podpiši"
    })), t.showPodpis = !1, t.podpisUrl = "", o("navigationEvent", "endSuccess"));
  }
  async function l(s) {
    let n = null;
    switch (console.log("click on " + s), s) {
      case "PreapprovedVloga": {
        await f() || (n = { name: "endFail" });
        break;
      }
      default:
        n = null;
    }
    return Promise.resolve(n);
  }
  return {
    navigationAction: l,
    signComplete: i
  };
}
const mb = /* @__PURE__ */ ie({
  __name: "preapproved-create-component",
  props: {
    data: { default: () => ({
      ..._m
    }) }
  },
  emits: ["update:data", "navigationEvent"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = W({ ...d.data }), i = Q("commClient"), l = o, s = W({ ...gm }), { signComplete: n, navigationAction: a } = bm(f, s, l);
    return G(
      () => d.data,
      // Watch for changes in the data
      (c) => {
        Object.assign(f, c);
      },
      { deep: !0 }
    ), G(f, async (c) => {
      l("update:data", c);
    }, { deep: !0 }), me(async () => {
      i.OnStreamDataReceived.AddCallback(n);
    }), Lt(() => {
      i.OnStreamDataReceived.RemoveCallback(n);
    }), t({
      navigationAction: a
    }), (c, m) => (S(), K(Ct, {
      display: s.showPodpis,
      onModalClosed: m[0] || (m[0] = (v) => s.showPodpis = !1),
      showAcceptButton: !1,
      showDeclineButton: !1,
      class: "dialog-preview"
    }, {
      default: P(() => [
        C(fn, {
          url: s.podpisUrl,
          frameBorder: "0"
        }, null, 8, ["url"])
      ]),
      _: 1
    }, 8, ["display"]));
  }
}), Cm = "data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20overflow='visible'%20style='display:%20block;'%20width='120'%20height='120'%20viewBox='0%200%20120%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='NLB%20pictograms'%20clip-path='url(%23clip0_0_60)'%3e%3cpath%20id='Vector'%20d='M19.5%2031.5H23.3C24.8%2031.5%2026.3%2032.1%2027.3%2033.2L35.6%2041.5C36.9%2042.8%2038.6%2043.5%2040.3%2043.5H50.9C52.1%2043.5%2053.2%2043%2054%2042.2C54.8%2041.4%2055.3%2040.3%2055.3%2039.1C55.3%2037.9%2055.1%2037.6%2054.7%2036.9C54.1%2035.9%2053.1%2035.1%2051.9%2034.8L44.5%2033.1C43.8%2032.9%2043.2%2032.3%2043.2%2031.5V30C43.2%2029.4%2043.5%2028.9%2044%2028.6L47.7%2026.5C48.8%2025.9%2050.1%2025.8%2051.2%2026.2L55.3%2027.8'%20stroke-width='3'%20stroke-linecap='round'%20stroke='%23230078'/%3e%3cpath%20id='Vector_2'%20d='M19.5%2013.5H52.6C54.8%2013.5%2057%2014.4%2058.6%2016L66.5%2023.9C67.1%2024.5%2067.5%2025.4%2067.5%2026.3'%20stroke-width='3'%20stroke-linecap='round'%20stroke='%23230078'/%3e%3cpath%20id='Vector_3'%20d='M19.5%2012.6V32.5C19.5%2033.6046%2018.6046%2034.5%2017.5%2034.5H12.5C11.3954%2034.5%2010.5%2033.6046%2010.5%2032.5L10.5%2012.6C10.5%2011.4954%2011.3954%2010.6%2012.5%2010.6H17.5C18.6046%2010.6%2019.5%2011.4954%2019.5%2012.6Z'%20stroke-width='3'%20stroke-linecap='round'%20stroke='%23230078'/%3e%3cpath%20id='Vector_4'%20d='M43.5%20100.5H76.5C79.8%20100.5%2082.5%20103.2%2082.5%20106.5V109.5H37.5V106.5C37.5%20103.2%2040.2%20100.5%2043.5%20100.5Z'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke='%23230078'/%3e%3cpath%20id='Vector_5'%20d='M45.5%2093H74.5C75.6%2093%2076.5%2093.9%2076.5%2095V99H43.5V95C43.5%2093.9%2044.4%2093%2045.5%2093Z'%20fill='%2384BD00'/%3e%3cpath%20id='Vector_6'%20d='M49.6%2088.5V85.8C49.6%2084.7%2049.2%2083.6%2048.5%2082.8C45.4%2079%2037.6%2066.4%2049.6%2049.6'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke='%23230078'/%3e%3cpath%20id='Vector_7'%20d='M70.5%2088.5V86.9C70.5%2085.1%2071.2%2083.3%2072.5%2082C74.6%2079.9%2074.3%2076.4%2071.9%2074.7L63.7%2068.8C62.5%2067.9%2061.7%2066.5%2061.7%2064.9'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke='%23230078'/%3e%3cpath%20id='Vector_8'%20d='M52.5%2035C56.2%2033.1%2060.3%2032%2064.6%2032C68.9%2032%2075.7%2033.9%2080.2%2037.2'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke='%23230078'/%3e%3cpath%20id='Vector_9'%20d='M42.8%2043.4C38.2%2049.5%2035.3%2057.4%2035.3%2066.2C35.3%2075%2036.6%2077.7%2038.8%2082.5'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke='%23230078'/%3e%3cpath%20id='Vector_10'%20d='M80.2%2037.2L74.9%2042.5'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke='%23230078'/%3e%3cpath%20id='Vector_11'%20d='M46.1%2079L38.8%2082.5'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke='%23230078'/%3e%3cpath%20id='Vector_12'%20d='M67.4%2039.6C78.6%2040.2%2077.3%2051.6%2077.3%2051.6L80.4%2054.7C82.6%2056.9%2082.6%2060.5%2080.4%2062.8L79.9%2063.3C78.6%2064.6%2076.7%2065.4%2074.9%2065.4C73%2065.4%2071.2%2064.6%2069.9%2063.3L66.4%2059.8C61.2%2059.8%2056.9%2055.6%2056.9%2050.3V49.8'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke='%23230078'/%3e%3cg%20id='Vector_13'%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_0_60'%3e%3crect%20width='120'%20height='120'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Im = "data:image/svg+xml,%3csvg%20width='120'%20height='120'%20viewBox='0%200%20120%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_1703_8766)'%3e%3cg%20clip-path='url(%23clip1_1703_8766)'%3e%3cpath%20d='M65.6999%2068.6984L59.9999%2065.4984L54.2999%2068.6984C52.7999%2069.4984%2050.8999%2068.3984%2050.8999%2066.6984V34.3984H68.9999V66.6984C68.9999%2068.3984%2067.0999%2069.4984%2065.5999%2068.6984H65.6999Z'%20fill='%2384BD00'/%3e%3cpath%20d='M99.4999%2033.0009H87.2999C87.7999%2032.4009%2088.2999%2031.8009%2088.6999%2031.1009C90.1999%2028.3009%2090.0999%2025.0009%2088.2999%2022.3009C86.7999%2020.0009%2084.2999%2018.5009%2081.3999%2018.1009C78.4999%2017.7009%2075.5999%2018.6009%2073.4999%2020.6009L59.9999%2033.0009H59.7999L46.2999%2020.6009C44.1999%2018.7009%2041.2999%2017.8009%2038.3999%2018.1009C35.5999%2018.5009%2032.9999%2020.0009%2031.4999%2022.3009C29.6999%2025.0009%2029.5999%2028.3009%2031.0999%2031.1009C31.4999%2031.8009%2031.9999%2032.5009%2032.4999%2033.0009H20.3999C18.8999%2033.0009%2017.5999%2033.6009%2016.4999%2034.6009C15.4999%2035.6009%2014.8999%2037.0009%2014.8999%2038.5009V45.6009C14.8999%2048.6009%2017.3999%2051.1009%2020.3999%2051.1009H20.8999V99.6009C20.8999%20102.601%2023.3999%20105.101%2026.3999%20105.101H93.3999C96.3999%20105.101%2098.8999%20102.601%2098.8999%2099.6009V51.1009H99.3999C102.4%2051.1009%20104.9%2048.6009%20104.9%2045.6009V38.6009C104.9%2035.6009%20102.4%2033.1009%2099.3999%2033.1009L99.4999%2033.0009ZM75.5999%2022.8009C76.7999%2021.7009%2078.4999%2021.0009%2080.1999%2021.0009C81.8999%2021.0009%2080.7999%2021.0009%2081.0999%2021.0009C83.0999%2021.2009%2084.7999%2022.3009%2085.7999%2023.8009C86.9999%2025.6009%2087.0999%2027.7009%2086.0999%2029.5009C84.9999%2031.6009%2082.6999%2032.9009%2080.1999%2032.9009H64.4999L75.5999%2022.7009V22.8009ZM34.0999%2023.9009C35.0999%2022.3009%2036.8999%2021.3009%2038.7999%2021.1009C40.7999%2020.9009%2042.8999%2021.5009%2044.2999%2022.8009L55.3999%2033.0009H39.6999C37.1999%2033.0009%2034.8999%2031.7009%2033.7999%2029.6009C32.7999%2027.7009%2032.8999%2025.7009%2034.0999%2023.9009ZM102%2045.5009C102%2046.9009%20100.9%2048.0009%2099.4999%2048.0009H73.4999C72.6999%2048.0009%2071.9999%2048.7009%2071.9999%2049.5009C71.9999%2050.3009%2072.6999%2051.0009%2073.4999%2051.0009H95.9999V99.5009C95.9999%20100.901%2094.8999%20102.001%2093.4999%20102.001H26.4999C25.0999%20102.001%2023.9999%20100.901%2023.9999%2099.5009V51.0009H46.4999C47.2999%2051.0009%2047.9999%2050.3009%2047.9999%2049.5009C47.9999%2048.7009%2047.2999%2048.0009%2046.4999%2048.0009H20.4999C19.0999%2048.0009%2017.9999%2046.9009%2017.9999%2045.5009V38.4009C17.9999%2037.7009%2018.2999%2037.1009%2018.6999%2036.6009C19.1999%2036.1009%2019.7999%2035.9009%2020.4999%2035.9009H99.4999C100.9%2035.9009%20102%2037.0009%20102%2038.4009V45.4009V45.5009Z'%20fill='%23230078'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1703_8766'%3e%3crect%20width='120'%20height='120'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_1703_8766'%3e%3crect%20width='120'%20height='120'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Em = {
  creditAmount: void 0,
  creditAmountNoDocumentation: void 0,
  creditAmountOnePay: void 0,
  taxNumber: void 0,
  msisdn: void 0,
  email: void 0,
  employmentType: void 0,
  isSlovenianCitizen: void 0,
  hadTRRExecution: void 0,
  hadLatePayment: void 0,
  hadBlockedTRR: void 0,
  hadBankruptcyProceedings: void 0,
  sumInstallments: void 0,
  averageSalary: void 0,
  marketingConsent: void 0,
  birthdate: null,
  hasSlovenianIncome: !1,
  //tuakj
  firstname: "",
  surname: "",
  address: "",
  postalCode: void 0,
  birthCity: "",
  citizen: void 0,
  temporaryAddress: "",
  temporaryPostalCode: void 0,
  temporaryCitizen: void 0,
  temporaryForeignPostalCode: "",
  employerName: "",
  employerAddress: "",
  employerPostCode: "",
  politicalFunction: void 0,
  pioFundsStatus: void 0,
  pioSourceFunds: void 0,
  countryFundsStatus: void 0,
  countrySourceFunds: void 0,
  TRR: "",
  personalDocumentType: void 0,
  idNumber: "",
  documentIssuer: "",
  issueDate: null,
  validityDate: null,
  marketingSummit: void 0,
  orderToken: "",
  reference: "",
  hasPreapprovedType: "B",
  preapprovedAmount: void 0
};
function Sm(e) {
  const t = Q("commClient");
  async function o(d) {
    let f = null;
    switch (d) {
      case "preapprove":
        f = { name: "nextStep" };
        break;
    }
    return f;
  }
  async function r() {
    return new Promise((d) => {
      t.executeMethodAsync("CalculateCreditLimit", {
        TaxNumber: e.taxNumber,
        Msisdn: e.msisdn,
        Email: e.email,
        Employment: e.employmentType,
        IsSlovenianCitizen: e.isSlovenianCitizen,
        HadTRRExecution: e.hadTRRExecution,
        HadLatePayment: e.hadLatePayment,
        HadBlockedTRR: e.hadBlockedTRR,
        HadBankruptcyProceedings: e.hadBankruptcyProceedings,
        SummitCheck: e.marketingConsent,
        IsPartOfContract: !1,
        Firstname: e.firstname,
        Surname: e.surname,
        Birthdate: e.birthdate,
        Address: e.address,
        PostalCode: e.postalCode,
        BirthCity: e.birthCity,
        Citizen: e.citizen,
        TemporaryAddress: e.temporaryAddress,
        TemporaryPostalCode: e.temporaryPostalCode,
        TemporaryCitizen: e.temporaryCitizen,
        TemporaryForeignPostalCode: e.temporaryForeignPostalCode,
        EmploymentType: e.employmentType,
        EmployerName: e.employerName,
        EmployerAddress: e.employerAddress,
        EmployerPostalCode: e.employerPostCode,
        PoliticalFunction: e.politicalFunction,
        PioFundsStatus: e.pioFundsStatus,
        PioSourceFunds: e.pioSourceFunds,
        CountryFundsStatus: e.countryFundsStatus,
        CountrySourceFunds: e.countrySourceFunds,
        TRR: e.TRR,
        PersonalDocumentType: e.personalDocumentType,
        IdNumber: e.idNumber,
        DocumentIssuer: e.documentIssuer,
        IssueDate: e.issueDate,
        ValidityDate: e.validityDate,
        MarketingSummit: e.marketingSummit,
        AverageSalary: e.averageSalary,
        SumInstallments: e.sumInstallments,
        HasSlovenianIncome: e.hasSlovenianIncome,
        OrderToken: e.orderToken
      }).then(async (f) => {
        f && f.Error === "" && f.MaxAvailable >= 100 ? (e.creditAmount = f.MaxAvailable, e.creditAmountNoDocumentation = f.MaxAvailableNoDocumentation, e.creditAmountOnePay = f.MaxAvailableOnePay, e.reference = f.LimitType, e.hasPreapprovedType = f.HasPreapprovedType, e.preapprovedAmount = f.PreapprovedAmount, d("")) : d("endFail");
      });
    });
  }
  return {
    navigationAction: o,
    calculationExecute: r
  };
}
const Pm = { class: "calculation-result-component" }, Tm = { class: "text-center" }, wm = { class: "page-heading__text font-weight-semibold" }, km = { class: "warm-green-100" }, Nm = {
  key: 1,
  class: "callout"
}, Am = { class: "section-heading mt-0" }, Mm = { class: "warm-green-100" }, Om = { class: "font-size-75 indigo-100" }, fb = /* @__PURE__ */ ie({
  __name: "calculation-result-component",
  props: {
    data: { default: () => ({
      ...Em
    }) }
  },
  emits: ["update:data", "navigationEvent", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = W({ ...d.data }), i = o;
    let l = re(!1);
    const { navigationAction: s, calculationExecute: n } = Sm(f);
    return G(
      () => d.data,
      // Watch for changes in the data
      (a) => {
        Object.assign(f, a);
      },
      { deep: !0 }
    ), G(f, async (a) => {
      i("update:data", a);
    }, { deep: !0 }), me(async () => {
      const a = await n();
      l.value = !0, console.log("CalculationResultComponent is ready."), i("componentReady"), console.log("Calculation result:", a), a === "endFail" && i("navigationEvent", "endFail");
    }), t({
      navigationAction: s,
      componentReady: l
    }), (a, c) => {
      var v;
      const m = V("v-btn");
      return S(), N("div", Pm, [
        p("div", Tm, [
          f.reference == null || f.reference === "" || ((v = f.reference) == null ? void 0 : v.toLowerCase()) === "custom" ? (S(), N("div", {
            key: 0,
            class: "callout",
            onClick: c[1] || (c[1] = (h) => i("navigationEvent", "toPreapproved"))
          }, [
            c[5] || (c[5] = p("img", {
              src: Cm,
              alt: ""
            }, null, -1)),
            c[6] || (c[6] = p("div", { class: "section-heading mt-2" }, " Naslednji korak: odobritev limita ", -1)),
            p("div", wm, [
              c[2] || (c[2] = ne(" Vaš informativni limit znaša ")),
              p("span", km, "do " + E(a.$n(f.creditAmount, "decimal")) + " €", 1),
              c[3] || (c[3] = ne("*. "))
            ]),
            c[7] || (c[7] = p("div", { class: "section-heading__text" }, [
              ne("Prikazani znesek je informativne narave. Za potrditev dejanskega limita nadaljujte postopek."),
              p("br"),
              ne(" Odobritev je brezplačna in brez obveznosti. ")
            ], -1)),
            C(m, {
              onClick: c[0] || (c[0] = (h) => i("navigationEvent", "toPreapproved")),
              class: "btn btn--primary-fill mb-4"
            }, {
              default: P(() => c[4] || (c[4] = [
                ne("Nadaljuj")
              ])),
              _: 1
            })
          ])) : (S(), N("div", Nm, [
            c[12] || (c[12] = p("img", {
              src: Im,
              alt: ""
            }, null, -1)),
            p("div", Am, [
              c[8] || (c[8] = ne(" Vaš informativni limit za nakup na obroke z ")),
              c[9] || (c[9] = p("br", null, null, -1)),
              c[10] || (c[10] = ne("NLB Buy&Go znaša ")),
              p("span", Mm, "do " + E(a.$n(f.creditAmount, "decimal")) + " €", 1),
              c[11] || (c[11] = ne("*. "))
            ]),
            c[13] || (c[13] = p("div", { class: "indigo-100 font-size-100 mb-4" }, " Nadaljujete lahko z nakupom na prodajnem mestu. ", -1))
          ])),
          p("div", Om, " * Izračunani limit je informativne narave. Odobritev dejanskega zneska za nakupe na obroke je odvisna od izbrane ročnosti, vpogleda v informacijski sistem za izmenjavo informacij o zadolženosti fizičnih oseb SISBON in odobritve s strani NLB Buy&Go. " + E(f.isSlovenianCitizen ? "" : "Višina limita je določena glede na višino plače in se lahko zviša z največ 5.000 € na največ 8.000 €."), 1)
        ])
      ]);
    };
  }
}), Rm = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19%2012H5'%20stroke='%23230078'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M12%2019L5%2012L12%205'%20stroke='%23230078'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Dr = {
  flowType: void 0,
  creditAmount: void 0,
  creditType: void 0,
  creditAmountTypeInfo: {
    S1: {
      documentationNeeded: !1,
      pay3Needed: !1
    },
    S2: {
      documentationNeeded: !0,
      pay3Needed: !1
    },
    S3: {
      documentationNeeded: !0,
      pay3Needed: !0
    },
    T1: {
      documentationNeeded: !0,
      pay3Needed: !1
    },
    T2: {
      documentationNeeded: !0,
      pay3Needed: !0
    },
    SP1: {
      documentationNeeded: !0,
      pay3Needed: !0
    }
  },
  creditAmountAvailable: [],
  hasSlovenianBankAccount: void 0,
  employmentType: void 0,
  documentationNeeded: !1,
  isViewDataLoading: !1,
  birthdate: null,
  hasSlovenianIncome: !1,
  taxNumber: void 0,
  isSlovenianCitizen: void 0,
  selectedCredit: null,
  averageSalary: void 0,
  sumInstallments: void 0,
  orderToken: ""
}, $m = {
  currentCheckedTaxNumber: void 0,
  ageError: "",
  creditAmountNotSelected: !1
};
function xm(e, t) {
  const { t: o } = H();
  return {
    validationRules: F(() => ({
      // creditAmount: {
      //     required: helpers.withMessage(t("GlobalErrors.FieldRequired"), required),
      // },
    }))
  };
}
function Lm(e, t) {
  const o = Q("commClient"), { scrollToFirstError: r } = Ie(), { validationRules: d } = xm(), f = be(d, F(() => e), { $autoDirty: !0 });
  async function i() {
    return f.value.$touch(), f.value.$validate();
  }
  async function l(c) {
    e.creditType !== c.creditType && (t.creditAmountNotSelected = !1);
  }
  async function s() {
    const c = await o.executeMethodAsync("PreapprovedCheckWeb", {
      TaxNumber: e.taxNumber,
      Birthdate: e.birthdate,
      SlovenianCitizen: e.isSlovenianCitizen,
      HasSlovenianIncome: e.hasSlovenianIncome,
      IsSP: e.employmentType == le.SP,
      AverageSalary: e.averageSalary,
      SumInstallments: e.sumInstallments,
      OrderToken: e.orderToken
    });
    c.length > 0 && (e.creditAmountAvailable = c);
  }
  function n() {
    r(".credit-amount-picker-component");
  }
  async function a(c) {
    let m = !1, v = null;
    switch (c) {
      case "validatecustomer":
      case "validate": {
        m = await i(), m && (v = { name: "valid" });
        break;
      }
      case "webNext": {
        console.log("v libraryu credit amount"), m = await i(), m && (e.creditAmount != null ? (e.isViewDataLoading = !0, v = { name: "nextStep" }) : (t.creditAmountNotSelected = !0, v = null));
        break;
      }
      default:
        v = null;
    }
    return Promise.resolve(v);
  }
  return {
    v$: f,
    preapprovedCheck: s,
    navigationAction: a,
    scrollToFirstErrorWrapper: n,
    dataChanged: l
  };
}
const Vm = "data:image/svg+xml,%3csvg%20width='64'%20height='64'%20viewBox='0%200%2064%2064'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_1707_10204)'%3e%3cg%20clip-path='url(%23clip1_1707_10204)'%3e%3cg%20clip-path='url(%23clip2_1707_10204)'%3e%3cpath%20d='M36.8008%208.79688V19.1969C36.8008%2020.9569%2038.2408%2022.3969%2040.0008%2022.3969H50.4008L36.8008%208.79688Z'%20fill='%2384BD00'/%3e%3cpath%20d='M47.2008%2056H16.8008C14.6141%2056%2012.8008%2054.1867%2012.8008%2052V12C12.8008%209.81333%2014.6141%208%2016.8008%208H37.3875L37.6008%208.21333C40.2141%2010.8267%2042.2941%2012.9067%2044.3208%2014.9333C46.3475%2016.96%2048.3741%2018.9867%2050.9341%2021.5467L51.1475%2021.76V51.9467C51.1475%2054.1333%2049.3341%2055.9467%2047.1475%2055.9467L47.2008%2056ZM16.8008%209.6C15.4674%209.6%2014.4008%2010.6667%2014.4008%2012V52C14.4008%2053.3333%2015.4674%2054.4%2016.8008%2054.4H47.2008C48.5341%2054.4%2049.6008%2053.3333%2049.6008%2052V22.4533C47.1475%2020%2045.1741%2018.0267%2043.2008%2016.0533C41.2275%2014.08%2039.2541%2012.0533%2036.7475%209.54667H16.8008V9.6Z'%20fill='%23230078'/%3e%3cpath%20d='M31.2012%2022.4516H20.0012C19.5745%2022.4516%2019.2012%2022.0782%2019.2012%2021.6516C19.2012%2021.2249%2019.5745%2020.8516%2020.0012%2020.8516H31.2012C31.6278%2020.8516%2032.0012%2021.2249%2032.0012%2021.6516C32.0012%2022.0782%2031.6278%2022.4516%2031.2012%2022.4516Z'%20fill='%23230078'/%3e%3cpath%20d='M44.0012%2032.8031H20.0012C19.5745%2032.8031%2019.2012%2032.4298%2019.2012%2032.0031C19.2012%2031.5765%2019.5745%2031.2031%2020.0012%2031.2031H44.0012C44.4278%2031.2031%2044.8012%2031.5765%2044.8012%2032.0031C44.8012%2032.4298%2044.4278%2032.8031%2044.0012%2032.8031Z'%20fill='%23230078'/%3e%3cpath%20d='M44.0012%2044.8031H20.0012C19.5745%2044.8031%2019.2012%2044.4298%2019.2012%2044.0031C19.2012%2043.5765%2019.5745%2043.2031%2020.0012%2043.2031H44.0012C44.4278%2043.2031%2044.8012%2043.5765%2044.8012%2044.0031C44.8012%2044.4298%2044.4278%2044.8031%2044.0012%2044.8031Z'%20fill='%23230078'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1707_10204'%3e%3crect%20width='64'%20height='64'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_1707_10204'%3e%3crect%20width='64'%20height='64'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip2_1707_10204'%3e%3crect%20width='64'%20height='64'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Fm = { class: "credit-amount-picker-component" }, jm = { class: "credit-amount-option__header" }, zm = {
  key: 0,
  class: "tag tag--green tag--with-dot"
}, Um = {
  key: 1,
  class: "tag tag--blue tag--with-dot"
}, Bm = { class: "credit-amount-option__header__amount" }, Gm = { class: "credit-amount-option__content" }, qm = { key: 0 }, Dm = { class: "credit-amount-option__content__document-name" }, Hm = { class: "" }, Ym = { key: 1 }, Zm = /* @__PURE__ */ ie({
  __name: "credit-amount-picker-component",
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    creditType: {
      Type: String,
      required: !0,
      default: ""
    },
    amount: {
      Type: Number,
      required: !0
    },
    pay3Needed: {
      type: Boolean,
      required: !0
    },
    documentationNeeded: {
      type: Boolean,
      required: !0
    },
    employmentType: {
      type: String,
      default: ""
    },
    hasSlovenianBankAccount: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const o = e, r = t;
    function d() {
      window.dataLayer && (console.log("Pushing GTM data: confirmation_1"), window.dataLayer.push({
        event: "confirmation_1",
        funnel_name: "pred_odobritvijo",
        step: 1,
        step_name: "izbira_zneska",
        cta_name: "Izberi"
      })), r("update:modelValue", {
        creditType: o.creditType,
        amount: o.amount
      });
    }
    const f = F(() => {
      var l, s;
      return ((l = o.modelValue) == null ? void 0 : l.creditType) === o.creditType && ((s = o.modelValue) == null ? void 0 : s.amount) === o.amount;
    });
    function i(l) {
      if (o.employmentType == le.Zaposlen) {
        if (l == "S2" && o.hasSlovenianBankAccount)
          return [
            {
              title: "Bančni izpisek",
              description: "Iz dokumenta mora biti razviden podatek o višini priliva iz naslova plače."
            }
          ];
        if (l == "S2" && !o.hasSlovenianBankAccount)
          return [
            {
              title: "Plačilna lista",
              description: "Priložite zadnjo plačilno listo, ki se ujema s spodaj vpisanim zneskom."
            }
          ];
        if (l == "S3")
          return [
            {
              title: "Bančni izpisek za zadnje 3 mesece",
              description: "Iz dokumenta mora biti razviden podatek o višini priliva iz naslova plače za zadnje 3 mesece."
            },
            {
              title: "Plačilna lista ali potrdilo CSD",
              description: "Priložite zadnjo plačilno listo, ki se ujema s spodaj vpisanim zneskom ali potrdilo CSD o nakazilu starševskega nadomestila."
            }
          ];
        if (l == "T1")
          return [
            {
              title: "Bančni izpisek",
              description: "Iz dokumenta mora biti razviden podatek o višini priliva iz naslova plače."
            },
            {
              title: "Plačilna lista",
              description: "Priložite zadnjo plačilno listo, ki se ujema s spodaj vpisanim zneskom."
            },
            {
              title: "Potrdilo o zaposlitvi",
              description: "Potrdilo o zaposlitvi najmanj za čas obročnega plačila mora izdati delodajalec s sedežem v SLoveniji."
            },
            {
              title: "Potrdilo o prijavi stalnega prebivališča v RS",
              description: ""
            }
          ];
        if (l == "T2")
          return [
            {
              title: "Bančni izpisek za zadnje 3 mesece",
              description: "Iz dokumenta mora biti razviden podatek o višini priliva iz naslova plače za zadnje 3 mesece."
            },
            {
              title: "Plačilna lista",
              description: "Priložite zadnjo plačilno listo, ki se ujema s spodaj vpisanim zneskom."
            },
            {
              title: "Potrdilo o zaposlitvi",
              description: "Potrdilo o zaposlitvi najmanj za čas obročnega plačila mora izdati delodajalec s sedežem v SLoveniji."
            },
            {
              title: "Potrdilo o prijavi stalnega prebivališča v RS",
              description: ""
            }
          ];
      } else if (o.employmentType == le.Upokojenec) {
        if (l == "S2")
          return [
            {
              title: "Bančni izpisek",
              description: "Iz dokumenta mora biti razviden podatek o višini priliva iz naslova pokojnine nakazane s strani ZPIZ."
            }
          ];
        if (l == "S3")
          return [
            {
              title: "Bančni izpisek",
              description: "Iz dokumenta mora biti razviden podatek o višini priliva iz naslova pokojnine nakazane s strani ZPIZ."
            }
          ];
        if (l == "T1")
          return [
            {
              title: "Bančni izpisek",
              description: "Iz dokumenta mora biti razviden podatek o višini priliva iz naslova pokojnine nakazane s strani ZPIZ."
            },
            {
              title: "Potrdilo o prijavi stalnega prebivališča v RS",
              description: ""
            }
          ];
        if (l == "T2")
          return [
            {
              title: "Bančni izpisek",
              description: "Iz dokumenta mora biti razviden podatek o višini priliva iz naslova pokojnine nakazane s strani ZPIZ."
            },
            {
              title: "Potrdilo o prijavi stalnega prebivališča v RS",
              description: ""
            }
          ];
      } else if (l == "SP1")
        return [
          {
            title: "Bančni izpisek za zadnje 3 mesece",
            description: "Iz dokumenta morajo biti razvidni podatki o višini prejemkov iz opravljanja dejavnosti za zadnje 3 mesece."
          }
        ];
      return [];
    }
    return (l, s) => {
      const n = V("v-btn");
      return S(), N("div", Fm, [
        p("div", {
          class: Le(["credit-amount-option", { "credit-amount-option--selected": f.value }])
        }, [
          p("div", jm, [
            p("div", null, [
              e.documentationNeeded ? (S(), N("span", zm, " Tudi za financiranje vozil ")) : (S(), N("span", Um, " Ni za financiranje vozil "))
            ]),
            p("div", Bm, " do " + E(l.$n(e.amount == null || e.amount.toString() == "" ? 0 : e.amount, "decimal")) + " EUR ", 1)
          ]),
          p("div", Gm, [
            e.documentationNeeded ? (S(), N("div", qm, [
              s[1] || (s[1] = p("div", { class: "credit-amount-option__content__title" }, " Zahtevana dokumentacija ", -1)),
              (S(!0), N(je, null, Mt(i(e.creditType), (a, c) => (S(), N("div", {
                key: c,
                class: "credit-amount-option__content__item"
              }, [
                s[0] || (s[0] = p("img", {
                  src: Vm,
                  alt: ""
                }, null, -1)),
                p("div", null, [
                  p("div", Dm, E(a.title), 1),
                  p("div", Hm, E(a.description), 1)
                ])
              ]))), 128))
            ])) : (S(), N("div", Ym, s[2] || (s[2] = [
              p("div", { class: "credit-amount-option__content__title" }, " Dokumentacija ni potrebna ", -1)
            ]))),
            p("div", null, [
              C(n, {
                onClick: d,
                disabled: f.value,
                class: "btn btn--primary-fill mt-4",
                block: ""
              }, {
                default: P(() => s[3] || (s[3] = [
                  ne("Izberi")
                ])),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ], 2)
      ]);
    };
  }
}), Wm = { class: "documentation-credit-amount-picker-component" }, Km = {
  key: 0,
  class: "v-input--error"
}, Qm = { class: "v-input__details" }, Xm = { class: "v-messages" }, Jm = { class: "v-messages__message" }, pb = /* @__PURE__ */ ie({
  __name: "documentation-credit-amount-picker-component",
  props: {
    data: { default: () => ({
      ...Dr
    }) }
  },
  emits: ["update:data", "componentReady", "update:creditType"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o;
    let i = re(!1);
    const l = W({ ...d.data, selectedCredit: null });
    let s = { ...Dr };
    const n = W({ ...$m }), { navigationAction: a, scrollToFirstErrorWrapper: c, preapprovedCheck: m, dataChanged: v } = Lm(l, n), h = F(() => l.selectedCredit ? "credit-selected" : ""), _ = F(() => l.selectedCredit ? (console.log("componentData.creditAmountAvailable", l.creditAmountAvailable), l.creditAmountAvailable != null ? l.creditAmountAvailable.filter(
      (y) => {
        var g;
        return y.type === ((g = l.selectedCredit) == null ? void 0 : g.creditType);
      }
    ) : null) : l.creditAmountAvailable);
    G(
      () => d.data,
      (y) => {
        Object.assign(l, y);
      },
      { deep: !0 }
    ), G(
      l,
      async (y) => {
        await v(s), Object.assign(s, y), f("update:data", y);
      },
      { deep: !0 }
    ), G(() => l.selectedCredit, (y) => {
      var g, I;
      l.creditAmount = (g = l.selectedCredit) == null ? void 0 : g.amount, l.creditType = (I = l.selectedCredit) == null ? void 0 : I.creditType, n.creditAmountNotSelected = !1;
    }), me(async () => {
      await m(), i.value = !0, f("componentReady");
    });
    function b() {
      l.selectedCredit = null;
    }
    return t({
      navigationAction: a,
      scrollToFirstErrorWrapper: c,
      componentReady: i
    }), (y, g) => (S(), N(je, null, [
      l.selectedCredit ? (S(), N("div", {
        key: 0,
        class: "btn-back-to-calculation",
        onClick: b
      }, g[1] || (g[1] = [
        p("img", { src: Rm }, null, -1),
        ne(" Nazaj na izbiro ")
      ]))) : x("", !0),
      p("div", Wm, [
        p("div", {
          class: Le(["credit-amount-options", h.value])
        }, [
          (S(!0), N(je, null, Mt(_.value, (I, T) => (S(), K(Zm, {
            modelValue: l.selectedCredit,
            "onUpdate:modelValue": g[0] || (g[0] = (w) => l.selectedCredit = w),
            key: T,
            creditType: I.type,
            amount: I.availableAmount,
            pay3Needed: l.creditAmountTypeInfo[I.type].pay3Needed,
            documentationNeeded: l.creditAmountTypeInfo[I.type].documentationNeeded,
            employmentType: l.employmentType,
            hasSlovenianBankAccount: l.hasSlovenianBankAccount
          }, null, 8, ["modelValue", "creditType", "amount", "pay3Needed", "documentationNeeded", "employmentType", "hasSlovenianBankAccount"]))), 128))
        ], 2),
        n.creditAmountNotSelected ? (S(), N("div", Km, [
          p("div", Qm, [
            p("div", Xm, [
              p("div", Jm, "NAPAKA - " + E(u(r)("GeneralErrors.ERROR_NEXT")), 1)
            ])
          ])
        ])) : x("", !0)
      ])
    ], 64));
  }
}), ef = ie({
  props: {
    modelValue: {
      type: null,
      required: !1
    },
    numberOfDecimals: {
      type: Number,
      default: 0
    },
    maxLength: {
      type: Number,
      default: 0
    },
    appendInnerIcon: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    maxValue: {
      type: Number
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    formatNumber: {
      type: Function,
      required: !1
    },
    appendText: {
      type: String,
      default: ""
    }
  },
  setup(e, { emit: t }) {
    const o = re(null), r = re(!1), d = F(() => e.modelValue), { n: f } = H();
    async function i() {
      await navigator.clipboard.readText().then((c) => {
        c = c.replace(/\s/g, "").replace(new RegExp("(?<=\\d)\\.(?=\\d{3})", "g"), "").replace(",", ".");
        let m = parseFloat(c);
        l(isNaN(m) ? 0 : m);
      });
    }
    G(d, () => {
      e.maxValue && e.modelValue > e.maxValue ? l(e.maxValue) : l(d.value);
    }), me(() => {
      l(e.modelValue);
    });
    function l(c) {
      c != parseFloat(o.value.value.replace(",", ".")) && (c != null && c != null ? o.value.value = f(parseFloat(c.toString().replace(",", ".")), { key: "decimal", minimumFractionDigits: e.numberOfDecimals, maximumFractionDigits: e.numberOfDecimals, useGrouping: !1 }) : o.value.value = null);
    }
    function s(c) {
      e.maxLength == 1 && !isNaN(parseInt(c.key)) ? c.target.value = "" : (e.numberOfDecimals == 0 && c.key == "," || c.key != "," && isNaN(parseInt(c.key))) && c.preventDefault();
    }
    function n(c) {
      let m = parseFloat(c.target.value.replace(",", "."));
      t("update:modelValue", isNaN(m) ? null : m);
    }
    function a(c) {
      r.value = !1;
      let m = c.target.value;
      m && e.numberOfDecimals > 0 && (c.target.value = f(parseFloat(m.replace(",", ".")), { key: "decimal", minimumFractionDigits: e.numberOfDecimals, maximumFractionDigits: e.numberOfDecimals, useGrouping: !1 }), t("update:modelValue", parseFloat(c.target.value.replace(",", "."))));
    }
    return {
      input: o,
      focused: r,
      KeyPressed: s,
      UpdateValue: n,
      FixInputValue: a,
      FixPasteValue: i
    };
  }
}), tf = {
  class: "v-field__field",
  "data-no-activator": ""
}, nf = {
  class: "v-field__input",
  "data-no-activator": ""
}, of = ["maxLength", "maxValue", "autofocus"], rf = {
  key: 0,
  class: "v-field__append-inner"
}, af = {
  key: 1,
  class: "v-field__append-inner"
};
function sf(e, t, o, r, d, f) {
  const i = V("v-input");
  return S(), K(i, { class: "v-text-field v-numeric-field" }, {
    default: P(() => [
      p("div", {
        tabIndex: 0,
        onFocus: t[6] || (t[6] = (...l) => e.input.focus && e.input.focus(...l)),
        class: Le([{ "v-field--appended": e.appendInnerIcon != "" || e.appendText != "", "v-field--focused": e.focused, "v-field--disabled": e.disabled }, "v-field v-field--variant-outlined"]),
        role: "textbox"
      }, [
        t[8] || (t[8] = p("div", { class: "v-field__overlay" }, null, -1)),
        p("div", tf, [
          t[7] || (t[7] = p("label", { class: "v-label v-field-label" }, null, -1)),
          p("div", nf, [
            p("input", Ot(e.$attrs, {
              ref: "input",
              onFocus: t[0] || (t[0] = (l) => e.focused = !0),
              onBlur: t[1] || (t[1] = (l) => e.focused = !1),
              onPaste: t[2] || (t[2] = (l) => e.FixPasteValue()),
              onKeypress: t[3] || (t[3] = (...l) => e.KeyPressed && e.KeyPressed(...l)),
              onInput: t[4] || (t[4] = (...l) => e.UpdateValue && e.UpdateValue(...l)),
              onChange: t[5] || (t[5] = (...l) => e.FixInputValue && e.FixInputValue(...l)),
              type: "text",
              size: "1",
              maxLength: e.maxLength == 0 ? void 0 : e.maxLength,
              maxValue: e.maxValue,
              autofocus: e.autofocus
            }), null, 16, of)
          ])
        ]),
        e.appendInnerIcon != "" ? (S(), N("div", rf, [
          p("i", {
            class: Le([e.appendInnerIcon, "mdi v-icon notranslate v-icon--size-default"]),
            "aria-hidden": "true"
          }, null, 2)
        ])) : x("", !0),
        e.appendText != "" ? (S(), N("div", af, E(e.appendText), 1)) : x("", !0),
        t[9] || (t[9] = p("div", { class: "v-field__outline" }, [
          p("div", { class: "v-field__outline__start" }),
          p("div", { class: "v-field__outline__end" })
        ], -1))
      ], 34)
    ]),
    _: 1
  });
}
const Te = /* @__PURE__ */ Do(ef, [["render", sf]]);
function lf(e) {
  const { t } = H();
  return F(() => ({
    lastMonthsIncome: {
      required: j.withMessage(t("GlobalErrors.FieldRequired"), he),
      minMinimalPay: j.withMessage(t("GlobalErrors.MinMinimalPay"), () => e.lastMonthsIncome !== void 0 && e.lastMonthsIncome > 100)
    },
    lastMonthsIncome2: {
      customRequired: j.withMessage(t("GlobalErrors.FieldRequired"), de(e.mustProvideThreeSalaries)),
      min100: j.withMessage(t("GlobalErrors.Min10Eur"), () => e.mustProvideThreeSalaries && e.lastMonthsIncome2 >= 1 || !e.mustProvideThreeSalaries)
    },
    lastMonthsIncome3: {
      customRequired: j.withMessage(t("GlobalErrors.FieldRequired"), de(e.mustProvideThreeSalaries)),
      min100: j.withMessage(t("GlobalErrors.Min10Eur"), () => e.mustProvideThreeSalaries && e.lastMonthsIncome3 >= 1 || !e.mustProvideThreeSalaries),
      avg1500IfT2: j.withMessage(
        t("GlobalErrors.MinAvgIncome1500"),
        () => {
          if (e.creditType === "T2") {
            const o = [e.lastMonthsIncome, e.lastMonthsIncome2, e.lastMonthsIncome3];
            return o.some((d) => typeof d != "number" || isNaN(d)) ? !0 : (o[0] + o[1] + o[2]) / 3 >= 1500;
          }
          return !0;
        }
      )
    }
  }));
}
function uf(e) {
  Q("navigationButtonsApi", null);
  const { scrollToFirstError: t } = Ie(), o = be(lf(e), F(() => e), { $autoDirty: !0 });
  async function r() {
    return o.value.$touch(), o.value.$validate();
  }
  const d = F(() => {
    const l = (/* @__PURE__ */ new Date()).getMonth();
    return {
      month0: l > 2 ? l - 3 : l + 9,
      month1: l > 1 ? l - 2 : l + 10,
      month2: l > 0 ? l - 1 : l + 11,
      month3: l
    };
  });
  function f() {
    t(".amount-insert-component");
  }
  async function i(l) {
    let s = !1, n = null;
    switch (l) {
      case "validate":
        s = await r(), s && (n = { name: "valid" });
        break;
    }
    return n;
  }
  return {
    pastMonths: d,
    navigationAction: i,
    scrollToFirstErrorWrapper: f,
    v$: o
  };
}
const df = {
  lastMonthsIncome: 0,
  lastMonthsIncome2: 0,
  lastMonthsIncome3: 0,
  flowType: void 0,
  mustProvideThreeSalaries: !1,
  isDocumentationNeeded: !1,
  employmentType: void 0,
  creditType: null
}, cf = {
  class: "amount-insert-component",
  ref: "rootRef"
}, mf = { class: "section-heading mb-4" }, ff = { class: "section-heading__text" }, pf = { key: 0 }, vf = { class: "mb-4" }, hf = { class: "form-label" }, yf = { class: "control-income-wrapper" }, _f = {
  key: 0,
  class: "mb-4"
}, gf = { class: "form-label" }, bf = {
  key: 1,
  class: "mb-4"
}, Cf = { class: "form-label" }, If = { key: 1 }, Ef = {
  key: 0,
  class: "section-heading mt-0"
}, Sf = { class: "mb-4" }, Pf = { class: "form-label" }, Tf = { class: "control-income-wrapper" }, vb = /* @__PURE__ */ ie({
  __name: "amount-insert-component",
  props: {
    data: { default: () => ({
      ...df
    }) }
  },
  emits: ["update:data", "navigation-event"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o;
    Q("commClient");
    const { t: f } = H(), i = W({ ...r.data }), { v$: l, navigationAction: s, pastMonths: n, scrollToFirstErrorWrapper: a } = uf(i);
    G(
      () => r.data,
      // Watch for changes in the data
      (m) => {
        Object.assign(i, m);
      },
      { deep: !0 }
    ), G(
      i,
      async (m) => {
        d("update:data", m);
      },
      { deep: !0 }
    );
    const c = F(() => {
      const m = i.isDocumentationNeeded;
      switch (i.employmentType) {
        case le.SP:
          return f("Components.InstallmentPlanComponent.MonthlyIncomeHintSPDoc");
        case le.Upokojenec:
          return f(m ? "Components.InstallmentPlanComponent.MonthlyIncomeHintUpokojenecDoc" : "Components.InstallmentPlanComponent.MonthlyIncomeHintUpokojenecNoDoc");
        case le.Zaposlen:
          return f(m ? "Components.InstallmentPlanComponent.MonthlyIncomeHintZaposleniDoc" : "Components.InstallmentPlanComponent.MonthlyIncomeHintZaposleniNoDoc");
        default:
          return "";
      }
    });
    return G(() => i.creditType, (m) => {
      const v = m == "S3" || m == "T2" || m == "SP1";
      i.mustProvideThreeSalaries = v, !v && i.employmentType !== le.SP && (i.lastMonthsIncome2 = void 0, i.lastMonthsIncome3 = void 0);
    }, { immediate: !0 }), t({
      navigationAction: s,
      scrollToFirstErrorWrapper: a
    }), (m, v) => {
      const h = V("v-col"), _ = V("v-row");
      return S(), N("div", cf, [
        p("h2", mf, E(u(f)("Components.InstallmentPlanComponent.MonthlyIncome")), 1),
        p("div", ff, E(i.creditType === "S1" && i.mustProvideThreeSalaries === !1 ? u(f)("Components.InstallmentPlanComponent.Info1P") : i.mustProvideThreeSalaries === !0 || i.creditType === "S3" ? u(f)("Components.InstallmentPlanComponent.Info3P") : u(f)("Components.InstallmentPlanComponent.Info")), 1),
        C(_, null, {
          default: P(() => [
            C(h, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                i.mustProvideThreeSalaries === !0 || i.creditType === "S3" ? (S(), N("div", pf, [
                  p("div", vf, [
                    p("label", hf, E(i.employmentType == u(le).SP || i.mustProvideThreeSalaries ? u(f)("Components.InstallmentPlanComponent.MonthlyIncome") + "- " + u(f)("Components.InstallmentPlanComponent.Months." + u(n).month0.toString()) : u(f)("Components.InstallmentPlanComponent.LastMonthlyIncome")), 1),
                    p("div", yf, [
                      C(Te, {
                        modelValue: i.lastMonthsIncome,
                        "onUpdate:modelValue": v[0] || (v[0] = (b) => i.lastMonthsIncome = b),
                        "error-messages": u(l).lastMonthsIncome.$errors[0] != null ? u(l).lastMonthsIncome.$errors[0].$message : "",
                        onFocus: u(l).lastMonthsIncome.$reset,
                        variant: "outlined",
                        appendText: "EUR",
                        numberOfDecimals: 2,
                        hint: c.value,
                        "persistent-hint": ""
                      }, null, 8, ["modelValue", "error-messages", "onFocus", "hint"])
                    ])
                  ]),
                  i.employmentType == u(le).SP || i.mustProvideThreeSalaries ? (S(), N("div", _f, [
                    p("label", gf, E(i.employmentType == u(le).SP || i.mustProvideThreeSalaries ? u(f)("Components.InstallmentPlanComponent.MonthlyIncome") + "- " + u(f)("Components.InstallmentPlanComponent.Months." + u(n).month1.toString()) : u(f)("Components.InstallmentPlanComponent.MonthlyIncome")), 1),
                    C(Te, {
                      modelValue: i.lastMonthsIncome2,
                      "onUpdate:modelValue": v[1] || (v[1] = (b) => i.lastMonthsIncome2 = b),
                      "error-messages": u(l).lastMonthsIncome2.$errors[0] != null ? u(l).lastMonthsIncome2.$errors[0].$message : "",
                      onFocus: u(l).lastMonthsIncome2.$reset,
                      variant: "outlined",
                      appendText: "EUR",
                      numberOfDecimals: 2,
                      hint: c.value,
                      "persistent-hint": ""
                    }, null, 8, ["modelValue", "error-messages", "onFocus", "hint"])
                  ])) : x("", !0),
                  i.employmentType == u(le).SP || i.mustProvideThreeSalaries ? (S(), N("div", bf, [
                    p("label", Cf, E(i.employmentType == u(le).SP || i.mustProvideThreeSalaries ? u(f)("Components.InstallmentPlanComponent.MonthlyIncome") + "- " + u(f)("Components.InstallmentPlanComponent.Months." + u(n).month2.toString()) : u(f)("Components.InstallmentPlanComponent.MonthlyIncome")), 1),
                    C(Te, {
                      modelValue: i.lastMonthsIncome3,
                      "onUpdate:modelValue": v[2] || (v[2] = (b) => i.lastMonthsIncome3 = b),
                      "error-messages": u(l).lastMonthsIncome3.$errors[0] != null ? u(l).lastMonthsIncome3.$errors[0].$message : "",
                      onFocus: u(l).lastMonthsIncome3.$reset,
                      variant: "outlined",
                      appendText: "EUR",
                      numberOfDecimals: 2,
                      hint: c.value,
                      "persistent-hint": ""
                    }, null, 8, ["modelValue", "error-messages", "onFocus", "hint"])
                  ])) : x("", !0)
                ])) : (S(), N("div", If, [
                  i.flowType !== u(R).LIMIT ? (S(), N("h2", Ef, E(u(f)("Components.InstallmentPlanComponent.MonthlyIncome")), 1)) : x("", !0),
                  p("div", Sf, [
                    p("label", Pf, E(i.employmentType == u(le).SP || i.mustProvideThreeSalaries ? u(f)("Components.InstallmentPlanComponent.MonthlyIncome") + "- " + u(f)("Components.InstallmentPlanComponent.Months." + u(n).month0.toString()) : u(f)("Components.InstallmentPlanComponent.LastMonthlyIncome")), 1),
                    p("div", Tf, [
                      C(Te, {
                        modelValue: i.lastMonthsIncome,
                        "onUpdate:modelValue": v[3] || (v[3] = (b) => i.lastMonthsIncome = b),
                        "error-messages": u(l).lastMonthsIncome.$errors[0] != null ? u(l).lastMonthsIncome.$errors[0].$message : "",
                        onFocus: u(l).lastMonthsIncome.$reset,
                        variant: "outlined",
                        appendText: "EUR",
                        numberOfDecimals: 2,
                        hint: c.value,
                        "persistent-hint": ""
                      }, null, 8, ["modelValue", "error-messages", "onFocus", "hint"])
                    ])
                  ])
                ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 512);
    };
  }
}), wf = {
  dataConfirmation: !1,
  termsAgreement: !1,
  flowType: void 0,
  firstname: "",
  surname: "",
  address: "",
  postalCode: void 0,
  birthCity: "",
  birthdate: void 0,
  citizen: void 0,
  countrySourceFunds: "",
  countryFundsStatus: "",
  idNumber: "",
  documentIssuer: "",
  issueDate: void 0,
  validityDate: void 0
}, kf = {
  isDataConfirmed: !1,
  errorMessage: ""
};
function Nf(e) {
  const { t } = H();
  return F(() => ({
    termsAgreement: e.flowType === R.POS_MOBILE ? {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), ho(!0))
    } : {}
  }));
}
function Af(e, t) {
  const o = be(Nf(e), F(() => e), { $autoDirty: !0 });
  async function r() {
    return o.value.$touch(), o.value.$validate();
  }
  async function d(i) {
    let l = !1, s = null;
    switch (i) {
      case "webNext":
        l = await r(), l && (t.errorMessage = "", s = { name: "nextStep" });
        break;
      case "validate":
        l = await r(), t.isDataConfirmed == !1 && (t.errorMessage = "Prosim potrdite podatke."), l && t.isDataConfirmed && (t.errorMessage = "", s = { name: "valid" });
        break;
    }
    return s;
  }
  function f() {
    t.isDataConfirmed = !0, t.errorMessage = "";
  }
  return {
    v$: o,
    navigationAction: d,
    confirmData: f
  };
}
const Mf = {
  class: "data-confirmation-component",
  ref: "rootRef"
}, Of = { class: "form-label form-label--text" }, Rf = { class: "form-label" }, $f = { class: "form-label form-label--text" }, xf = { class: "form-label" }, Lf = { class: "form-label form-label--text" }, Vf = { class: "form-label form-label--text" }, Ff = { class: "form-label" }, jf = { class: "form-label" }, zf = { class: "form-label" }, Uf = { class: "form-label" }, Bf = { class: "form-label" }, Gf = { class: "callout mb-0 mt-4" }, qf = { class: "font-weight-600" }, Df = { class: "mt-4" }, Hf = {
  key: 4,
  class: "v-input--error"
}, Yf = { class: "v-input__details" }, Zf = { class: "v-messages" }, Wf = { class: "v-messages__message" }, Kf = { class: "" }, Qf = { class: "" }, Xf = {
  target: "_blank",
  href: "https://nlbleaseandgo.si/pravna-vsebina/pogoji-uporabe"
}, Jf = {
  target: "_blank",
  href: "https://nlbleaseandgo.si/pravna-vsebina/varstvo-osebnih-podatkov"
}, hb = /* @__PURE__ */ ie({
  __name: "data-confirmation-component",
  props: {
    data: { default: () => ({
      ...wf
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o, { t: f } = H(), i = W({ ...r.data });
    let l = re(!1);
    const s = W({ ...kf }), { v$: n, navigationAction: a, confirmData: c } = Af(i, s);
    G(
      () => r.data,
      // Watch for changes in the data
      (v) => {
        Object.assign(i, v);
      },
      { deep: !0 }
    ), G(
      i,
      (v) => {
        d("update:data", v);
      },
      { deep: !0 }
    ), me(async () => {
      l.value = !0, d("componentReady");
    });
    const m = Q("generalStore");
    return t({
      navigationAction: a,
      componentReady: l
    }), (v, h) => {
      const _ = V("v-col"), b = V("v-row"), y = V("v-autocomplete"), g = V("Datepicker"), I = V("v-btn"), T = V("v-checkbox");
      return S(), N("div", Mf, [
        C(b, null, {
          default: P(() => [
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", Of, E(u(f)("Components.DataConfirmationComponent.NameSurname")), 1),
                  C(Pe, {
                    "model-value": `${i.firstname} ${i.surname}`,
                    variant: "outlined",
                    disabled: !0
                  }, null, 8, ["model-value"])
                ])
              ]),
              _: 1
            }),
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", Rf, E(u(f)("Components.DataConfirmationComponent.CompleteAddress")), 1),
                  C(Pe, {
                    "model-value": `${i.address}, ${i.postalCode}`,
                    variant: "outlined",
                    disabled: !0
                  }, null, 8, ["model-value"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        C(b, null, {
          default: P(() => [
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", $f, E(u(f)("Components.DataConfirmationComponent.BirthCity")), 1),
                  C(Pe, {
                    "model-value": i.birthCity,
                    variant: "outlined",
                    disabled: !0
                  }, null, 8, ["model-value"])
                ])
              ]),
              _: 1
            }),
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => {
                var w;
                return [
                  p("div", null, [
                    p("label", xf, E(u(f)("Components.DataConfirmationComponent.Birthdate")), 1),
                    C(Pe, {
                      "model-value": (w = i.birthdate) == null ? void 0 : w.toLocaleDateString("he-IL"),
                      variant: "outlined",
                      disabled: !0
                    }, null, 8, ["model-value"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        C(b, null, {
          default: P(() => [
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", Lf, E(u(f)("Components.DataConfirmationComponent.Citizenship")), 1),
                  C(y, {
                    modelValue: i.citizen,
                    "onUpdate:modelValue": h[0] || (h[0] = (w) => i.citizen = w),
                    items: u(m).state.countryList,
                    "item-title": "Value",
                    "item-value": "Key",
                    disabled: !0,
                    variant: "outlined"
                  }, null, 8, ["modelValue", "items"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        i.flowType == u(R).POS_STRANKA && i.countrySourceFunds != "" || i.flowType == u(R).POS_STRANKA && i.countryFundsStatus != "" ? (S(), K(b, { key: 0 }, {
          default: P(() => [
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", Vf, E(u(f)("Components.DataConfirmationComponent.SourceFunds")), 1),
                  C(Pe, {
                    "model-value": i.countrySourceFunds,
                    variant: "outlined",
                    disabled: !0,
                    hint: u(f)("Components.DataConfirmationComponent.SourceFundsInfo")
                  }, null, 8, ["model-value", "hint"])
                ])
              ]),
              _: 1
            }),
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", Ff, E(u(f)("Components.DataConfirmationComponent.FundsStatus")), 1),
                  C(Pe, {
                    "model-value": i.countryFundsStatus,
                    variant: "outlined",
                    disabled: !0,
                    hint: u(f)("Components.DataConfirmationComponent.FundsStatusInfo")
                  }, null, 8, ["model-value", "hint"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        i.flowType == u(R).POS_STRANKA ? (S(), K(b, { key: 1 }, {
          default: P(() => [
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", jf, E(u(f)("Components.IdDocumentComponent.IdNumber")), 1),
                C(Pe, {
                  modelValue: i.idNumber,
                  "onUpdate:modelValue": h[1] || (h[1] = (w) => i.idNumber = w),
                  variant: "outlined",
                  disabled: !0
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", zf, E(u(f)("Components.IdDocumentComponent.DocumentIssuer")), 1),
                C(Pe, {
                  modelValue: i.documentIssuer,
                  "onUpdate:modelValue": h[2] || (h[2] = (w) => i.documentIssuer = w),
                  variant: "outlined",
                  prefix: "UE",
                  disabled: !0
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        i.flowType == u(R).POS_STRANKA ? (S(), K(b, { key: 2 }, {
          default: P(() => [
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", Uf, E(u(f)("Components.IdDocumentComponent.IssueDate")), 1),
                C(g, {
                  modelValue: i.issueDate,
                  "onUpdate:modelValue": h[3] || (h[3] = (w) => i.issueDate = w),
                  enableTimePicker: !1,
                  autoApply: "",
                  position: "right",
                  locale: "sl",
                  textInput: "",
                  format: "d.M.yyyy",
                  disabled: !0
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", Bf, E(u(f)("Components.IdDocumentComponent.ValidityDate")), 1),
                C(g, {
                  modelValue: i.validityDate,
                  "onUpdate:modelValue": h[4] || (h[4] = (w) => i.validityDate = w),
                  enableTimePicker: !1,
                  autoApply: "",
                  position: "right",
                  locale: "sl",
                  textInput: "",
                  format: "d.M.yyyy",
                  disabled: !0
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        s.isDataConfirmed == !1 ? (S(), K(b, { key: 3 }, {
          default: P(() => [
            C(_, null, {
              default: P(() => [
                p("div", Gf, [
                  ne(E(u(f)("Components.DataConfirmationComponent.CheckData")) + " ", 1),
                  h[7] || (h[7] = p("br", null, null, -1)),
                  h[8] || (h[8] = p("br", null, null, -1)),
                  p("span", qf, E(u(f)("Components.DataConfirmationComponent.CheckDataTitle")), 1),
                  h[9] || (h[9] = p("br", null, null, -1)),
                  h[10] || (h[10] = p("br", null, null, -1)),
                  ne(" " + E(u(f)("Components.DataConfirmationComponent.CheckDataText")), 1),
                  h[11] || (h[11] = p("br", null, null, -1)),
                  h[12] || (h[12] = p("br", null, null, -1)),
                  p("div", Df, [
                    C(I, {
                      onClick: h[5] || (h[5] = (w) => {
                        u(c)();
                      }),
                      class: "btn btn--primary-fill",
                      variant: "flat"
                    }, {
                      default: P(() => [
                        ne(E(u(f)("Components.DataConfirmationComponent.ConfirmData")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        s.errorMessage != "" ? (S(), N("div", Hf, [
          p("div", Yf, [
            p("div", Zf, [
              p("div", Wf, E(s.errorMessage), 1)
            ])
          ])
        ])) : x("", !0),
        i.flowType == u(R).POS_MOBILE ? (S(), K(T, {
          key: 5,
          modelValue: i.termsAgreement,
          "onUpdate:modelValue": h[6] || (h[6] = (w) => i.termsAgreement = w),
          "error-messages": u(n).termsAgreement.$errors[0] != null ? u(n).termsAgreement.$errors[0].$message : "",
          onFocus: u(n).termsAgreement.$reset
        }, {
          label: P(() => [
            p("div", Kf, [
              p("span", Qf, E(u(f)("Components.DataConfirmationComponent.TermsAgreement1")), 1),
              p("a", Xf, E(u(f)("Components.DataConfirmationComponent.TermsAgreement2")), 1),
              ne(" " + E(u(f)("Components.DataConfirmationComponent.TermsAgreement3")) + " ", 1),
              p("a", Jf, E(u(f)("Components.DataConfirmationComponent.TermsAgreement4")), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "error-messages", "onFocus"])) : x("", !0)
      ], 512);
    };
  }
}), e0 = {
  documentationFiles: [],
  documentationId: "",
  flowType: void 0,
  isSlovenianCitizen: !1,
  employmentType: null,
  isPreapproved: !1,
  creditAmount: void 0,
  isDocumentationNeeded: void 0,
  willAttachDocumentation: void 0,
  headerTitle: "",
  headerSubtitle: "",
  isViewDataLoading: !1,
  preapprovedCreditType: void 0,
  taxNumber: void 0,
  shouldShowFinapi: !1
}, t0 = {
  isSlovenianCitizen: !1,
  employmentType: null,
  hasSlovenianIncome: !1,
  pay3: 0,
  foreignCitizenOver5k: !1,
  is15k: !1,
  comment: ""
};
function n0(e) {
  const { t } = H();
  return F(() => ({
    documentationFiles: {
      required: j.withMessage(t("GlobalErrors.FileAdd"), () => e.documentationFiles.length > 0)
    }
  }));
}
function o0(e, t) {
  const o = Q("commClient"), { copySharedProperties: r, scrollToFirstError: d } = Ie(), f = be(n0(e), F(() => e), { $autoDirty: !0 });
  async function i() {
    return f.value.$touch(), await f.value.$validate();
  }
  async function l() {
    const m = await o.executeMethodAsync("sw.DocumentationDataGet", {
      DocumentationId: e.documentationId,
      TaxNumber: e.taxNumber === void 0 ? "" : e.taxNumber,
      PreapprovedCreditType: e.preapprovedCreditType === void 0 ? "" : e.preapprovedCreditType
    });
    return m ? (console.log(m), r(t, m), e.isSlovenianCitizen = t.isSlovenianCitizen, e.employmentType = t.employmentType, e.shouldShowFinapi = m.shouldShowFinapi, "") : (e.headerSubtitle = "DocumentationNotFound", "endFail");
  }
  async function s() {
    return new Promise(async (m, v) => {
      let h = e.documentationFiles.map((_) => _.FileId);
      e.isViewDataLoading = !0, await o.executeMethodAsync("UploadDocumentationSub", {
        DocumentationId: e.documentationId,
        Files: h.join(";")
      }).then((_) => {
        e.isViewDataLoading = !1, _.Success ? m({ name: "nextStep" }) : (e.headerSubtitle = _.Error, m({ name: "endFail" }));
      }).catch((_) => {
        e.isViewDataLoading = !1, e.headerSubtitle = "GeneralError", m({ name: "endFail" });
      });
    });
  }
  function n() {
    d(".documentation-component");
  }
  async function a(m) {
    let v = !1, h = null;
    switch (m) {
      case "validate": {
        v = await i(), v && (h = { name: "valid" });
        break;
      }
      case "webNext": {
        v = await i(), v && (h = { name: "nextStep" });
        break;
      }
      case "createContract": {
        v = await i(), v && (h = { name: "endFail" });
        break;
      }
      case "uploadDocumentation": {
        if (v = await i(), v)
          return Promise.resolve(await s());
        break;
      }
      default:
        h = null;
    }
    return Promise.resolve(h);
  }
  const c = F(() => e.isPreapproved);
  return {
    v$: f,
    navigationAction: a,
    getPreapprovedValidity: c,
    LoadDocumentationData: l,
    scrollToFirstErrorWrapper: n
  };
}
const r0 = { key: 0 }, i0 = { key: 0 }, a0 = {
  key: 0,
  class: "documentation-info__condition"
}, s0 = {
  key: 1,
  class: "documentation-info__condition"
}, l0 = {
  key: 2,
  class: "documentation-info__condition"
}, u0 = { key: 1 }, d0 = {
  key: 0,
  class: "documentation-info__condition"
}, c0 = {
  key: 1,
  class: "documentation-info__condition"
}, m0 = {
  key: 2,
  class: "documentation-info__condition"
}, f0 = {
  key: 3,
  class: "documentation-info__condition"
}, p0 = { key: 1 }, v0 = { key: 0 }, h0 = { key: 1 }, y0 = { key: 0 }, _0 = { key: 1 }, g0 = { key: 2 }, b0 = { key: 0 }, C0 = { key: 0 }, I0 = { key: 1 }, E0 = {
  key: 0,
  class: "documentation-info__condition"
}, S0 = {
  key: 1,
  class: "documentation-info__condition"
}, P0 = { key: 1 }, T0 = {
  key: 0,
  class: "documentation-info__condition"
}, w0 = {
  key: 1,
  class: "documentation-info__condition"
}, k0 = /* @__PURE__ */ ie({
  __name: "documentation-content",
  props: {
    showDocumentation: {
      type: Boolean,
      required: !1
    },
    slovenianCitizen: {
      type: Boolean,
      default: !0
    },
    foreignCitizenOver5k: {
      type: Boolean,
      default: !1
    },
    pay3: {
      type: Boolean,
      default: !1
    },
    is15k: {
      type: Boolean,
      default: !1
    },
    employmentType: {
      type: String,
      // 0 = zaposlen, 1 = upokojenec, 2 = S.P.
      default: "Z"
    },
    slovenianEmployment: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, o) => (S(), N("div", null, [
      e.slovenianCitizen == !1 ? (S(), N("div", r0, [
        e.foreignCitizenOver5k ? (S(), N("div", i0, [
          e.pay3 ? (S(), N("div", a0, o[0] || (o[0] = [
            p("div", null, "Bančni izpisek ali potrdilo banke", -1),
            p("div", null, "Iz dokumenta mora biti razviden podatek o višini priliva iz naslova plače za zadnje 3 mesece ali pokojnine nakazane s strani ZPIZ-a v zadnjem mesecu.", -1)
          ]))) : x("", !0),
          e.employmentType != "U" ? (S(), N("div", s0, o[1] || (o[1] = [
            p("div", null, "Plačilno listo", -1),
            p("div", null, "Priložite zadnjo, ujemajočo se plačilno listo.", -1)
          ]))) : x("", !0),
          o[3] || (o[3] = p("div", { class: "documentation-info__condition" }, [
            p("div", null, "Potrdilo iz UE o prijavi stalnega prebivališča")
          ], -1)),
          e.employmentType != "U" ? (S(), N("div", l0, o[2] || (o[2] = [
            p("div", null, "Potrdilo ali pogodbo delodajalca o zaposlitvi", -1),
            p("div", null, "Dokument mora veljati najmanj za čas obročnega plačevanja.", -1)
          ]))) : x("", !0)
        ])) : (S(), N("div", u0, [
          e.pay3 ? x("", !0) : (S(), N("div", d0, o[4] || (o[4] = [
            p("div", null, "Bančni izpisek ali potrdilo banke", -1),
            p("div", null, "Iz dokumenta mora biti razviden podatek o višini priliva iz naslova plače ali pokojnine nakazane s strani ZPIZ-a.", -1)
          ]))),
          e.pay3 ? (S(), N("div", c0, o[5] || (o[5] = [
            p("div", null, "Bančni izpisek ali potrdilo banke", -1),
            p("div", null, "Iz dokumenta mora biti razviden podatek o višini priliva iz naslova plače za zadnje 3 mesece ali pokojnine nakazane s strani ZPIZ-a v zadnjem mesecu.", -1)
          ]))) : x("", !0),
          e.employmentType != "U" ? (S(), N("div", m0, o[6] || (o[6] = [
            p("div", null, "Plačilno listo", -1),
            p("div", null, "Priložite zadnjo, ujemajočo se plačilno listo.", -1)
          ]))) : x("", !0),
          o[8] || (o[8] = p("div", { class: "documentation-info__condition" }, [
            p("div", null, "Potrdilo iz UE o prijavi stalnega prebivališča")
          ], -1)),
          e.employmentType != "U" ? (S(), N("div", f0, o[7] || (o[7] = [
            p("div", null, "Potrdilo ali pogodbo delodajalca o zaposlitvi", -1),
            p("div", null, "Dokument mora veljati najmanj za čas obročnega plačevanja.", -1)
          ]))) : x("", !0)
        ]))
      ])) : (S(), N("div", p0, [
        e.employmentType == "SP" ? (S(), N("div", v0, o[9] || (o[9] = [
          p("div", { class: "documentation-info__condition" }, [
            p("div", null, "Bančni izpisek ali potrdilo banke"),
            p("div", null, "Iz dokumenta morajo biti razvidni podatki o višini prejemkov iz opravljanja dejavnosti za zadnje 3 mesece.")
          ], -1)
        ]))) : x("", !0),
        e.employmentType == "U" ? (S(), N("div", h0, [
          e.slovenianEmployment == !0 ? (S(), N("div", y0, o[10] || (o[10] = [
            p("div", { class: "documentation-info__condition" }, [
              p("div", null, "Bančni izpisek ali potrdilo banke"),
              p("div", null, "Iz dokumenta mora biti razviden podatek o višini priliva iz naslova pokojnine nakazane s strani ZPIZ-a.")
            ], -1)
          ]))) : x("", !0),
          e.slovenianEmployment == !1 ? (S(), N("div", _0, o[11] || (o[11] = [
            p("div", { class: "documentation-info__condition" }, [
              p("div", null, "Bančni izpisek ali potrdilo banke"),
              p("div", null, "Iz dokumenta mora biti razviden podatek o prilivu iz naslova rente ali pokojnine iz tujine. ")
            ], -1),
            p("div", { class: "documentation-info__condition" }, [
              p("div", null, "Odločbo ali drug dokument o prejemanju tuje pokojnine ali rente")
            ], -1)
          ]))) : x("", !0)
        ])) : x("", !0),
        e.employmentType == "Z" ? (S(), N("div", g0, [
          e.slovenianEmployment == !0 ? (S(), N("div", b0, [
            e.is15k ? (S(), N("div", C0, o[12] || (o[12] = [
              p("div", { class: "documentation-info__condition" }, [
                p("div", null, "Bančni izpisek ali potrdilo banke"),
                p("div", null, "Iz dokumenta mora biti razviden podatek o prilivu iz naslova plače za zadnje 3 mesece. ")
              ], -1),
              p("div", { class: "documentation-info__condition" }, [
                p("div", null, "Zadnjo ujemajočo se plačilno listo."),
                p("div", null, "Znesek na plačilni listi se mora ujemati z zneskom na bančnem izpisku.")
              ], -1)
            ]))) : (S(), N("div", I0, [
              e.pay3 ? x("", !0) : (S(), N("div", E0, o[13] || (o[13] = [
                p("div", null, "Bančni izpisek ali potrdilo banke", -1),
                p("div", null, "Iz dokumenta mora biti razviden podatek o prilivu iz naslova plače.", -1)
              ]))),
              e.pay3 ? (S(), N("div", S0, o[14] || (o[14] = [
                p("div", null, "Bančni izpisek ali potrdilo banke", -1),
                p("div", null, "Iz dokumenta mora biti razviden podatek o prilivu iz naslova plače za zadnje 3 mesece. ", -1)
              ]))) : x("", !0)
            ]))
          ])) : x("", !0),
          e.slovenianEmployment == !1 ? (S(), N("div", P0, [
            e.pay3 ? x("", !0) : (S(), N("div", T0, o[15] || (o[15] = [
              p("div", null, "Bančni izpisek ali potrdilo banke", -1),
              p("div", null, "Iz dokumenta mora biti razviden podatek o prilivu iz naslova plače.", -1)
            ]))),
            e.pay3 ? (S(), N("div", w0, o[16] || (o[16] = [
              p("div", null, "Bančni izpisek ali potrdilo banke", -1),
              p("div", null, "Iz dokumenta mora biti razviden podatek o prilivu iz naslova plače za zadnje 3 mesece", -1)
            ]))) : x("", !0),
            o[17] || (o[17] = p("div", { class: "documentation-info__condition" }, [
              p("div", null, "Plačilno listo"),
              p("div", null, "Priložite zadnjo, ujemajočo se plačilno listo.")
            ], -1))
          ])) : x("", !0)
        ])) : x("", !0)
      ]))
    ]));
  }
}), N0 = { class: "documentation-component" }, A0 = { class: "section-heading mt-0" }, M0 = { key: 0 }, O0 = { key: 1 }, R0 = { class: "mt-8" }, $0 = { class: "form-label" }, yb = /* @__PURE__ */ ie({
  __name: "documentation-component",
  props: {
    data: { default: () => ({
      ...e0
    }) },
    showDocInfo: { type: Boolean, default: !0 }
  },
  emits: ["update:data", "navigation-event", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o, i = W({ ...d.data }), l = W({ ...t0 });
    let s = re(!1);
    const { v$: n, navigationAction: a, LoadDocumentationData: c, scrollToFirstErrorWrapper: m } = o0(i, l);
    return G(
      () => d.data,
      // Watch for changes in the data
      (v) => {
        Object.assign(i, v);
      },
      { deep: !0 }
    ), G(
      i,
      (v) => {
        f("update:data", v);
      },
      { deep: !0 }
    ), me(async () => {
      if (i.flowType === R.DOKUMENTACIJA || i.flowType === R.LIMIT) {
        const v = await c();
        v !== "" && f("navigation-event", v);
      }
      s.value = !0, f("componentReady");
    }), t({
      navigationAction: a,
      componentReady: s,
      scrollToFirstErrorWrapper: m
    }), (v, h) => (S(), N("div", N0, [
      p("h2", A0, E(u(r)("Components.DocumentationComponent.DocumentationTitle")), 1),
      l.comment != "" ? (S(), N("div", M0, E(l.comment), 1)) : x("", !0),
      d.showDocInfo && l.comment == "" ? (S(), N("div", O0, [
        h[1] || (h[1] = p("div", { class: "documentation-info__title" }, "Za sklenitev pogodbe priložite dokumentacijo, na podlagi katere bomo potrdili vaše mesečne prihodke. ", -1)),
        C(k0, {
          showDocumentation: !0,
          slovenianCitizen: l.isSlovenianCitizen,
          employmentType: l.employmentType,
          slovenianEmployment: l.hasSlovenianIncome,
          pay3: l.pay3 != 0,
          foreignCitizenOver5k: l.foreignCitizenOver5k,
          is15k: l.is15k
        }, null, 8, ["slovenianCitizen", "employmentType", "slovenianEmployment", "pay3", "foreignCitizenOver5k", "is15k"])
      ])) : x("", !0),
      p("div", R0, [
        p("label", $0, E(u(r)("Components.DocumentationComponent.AddingFiles")), 1),
        C(yo, {
          modelValue: i.documentationFiles,
          "onUpdate:modelValue": h[0] || (h[0] = (_) => i.documentationFiles = _),
          error: u(n).documentationFiles.$error,
          errorText: u(n).documentationFiles.$errors[0] != null ? u(n).documentationFiles.$errors : [],
          infoText: u(r)("Components.DocumentationComponent.AddFiles")
        }, null, 8, ["modelValue", "error", "errorText", "infoText"])
      ])
    ]));
  }
}), x0 = {
  isViewDataLoading: !1,
  headerTitle: "",
  headerSubtitle: "",
  isIdentified: !1,
  selectedBankId: void 0,
  documentationId: void 0
}, L0 = {
  showFinapiFlow: !1
};
function V0(e, t, o) {
  const r = Q("commClient"), { t: d } = H();
  let f = null;
  function i() {
    if (f)
      try {
        f.closed || f.focus();
      } catch (b) {
        console.warn("[finAPI-popup] Unable to focus popup window", b);
      }
  }
  function l() {
    if (f)
      try {
        f.closed || f.close();
      } catch (b) {
        console.warn("[finAPI-popup] Unable to close popup window", b);
      } finally {
        f = null;
      }
  }
  function s(b) {
    e.selectedBankId = b;
  }
  async function n() {
    if (e.selectedBankId != null && e.selectedBankId !== "") {
      t.showFinapiFlow = !1, e.isViewDataLoading = !0;
      let b = await r.executeMethodAsync("FinApiStartProcess", {
        BankId: e.selectedBankId,
        DocumentationId: e.documentationId
      });
      e.isViewDataLoading = !1, b && b.url != "" && v(b.url);
    } else
      alert("Najprej izberite banko.");
  }
  function a(b) {
    b && b[0] && b[0].CallbackType == "FINAPI_FINALISED" && (console.log("FinAPI process finalised"), m(), b[0].Status == "COMPLETED" ? o("navigationEvent", "nextStepFinApi") : o("navigationEvent", "endFailFinApi"));
  }
  function c() {
    t.showFinapiFlow = !0, e.selectedBankId = void 0;
  }
  function m() {
    console.log("Hiding FinAPI flow popup"), o("popupVisibilityChange", !1), t.showFinapiFlow = !1, e.selectedBankId = void 0, console.log("hiding popup", f), f && !f.closed && (console.log("Closing FinAPI popup"), l());
  }
  async function v(b) {
    const I = window.screenX + Math.max(0, (window.outerWidth - 960) / 2), T = window.screenY + Math.max(0, (window.outerHeight - 680) / 2), w = window.open(
      b,
      "finApiBankSelection",
      `popup=yes,width=960,height=680,left=${I},top=${T},resizable=no,scrollbars=yes`
    );
    return w ? (f = w, o("popupVisibilityChange", !0), new Promise((M) => {
      const k = () => {
        i();
      }, L = (U) => {
        const oe = U.data;
        if (console.log("[finAPI-popup] Message received", {
          origin: U.origin,
          payload: oe
        }), U.origin !== window.location.origin || !U.data || typeof U.data != "object") {
          console.warn("[finAPI-popup] Ignoring message due to origin/payload validation failure", {
            expectedOrigin: window.location.origin,
            receivedOrigin: U.origin
          });
          return;
        }
        (typeof oe.type == "string" ? oe.type : "") === "CLOSE_DIALOG" && (console.log("close dialog"), X(), M(null));
      }, $ = () => {
        window.setTimeout(k, 80);
      }, q = () => {
        document.visibilityState === "hidden" && window.setTimeout(k, 80);
      }, J = window.setInterval(() => {
        k();
      }, 1200), X = () => {
        window.removeEventListener("message", L), window.removeEventListener("blur", $), document.removeEventListener("visibilitychange", q), window.clearInterval(J), f = null, o("popupVisibilityChange", !1);
      };
      w.focus(), window.addEventListener("message", L), window.addEventListener("blur", $), document.addEventListener("visibilitychange", q);
    })) : (console.warn("[finAPI-popup] Popup could not be opened (blocked by browser)"), null);
  }
  async function h() {
    try {
      const b = e.selectedBankId;
      return b ? (console.log("Initiating FinAPI authentication with bank:", b), !0) : (console.error("No bank selected"), !1);
    } catch (b) {
      return console.error("FinAPI authentication error:", b), !1;
    }
  }
  async function _(b) {
    let y = null;
    switch (console.log("Button clicked: ", b), b) {
      case "startFinApiDialog":
        await h().then((g) => {
          if (g)
            e.headerTitle = d("EndSuccess.FinApi.Title"), e.headerSubtitle = d("EndSuccess.FinApi.Subtitle"), y = { name: "nextStepFinApi" };
          else {
            e.headerTitle = d("EndFail.FinApi.Title"), e.headerSubtitle = d("EndFail.FinApi.Subtitle"), y = { name: "endFailFinApi" };
            return;
          }
        });
        break;
    }
    return y;
  }
  return {
    navigationAction: _,
    openFinApiBankSelectionPopup: v,
    bankSelected: s,
    showFinapiFlowPopup: c,
    hideFinapiFlowPopup: m,
    startFinApiProcess: n,
    finapiFinalised: a
  };
}
function F0(e, t) {
  const o = Q("commClient"), { copySharedProperties: r } = Ie();
  async function d(i) {
    e.selectedBankId = i, t("bankSelection", i);
  }
  async function f() {
    let i = await o.executeMethodAsync("sw.LoadFinApiBanks", {});
    i && r(e, i);
  }
  return {
    bankSelected: d,
    loadBanks: f
  };
}
const j0 = {
  bankList: [],
  selectedBankId: void 0
}, z0 = { class: "finapi-bank-selection" }, U0 = ["onClick"], B0 = { key: 0 }, G0 = /* @__PURE__ */ ie({
  __name: "fin-api-bank-selection-popup",
  emits: ["bankSelection"],
  setup(e, { emit: t }) {
    console.log("starting bank selection popup component");
    const o = W({ ...j0 }), r = t, { bankSelected: d, loadBanks: f } = F0(o, r);
    return me(async () => {
      o.selectedBankId = void 0, await f();
    }), (i, l) => (S(), N(je, null, [
      l[0] || (l[0] = p("div", { class: "documentation-info__title" }, "Izberite banko, pri kateri imate odprt račun, na katerega prejemate plačo ali pokojnino. Ob izbiri boste preusmerjeni na storitev finAPI. ", -1)),
      p("div", z0, [
        (S(!0), N(je, null, Mt(o.bankList, (s) => (S(), N("div", {
          key: s.finapiBankId,
          class: Le(o.selectedBankId === s.finapiBankId ? "selected" : ""),
          onClick: (n) => u(d)(s.finapiBankId)
        }, [
          s.icon ? (S(), N("span", B0, E(s.icon), 1)) : x("", !0),
          ne(" " + E(s.shortName), 1)
        ], 10, U0))), 128))
      ])
    ], 64));
  }
}), q0 = { class: "documentation-component" }, D0 = { class: "mt-10 mb-6" }, _b = /* @__PURE__ */ ie({
  __name: "fin-api-content-component",
  props: {
    data: { default: () => ({ ...x0 }) },
    popupUrl: {}
  },
  emits: ["update:data", "navigation-event", "componentReady", "popupVisibilityChange"],
  setup(e, { expose: t, emit: o }) {
    const r = Q("commClient"), d = e, f = W({ ...L0 }), i = o, l = W({ ...d.data });
    let s = re(!1);
    const { navigationAction: n, bankSelected: a, showFinapiFlowPopup: c, startFinApiProcess: m, finapiFinalised: v } = V0(l, f, i);
    return G(() => d.data, (h) => {
      h && Object.assign(l, h);
    }, { deep: !0 }), G(l, (h) => {
      i("update:data", h);
    }, { deep: !0 }), me(() => {
      r.OnStreamDataReceived.AddCallback(v), s.value = !0, i("componentReady");
    }), Lt(() => {
      r.OnStreamDataReceived.RemoveCallback(v);
    }), t({
      navigationAction: n,
      componentReady: s
    }), (h, _) => {
      const b = V("v-btn");
      return S(), N(je, null, [
        p("div", q0, [
          _[2] || (_[2] = p("span", { class: "tag tag--blue" }, " Priporočamo ", -1)),
          _[3] || (_[3] = p("h2", { class: "section-heading mt-4" }, "Digitalno potrdite višino mesečnih prihodkov ", -1)),
          _[4] || (_[4] = p("div", null, [
            p("span", { class: "font-weight-semibold" }, "Komitenti banke NLB lahko višino svojih mesečnih prihodkov enostavno potrdite prek digitalne bančne poti"),
            ne(" — neposredno z vašega bančnega računa in v le nekaj klikih."),
            p("br"),
            p("br"),
            ne("Če izberete digitalno potrditev, boste preusmerjeni v varen in enostaven postopek odprtega bančništva, kjer boste pri svoji banki podali soglasje za enkratni vpogled v podatke o prilivih na vaš račun."),
            p("br"),
            p("br"),
            ne("Podatki se uporabijo izključno za namen ocene vaše kreditne sposobnosti v okviru te vloge za nakup na obroke. ")
          ], -1)),
          p("div", D0, [
            C(b, {
              onClick: u(c),
              class: "btn btn--primary-fill",
              variant: "flat"
            }, {
              default: P(() => _[1] || (_[1] = [
                ne(" Potrdi digitalno prek banke ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ]),
          _[5] || (_[5] = p("div", { class: "font-size-75" }, "Varen dostop do podatkov omogoča finAPI, certificirana evropska storitev za varno povezovanje z bankami, ki deluje v skladu s standardi odprtega bančništva (PSD2). ", -1))
        ]),
        C(Ct, {
          display: f.showFinapiFlow,
          showCloseXButton: !0,
          title: "Izbira banke",
          showAcceptButton: !0,
          acceptText: "Izberi",
          closeText: "Prekliči",
          showDeclineButton: !0,
          onAccept: u(m),
          onModalClosed: _[0] || (_[0] = (y) => f.showFinapiFlow = !1)
        }, {
          default: P(() => [
            C(G0, { onBankSelection: u(a) }, null, 8, ["onBankSelection"])
          ]),
          _: 1
        }, 8, ["display", "onAccept"])
      ], 64);
    };
  }
}), H0 = {
  isViewDataLoading: !1,
  headerTitle: "",
  headerSubtitle: "",
  documentationId: void 0
}, Y0 = {
  isSuccess: !1,
  isIdentified: !1,
  isWebProcess: !1,
  identificationUrl: ""
};
function Z0(e, t, o) {
  const r = Q("commClient"), { copySharedProperties: d } = Ie();
  async function f() {
    let i = null, l = await r.executeMethodAsync("FinApiDataGet", {
      DocumentationId: e.documentationId
    });
    return console.log(l), l && d(t, l), i;
  }
  return {
    finApiDataGet: f
  };
}
const W0 = { class: "fin-api-dataget-component" }, K0 = {
  key: 0,
  class: "loading-overlay"
}, Q0 = { class: "card card--default card--no-border text-center pa-14 pl-16 pr-16" }, X0 = { class: "contract-heading__heading mb-10" }, J0 = { class: "contract-heading__text" }, gb = /* @__PURE__ */ ie({
  __name: "fin-api-dataget-component",
  props: {
    data: { default: () => ({ ...H0 }) }
  },
  emits: ["update:data", "navigation-event", "componentReady", "popupVisibilityChange"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = W({ ...Y0 }), i = o, l = W({ ...d.data });
    let s = re(!1);
    const n = F(() => f.isSuccess ? r("Components.FinApiDataGet.HeaderSuccess") : r("Components.FinApiDataGet.HeaderFail")), a = F(() => f.isSuccess ? f.isWebProcess ? f.isIdentified ? r("Components.FinApiDataGet.TextSuccessIdentified") : r("Components.FinApiDataGet.TextSuccessNotIdentified") : r("Components.FinApiDataGet.TextPOSSuccess") : r("Components.FinApiDataGet.TextFail")), c = F(() => f.isSuccess ? f.isWebProcess && !f.isIdentified ? r("Components.FinApiDataGet.ButtonSuccessNotIdentified") : "" : r("Components.FinApiDataGet.ButtonFailBackToDocumentation")), m = F(() => f.isSuccess ? !!(f.isWebProcess && !f.isIdentified) : !0), v = F(() => f.isSuccess ? f.isWebProcess && !f.isIdentified ? 1 : 0 : 2);
    function h() {
      v.value === 1 ? window.open(f.identificationUrl) : v.value === 2 && (console.log("backToDocumentation", l.documentationId), i("navigation-event", "backToDocumentation", { id: l.documentationId }));
    }
    const { finApiDataGet: _ } = Z0(l, f);
    return G(() => d.data, (b) => {
      b && Object.assign(l, b);
    }, { deep: !0 }), G(l, (b) => {
      i("update:data", b);
    }, { deep: !0 }), me(async () => {
      l.isViewDataLoading = !0, await _(), l.isViewDataLoading = !1, s.value = !0, i("componentReady");
    }), t({
      componentReady: s
    }), (b, y) => {
      const g = V("v-icon"), I = V("v-btn");
      return S(), N("div", W0, [
        l.isViewDataLoading ? (S(), N("div", K0, y[1] || (y[1] = [
          p("div", { class: "loading-spinner" }, [
            p("span", { class: "spinner" }),
            ne(" Pridobivanje podatkov ... ")
          ], -1)
        ]))) : x("", !0),
        p("div", Q0, [
          f.isSuccess ? (S(), K(g, {
            key: 0,
            icon: "custom:iconSuccess"
          })) : (S(), K(g, {
            key: 1,
            icon: "custom:iconFailMessage"
          })),
          p("h1", X0, E(n.value), 1),
          p("div", J0, E(a.value), 1),
          m.value ? (S(), K(I, {
            key: 2,
            onClick: y[0] || (y[0] = (T) => h()),
            class: "btn btn--primary-fill my-4"
          }, {
            default: P(() => [
              ne(E(c.value), 1)
            ]),
            _: 1
          })) : x("", !0)
        ])
      ]);
    };
  }
}), ep = {
  employmentType: void 0,
  employerName: "",
  employerAddress: "",
  employerPostCode: "",
  flowType: void 0,
  hasSlovenianIncome: void 0,
  isSlovenianCitizen: void 0
};
function tp(e) {
  const { t } = H();
  return F(() => ({
    employmentType: {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), he)
    },
    // employerName: {
    //     required: helpers.withMessage(t("GlobalErrors.FIELD_REQUIRED"), requiredIf(componentData.employmentType !== EnumEmploymentType.Upokojenec))
    // },
    // employerAddress: {
    //     required: helpers.withMessage(t("GlobalErrors.FIELD_REQUIRED"), requiredIf(componentData.employmentType !== EnumEmploymentType.Upokojenec))
    // },
    // employerPostCode: {
    //     required: helpers.withMessage(t("GlobalErrors.ChoiceRequired"), requiredIf(componentData.employmentType !== EnumEmploymentType.Upokojenec))
    // },
    employerName: {
      required: j.withMessage(t("GlobalErrors.FIELD_REQUIRED"), de(() => e.employmentType !== le.Upokojenec))
    },
    employerAddress: {
      required: j.withMessage(t("GlobalErrors.FIELD_REQUIRED"), de(() => e.employmentType !== le.Upokojenec))
    },
    employerPostCode: {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), de(() => e.employmentType !== le.Upokojenec))
    }
  }));
}
function np(e) {
  const t = Q("generalStore"), { scrollToFirstError: o } = Ie(), r = be(tp(e), F(() => e), { $autoDirty: !0 });
  async function d() {
    return r.value.$touch(), r.value.$validate();
  }
  const f = F(() => ![
    R.LIMIT
  ].includes(e.flowType)), i = F(() => e.isSlovenianCitizen == !0 ? e.hasSlovenianIncome == !0 || e.employmentType === le.SP ? t.state.postalCodeList.slice(0, t.state.postalCodeList.length - 1) : t.state.postalCodeList.slice(-1) : e.isSlovenianCitizen == !1 ? t.state.postalCodeList.slice(0, t.state.postalCodeList.length - 1) : t.state.postalCodeList);
  function l() {
    o(".employment-info-component");
  }
  async function s(n) {
    let a = !1, c = null;
    switch (n) {
      case "validate":
        a = await d(), a && (c = { name: "valid" });
        break;
    }
    return c;
  }
  return {
    v$: r,
    getPostCodeEmploymentInfo: i,
    navigationAction: s,
    scrollToFirstErrorWrapper: l,
    showHeading: f
  };
}
const op = {
  class: "employment-info-component",
  ref: "rootRef"
}, rp = {
  key: 0,
  class: "section-heading"
}, ip = { class: "mb-2" }, ap = { class: "form-label" }, sp = { class: "mb-2" }, lp = { class: "form-label" }, up = { class: "form-label" }, dp = {
  key: 3,
  class: "mb-8 mt-4 hr"
}, bb = /* @__PURE__ */ ie({
  __name: "employment-info-component",
  props: {
    data: { default: () => ({
      ...ep
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o, i = W({ ...d.data });
    let l = re(!1);
    const { v$: s, navigationAction: n, getPostCodeEmploymentInfo: a, scrollToFirstErrorWrapper: c, showHeading: m } = np(i);
    return G(
      () => d.data,
      // Watch for changes in the data
      (v) => {
        Object.assign(i, v);
      },
      { deep: !0 }
    ), G(
      i,
      (v) => {
        f("update:data", v);
      },
      { deep: !0 }
    ), me(async () => {
      l.value = !0, f("componentReady");
    }), t({
      navigationAction: n,
      scrollToFirstErrorWrapper: c,
      componentReady: l
    }), (v, h) => {
      const _ = V("v-col"), b = V("v-row"), y = V("v-autocomplete");
      return S(), N("div", op, [
        u(m) ? (S(), N("h2", rp, E(u(r)("Components.EmplymentInfoComponent.EmploymentTitle")), 1)) : x("", !0),
        i.employmentType !== u(le).Upokojenec ? (S(), K(b, { key: 1 }, {
          default: P(() => [
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", ip, [
                  p("label", ap, E(u(r)("Components.EmplymentInfoComponent.EmployerName")), 1),
                  C(Pe, {
                    ref: "employerNameRef",
                    modelValue: i.employerName,
                    "onUpdate:modelValue": h[0] || (h[0] = (g) => i.employerName = g),
                    "error-messages": u(s).employerName.$errors[0] != null ? u(s).employerName.$errors[0].$message : "",
                    onFocus: u(s).employerName.$reset,
                    variant: "outlined"
                  }, null, 8, ["modelValue", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            }),
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", sp, [
                  p("label", lp, E(u(r)("Components.EmplymentInfoComponent.EmployerAddress")), 1),
                  C(Pe, {
                    ref: "employerAddressRef",
                    modelValue: i.employerAddress,
                    "onUpdate:modelValue": h[1] || (h[1] = (g) => i.employerAddress = g),
                    "error-messages": u(s).employerAddress.$errors[0] != null ? u(s).employerAddress.$errors[0].$message : "",
                    onFocus: u(s).employerAddress.$reset,
                    variant: "outlined"
                  }, null, 8, ["modelValue", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        i.employmentType !== u(le).Upokojenec ? (S(), K(b, { key: 2 }, {
          default: P(() => [
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", up, E(u(r)("Components.EmplymentInfoComponent.EmployerPostalCode")), 1),
                  C(y, {
                    modelValue: i.employerPostCode,
                    "onUpdate:modelValue": h[2] || (h[2] = (g) => i.employerPostCode = g),
                    "error-messages": u(s).employerPostCode.$errors[0] != null ? u(s).employerPostCode.$errors[0].$message : "",
                    onFocus: u(s).employerPostCode.$reset,
                    items: u(a),
                    "item-title": "Value",
                    "item-value": "Key",
                    variant: "outlined"
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "items"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        i.employmentType !== u(le).Upokojenec ? (S(), N("hr", dp)) : x("", !0)
      ], 512);
    };
  }
});
function cp(e) {
  const { t } = H();
  return {
    validationRules: F(() => ({
      employmentSubType: {
        required: j.withMessage(
          t("GlobalErrors.ChoiceRequired"),
          de(() => e.isCompanyTaxNumber === !0)
        )
      },
      employmentType: {
        required: j.withMessage(
          t("GlobalErrors.ChoiceRequired"),
          de(
            () => e.isCompanyTaxNumber === !1 || e.employmentSubType === ut.AfternoonSP
          )
        )
      }
    }))
  };
}
function mp(e) {
  const { scrollToFirstError: t } = Ie(), { validationRules: o } = cp(e), r = be(o, F(() => e), { $autoDirty: !0 });
  async function d() {
    return r.value.$touch(), r.value.$validate();
  }
  function f() {
    t(".employment-type-component");
  }
  async function i(l) {
    let s = !1, n = null;
    switch (l) {
      case "validate":
        s = await d(), s && (n = { name: "valid" });
        break;
    }
    return n;
  }
  return {
    v$: r,
    navigationAction: i,
    scrollToFirstErrorWrapper: f
  };
}
const fp = {
  isSlovenianCitizen: void 0,
  employmentType: void 0,
  // birthdate: undefined,
  employmentSubType: void 0,
  showEmploymentType: !1,
  isCompanyTaxNumber: !1
}, pp = {
  class: "employment-type-component",
  ref: "rootRef"
}, vp = { class: "form-label" }, hp = { class: "form-label" }, yp = { class: "form-label" }, Cb = /* @__PURE__ */ ie({
  __name: "employment-type-component",
  props: {
    data: { default: () => ({
      ...fp
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o;
    let i = re(!1);
    const l = W({ ...d.data }), { v$: s, navigationAction: n, scrollToFirstErrorWrapper: a } = mp(l);
    return G(
      () => d.data,
      // Watch for changes in the data
      (c) => {
        Object.assign(l, c);
      },
      { deep: !0 }
    ), G(
      l,
      async (c) => {
        f("update:data", c);
      },
      { deep: !0 }
    ), G(() => l.employmentSubType, (c) => {
      c === ut.SP ? l.employmentType = le.SP : c !== ut.AfternoonSP && (l.employmentType = void 0);
    }), G(() => l.isCompanyTaxNumber, () => {
      l.employmentSubType = void 0, l.employmentType = void 0;
    }), me(() => {
      i.value = !0, f("componentReady");
    }), t({
      navigationAction: n,
      scrollToFirstErrorWrapper: a,
      componentReady: i
    }), (c, m) => {
      const v = V("v-radio"), h = V("v-radio-group"), _ = V("v-col"), b = V("v-row");
      return S(), N("div", pp, [
        C(b, null, {
          default: P(() => [
            l.showEmploymentType ? (S(), N(je, { key: 0 }, [
              l.isCompanyTaxNumber ? (S(), N(je, { key: 0 }, [
                C(_, { class: "v-col-12 v-col-md-6" }, {
                  default: P(() => [
                    p("label", vp, E(u(r)("Components.EmplymentInfoComponent.SPType")), 1),
                    C(h, {
                      class: "radio-employment-type",
                      modelValue: l.employmentSubType,
                      "onUpdate:modelValue": m[0] || (m[0] = (y) => l.employmentSubType = y),
                      error: u(s).employmentSubType.error,
                      "error-messages": u(s).employmentSubType.$errors[0] != null ? u(s).employmentSubType.$errors[0].$message : "",
                      onFocus: u(s).employmentSubType.$reset
                    }, {
                      default: P(() => [
                        C(v, {
                          label: u(r)("Components.EmplymentInfoComponent.AfternoonSP"),
                          value: u(ut).AfternoonSP
                        }, null, 8, ["label", "value"]),
                        C(v, {
                          label: u(r)("Components.EmplymentInfoComponent.SP"),
                          disabled: l.isSlovenianCitizen === !1,
                          value: u(ut).SP
                        }, null, 8, ["label", "disabled", "value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "error", "error-messages", "onFocus"])
                  ]),
                  _: 1
                }),
                l.employmentSubType === u(ut).AfternoonSP ? (S(), K(_, {
                  key: 0,
                  class: "v-col-12 v-col-md-6"
                }, {
                  default: P(() => [
                    p("label", hp, E(u(r)("Components.EmplymentInfoComponent.EmploymentType")), 1),
                    C(h, {
                      class: "radio-employment-type",
                      modelValue: l.employmentType,
                      "onUpdate:modelValue": m[1] || (m[1] = (y) => l.employmentType = y),
                      error: u(s).employmentType.error,
                      "error-messages": u(s).employmentType.$errors[0] != null ? u(s).employmentType.$errors[0].$message : "",
                      onFocus: u(s).employmentType.$reset
                    }, {
                      default: P(() => [
                        C(v, {
                          label: u(r)("Components.EmplymentInfoComponent.Employed"),
                          value: u(le).Zaposlen
                        }, null, 8, ["label", "value"]),
                        C(v, {
                          label: u(r)("Components.EmplymentInfoComponent.Pensioner"),
                          value: u(le).Upokojenec
                        }, null, 8, ["label", "value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "error", "error-messages", "onFocus"])
                  ]),
                  _: 1
                })) : x("", !0)
              ], 64)) : (S(), K(_, {
                key: 1,
                class: "v-col-12 v-col-md-6"
              }, {
                default: P(() => [
                  p("label", yp, E(u(r)("Components.EmplymentInfoComponent.EmploymentType")), 1),
                  C(h, {
                    class: "radio-employment-type",
                    modelValue: l.employmentType,
                    "onUpdate:modelValue": m[2] || (m[2] = (y) => l.employmentType = y),
                    error: u(s).employmentType.error,
                    "error-messages": u(s).employmentType.$errors[0] != null ? u(s).employmentType.$errors[0].$message : "",
                    onFocus: u(s).employmentType.$reset
                  }, {
                    default: P(() => [
                      C(v, {
                        label: u(r)("Components.EmplymentInfoComponent.Employed"),
                        value: u(le).Zaposlen
                      }, null, 8, ["label", "value"]),
                      C(v, {
                        label: u(r)("Components.EmplymentInfoComponent.Pensioner"),
                        value: u(le).Upokojenec
                      }, null, 8, ["label", "value"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "error", "error-messages", "onFocus"])
                ]),
                _: 1
              }))
            ], 64)) : x("", !0)
          ]),
          _: 1
        })
      ], 512);
    };
  }
}), Hr = {
  hadTRRExecution: void 0,
  hadBlockedTRR: void 0,
  hadLatePayment: void 0,
  hadBankruptcyProceedings: void 0,
  flowType: void 0,
  isViewDataLoading: !1,
  orderToken: "",
  averageSalary: void 0,
  sumInstallments: void 0,
  taxNumber: void 0,
  msisdn: void 0,
  isSlovenianCitizen: void 0
}, _p = {
  showConfirmData: !0,
  confirmDataError: !1
};
function gp(e) {
  const { t } = H();
  return F(() => ({
    hadTRRExecution: {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), he)
    },
    hadBlockedTRR: {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), he)
    },
    hadLatePayment: {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), he)
    },
    hadBankruptcyProceedings: {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), he)
    },
    averageSalary: {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), he)
    },
    sumInstallments: {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), he)
    }
  }));
}
function bp(e, t) {
  const o = be(gp(), F(() => e), { $autoDirty: !0 }), r = Q("commClient"), d = Q("navigationButtonsApi", null), { scrollToFirstError: f } = Ie();
  async function i() {
    return o.value.$touch(), o.value.$validate();
  }
  const l = F(() => ![
    R.LIMIT
  ].includes(e.flowType));
  function s() {
    d !== null && d.setButtonDisabled("Next", !0);
  }
  async function n() {
    o.value.$touch();
    const v = await o.value.$validate();
    return v && (window.dataLayer && window.dataLayer.push({
      event: "funnel_8",
      funnel_name: "izracun_limita",
      step: 8,
      step_name: "financni_podatki",
      cta_name: "Potrdi"
    }), d !== null && (d == null || d.setButtonDisabled("Next", !1)), t.showConfirmData = !1, t.confirmDataError = !1), v;
  }
  async function a(v) {
    [
      "hadTRRExecution",
      "hadBlockedTRR",
      "hadLatePayment",
      "hadBankruptcyProceedings",
      "averageSalary",
      "sumInstallments"
    ].some((b) => e[b] !== v[b]) && (d !== null && (d == null || d.setButtonDisabled("Next", !0)), t.showConfirmData = !0, t.confirmDataError = !1);
  }
  function c() {
    f(".financial-conditions-component");
  }
  async function m(v) {
    let h = !1, _ = null;
    switch (v) {
      case "validate":
        h = await i(), h && (_ = { name: "valid" });
        break;
      case "webNext":
        if (h = await i(), h) {
          if (t.showConfirmData)
            return t.confirmDataError = !0, null;
          await r.executeMethodAsync("SaveFinancialData", {
            TaxNumber: e.taxNumber,
            Msisdn: e.msisdn,
            IsSlovenianCitizen: e.isSlovenianCitizen,
            HadTRRExecution: e.hadTRRExecution,
            HadBlockedTRR: e.hadBlockedTRR,
            HadLatePayment: e.hadLatePayment,
            HadBankruptcyProceedings: e.hadBankruptcyProceedings,
            AverageSalary: e.averageSalary,
            SumInstallments: e.sumInstallments,
            OrderToken: e.orderToken
          }), e.hadBankruptcyProceedings === !0 || e.hadLatePayment === !0 || e.hadBlockedTRR === !0 || e.hadTRRExecution === !0 ? _ = { name: "endFail" } : _ = { name: "nextStep" };
        }
        break;
    }
    return _;
  }
  return {
    v$: o,
    navigationAction: m,
    scrollToFirstErrorWrapper: c,
    confirmData: n,
    dataChanged: a,
    setupComponent: s,
    showHeading: l
  };
}
const Cp = {
  class: "financial-conditions-component",
  ref: "rootRef"
}, Ip = {
  key: 0,
  class: "section-heading"
}, Ep = {
  key: 1,
  class: "callout mt-10"
}, Sp = { class: "mt-8" }, Pp = {
  key: 0,
  class: "v-input--error mt-4"
}, Tp = { class: "v-input__details" }, wp = { class: "v-messages" }, kp = { class: "v-messages__message" }, Ib = /* @__PURE__ */ ie({
  __name: "financial-conditions-component",
  props: {
    data: { default: () => ({
      ...Hr
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o;
    let i = re(!1);
    const l = W({ ...d.data });
    let s = { ...Hr };
    const n = W({ ..._p }), { v$: a, navigationAction: c, scrollToFirstErrorWrapper: m, confirmData: v, dataChanged: h, showHeading: _, setupComponent: b } = bp(l, n);
    return G(
      () => d.data,
      // Watch for changes in the data
      (y) => {
        Object.assign(l, y);
      },
      { deep: !0 }
    ), G(
      l,
      async (y) => {
        await h(s), Object.assign(s, y), f("update:data", y);
      },
      { deep: !0 }
    ), me(() => {
      b(), i.value = !0, f("componentReady");
    }), t({
      navigationAction: c,
      scrollToFirstErrorWrapper: m,
      componentReady: i
    }), (y, g) => {
      const I = V("v-radio"), T = V("v-radio-group"), w = V("v-col"), M = V("v-row"), k = V("v-btn");
      return S(), N("div", Cp, [
        u(_) ? (S(), N("h2", Ip, E(u(r)("Components.FinancialConditionComponent.FinancialTitle")), 1)) : x("", !0),
        C(M, null, {
          default: P(() => [
            C(w, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                g[7] || (g[7] = p("label", { class: "form-label" }, " Ste imeli v zadnjem letu izvršbo na TRR? ", -1)),
                C(T, {
                  modelValue: l.hadTRRExecution,
                  "onUpdate:modelValue": g[0] || (g[0] = (L) => l.hadTRRExecution = L),
                  error: u(a).hadTRRExecution.error,
                  "error-messages": u(a).hadTRRExecution.$errors[0] != null ? u(a).hadTRRExecution.$errors[0].$message : "",
                  onFocus: u(a).hadTRRExecution.$reset
                }, {
                  default: P(() => [
                    C(I, {
                      label: u(r)("GeneralButtons.Yes"),
                      value: !0
                    }, null, 8, ["label"]),
                    C(I, {
                      label: u(r)("GeneralButtons.No"),
                      value: !1
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            }),
            C(w, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                g[8] || (g[8] = p("label", { class: "form-label" }, " Ste imeli v zadnjem letu blokiran TRR? ", -1)),
                C(T, {
                  modelValue: l.hadBlockedTRR,
                  "onUpdate:modelValue": g[1] || (g[1] = (L) => l.hadBlockedTRR = L),
                  error: u(a).hadBlockedTRR.error,
                  "error-messages": u(a).hadBlockedTRR.$errors[0] != null ? u(a).hadBlockedTRR.$errors[0].$message : "",
                  onFocus: u(a).hadBlockedTRR.$reset
                }, {
                  default: P(() => [
                    C(I, {
                      label: u(r)("GeneralButtons.Yes"),
                      value: !0
                    }, null, 8, ["label"]),
                    C(I, {
                      label: u(r)("GeneralButtons.No"),
                      value: !1
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        C(M, null, {
          default: P(() => [
            C(w, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                g[9] || (g[9] = p("label", { class: "form-label" }, " Ste v zadnjem letu zamujali s plačilom obroka kredita ali leasinga? ", -1)),
                C(T, {
                  modelValue: l.hadLatePayment,
                  "onUpdate:modelValue": g[2] || (g[2] = (L) => l.hadLatePayment = L),
                  error: u(a).hadLatePayment.error,
                  "error-messages": u(a).hadLatePayment.$errors[0] != null ? u(a).hadLatePayment.$errors[0].$message : "",
                  onFocus: u(a).hadLatePayment.$reset
                }, {
                  default: P(() => [
                    C(I, {
                      label: u(r)("GeneralButtons.Yes"),
                      value: !0
                    }, null, 8, ["label"]),
                    C(I, {
                      label: u(r)("GeneralButtons.No"),
                      value: !1
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            }),
            C(w, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                g[10] || (g[10] = p("label", { class: "form-label" }, " Ste trenutno v stečajnem postopku? ", -1)),
                C(T, {
                  modelValue: l.hadBankruptcyProceedings,
                  "onUpdate:modelValue": g[3] || (g[3] = (L) => l.hadBankruptcyProceedings = L),
                  error: u(a).hadBankruptcyProceedings.error,
                  "error-messages": u(a).hadBankruptcyProceedings.$errors[0] != null ? u(a).hadBankruptcyProceedings.$errors[0].$message : "",
                  onFocus: u(a).hadBankruptcyProceedings.$reset
                }, {
                  default: P(() => [
                    C(I, {
                      label: u(r)("GeneralButtons.Yes"),
                      value: !0
                    }, null, 8, ["label"]),
                    C(I, {
                      label: u(r)("GeneralButtons.No"),
                      value: !1
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        C(M, null, {
          default: P(() => [
            C(w, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                g[11] || (g[11] = p("label", { class: "form-label" }, " Znesek plače ali pokojnine ", -1)),
                C(Te, {
                  modelValue: l.averageSalary,
                  "onUpdate:modelValue": g[4] || (g[4] = (L) => l.averageSalary = L),
                  "error-messages": u(a).averageSalary.$errors[0] != null ? u(a).averageSalary.$errors[0].$message : "",
                  onFocus: u(a).averageSalary.$reset,
                  variant: "outlined",
                  appendInnerIcon: "mdi-currency-eur",
                  numberOfDecimals: 2,
                  hint: "Vpišite vsoto neto prihodka, prehrane in prevoza.",
                  "persistent-hint": ""
                }, null, 8, ["modelValue", "error-messages", "onFocus"])
              ]),
              _: 1
            }),
            C(w, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                g[12] || (g[12] = p("label", { class: "form-label" }, " Vsota vseh trenutnih mesečnih obrokov ", -1)),
                C(Te, {
                  modelValue: l.sumInstallments,
                  "onUpdate:modelValue": g[5] || (g[5] = (L) => l.sumInstallments = L),
                  "error-messages": u(a).sumInstallments.$errors[0] != null ? u(a).sumInstallments.$errors[0].$message : "",
                  onFocus: u(a).sumInstallments.$reset,
                  variant: "outlined",
                  appendInnerIcon: "mdi-currency-eur",
                  numberOfDecimals: 2,
                  hint: "Vpišite seštevek vseh svojih obrokov iz naslova kreditov in leasingov.",
                  "persistent-hint": ""
                }, null, 8, ["modelValue", "error-messages", "onFocus"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        n.showConfirmData ? (S(), N("div", Ep, [
          g[14] || (g[14] = ne(" Prosimo ponovno preverite in potrdite točnost vnesenih finančnih podatkov. ")),
          g[15] || (g[15] = p("br", null, null, -1)),
          g[16] || (g[16] = p("br", null, null, -1)),
          g[17] || (g[17] = p("span", { class: "font-weight-600" }, "Za podane podatke ste pravno in materialno odgovorni.", -1)),
          g[18] || (g[18] = ne()),
          g[19] || (g[19] = p("br", null, null, -1)),
          g[20] || (g[20] = p("br", null, null, -1)),
          g[21] || (g[21] = ne(" Vnesene finančne podatke bomo po identifikaciji preverili v informacijskem sistemu bonitet fizičnih oseb (SISBON). Če se bo ob preverjanju izkazalo, da so podatki delno ali v celoti napačni, bo ocena limita za obročno odplačevanje lahko negativna in pogodbe ne bo možno skleniti.")),
          g[22] || (g[22] = p("br", null, null, -1)),
          g[23] || (g[23] = p("br", null, null, -1)),
          p("div", Sp, [
            C(k, {
              onClick: g[6] || (g[6] = (L) => u(v)()),
              class: "btn btn--primary-fill",
              variant: "flat"
            }, {
              default: P(() => g[13] || (g[13] = [
                ne(" Potrdi podatke ")
              ])),
              _: 1
            })
          ]),
          n.confirmDataError ? (S(), N("div", Pp, [
            p("div", Tp, [
              p("div", wp, [
                p("div", kp, E(u(r)("GlobalErrors.ConfirmDataError")), 1)
              ])
            ])
          ])) : x("", !0)
        ])) : x("", !0)
      ], 512);
    };
  }
}), Np = {
  orderToken: void 0,
  TRR: "",
  flowType: void 0,
  isSlovenianCitizen: void 0,
  hasSlovenianBankAccount: void 0,
  employmentType: void 0,
  isViewDataLoading: !1
}, Ap = {
  externalResults: {},
  message: ""
};
function Mp(e) {
  const { t } = H();
  return F(() => ({
    hasSlovenianBankAccount: {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), he)
    },
    TRR: {
      required: j.withMessage(t("GlobalErrors.FieldRequired"), he)
    }
  }));
}
function Op(e, t) {
  const o = Q("commClient"), { scrollToFirstError: r } = Ie(), { t: d } = H(), f = be(Mp(), F(() => e), { $autoDirty: !0, $externalResults: t.externalResults });
  async function i() {
    return f.value.$touch(), await f.value.$validate();
  }
  const l = F(() => ![
    R.LIMIT
  ].includes(e.flowType));
  async function s(b) {
    e.hasSlovenianBankAccount != b.hasSlovenianBankAccount && e.hasSlovenianBankAccount && (e.TRR = "");
  }
  const n = F(() => {
    if (e.hasSlovenianBankAccount === !0 || e.employmentType === le.SP)
      return 15;
  });
  async function a() {
    return e.isViewDataLoading = !0, new Promise((b, y) => {
      t.externalResults.TRR = [], o.executeMethodAsync(
        "CheckIban",
        {
          OrderToken: e.orderToken,
          IBAN: e.hasSlovenianBankAccount ? "SI56" + e.TRR : e.TRR
        }
      ).then(async (g) => {
        g.Status == "VALID" ? b(!0) : g.Status == "UNCHECKED" ? (e.hasSlovenianBankAccount || e.employmentType == le.SP) && !c() ? (t.externalResults.TRR = [d("Components.FinancialDataComponent.InvalidIban")], y(!1)) : m() ? b(!0) : (t.externalResults.TRR = [d("Components.FinancialDataComponent.InvalidIban")], y(!1)) : (t.externalResults.TRR = [d("Components.FinancialDataComponent.InvalidIban")], y(!1)), e.isViewDataLoading = !1;
      });
    });
  }
  function c() {
    var b = (98 - parseInt(e.TRR.substring(0, 13) + "00") % 97).toString();
    return b.length == 1 && (b = "0" + b), e.TRR == e.TRR.substring(0, 13) + b;
  }
  function m() {
    return e.TRR.replaceAll(" ", "").length > 14 && /^[A-Za-z]{2}[A-Za-z0-9]*$/.test(e.TRR.replaceAll(" ", ""));
  }
  function v() {
    e.employmentType == le.SP && (e.hasSlovenianBankAccount = !0);
  }
  function h() {
    r(".financial-data-component");
  }
  async function _(b) {
    let y = !1, g = null;
    switch (b) {
      case "validate":
        y = await i(), y && await a().then(() => {
          g = { name: "valid" };
        }).catch((I) => {
          f.value.TRR.$touch();
        });
        break;
      case "webNext":
        y = await i(), console.log("Si v webNext"), console.log("is form valid al kaku: ", y), y && (console.log("form validirana financialS"), g = { name: "nextStep" });
        break;
    }
    return g;
  }
  return {
    v$: f,
    dataChanged: s,
    trrMaxLength: n,
    navigationAction: _,
    scrollToFirstErrorWrapper: h,
    SetTrr: v,
    showHeading: l
  };
}
const Rp = {
  class: "financial-data-component",
  ref: "rootRef"
}, $p = {
  key: 0,
  class: "section-heading"
}, xp = { class: "form-label form-label--text" }, Lp = { class: "form-label" }, Eb = /* @__PURE__ */ ie({
  __name: "financial-data-component",
  props: {
    data: { default: () => ({
      ...Np
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o, i = W({ ...d.data });
    let l = re(!1);
    me(() => {
      m(), l.value = !0, f("componentReady");
    });
    const s = W({ ...Ap }), { v$: n, trrMaxLength: a, navigationAction: c, SetTrr: m, scrollToFirstErrorWrapper: v, showHeading: h } = Op(i, s);
    return G(
      () => d.data,
      // Watch for changes in the data
      (_) => {
        Object.assign(i, _);
      },
      { deep: !0 }
    ), G(
      i,
      (_) => {
        f("update:data", _);
      },
      { deep: !0 }
    ), t({
      navigationAction: c,
      scrollToFirstErrorWrapper: v,
      componentReady: l
    }), (_, b) => {
      const y = V("v-radio"), g = V("v-radio-group"), I = V("v-col"), T = V("v-row");
      return S(), N("div", Rp, [
        u(h) ? (S(), N("h2", $p, E(u(r)("Components.FinancialDataComponent.FinancialDataTitle")), 1)) : x("", !0),
        C(T, null, {
          default: P(() => [
            C(I, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", xp, E(u(r)("Components.FinancialDataComponent.SlovenianTrr")), 1),
                  C(g, {
                    modelValue: i.hasSlovenianBankAccount,
                    "onUpdate:modelValue": b[0] || (b[0] = (w) => i.hasSlovenianBankAccount = w),
                    disabled: i.isSlovenianCitizen == !1 && i.hasSlovenianBankAccount == !0 || i.employmentType === u(le).SP,
                    error: u(n).hasSlovenianBankAccount.error,
                    "error-messages": u(n).hasSlovenianBankAccount.$errors[0] != null ? u(n).hasSlovenianBankAccount.$errors[0].$message : "",
                    onFocus: u(n).hasSlovenianBankAccount.$reset
                  }, {
                    default: P(() => [
                      C(y, {
                        label: u(r)("GeneralButtons.Yes"),
                        value: !0
                      }, null, 8, ["label"]),
                      C(y, {
                        label: u(r)("GeneralButtons.No"),
                        value: !1
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled", "error", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            }),
            C(I, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", Lp, E(u(r)("Components.FinancialDataComponent.TrrNumber")), 1),
                  C(Pe, {
                    ref: "trrRef",
                    modelValue: i.TRR,
                    "onUpdate:modelValue": b[1] || (b[1] = (w) => i.TRR = w),
                    "error-messages": u(n).TRR.$errors[0] != null ? u(n).TRR.$errors[0].$message : "",
                    onFocus: u(n).TRR.$reset,
                    variant: "outlined",
                    prefix: i.hasSlovenianBankAccount == !0 || i.isSlovenianCitizen == !1 || i.employmentType === u(le).SP ? "SI56" : void 0,
                    counter: i.hasSlovenianBankAccount == !0 || i.isSlovenianCitizen == !1 || i.employmentType === u(le).SP ? "15" : void 0,
                    maxLength: u(a)
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "prefix", "counter", "maxLength"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 512);
    };
  }
}), or = "data:image/svg+xml,%3csvg%20width='120'%20height='120'%20viewBox='0%200%20120%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_25105_93412)'%3e%3cg%20clip-path='url(%23clip1_25105_93412)'%3e%3cpath%20d='M48%2090C48%2096.6%2053.4%20102%2060%20102C66.6%20102%2072%2096.6%2072%2090'%20fill='%2384BD00'/%3e%3cpath%20d='M34.9%2031.1001C35.5%2030.6001%2035.6%2029.6001%2035%2029.0001C34.5%2028.4001%2033.5%2028.3001%2032.9%2028.9001C25.5%2035.3001%2021.2%2044.2001%2020.6%2053.9001C20.6%2054.7001%2021.2%2055.4001%2022%2055.5001C22.8%2055.5001%2023.4%2054.9001%2023.5%2054.1001C24%2045.2001%2028%2037.0001%2034.8%2031.1001H34.9Z'%20fill='%23230078'/%3e%3cpath%20d='M87.0999%2028.9C86.4999%2028.4%2085.5%2028.4%2085%2029C84.5%2029.6%2084.4999%2030.6%2085.0999%2031.1C91.7999%2037%2095.9%2045.1%2096.4%2054.1C96.4%2054.9%2097.1%2055.5%2097.9%2055.5C98.7%2055.5%2099.4%2054.7%2099.3%2053.9C98.7%2044.2%2094.4%2035.3%2087%2028.9H87.0999Z'%20fill='%23230078'/%3e%3cpath%20d='M90.5%2075.1H87.5V56.1C87.5%2044.1%2079.8%2033.8%2069%2030.1V25.5C69%2021.4%2065.6%2018%2061.5%2018H58.5C54.4%2018%2051%2021.4%2051%2025.5V30C40.2%2033.7%2032.4%2044%2032.4%2056V75H29.5C26.5%2075%2024%2077.5%2024%2080.5V84.4C24%2087.4%2026.5%2089.9%2029.5%2089.9H90.5C93.5%2089.9%2096%2087.4%2096%2084.4V80.5C96%2077.5%2093.5%2075%2090.5%2075V75.1ZM54%2025.5C54%2023%2056%2021%2058.5%2021H61.5C64%2021%2066%2023%2066%2025.5V29.2C64.1%2028.8%2062%2028.5%2059.9%2028.5C57.8%2028.5%2055.9%2028.7%2053.9%2029.2V25.5H54ZM93%2084.5C93%2085.9%2091.9%2087%2090.5%2087H29.5C28.1%2087%2027%2085.9%2027%2084.5V80.6C27%2079.2%2028.1%2078.1%2029.5%2078.1H73.9C74.7%2078.1%2075.4%2077.4%2075.4%2076.6C75.4%2075.8%2074.7%2075.1%2073.9%2075.1H35.4V56.1C35.4%2042.6%2046.4%2031.5%2060%2031.5C73.6%2031.5%2084.6%2042.5%2084.6%2056.1V76.6C84.6%2077.4%2085.3%2078.1%2086.1%2078.1H90.6C92%2078.1%2093.1%2079.2%2093.1%2080.6V84.5H93Z'%20fill='%23230078'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_25105_93412'%3e%3crect%20width='120'%20height='120'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_25105_93412'%3e%3crect%20width='120'%20height='120'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Yr = {
  creditAmount: void 0,
  selectedSpecialProduct: void 0,
  selectedPromoProduct: void 0,
  selectedProduct: void 0,
  selectedProductType: void 0,
  productList: [],
  specialProductList: [],
  promoProductList: [],
  EOMInstallmentMax: void 0,
  promoCode: void 0,
  flowType: void 0,
  employmentType: void 0,
  isSlovenianCitizen: !1,
  isPreapproved: !1,
  preapprovedCreditAmount: 0,
  partnerDiyType: void 0,
  partnerId: -1,
  partnerLimitsEOM: !1,
  summitDebt: 0,
  maxTriglavAmount: void 0,
  isViewDataLoading: !1,
  headerTitle: "",
  headerSubtitle: "",
  birthdate: void 0
}, Vp = {
  showPermanentValidity: !1,
  codeMatches: !1,
  isDataLoading: !1,
  externalResults: {},
  isCodeSent: !1,
  isEmailValidationSent: !1,
  ageError: "",
  creditAmountError: "",
  creditAmountPreapprovedError: "",
  showPodpis: !1,
  podpisUrl: "",
  emailVerificationSending: !1
};
function Fp(e, t) {
  const { t: o, n: r } = H(), d = F(() => e.isPreapproved && (e.creditAmount == null || e.creditAmount <= e.preapprovedCreditAmount)), f = F(() => {
    let a = 0;
    if (e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct != null)
      return e.selectedSpecialProduct.amountMin;
    if (e.promoCode != "")
      for (let c = 0; c < e.promoProductList.length; c++)
        e.promoProductList[c].amountMin > a && (a = e.promoProductList[c].amountMin);
    else {
      if (e.selectedProduct != null)
        return e.selectedProduct.amountMin;
      a = 99999;
      for (let c = 0; c < e.productList.length; c++)
        e.productList[c].amountMin < a && (a = e.productList[c].amountMin);
    }
    return a;
  }), i = F(() => {
    let a = 99999;
    if (e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct != null)
      return a = e.selectedSpecialProduct.amountMax - e.summitDebt, e.maxTriglavAmount != null && e.maxTriglavAmount < a && (a = e.maxTriglavAmount), a;
    if (e.promoCode != "")
      for (let c = 0; c < e.promoProductList.length; c++)
        e.promoProductList[c].amountMax < a && (a = e.promoProductList[c].amountMax);
    else {
      if (e.selectedProduct != null)
        return a = e.selectedProduct.amountMax - e.summitDebt, e.maxTriglavAmount != null && e.maxTriglavAmount < a && (a = e.maxTriglavAmount), a;
      a = 0;
      for (let c = 0; c < e.productList.length; c++)
        e.productList[c].amountMax > a && (a = e.productList[c].amountMax);
    }
    return e.maxTriglavAmount != null && e.maxTriglavAmount < a && (a = e.maxTriglavAmount), a - e.summitDebt;
  });
  function l(a) {
    if (e.flowType == R.POS || e.flowType == R.POS_STRANKA || e.flowType == R.POS_MOBILE) {
      if (t.creditAmountPreapprovedError = "", a == null || a.toString() == "")
        return t.creditAmountError = o("GlobalErrors.FIELD_REQUIRED"), !1;
      {
        let c = i.value;
        if (e.isSlovenianCitizen == !1 && (c = 8e3 - e.summitDebt), c <= f.value)
          return t.creditAmountError = o("GlobalErrors.NO_CREDIT"), !1;
        if (e.isPreapproved && !d) {
          let m = e.preapprovedCreditAmount;
          a > m && (t.creditAmountPreapprovedError = o("GlobalErrors.CUSTOM_AMOUNT", { prvi: r(f.value, "decimal"), drugi: r(m, "decimal") }));
        }
        return t.creditAmountError = o("GlobalErrors.CUSTOM_AMOUNT2", { prvi: r(f.value, "decimal"), drugi: r(c, "decimal") }), a >= f.value && a <= c;
      }
    }
    return !0;
  }
  const s = () => e.flowType === R.POS || e.flowType === R.POS_STRANKA || e.flowType === R.POS_MOBILE;
  return {
    validationRules: F(() => ({
      creditAmount: {
        requiredIf: j.withMessage(o("GlobalErrors.FieldRequired"), de(s)),
        isValidNumber: j.withMessage(o("GlobalErrors.AmountCannotBeZero"), od(ho(0))),
        customValidator: l
      },
      selectedProductType: {
        requiredIf: j.withMessage(o("GlobalErrors.ChoiceRequired"), de(s))
      },
      // birthdate: {
      //     required: helpers.withMessage(t("GlobalErrors.FieldRequired"), requiredIf(isFlowTypeWebRelevant)),
      //     customAge: helpers.withMessage(t("GlobalErrors.Age_limit"), () => {
      //         return isFlowTypeWebRelevant() ? CheckForComingOfAge() : true;
      //     })
      // },
      selectedSpecialProduct: {
        required: j.withMessage(o("GlobalErrors.FIELD_REQUIRED"), de(() => e.selectedProductType === "SPECIAL"))
      }
    }))
  };
}
function jp(e, t, o) {
  const r = Q("commClient"), d = Q("navigationButtonsApi"), { scrollToFirstError: f } = Ie(), { t: i } = H(), { validationRules: l } = Fp(e, t), s = be(l, F(() => e), { $autoDirty: !0, $externalResults: t.externalResults });
  function n(I) {
    if (!I) return 0;
    const T = /* @__PURE__ */ new Date();
    let w = T.getFullYear() - I.getFullYear();
    const M = T.getMonth() - I.getMonth();
    return (M < 0 || M === 0 && T.getDate() < I.getDate()) && w--, w;
  }
  const a = F(() => {
    let I = e.specialProductList;
    e.isSlovenianCitizen === !1 && (I = I.filter((w) => w.hasDocumentation));
    const T = n(e.birthdate);
    return T > 0 && (I = I.filter((w) => T >= w.ageMin)), I;
  });
  async function c() {
    return s.value.$touch(), await s.value.$validate();
  }
  async function m(I) {
    if (e.selectedProductType != I.selectedProductType)
      for (let T = 0; T < e.productList.length; T++)
        e.productList[T].productId == e.selectedProductType && (e.selectedProduct = e.productList[T]);
  }
  function v() {
    e.partnerDiyType == xt.NONE && (d == null || d.setButtonVisible("DIYMobileNext", !1)), e.partnerDiyType == xt.POS_MOBILE && (d == null || d.setButtonVisible("SignVloga", !1));
  }
  async function h() {
    const I = await r.executeMethodAsync("sf.ProductList", {
      Employment: e.employmentType == le.SP ? "2" : "1"
      // Employment = 2 means SP, else it is 1
    });
    I && (e.productList = I.productList, e.specialProductList = I.specialProducts, e.promoProductList = I.promoProducts, I.productList.length == 1 && (e.selectedProduct = I.productList[0], e.selectedSpecialProduct = void 0, e.selectedPromoProduct = void 0));
  }
  function _() {
    let I = [];
    return e.productList.forEach((T) => {
      I.push({
        Key: T.productId,
        Value: i("Product." + T.productId),
        AdditionalData: {
          image: T.productId
        }
      });
    }), I;
  }
  function b(I) {
    for (let T = 0; T < e.productList.length; T++)
      if (e.productList[T].productId == I)
        return !0;
    return !1;
  }
  function y() {
    f(".financing-options-component");
  }
  async function g(I) {
    let T = !1, w = null;
    switch (I) {
      case "validate":
        T = await c(), T && (w = { name: "valid" });
        break;
    }
    return w;
  }
  return {
    dataChanged: m,
    ProductList: h,
    navigationAction: g,
    getProductTranslated: _,
    productIsAvailable: b,
    filteredSpecialProductList: a,
    setupButtons: v,
    v$: s,
    scrollToFirstErrorWrapper: y
  };
}
const zp = { class: "financing-options-component" }, Up = {
  key: 0,
  class: "section-heading"
}, Bp = { key: 1 }, Gp = { class: "form-label" }, qp = {
  key: 0,
  class: "notification notification--warning mt-4"
}, Dp = { class: "control-product-type" }, Hp = { class: "form-label" }, Yp = { key: 0 }, Zp = { class: "form-label" }, Wp = {
  key: 0,
  class: "form-label"
}, Sb = /* @__PURE__ */ ie({
  __name: "financing-options-component",
  props: {
    data: { default: () => ({
      ...Yr
    }) }
  },
  emits: ["update:data", "navigationEvent", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o, i = W({ ...d.data });
    let l = { ...Yr }, s = re(!1);
    const n = W({ ...Vp }), {
      v$: a,
      dataChanged: c,
      productIsAvailable: m,
      setupButtons: v,
      ProductList: h,
      navigationAction: _,
      scrollToFirstErrorWrapper: b,
      filteredSpecialProductList: y
    } = jp(i, n);
    return G(
      () => d.data,
      // Watch for changes in the data
      (g) => {
        Object.assign(i, g);
      },
      { deep: !0 }
    ), G(
      i,
      async (g) => {
        await c(l), Object.assign(l, g), f("update:data", g);
      },
      { deep: !0 }
    ), Q("generalStore"), me(async () => {
      switch (v(), i.flowType) {
        case R.POS:
          await h();
          break;
      }
      s.value = !0, f("componentReady");
    }), t({
      navigationAction: _,
      scrollToFirstErrorWrapper: b,
      componentReady: s
    }), (g, I) => {
      const T = V("v-col"), w = V("v-radio"), M = V("v-radio-group"), k = V("v-autocomplete"), L = V("v-row");
      return S(), N("div", zp, [
        i.flowType === u(R).POS || i.flowType === u(R).POS_STRANKA || i.flowType === u(R).POS_MOBILE ? (S(), N("h2", Up, E(u(r)("Components.IdentificationDataComponent.FinancingTitle")), 1)) : x("", !0),
        i.isPreapproved === !0 && (i.creditAmount === void 0 || i.preapprovedCreditAmount >= i.creditAmount) ? (S(), N("div", Bp, I[5] || (I[5] = [
          p("div", { class: "notification notification--big" }, [
            p("div", { class: "d-flex ga-4" }, [
              p("img", {
                src: or,
                alt: "Predodobreno",
                class: ""
              }),
              p("div", null, [
                p("div", { class: "title" }, "Vnaprej odobreno plačilo na obroke"),
                p("div", null, "Stranka ima vnaprej odobreno plačilo na obroke, zato bo sklenitev pogodbe izvedena po skrajšanem postopku. ")
              ])
            ])
          ], -1)
        ]))) : x("", !0),
        i.flowType === u(R).POS || i.flowType === u(R).POS_STRANKA || i.flowType === u(R).POS_MOBILE ? (S(), K(L, { key: 2 }, {
          default: P(() => [
            C(T, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", Gp, E(u(r)("Components.IdentificationDataComponent.CreditAmount")), 1),
                C(Te, {
                  modelValue: i.creditAmount,
                  "onUpdate:modelValue": I[0] || (I[0] = ($) => i.creditAmount = $),
                  numberOfDecimals: 2,
                  appendText: "EUR",
                  "error-messages": u(a).creditAmount.$errors[0] != null ? n.creditAmountError : "",
                  onFocus: u(a).creditAmount.$reset,
                  formatNumber: ($, q) => $.toLocaleString("sl-SI", { minimumFractionDigits: q, maximumFractionDigits: q })
                }, null, 8, ["modelValue", "error-messages", "onFocus", "formatNumber"]),
                i.isPreapproved === !0 && i.creditAmount !== void 0 && i.preapprovedCreditAmount < i.creditAmount ? (S(), N("div", qp, E(u(r)("Components.IdentificationDataComponent.PreapprovedAmountNotOk")), 1)) : x("", !0)
              ]),
              _: 1
            }),
            C(T, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", Dp, [
                  p("label", Hp, E(u(r)("Components.IdentificationDataComponent.ChooseProductType")), 1),
                  C(M, {
                    modelValue: i.selectedProductType,
                    "onUpdate:modelValue": I[1] || (I[1] = ($) => i.selectedProductType = $),
                    error: u(a).selectedProductType.error,
                    "error-messages": u(a).selectedProductType.$errors[0] != null ? u(a).selectedProductType.$errors[0].$message : "",
                    onFocus: u(a).selectedProductType.$reset
                  }, {
                    default: P(() => [
                      u(m)("OBR") ? (S(), K(w, {
                        key: 0,
                        class: "product-type__obrestni",
                        value: "OBR",
                        label: u(r)("Product.OBR")
                      }, null, 8, ["label"])) : x("", !0),
                      u(m)("BREZOBR") ? (S(), K(w, {
                        key: 1,
                        class: "product-type__brez-obresti",
                        value: "BREZOBR",
                        label: u(r)("Product.BREZOBR")
                      }, null, 8, ["label"])) : x("", !0),
                      u(m)("EOM0") ? (S(), K(w, {
                        key: 2,
                        class: "product-type__eom0",
                        value: "EOM0",
                        label: u(r)("Product.EOM0")
                      }, null, 8, ["label"])) : x("", !0),
                      u(m)("MOR") ? (S(), K(w, {
                        key: 3,
                        class: "product-type__moratorij",
                        value: "MOR",
                        label: u(r)("Product.MOR")
                      }, null, 8, ["label"])) : x("", !0),
                      u(y) != null && u(y).length > 0 ? (S(), K(w, {
                        key: 4,
                        class: "product-type__posebne-akcije",
                        value: "SPECIAL",
                        label: u(r)("Product.SPECIAL")
                      }, null, 8, ["label"])) : x("", !0)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "error", "error-messages", "onFocus"]),
                  i.selectedProductType === "EOM0" && i.partnerLimitsEOM === !0 && i.partnerDiyType !== "NONE" ? (S(), N("div", Yp, [
                    p("label", Zp, E(u(r)("Components.IdentificationDataComponent.EOMInstallmentMax")), 1),
                    C(Te, {
                      modelValue: i.EOMInstallmentMax,
                      "onUpdate:modelValue": I[2] || (I[2] = ($) => i.EOMInstallmentMax = $),
                      numberOfDecimals: 0
                    }, null, 8, ["modelValue"])
                  ])) : x("", !0)
                ]),
                i.selectedProductType === "SPECIAL" ? (S(), N("label", Wp, " Posebne akcije ")) : x("", !0),
                i.selectedProductType === "SPECIAL" ? (S(), K(k, {
                  key: 1,
                  modelValue: i.selectedSpecialProduct,
                  "onUpdate:modelValue": I[3] || (I[3] = ($) => i.selectedSpecialProduct = $),
                  items: u(y),
                  error: u(a).selectedSpecialProduct.error,
                  "error-messages": u(a).selectedSpecialProduct.$errors[0] != null ? u(a).selectedSpecialProduct.$errors[0].$message : "",
                  onFocus: u(a).selectedSpecialProduct.$reset,
                  "return-object": !0,
                  "item-title": "productName",
                  "item-value": "productId",
                  variant: "outlined"
                }, null, 8, ["modelValue", "items", "error", "error-messages", "onFocus"])) : x("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        C(Ct, {
          display: n.showPodpis,
          onModalClosed: I[4] || (I[4] = ($) => n.showPodpis = !1),
          showAcceptButton: !1,
          showDeclineButton: !1,
          showCloseXButton: !0,
          title: u(r)("Components.IdentificationDataComponent.SignatureTitle"),
          class: "dialog-preview"
        }, {
          default: P(() => [
            C(fn, {
              url: n.podpisUrl,
              frameBorder: "0"
            }, null, 8, ["url"])
          ]),
          _: 1
        }, 8, ["display", "title"])
      ]);
    };
  }
}), Zr = {
  flowType: void 0,
  personalDocumentType: void 0,
  idNumber: "",
  idNumberCheck: "",
  documentIssuer: "",
  permanentValidity: void 0,
  issueDate: void 0,
  validityDate: void 0,
  identificationConfirmation: !1,
  userFullName: "",
  isSlovenianCitizen: !1,
  birthdate: void 0,
  isExistingUser: !1,
  isIdentified: !1,
  prefilledData: !1,
  isViewDataLoading: !1,
  isDataChecked: !1
}, Kp = {
  showPermanentValidity: !1
};
function Qp(e, t) {
  const { t: o } = H();
  return {
    validationRules: F(() => ({
      personalDocumentType: {
        required: j.withMessage(o("GlobalErrors.ChoiceRequired"), he)
      },
      idNumber: {
        required: j.withMessage(o("GlobalErrors.FieldRequired"), he),
        customIdNumber: j.withMessage(o("GlobalErrors.ExactNumber"), () => e.isSlovenianCitizen == !0 && e.personalDocumentType == At.PersonalId ? e.idNumber.length == 9 : !0),
        customCheckIfNumber: j.withMessage(o("GlobalErrors.CheckNumber"), () => e.isSlovenianCitizen == !0 && e.idNumber.length == 9 && e.personalDocumentType == At.PersonalId ? !!(/^\d+$/.test(e.idNumber) || e.idNumber.startsWith("IE") && /^\d+$/.test(e.idNumber.substring(2))) : !0),
        foreignCheck: j.withMessage(o("GlobalErrors.SiError"), () => {
          var d;
          return !(e.isSlovenianCitizen === !1 && ((d = e.idNumber) != null && d.startsWith("SI")));
        }),
        checkForPL: j.withMessage(o("GlobalErrors.Starts_with"), () => e.isSlovenianCitizen == !0 && e.personalDocumentType == "PL" ? /^[A-Z]{2}\d{7}$/.test(e.idNumber.toUpperCase()) : !0),
        customMinIdNumber: j.withMessage(o("GlobalErrors.MinLength"), () => e.isSlovenianCitizen == !1 ? e.idNumber.length >= 8 : !0)
      },
      documentIssuer: {
        required: j.withMessage(o("GlobalErrors.FieldRequired"), he)
      },
      issueDate: {
        required: j.withMessage(o("GlobalErrors.FieldRequired"), he)
      },
      permanentValidity: {
        customRequired: j.withMessage(o("GlobalErrors.ChoiceRequired"), de(() => t.showPermanentValidity === !0))
      },
      validityDate: {
        customRequired: j.withMessage(o("GlobalErrors.FieldRequired"), de(() => e.permanentValidity === !1 || e.permanentValidity === void 0))
      },
      // identificationConfirmation: {
      //     required: helpers.withMessage(t("GlobalErrors.ValidIdentification"), sameAs(true)),  
      // },
      identificationConfirmation: e.flowType === R.POS ? {
        required: j.withMessage(o("GlobalErrors.ValidIdentification"), ho(!0))
      } : {}
    }))
  };
}
function Xp(e, t, o) {
  const { scrollToFirstError: r } = Ie();
  async function d(m) {
    if (e.birthdate != m.birthdate) {
      let v = e.birthdate;
      v && ((/* @__PURE__ */ new Date()).getFullYear() - v.getFullYear() >= 70 ? t.showPermanentValidity = !0 : t.showPermanentValidity = !1);
    }
  }
  const f = F(() => ![
    R.POS_STRANKA,
    R.LIMIT
  ].includes(e.flowType)), { validationRules: i } = Qp(e, t), l = be(i, F(() => e), { $autoDirty: !0 });
  async function s() {
    return l.value.$touch(), await l.value.$validate();
  }
  function n() {
    e.idNumber != "" && e.idNumber != e.idNumberCheck && (e.documentIssuer = "", e.issueDate = void 0, e.validityDate = void 0);
  }
  function a() {
    r(".identification-document-component");
  }
  async function c(m) {
    let v = !1, h = null;
    switch (m) {
      case "validatecustomer":
      case "validate":
        v = await s(), v && (h = { name: "valid" });
        break;
      case "webNext":
        v = await s(), v && (e.isViewDataLoading = !0, h = { name: "nextStep" });
        break;
    }
    return h;
  }
  return {
    navigationAction: c,
    dataChanged: d,
    v$: l,
    CheckIdNumber: n,
    scrollToFirstError: r,
    scrollToFirstErrorWrapper: a,
    showHeading: f
  };
}
const Jp = {
  class: "identification-document-component",
  ref: "rootRef"
}, ev = {
  key: 0,
  class: "section-heading"
}, tv = { class: "notification notification--notice" }, nv = {
  key: 0,
  class: "notification notification--alert"
}, ov = { class: "form-label" }, rv = { class: "form-label" }, iv = { class: "form-label" }, av = { class: "form-label" }, sv = {
  key: 0,
  class: "v-input--error"
}, lv = { class: "v-input__details" }, uv = { class: "v-messages" }, dv = { class: "v-messages__message" }, cv = { class: "form-label" }, mv = {
  key: 0,
  class: "v-input--error"
}, fv = { class: "v-input__details" }, pv = { class: "v-messages" }, vv = { class: "v-messages__message" }, hv = { class: "form-label form-label--text" }, Pb = /* @__PURE__ */ ie({
  __name: "id-document-component",
  props: {
    data: { default: () => ({
      ...Zr
    }) }
  },
  emits: ["update:data", "navigationEvent", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o, i = W({ ...d.data });
    let l = { ...Zr }, s = re(!1);
    Object.assign(l, i);
    const n = W({ ...Kp }), { v$: a, navigationAction: c, dataChanged: m, CheckIdNumber: v, scrollToFirstErrorWrapper: h, showHeading: _ } = Xp(i, n);
    return G(
      () => d.data,
      // Watch for changes in the data
      (b) => {
        Object.assign(i, b);
      },
      { deep: !0 }
    ), G(
      i,
      async (b) => {
        await m(l), Object.assign(l, b), f("update:data", b);
      },
      { deep: !0 }
    ), me(async () => {
      s.value = !0, f("componentReady");
    }), t({
      navigationAction: c,
      scrollToFirstErrorWrapper: h,
      componentReady: s
    }), (b, y) => {
      const g = V("v-col"), I = V("v-row"), T = V("v-radio"), w = V("v-radio-group"), M = V("Datepicker"), k = V("v-checkbox");
      return S(), N("div", Jp, [
        i.flowType !== u(R).POS_STRANKA ? (S(), N(je, { key: 0 }, [
          u(_) ? (S(), N("h2", ev, E(u(r)("Components.IdDocumentComponent.IdentificationDataTitle")), 1)) : x("", !0),
          i.flowType === u(R).POS || i.flowType === u(R).WEB ? (S(), K(I, { key: 1 }, {
            default: P(() => [
              C(g, null, {
                default: P(() => [
                  p("div", tv, E(u(r)("Components.IdDocumentComponent.Notification")), 1),
                  i.isSlovenianCitizen ? x("", !0) : (S(), N("div", nv, E(u(r)("Components.IdDocumentComponent.ForeignerAlert")), 1))
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : x("", !0),
          C(I, null, {
            default: P(() => [
              C(g, { class: "v-col-12 v-col-md-6" }, {
                default: P(() => [
                  p("label", ov, E(u(r)("Components.IdDocumentComponent.PersonalDocumentType")), 1),
                  C(w, {
                    ref: "personalDocumentTypeRef",
                    modelValue: i.personalDocumentType,
                    "onUpdate:modelValue": [
                      y[0] || (y[0] = (L) => i.personalDocumentType = L),
                      y[1] || (y[1] = (L) => i.idNumber = "")
                    ],
                    error: u(a).personalDocumentType.error,
                    "error-messages": u(a).personalDocumentType.$errors[0] != null ? u(a).personalDocumentType.$errors[0].$message : "",
                    onFocus: u(a).personalDocumentType.$reset
                  }, {
                    default: P(() => [
                      C(T, {
                        label: u(r)("Components.IdDocumentComponent.PersonalId"),
                        value: u(At).PersonalId
                      }, null, 8, ["label", "value"]),
                      C(T, {
                        label: u(r)("Components.IdDocumentComponent.Passport"),
                        value: u(At).Passport
                      }, null, 8, ["label", "value"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "error", "error-messages", "onFocus"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          C(I, null, {
            default: P(() => [
              C(g, { class: "v-col-12 v-col-md-6" }, {
                default: P(() => [
                  p("label", rv, E(u(r)("Components.IdDocumentComponent.IdNumber")), 1),
                  C(Pe, {
                    ref: "idNumberRef",
                    modelValue: i.idNumber,
                    "onUpdate:modelValue": y[2] || (y[2] = (L) => i.idNumber = L),
                    "error-messages": u(a).idNumber.$errors[0] != null ? u(a).idNumber.$errors[0].$message : "",
                    onFocus: u(a).idNumber.$reset,
                    onChange: y[3] || (y[3] = (L) => u(v)()),
                    variant: "outlined",
                    maxLength: i.isSlovenianCitizen === !0 && (i.personalDocumentType === u(At).PersonalId || i.personalDocumentType === u(At).Passport) ? "9" : void 0,
                    notPrefilled: !!((i.isExistingUser && i.isDataChecked || i.prefilledData) && i.documentIssuer == "")
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "maxLength", "notPrefilled"])
                ]),
                _: 1
              }),
              C(g, { class: "v-col-12 v-col-md-6" }, {
                default: P(() => [
                  p("label", iv, E(u(r)("Components.IdDocumentComponent.DocumentIssuer")), 1),
                  C(Pe, {
                    ref: "documentIssuerRef",
                    modelValue: i.documentIssuer,
                    "onUpdate:modelValue": y[4] || (y[4] = (L) => i.documentIssuer = L),
                    "error-messages": u(a).documentIssuer.$errors[0] != null ? u(a).documentIssuer.$errors[0].$message : "",
                    onFocus: u(a).documentIssuer.$reset,
                    variant: "outlined",
                    prefix: "UE",
                    notPrefilled: !!((i.isExistingUser && i.isDataChecked || i.prefilledData) && i.documentIssuer == "")
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "notPrefilled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          C(I, null, {
            default: P(() => [
              C(g, { class: "v-col-12 v-col-md-6" }, {
                default: P(() => [
                  p("label", av, E(u(r)("Components.IdDocumentComponent.IssueDate")), 1),
                  C(M, {
                    modelValue: i.issueDate,
                    "onUpdate:modelValue": y[5] || (y[5] = (L) => i.issueDate = L),
                    maxDate: /* @__PURE__ */ new Date(),
                    enableTimePicker: !1,
                    autoApply: "",
                    position: "right",
                    locale: "sl",
                    textInput: "",
                    format: "d.M.yyyy",
                    class: Le(u(a).issueDate.$errors[0] ? "v-input--error" : "")
                  }, null, 8, ["modelValue", "maxDate", "class"]),
                  u(a).issueDate.$errors[0] ? (S(), N("div", sv, [
                    p("div", lv, [
                      p("div", uv, [
                        p("div", dv, E(u(a).issueDate.$errors[0].$message), 1)
                      ])
                    ])
                  ])) : x("", !0)
                ]),
                _: 1
              }),
              C(g, { class: "v-col-12 v-col-md-6" }, {
                default: P(() => [
                  p("label", cv, E(u(r)("Components.IdDocumentComponent.ValidityDate")), 1),
                  C(M, {
                    modelValue: i.validityDate,
                    "onUpdate:modelValue": y[6] || (y[6] = (L) => i.validityDate = L),
                    minDate: /* @__PURE__ */ new Date(),
                    enableTimePicker: !1,
                    autoApply: "",
                    position: "right",
                    locale: "sl",
                    textInput: "",
                    format: "d.M.yyyy",
                    disabled: i.permanentValidity == !0,
                    class: Le(u(a).validityDate.$errors[0] ? "v-input--error" : "")
                  }, null, 8, ["modelValue", "minDate", "disabled", "class"]),
                  u(a).validityDate.$errors[0] ? (S(), N("div", mv, [
                    p("div", fv, [
                      p("div", pv, [
                        p("div", vv, E(u(a).validityDate.$errors[0].$message), 1)
                      ])
                    ])
                  ])) : x("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          n.showPermanentValidity ? (S(), K(I, { key: 2 }, {
            default: P(() => [
              C(g, { class: "v-col-12 v-col-md-6" }, {
                default: P(() => [
                  p("label", hv, E(u(r)("Components.IdDocumentComponent.PermanentValidity")), 1),
                  C(w, {
                    modelValue: i.permanentValidity,
                    "onUpdate:modelValue": y[8] || (y[8] = (L) => i.permanentValidity = L),
                    error: u(a).permanentValidity.error,
                    "error-messages": u(a).permanentValidity.$errors[0] != null ? u(a).permanentValidity.$errors[0].$message : "",
                    onFocus: u(a).permanentValidity.$reset
                  }, {
                    default: P(() => [
                      C(T, {
                        value: !0,
                        onClick: y[7] || (y[7] = (L) => i.validityDate = void 0),
                        label: u(r)("GeneralButtons.Yes")
                      }, null, 8, ["label"]),
                      C(T, {
                        label: u(r)("GeneralButtons.No"),
                        value: !1
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "error", "error-messages", "onFocus"])
                ]),
                _: 1
              }),
              C(g, { class: "v-col-12 v-col-md-6" })
            ]),
            _: 1
          })) : x("", !0),
          i.flowType === u(R).POS ? (S(), K(k, {
            key: 3,
            modelValue: i.identificationConfirmation,
            "onUpdate:modelValue": y[9] || (y[9] = (L) => i.identificationConfirmation = L),
            "error-messages": u(a).identificationConfirmation.$errors[0] != null ? u(a).identificationConfirmation.$errors[0].$message : "",
            onFocus: u(a).identificationConfirmation.$reset,
            label: i.userFullName + u(r)("Components.IdDocumentComponent.IdentificationComfirmLabel"),
            class: "mt-8"
          }, null, 8, ["modelValue", "error-messages", "onFocus", "label"])) : x("", !0)
        ], 64)) : x("", !0)
      ], 512);
    };
  }
}), Wr = {
  orderToken: "",
  partnerLink: "",
  firstname: "",
  surname: "",
  calculationId: void 0,
  creditAmount: 0,
  installmentNr: 0,
  installmentVal: 0,
  installmentValNoCost: 0,
  lastMonthsIncome: 0,
  lastMonthsIncome2: 0,
  lastMonthsIncome3: 0,
  flowType: void 0,
  isPreapproved: !1,
  preapprovedCreditAmount: 0,
  preapprovedInstallmentAmount: 0,
  numberOfPreapprovedSalaries: 0,
  employmentType: void 0,
  mustProvideThreeSalaries: !1,
  isSlovenianCitizen: !0,
  hasSlovenianIncome: !0,
  citizen: -1,
  selectedProduct: void 0,
  selectedSpecialProduct: void 0,
  msisdn: "",
  taxNumber: "",
  prefix: void 0,
  phoneNumber: void 0,
  emso: "",
  birthdate: null,
  headerTitle: "",
  headerSubtitle: "",
  headerParameter: "",
  isDocumentationNeeded: !1,
  isViewDataLoading: !1,
  selectedProductType: void 0,
  productList: [],
  specialProductList: [],
  sisbonResultId: -1,
  debtAmount: 0,
  debtInstallments: 0,
  contractDebtInstallments: 0,
  minSalary: 0,
  minCredit: 0,
  email: void 0
}, yv = {
  isDataLoading: !1,
  installmentVal: 0,
  installmentValNoCost: 0,
  interestNr: 0,
  EOM: 0,
  amountTotal: 0,
  insuranceVal: 0,
  approvalVal: 0,
  calculationError: "",
  showMore: !1,
  clientIncomeInsert: !1,
  printCalculation: !1,
  dateOfFirstInstallment: "",
  dateOfLastInstallment: "",
  isSalaryConfirmed: !1,
  minInstallment: 3,
  maxInstallment: 84,
  isUserDraggingSlider: !1,
  showModal: !1,
  modalErrorMessage: null,
  overridenProductName: null,
  isOverridenProduct: !1,
  overridenMaxInstallments: null
};
function _v(e, t) {
  const { t: o } = H();
  return F(() => ({
    lastMonthsIncome: {
      required: j.withMessage(o("GlobalErrors.FieldRequired"), he),
      minMinimalPay: j.withMessage(o("GlobalErrors.MinMinimalPay"), () => e.lastMonthsIncome !== void 0 && e.lastMonthsIncome > 100)
    },
    lastMonthsIncome2: {
      customRequired: j.withMessage(o("GlobalErrors.FieldRequired"), de(() => e.mustProvideThreeSalaries)),
      min100: j.withMessage(o("GlobalErrors.Min10Eur"), () => e.mustProvideThreeSalaries && e.lastMonthsIncome2 >= 1 || !e.mustProvideThreeSalaries)
    },
    lastMonthsIncome3: {
      customRequired: j.withMessage(o("GlobalErrors.FieldRequired"), de(() => e.mustProvideThreeSalaries)),
      min100: j.withMessage(o("GlobalErrors.Min10Eur"), () => e.mustProvideThreeSalaries && e.lastMonthsIncome3 >= 1 || !e.mustProvideThreeSalaries)
    },
    selectedProductType: {
      required: j.withMessage(o("GlobalErrors.ChoiceRequired"), de(() => e.flowType === R.INFOCALC))
    },
    selectedSpecialProduct: {
      required: j.withMessage(o("GlobalErrors.FIELD_REQUIRED"), de(() => e.selectedProductType === "SPECIAL"))
    },
    email: {
      emailOrPhoneRequired: j.withMessage(o("GlobalErrors.FieldRequired"), () => {
        const r = e.email != null && e.email !== "", d = e.prefix != null && e.phoneNumber != null;
        return r || d;
      }),
      emailFormat: j.withMessage(o("GlobalErrors.CorrectEmail"), () => e.email === void 0 || e.email === "" ? !0 : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.email))
    },
    prefix: {
      emailOrPhoneRequired: j.withMessage(o("GlobalErrors.FieldRequired"), () => {
        const r = e.email != null && e.email !== "", d = e.prefix != null && e.phoneNumber != null;
        return r || d;
      })
    },
    phoneNumber: {
      emailOrPhoneRequired: j.withMessage(o("GlobalErrors.FieldRequired"), () => {
        const r = e.email != null && e.email !== "", d = e.prefix != null && e.phoneNumber != null;
        return r || d;
      }),
      minLength: j.withMessage(o("GlobalErrors.CorrectPhoneNumber"), Ft(8)),
      maxLength: j.withMessage(o("GlobalErrors.CorrectPhoneNumber"), Vt(12))
    }
  }));
}
function gv(e, t, o) {
  const r = Q("navigationButtonsApi", null), d = Q("commClient"), f = Q("showReport"), { copySharedProperties: i, scrollToFirstError: l } = Ie(), s = be(_v(e), F(() => e), { $autoDirty: !0 });
  async function n() {
    return s.value.$touch(), s.value.$validate();
  }
  let a;
  function c() {
    t.maxInstallment > 0 && e.installmentNr > t.maxInstallment && (e.installmentNr = t.maxInstallment);
  }
  async function m() {
    e.isViewDataLoading = !0, t.printCalculation = !0, await J(), await f(
      {
        Title: "Izpis informativnega izračuna",
        MethodName: "InformativniIzracunForPrint",
        Parameters: { IzracunId: e.calculationId },
        FileName: "InformativniIzracun_" + e.calculationId.toString()
      }
    ), e.isViewDataLoading = !1, t.printCalculation = !1;
  }
  function v() {
    s.value.email.$reset(), s.value.prefix.$reset(), s.value.phoneNumber.$reset(), t.modalErrorMessage = null, t.showModal = !0;
  }
  function h() {
    t.showModal = !1, t.modalErrorMessage = null, e.email = void 0, e.prefix = void 0, e.phoneNumber = void 0;
  }
  async function _() {
    var B;
    s.value.email.$touch(), s.value.prefix.$touch(), s.value.phoneNumber.$touch(), !(s.value.email.$invalid || s.value.prefix.$invalid || s.value.phoneNumber.$invalid) && (t.modalErrorMessage = null, t.printCalculation = !0, await J(), e.email != null && e.email !== "" && await d.executeMethodAsync("SendCalculationEmail", {
      CalculationId: e.calculationId,
      Email: e.email
    }).then((te) => {
      te.Success ? h() : t.modalErrorMessage = te.Error;
    }), e.phoneNumber != null && e.prefix != null && await d.executeMethodAsync("SendCalculationPhone", {
      CalculationId: e.calculationId,
      PhoneNumber: ((B = e.prefix) == null ? void 0 : B.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString()
    }).then((te) => {
      te.Success ? h() : t.modalErrorMessage = te.Error;
    }));
  }
  async function b(B) {
    if (c(), e.installmentNr != B.installmentNr && (clearTimeout(a), a = setTimeout(async () => {
      const te = await J();
      te != null && te.name != null && o("navigation-event", te.name);
    }, 500)), e.selectedProductType != B.selectedProductType || e.selectedSpecialProduct != B.selectedSpecialProduct) {
      for (let te = 0; te < e.productList.length; te++)
        e.productList[te].productId == e.selectedProductType && (e.selectedProduct = e.productList[te]);
      e.selectedProductType === "SPECIAL" ? e.selectedSpecialProduct != null && (t.minInstallment = e.selectedSpecialProduct.installmentMin, t.maxInstallment = e.selectedSpecialProduct.installmentMax) : (t.minInstallment = e.selectedProduct.installmentMin, t.maxInstallment = e.selectedProduct.installmentMax), e.installmentNr > t.maxInstallment ? e.installmentNr = t.maxInstallment : await J().then((te) => {
        te != null && te.name != null && o("navigation-event", te.name);
      });
    }
  }
  const y = F(() => e.mustProvideThreeSalaries || e.isPreapproved && e.numberOfPreapprovedSalaries === 3 || e.lastMonthsIncome2 != null && e.lastMonthsIncome2 > 0 ? ((e.lastMonthsIncome ? e.lastMonthsIncome : 0) + (e.lastMonthsIncome2 ? e.lastMonthsIncome2 : 0) + (e.lastMonthsIncome3 ? e.lastMonthsIncome3 : 0)) / 3 : e.lastMonthsIncome ? e.lastMonthsIncome : 0), g = F(() => {
    const B = (/* @__PURE__ */ new Date()).getMonth();
    return {
      month0: B > 2 ? B - 3 : B + 9,
      month1: B > 1 ? B - 2 : B + 10,
      month2: B > 0 ? B - 1 : B + 11,
      month3: B
    };
  }), I = F(() => e.isPreapproved && (e.creditAmount == null || e.creditAmount <= e.preapprovedCreditAmount) && (t.installmentValNoCost == null || t.installmentValNoCost <= e.preapprovedInstallmentAmount)), T = F(() => e.isPreapproved && (e.creditAmount == null || e.creditAmount <= e.preapprovedCreditAmount)), w = F(() => ({
    [t.minInstallment]: `${t.minInstallment} obrokov`,
    [t.minInstallment + Math.round((t.maxInstallment - t.minInstallment) / 2)]: `${t.minInstallment + Math.round((t.maxInstallment - t.minInstallment) / 2)} obrokov`,
    [t.maxInstallment]: `${t.maxInstallment} obrokov`
  }));
  async function M() {
    var te;
    e.isViewDataLoading = !0;
    let B;
    switch (e.flowType) {
      case R.POS:
        if (B = await d.executeMethodAsync("GetSalaryInformationPOS", {
          SelectedProductId: (te = e.selectedProduct) == null ? void 0 : te.productId,
          SpecialProductId: e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct !== void 0 ? parseInt(e.selectedSpecialProduct.productId) : -1,
          TaxNumber: e.taxNumber,
          CreditAmount: e.creditAmount,
          Birthdate: e.birthdate,
          SlovenianCitizen: e.isSlovenianCitizen,
          ZaposlitevSlo: e.hasSlovenianIncome === void 0 ? !0 : e.hasSlovenianIncome,
          EmploymentType: e.employmentType
        }), B) {
          if (B.success === !0)
            return i(e, B), i(t, B), null;
          switch (B.error) {
            case "NoSuitableProduct":
              return e.headerSubtitle = B.error, { name: "endFail" };
          }
        }
        break;
      case R.WEB:
      case R.POS_STRANKA:
      case R.POS_MOBILE:
      case R.SKLENI_SAM:
        if (B = await d.executeMethodAsync("GetSalaryInformationWeb", {
          OrderToken: e.orderToken,
          OrderType: e.flowType,
          TaxNumber: e.taxNumber,
          SlovenianCitizen: e.isSlovenianCitizen,
          EmploymentType: e.employmentType,
          Birthdate: e.birthdate
        }), B) {
          if (B.success === !0)
            return i(e, B), i(t, B), null;
          switch (B.error) {
            case "NoSuitableProduct":
            case "ProcessError":
              return e.headerSubtitle = B.error, { name: "endFail" };
          }
        }
        break;
    }
    return null;
  }
  async function k() {
    return c(), e.isViewDataLoading = !0, new Promise((B) => {
      var te, Ee;
      e.installmentNr > 2 && d.executeMethodAsync("ContractCalculationCreateCheckExposure", {
        SelectedProductId: (te = e.selectedProduct) == null ? void 0 : te.productId,
        SpecialProductId: e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct !== void 0 ? parseInt(e.selectedSpecialProduct.productId) : -1,
        SisbonResultId: e.sisbonResultId,
        TaxNumber: e.taxNumber,
        Firstname: e.firstname,
        Surname: e.surname,
        PhoneNumber: ((Ee = e.prefix) == null ? void 0 : Ee.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString(),
        CreditAmount: e.creditAmount,
        InstallmentNr: e.installmentNr,
        Birthdate: e.birthdate,
        SlovenianCitizen: e.isSlovenianCitizen,
        SlovenianIncome: e.hasSlovenianIncome,
        ZaposlitevSlo: e.hasSlovenianIncome === void 0 ? !0 : e.hasSlovenianIncome,
        EmploymentType: e.employmentType,
        IsFinalCalculation: !0,
        // will be saved to the database
        Salary1: e.lastMonthsIncome,
        Salary2: e.lastMonthsIncome2 !== void 0 ? e.lastMonthsIncome2 : 0,
        Salary3: e.lastMonthsIncome3 !== void 0 ? e.lastMonthsIncome3 : 0,
        minCredit: e.minCredit,
        SisbonDebt: e.debtInstallments,
        ContractDebt: e.contractDebtInstallments
      }).then(async (Z) => {
        if (Z)
          if (Z.success === !0)
            i(e, Z), i(t, Z), B({ name: "nextStep" });
          else
            switch (Z.error) {
              case "NoSuitableProduct":
              case "CreditDenied":
              case "InstallmentTooHigh":
              case "CreditErrorMaxAmount":
              case "CreditErrorMinAmount":
              case "InstallmentErrorMinAmount":
              case "InstallmentNrErrorMax":
              case "InstallmentNrErrorMin":
              case "CalculationFailed":
                t.calculationError = Z.error, B(null);
                break;
              default:
                e.headerSubtitle = Z.error, B({ name: "endFail" });
                break;
            }
        else
          B(null);
      });
    });
  }
  async function L() {
    return c(), e.isViewDataLoading = !0, new Promise((B) => {
      e.installmentNr > 2 && d.executeMethodAsync("ContractCalculationCreate", {
        OrderToken: e.orderToken,
        OrderType: e.flowType,
        Installments: e.installmentNr,
        Firstname: "",
        Surname: "",
        TaxNumber: e.taxNumber,
        Msisdn: e.msisdn,
        Birthdate: e.birthdate,
        Salary: y.value,
        minCredit: e.minCredit,
        ContractDebt: e.contractDebtInstallments,
        SisbonDebt: e.debtInstallments,
        SlovenianCitizen: e.isSlovenianCitizen === void 0 ? e.citizen === 204 : e.isSlovenianCitizen,
        HasSlovenianIncome: e.hasSlovenianIncome,
        EmploymentType: e.employmentType
      }).then(async (te) => {
        if (te)
          if (te.success === !0)
            i(e, te), i(t, te), await n() && (e.flowType === R.WEB || e.flowType === R.SKLENI_SAM ? e.isPreapproved && e.preapprovedCreditAmount >= e.creditAmount && e.preapprovedInstallmentAmount >= e.installmentValNoCost ? B({ name: "nextStepPreapproved" }) : B({ name: "nextStep" }) : B({ name: "nextStepCustomer" }));
          else
            switch (te.calculationError) {
              case "ProcessError":
              case "TaxNrMsisdnMismatch":
              case "MaxRemainingCredit":
              case "SpNeustrezen":
              case "InstallmentTooHigh":
              case "SalaryRequirementsFail1":
              case "SalaryRequirementsFail2":
                e.headerSubtitle = te.calculationError, B({ name: "endFail" });
                break;
              case "NoSuitableProduct":
              case "CreditErrorMaxAmount":
              case "CreditErrorMinAmount":
              case "InstallmentErrorMinAmount":
              case "InstallmentNrErrorMax":
              case "InstallmentNrErrorMin":
              case "CalculationFailed":
                t.calculationError = te.calculationError, B(null);
                break;
              default:
                e.headerSubtitle = te.calculationError, B({ name: "endFail" });
                break;
            }
        else
          B(null);
      }).catch((te) => B({ name: "endFail" }));
    });
  }
  function $(B) {
    B && (B.success && i(e, B), i(t, B));
  }
  async function q() {
    return t.calculationError = "", e.isViewDataLoading = !0, new Promise(async (B, te) => {
      var Ee;
      switch (e.flowType) {
        case R.WEB:
        case R.POS_STRANKA:
        case R.POS_MOBILE:
        case R.SKLENI_SAM:
          await d.executeMethodAsync("SalaryRequirementsNewWeb", {
            OrderToken: e.orderToken,
            OrderType: e.flowType,
            TaxNumber: e.taxNumber,
            SlovenianCitizen: e.isSlovenianCitizen,
            EmploymentType: e.employmentType,
            Salary: y.value,
            minCredit: e.minCredit,
            ContractDebt: e.contractDebtInstallments,
            SisbonDebt: e.debtInstallments
          }).then(async (Z) => {
            $(Z), Z.success ? B(null) : (e.headerSubtitle = Z.errorId, B({ name: "endFail" }));
          }).catch((Z) => B({ name: "endFail" }));
          break;
        case R.POS:
          await d.executeMethodAsync("SalaryRequirementsNewPos", {
            SelectedProductId: (Ee = e.selectedProduct) == null ? void 0 : Ee.productId,
            SpecialProductId: e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct !== void 0 ? parseInt(e.selectedSpecialProduct.productId) : -1,
            TaxNumber: e.taxNumber,
            CreditAmount: e.creditAmount,
            SlovenianCitizen: e.isSlovenianCitizen,
            ZaposlitevSlo: e.hasSlovenianIncome === void 0 ? !0 : e.hasSlovenianIncome,
            EmploymentType: e.employmentType,
            SisbonDebt: e.debtInstallments,
            ContractDebt: e.contractDebtInstallments,
            Salary: y.value,
            minCredit: e.minCredit
          }).then(async (Z) => {
            $(Z), Z.success ? B(null) : (e.headerSubtitle = Z.errorId, console.log(Z), Z.errorId === "SalaryRequirementsFail3" && (console.log(Z.availableAmount), e.headerParameter = Z.availableAmount.toLocaleString("sl-SI", { style: "currency", currency: "EUR" }), console.log(e.headerParameter)), B({ name: "endFail" }));
          }).catch((Z) => B({ name: "endFail" }));
          break;
      }
    });
  }
  async function J() {
    var B, te, Ee;
    if (c(), t.calculationError = "", e.installmentNr >= 3) {
      let Z;
      switch (e.flowType) {
        case R.PORTAL_INFOCALC:
          if (Z = await d.executeMethodAsync("CalculationCreate", {
            CreditAmount: e.creditAmount,
            InstallmentNr: e.installmentNr,
            PrintCalculation: t.printCalculation
          }), $(Z), !Z.success)
            switch (Z.CalculationError) {
              case "NoSuitableProduct":
              case "CreditErrorMaxAmount":
              case "CreditErrorMinAmount":
              case "InstallmentErrorMinAmount":
              case "InstallmentNrErrorMax":
              case "InstallmentNrErrorMin":
              case "CalculationFailed":
                t.calculationError = Z.CalculationError;
            }
          break;
        case R.WEB_INFOCALC:
          if (Z = await d.executeMethodAsync("InformativeCalculationCreate", {
            PartnerUrlParam: e.partnerLink,
            Amount: e.creditAmount,
            Installments: e.installmentNr,
            PrintCalculation: t.printCalculation
          }), $(Z), !Z.success)
            switch (Z.CalculationError) {
              case "NoSuitableProduct":
              case "CreditErrorMaxAmount":
              case "CreditErrorMinAmount":
              case "InstallmentErrorMinAmount":
              case "InstallmentNrErrorMax":
              case "InstallmentNrErrorMin":
              case "CalculationFailed":
                t.calculationError = Z.CalculationError;
            }
          break;
        case R.INFOCALC:
          if (Z = await d.executeMethodAsync("CalculationCreateNewPos", {
            SelectedProductId: (B = e.selectedProduct) == null ? void 0 : B.productId,
            SpecialProductId: e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct !== void 0 ? parseInt(e.selectedSpecialProduct.productId) : -1,
            CreditAmount: e.creditAmount,
            InstallmentNr: e.installmentNr,
            PrintCalculation: t.printCalculation
          }), $(Z), !Z.success)
            switch (Z.CalculationError) {
              case "NoSuitableProduct":
              case "CreditErrorMaxAmount":
              case "CreditErrorMinAmount":
              case "InstallmentErrorMinAmount":
              case "InstallmentNrErrorMax":
              case "InstallmentNrErrorMin":
              case "CalculationFailed":
                t.calculationError = Z.CalculationError;
            }
          break;
        case R.WEB:
        case R.POS_STRANKA:
        case R.POS_MOBILE:
        case R.SKLENI_SAM:
          if (Z = await d.executeMethodAsync("GenericCalculationCreateNewWeb", {
            OrderToken: e.orderToken,
            OrderType: e.flowType,
            TaxNumber: e.taxNumber,
            InstallmentNr: e.installmentNr,
            SlovenianCitizen: e.isSlovenianCitizen,
            EmploymentType: e.employmentType,
            Birthdate: e.birthdate,
            Salary: y.value,
            minCredit: e.minCredit,
            ContractDebt: e.contractDebtInstallments
          }), $(Z), Z.success)
            r !== null && (r == null || r.setButtonDisabled("Next", !1));
          else
            switch (r !== null && (r == null || r.setButtonDisabled("Next", !0)), Z.calculationError) {
              case "MaxRemainingCredit":
              case "ProcessError":
                return e.headerSubtitle = Z.calculationError, { name: "endFail" };
              case "CreditDenied":
              case "NoSuitableProduct":
              case "InstallmentTooHigh":
              case "CreditErrorMaxAmount":
              case "CreditErrorMinAmount":
              case "InstallmentErrorMinAmount":
              case "InstallmentNrErrorMax":
              case "InstallmentNrErrorMin":
              case "CalculationFailed":
                t.calculationError = Z.calculationError;
            }
          break;
        case R.POS:
          if (Z = await d.executeMethodAsync("ContractCalculationCreateNewPos", {
            SelectedProductId: (te = e.selectedProduct) == null ? void 0 : te.productId,
            SpecialProductId: e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct !== void 0 ? parseInt(e.selectedSpecialProduct.productId) : -1,
            TaxNumber: e.taxNumber,
            PhoneNumber: ((Ee = e.prefix) == null ? void 0 : Ee.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString(),
            CreditAmount: e.creditAmount,
            InstallmentNr: e.installmentNr,
            Birthdate: e.birthdate,
            SlovenianCitizen: e.isSlovenianCitizen,
            ZaposlitevSlo: e.hasSlovenianIncome === void 0 ? !0 : e.hasSlovenianIncome,
            EmploymentType: e.employmentType,
            SisbonDebt: e.debtInstallments,
            ContractDebt: e.contractDebtInstallments,
            Salary: y.value,
            minCredit: e.minCredit,
            IsFinalCalculation: !1
            // wont be saved to the database, only for display purposes
          }), $(Z), Z.success)
            r !== null && (r == null || r.setButtonDisabled("Next", !1));
          else
            switch (r !== null && (r == null || r.setButtonDisabled("Next", !0)), Z.calculationError) {
              case "MaxRemainingCredit":
                return e.headerSubtitle = Z.calculationError, { name: "endFail" };
              case "CreditDenied":
              case "NoSuitableProduct":
              case "InstallmentTooHigh":
              case "CreditErrorMaxAmount":
              case "CreditErrorMinAmount":
              case "InstallmentErrorMinAmount":
              case "InstallmentNrErrorMax":
              case "InstallmentNrErrorMin":
              case "CalculationFailed":
                t.calculationError = Z.calculationError;
                break;
            }
          break;
      }
    }
    return null;
  }
  async function X() {
    e.isViewDataLoading = !0, await d.executeMethodAsync("sf.ProductList", {
      Employment: "1"
      // zaposleni
    }).then(async (B) => {
      var te;
      B && (e.productList = B.productList, e.specialProductList = B.specialProducts, e.selectedProduct = B.productList[0], e.selectedProductType = (te = e.selectedProduct) == null ? void 0 : te.productId, e.selectedSpecialProduct = void 0), e.isViewDataLoading = !1;
    });
  }
  function U(B) {
    if (e.productList != null) {
      for (let te = 0; te < e.productList.length; te++)
        if (e.productList[te].productId == B)
          return !0;
    }
    return !1;
  }
  async function oe() {
    var B;
    e.lastMonthsIncome = void 0, e.lastMonthsIncome2 = void 0, e.lastMonthsIncome3 = void 0, s.value.lastMonthsIncome.$reset(), s.value.lastMonthsIncome2.$reset(), s.value.lastMonthsIncome3.$reset(), t.clientIncomeInsert = !0, await d.executeMethodAsync("CreateUrl", {
      Msisdn: ((B = e.prefix) == null ? void 0 : B.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString(),
      IsSP: e.employmentType == le.SP || e.mustProvideThreeSalaries
    }).then(async (te) => {
    });
  }
  async function fe() {
    e.lastMonthsIncome = void 0, e.lastMonthsIncome2 = void 0, e.lastMonthsIncome3 = void 0, s.value.lastMonthsIncome.$reset(), s.value.lastMonthsIncome2.$reset(), s.value.lastMonthsIncome3.$reset(), t.clientIncomeInsert = !1;
  }
  function ve(B) {
    B && B[0] && B[0].CallbackType == "INCOME_INSERTION" && (e.lastMonthsIncome = B[0].IncomeData.IncomeOne || void 0, e.lastMonthsIncome2 = B[0].IncomeData.IncomeTwo || void 0, e.lastMonthsIncome3 = B[0].IncomeData.IncomeThree || void 0, ze());
  }
  async function Re() {
    if (e.flowType === R.PORTAL_INFOCALC) {
      const B = await d.executeMethodAsync("PortalActionData", {}), te = se(B);
      return te != "" ? { name: te } : null;
    } else if (e.flowType === R.WEB_INFOCALC) {
      const B = await d.executeMethodAsync("WebActionData", {
        PartnerUrlParam: e.partnerLink
      }), te = se(B);
      return te != "" ? { name: te } : null;
    } else {
      const B = await d.executeMethodAsync("ActionData", {
        OrderToken: e.orderToken,
        OrderType: e.flowType,
        TaxNumber: e.taxNumber,
        IsSlovenianCitizen: e.isSlovenianCitizen,
        IsSP: e.employmentType === le.SP
      }), te = se(B);
      return te != "" ? { name: te } : null;
    }
  }
  function ae() {
    e.creditAmount !== void 0 && e.creditAmount > 0 && (e.creditAmount < 1e3 ? e.installmentNr = 6 : e.creditAmount < 2e3 ? e.installmentNr = 12 : e.creditAmount < 5e3 || e.creditAmount < 1e4 ? e.installmentNr = 24 : e.installmentNr = 36);
  }
  function se(B) {
    return B.Success ? (e.selectedProduct = {
      productId: "",
      productName: "",
      installmentMin: B.MinInstallment,
      installmentMax: B.MaxInstallment,
      amountMin: B.MinAmount,
      amountMax: B.MaxAmount,
      ageMin: 0,
      ageMax: 0
    }, t.minInstallment = B.MinInstallment, t.maxInstallment = B.MaxInstallment, B.CreditAmount != null && (e.creditAmount = B.CreditAmount), B.Installments != null ? e.installmentNr = B.Installments : ae(), "") : (e.headerSubtitle = B.Error, "endFail");
  }
  const pe = [
    R.INFOCALC,
    R.WEB_INFOCALC,
    R.PORTAL_INFOCALC
  ];
  function $e() {
    r !== null && (pe.includes(e.flowType) ? r == null || r.setButtonVisible("Print", !0) : r == null || r.setButtonVisible("Print", !1)), (T.value || e.flowType === R.INFOCALC || e.flowType === R.WEB_INFOCALC || e.flowType === R.PORTAL_INFOCALC) && (t.isSalaryConfirmed = !0), T.value || (e.lastMonthsIncome = void 0, e.lastMonthsIncome2 = void 0, e.lastMonthsIncome3 = void 0, s.value.lastMonthsIncome.$reset(), s.value.lastMonthsIncome2.$reset(), s.value.lastMonthsIncome3.$reset()), r !== null && !e.isPreapproved && (r == null || r.setButtonDisabled("Next", !0));
  }
  async function ze() {
    s.value.lastMonthsIncome.$touch(), s.value.lastMonthsIncome2.$touch(), s.value.lastMonthsIncome3.$touch(), (await Promise.all([
      s.value.lastMonthsIncome.$validate(),
      s.value.lastMonthsIncome2.$validate(),
      s.value.lastMonthsIncome3.$validate()
    ])).every((Ee) => Ee === !0) && await q().then(async (Ee) => {
      Ee !== null ? (e.isViewDataLoading = !1, o("navigation-event", Ee.name)) : (e.installmentNr = t.minInstallment + Math.round((t.maxInstallment - t.minInstallment) / 2), t.isSalaryConfirmed = !0, r !== null && (r == null || r.setButtonDisabled("Next", !1)));
    }), e.isViewDataLoading = !1;
  }
  function Qe() {
    l(".installment-plan-component");
  }
  function ot() {
    const B = document.querySelector("#calculation-error");
    B && B.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  async function It(B) {
    let te = !1, Ee = null;
    switch (B) {
      case "calculationAndExposure":
      case "webNext":
        if (I.value || (e.isPreapproved = !1), te = await n(), !te) return null;
        B === "calculationAndExposure" ? Ee = await k() : Ee = await L(), Ee === null && (t.calculationError !== "" ? ot() : Qe());
        break;
      case "printCalculation":
        await m();
        break;
      case "sendCalculation":
        v();
        break;
      case "toLimit":
        Ee = { name: "toLimit" };
        break;
    }
    return Ee;
  }
  return {
    getPreapprovedValidity: I,
    getPreapprovedAmountValidity: T,
    pastMonths: g,
    getSliderTicks: w,
    dataChanged: b,
    navigationAction: It,
    productIsAvailable: U,
    ProductList: X,
    CreateInformativeCalculation: J,
    WebActionData: Re,
    scrollToFirstErrorWrapper: Qe,
    confirmSalary: ze,
    SetupInstallmentBasedOnAmount: ae,
    initData: $e,
    customerIncomeInsert: oe,
    v$: s,
    SendEmailOrPhone: _,
    CloseModalDialog: h,
    customerSetIncome: ve,
    partnerIncomeInsert: fe,
    GetSalaryInformation: M
  };
}
const bv = {
  class: "installment-plan-component",
  ref: "rootRef"
}, Cv = { key: 0 }, Iv = { key: 0 }, Ev = { class: "section-heading mt-0" }, Sv = { class: "mb-4" }, Pv = { class: "form-label" }, Tv = { class: "control-income-wrapper" }, wv = {
  key: 0,
  class: "mb-4"
}, kv = { class: "form-label" }, Nv = {
  key: 1,
  class: "mb-4"
}, Av = { class: "form-label" }, Mv = { class: "callout" }, Ov = { key: 0 }, Rv = { key: 1 }, $v = { class: "mt-4" }, xv = { class: "section-heading mt-0" }, Lv = { class: "form-label" }, Vv = { class: "form-label" }, Fv = {
  key: 0,
  class: "notification notification--alert mt-8"
}, jv = { key: 1 }, zv = { class: "control-product-type" }, Uv = { class: "form-label" }, Bv = {
  key: 0,
  class: "form-label"
}, Gv = { class: "installment-plan-calculation installment-plan-calculation--bg ml-md-6" }, qv = { class: "installment-plan-calculation__grid" }, Dv = { class: "installment-plan-calculation__installment" }, Hv = { key: 0 }, Yv = { key: 1 }, Zv = { class: "installment-plan-calculation__disclaimer" }, Wv = {
  key: 0,
  class: "alert alert--error mb-5 mt-5 alert-predodobreno"
}, Kv = {
  key: 0,
  class: "notification notification--warning mb-4"
}, Qv = { class: "mb-4" }, Xv = { class: "form-label" }, Jv = { class: "control-email-wrapper" }, e1 = { class: "form-label" }, t1 = { class: "control-phone-wrapper" }, n1 = {
  key: 3,
  id: "calculation-error",
  class: "notification notification--warning mt-4"
}, Tb = /* @__PURE__ */ ie({
  __name: "installment-plan-component",
  props: {
    data: { default: () => ({
      ...Wr
    }) }
  },
  emits: ["update:data", "navigation-event", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o, f = Q("commClient"), { getDateCorrectedFormat: i } = Ie(), l = Q("generalStore"), { t: s } = H(), n = W({ ...r.data });
    let a = { ...Wr }, c = re(!1);
    const m = W({ ...yv }), {
      v$: v,
      getPreapprovedValidity: h,
      getPreapprovedAmountValidity: _,
      navigationAction: b,
      pastMonths: y,
      getSliderTicks: g,
      dataChanged: I,
      ProductList: T,
      productIsAvailable: w,
      initData: M,
      CreateInformativeCalculation: k,
      WebActionData: L,
      scrollToFirstErrorWrapper: $,
      confirmSalary: q,
      customerIncomeInsert: J,
      customerSetIncome: X,
      partnerIncomeInsert: U,
      SendEmailOrPhone: oe,
      CloseModalDialog: fe,
      GetSalaryInformation: ve
    } = gv(n, m, d);
    G(
      () => r.data,
      // Watch for changes in the data
      (ae) => {
        Object.assign(n, ae);
      },
      { deep: !0 }
    ), G(
      n,
      async (ae) => {
        await I(a), Object.assign(a, ae), d("update:data", ae);
      },
      { deep: !0 }
    ), me(async () => {
      if (f.OnStreamDataReceived.AddCallback(X), M(), n.flowType == R.INFOCALC)
        await T(), await k();
      else if (n.flowType == R.WEB_INFOCALC || n.flowType == R.PORTAL_INFOCALC)
        await L();
      else if (n.flowType != R.POS) {
        const ae = await L();
        if (ae != null && ae.name != null)
          d("navigation-event", ae.name);
        else {
          const se = await ve();
          se != null && se.name != null && d("navigation-event", se.name);
        }
      } else {
        const ae = await ve();
        ae != null && ae.name != null && d("navigation-event", ae.name);
      }
      c.value = !0, d("componentReady");
    }), Lt(() => {
      f.OnStreamDataReceived.RemoveCallback(X);
    });
    const Re = F(() => {
      if (m.isSalaryConfirmed)
        return "";
      const ae = n.isDocumentationNeeded;
      switch (n.employmentType) {
        case le.SP:
          return s("Components.InstallmentPlanComponent.MonthlyIncomeHintSPDoc");
        case le.Upokojenec:
          return s(ae ? "Components.InstallmentPlanComponent.MonthlyIncomeHintUpokojenecDoc" : "Components.InstallmentPlanComponent.MonthlyIncomeHintUpokojenecNoDoc");
        case le.Zaposlen:
          return s(ae ? "Components.InstallmentPlanComponent.MonthlyIncomeHintZaposleniDoc" : "Components.InstallmentPlanComponent.MonthlyIncomeHintZaposleniNoDoc");
        default:
          return "";
      }
    });
    return G(() => m.calculationError, (ae) => {
      ae !== "" && on(() => {
        const se = document.querySelector("#calculation-error");
        se && se.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }), t({
      navigationAction: b,
      scrollToFirstErrorWrapper: $,
      componentReady: c
    }), (ae, se) => {
      const pe = V("v-text-field"), $e = V("v-btn"), ze = V("v-tooltip"), Qe = V("v-col"), ot = V("v-row"), It = V("v-slider"), B = V("v-radio"), te = V("v-radio-group"), Ee = V("v-autocomplete");
      return S(), N("div", bv, [
        n.isPreapproved === !0 && n.creditAmount <= n.preapprovedCreditAmount && n.installmentValNoCost <= n.preapprovedInstallmentAmount && (n.flowType === u(R).WEB || n.flowType === u(R).SKLENI_SAM || n.flowType === u(R).POS) ? (S(), N("div", Cv, se[15] || (se[15] = [
          p("div", { class: "notification notification--big" }, [
            p("div", { class: "d-flex ga-4" }, [
              p("img", {
                src: or,
                alt: "Predodobreno",
                class: ""
              }),
              p("div", null, [
                p("div", { class: "title" }, "Vnaprej odobreno plačilo na obroke"),
                p("div", null, "Imate vnaprej odobreno plačilo na obroke, zato bo sklenitev plačila na obroke izvedena po skrajšanem postopku. ")
              ])
            ])
          ], -1)
        ]))) : x("", !0),
        n.flowType != u(R).INFOCALC && n.flowType != u(R).WEB_INFOCALC && n.flowType != u(R).PORTAL_INFOCALC ? (S(), K(ot, { key: 1 }, {
          default: P(() => [
            C(Qe, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                !u(_) || n.mustProvideThreeSalaries === !0 && n.numberOfPreapprovedSalaries < 3 ? (S(), N("div", Iv, [
                  p("h2", Ev, E(u(s)("Components.InstallmentPlanComponent.MonthlyIncome")), 1),
                  p("div", Sv, [
                    p("label", Pv, E(n.employmentType == u(le).SP || n.mustProvideThreeSalaries ? u(s)("Components.InstallmentPlanComponent.MonthlyIncome") + "- " + u(s)("Components.InstallmentPlanComponent.Months." + u(y).month0.toString()) : u(s)("Components.InstallmentPlanComponent.LastMonthlyIncome")), 1),
                    p("div", Tv, [
                      He(C(Te, {
                        modelValue: n.lastMonthsIncome,
                        "onUpdate:modelValue": se[0] || (se[0] = (Z) => n.lastMonthsIncome = Z),
                        "error-messages": u(v).lastMonthsIncome.$errors[0] != null ? u(v).lastMonthsIncome.$errors[0].$message : "",
                        disabled: m.isSalaryConfirmed || m.clientIncomeInsert,
                        onFocus: u(v).lastMonthsIncome.$reset,
                        variant: "outlined",
                        appendText: "EUR",
                        numberOfDecimals: 2,
                        hint: Re.value,
                        "persistent-hint": ""
                      }, null, 8, ["modelValue", "error-messages", "disabled", "onFocus", "hint"]), [
                        [Ye, !m.clientIncomeInsert || n.lastMonthsIncome == null]
                      ]),
                      He(C(pe, {
                        modelValue: "********",
                        variant: "outlined",
                        suffix: "EUR",
                        hint: Re.value,
                        "persistent-hint": "",
                        disabled: ""
                      }, null, 8, ["hint"]), [
                        [Ye, m.clientIncomeInsert && n.lastMonthsIncome != null]
                      ]),
                      n.flowType == u(R).POS && !m.clientIncomeInsert ? (S(), K(ze, {
                        key: 0,
                        text: n.mustProvideThreeSalaries ? ae.$t("Components.InstallmentPlanComponent.CustomerIncome3BtnTooltip") : ae.$t("Components.InstallmentPlanComponent.CustomerIncomeBtnTooltip"),
                        location: "bottom",
                        class: "tooltip--vnese-stranka",
                        "close-on-content-click": !0
                      }, {
                        activator: P(({ props: Z }) => [
                          C($e, Ot(Z, {
                            onClick: se[1] || (se[1] = (Et) => u(J)()),
                            flat: "",
                            size: "x-small",
                            class: "btn btn--primary-outline btn--sm",
                            disabled: m.isSalaryConfirmed
                          }), {
                            default: P(() => [
                              ne(E(ae.$t("Components.InstallmentPlanComponent.CustomerIncomeBtn")), 1)
                            ]),
                            _: 2
                          }, 1040, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["text"])) : n.flowType == u(R).POS && m.clientIncomeInsert ? (S(), K($e, {
                        key: 1,
                        onClick: se[2] || (se[2] = (Z) => u(U)()),
                        flat: "",
                        size: "x-small",
                        class: "btn btn--primary-outline btn--sm",
                        disabled: m.isSalaryConfirmed
                      }, {
                        default: P(() => [
                          ne(E(ae.$t("Components.InstallmentPlanComponent.PartnerIncomeBtn")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])) : x("", !0)
                    ])
                  ]),
                  n.employmentType == u(le).SP || n.mustProvideThreeSalaries ? (S(), N("div", wv, [
                    p("label", kv, E(n.employmentType == u(le).SP || n.mustProvideThreeSalaries ? u(s)("Components.InstallmentPlanComponent.MonthlyIncome") + "- " + u(s)("Components.InstallmentPlanComponent.Months." + u(y).month1.toString()) : u(s)("Components.InstallmentPlanComponent.MonthlyIncome")), 1),
                    He(C(Te, {
                      modelValue: n.lastMonthsIncome2,
                      "onUpdate:modelValue": se[3] || (se[3] = (Z) => n.lastMonthsIncome2 = Z),
                      "error-messages": u(v).lastMonthsIncome2.$errors[0] != null ? u(v).lastMonthsIncome2.$errors[0].$message : "",
                      onFocus: u(v).lastMonthsIncome2.$reset,
                      variant: "outlined",
                      appendText: "EUR",
                      disabled: m.isSalaryConfirmed || m.clientIncomeInsert,
                      numberOfDecimals: 2,
                      hint: Re.value,
                      "persistent-hint": ""
                    }, null, 8, ["modelValue", "error-messages", "onFocus", "disabled", "hint"]), [
                      [Ye, !m.clientIncomeInsert || n.lastMonthsIncome2 == null]
                    ]),
                    He(C(pe, {
                      modelValue: "********",
                      variant: "outlined",
                      suffix: "EUR",
                      hint: Re.value,
                      "persistent-hint": "",
                      disabled: ""
                    }, null, 8, ["hint"]), [
                      [Ye, m.clientIncomeInsert && n.lastMonthsIncome2 != null]
                    ])
                  ])) : x("", !0),
                  n.employmentType == u(le).SP || n.mustProvideThreeSalaries ? (S(), N("div", Nv, [
                    p("label", Av, E(n.employmentType == u(le).SP || n.mustProvideThreeSalaries ? u(s)("Components.InstallmentPlanComponent.MonthlyIncome") + "- " + u(s)("Components.InstallmentPlanComponent.Months." + u(y).month2.toString()) : u(s)("Components.InstallmentPlanComponent.MonthlyIncome")), 1),
                    He(C(Te, {
                      modelValue: n.lastMonthsIncome3,
                      "onUpdate:modelValue": se[4] || (se[4] = (Z) => n.lastMonthsIncome3 = Z),
                      "error-messages": u(v).lastMonthsIncome3.$errors[0] != null ? u(v).lastMonthsIncome3.$errors[0].$message : "",
                      onFocus: u(v).lastMonthsIncome3.$reset,
                      variant: "outlined",
                      appendText: "EUR",
                      disabled: m.isSalaryConfirmed || m.clientIncomeInsert,
                      numberOfDecimals: 2,
                      hint: Re.value,
                      "persistent-hint": ""
                    }, null, 8, ["modelValue", "error-messages", "onFocus", "disabled", "hint"]), [
                      [Ye, !m.clientIncomeInsert || n.lastMonthsIncome3 == null]
                    ]),
                    He(C(pe, {
                      modelValue: "********",
                      variant: "outlined",
                      suffix: "EUR",
                      hint: Re.value,
                      "persistent-hint": "",
                      disabled: ""
                    }, null, 8, ["hint"]), [
                      [Ye, m.clientIncomeInsert && n.lastMonthsIncome3 != null]
                    ])
                  ])) : x("", !0)
                ])) : x("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        !m.clientIncomeInsert && !m.isSalaryConfirmed && n.flowType != u(R).INFOCALC && n.flowType != u(R).WEB_INFOCALC && n.flowType != u(R).PORTAL_INFOCALC ? (S(), K(ot, { key: 2 }, {
          default: P(() => [
            C(Qe, null, {
              default: P(() => [
                p("div", Mv, [
                  n.flowType === u(R).POS ? (S(), N("div", Ov, " Preverite točnost vpisanih podatkov s stranko. ")) : (S(), N("div", Rv, "Potrjujem, da so vpisani zneski mesečnih prihodkov točni in se ujemajo s podatki na plačilnih listah ali bančnih izpisih. ")),
                  p("div", $v, [
                    C($e, {
                      class: "btn btn--primary-fill",
                      onClick: se[5] || (se[5] = (Z) => u(q)())
                    }, {
                      default: P(() => se[16] || (se[16] = [
                        ne(" Potrjujem podatke ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        C(ot, {
          class: Le(m.isSalaryConfirmed ? "" : "disabled")
        }, {
          default: P(() => [
            C(Qe, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("h2", xv, E(n.flowType == u(R).INFOCALC || n.flowType == u(R).WEB_INFOCALC || n.flowType == u(R).PORTAL_INFOCALC ? u(s)("Components.InstallmentPlanComponent.InfoCalculTitle") : u(s)("Components.InstallmentPlanComponent.Title")), 1),
                  p("div", null, [
                    p("label", Lv, E(u(s)("Components.InstallmentPlanComponent.PurchaseAmount")), 1),
                    C(Te, {
                      ref: "creditAmountRef",
                      modelValue: n.creditAmount,
                      "onUpdate:modelValue": se[6] || (se[6] = (Z) => n.creditAmount = Z),
                      numberOfDecimals: 2,
                      onChange: se[7] || (se[7] = (Z) => u(k)()),
                      disabled: n.flowType != u(R).INFOCALC && n.flowType != u(R).WEB_INFOCALC && n.flowType != u(R).PORTAL_INFOCALC,
                      appendText: "EUR",
                      formatNumber: (Z, Et) => Z.toLocaleString("sl-SI", { minimumFractionDigits: Et, maximumFractionDigits: Et })
                    }, null, 8, ["modelValue", "disabled", "formatNumber"])
                  ]),
                  p("div", null, [
                    p("label", Vv, E(u(s)("Components.InstallmentPlanComponent.InstallmentNumber")), 1),
                    C(Te, {
                      ref: "installmentNrRef",
                      modelValue: n.installmentNr,
                      "onUpdate:modelValue": se[8] || (se[8] = (Z) => n.installmentNr = Z),
                      minValue: m.minInstallment,
                      maxValue: m.maxInstallment,
                      disabled: !m.isSalaryConfirmed,
                      appendText: "obrokov"
                    }, null, 8, ["modelValue", "minValue", "maxValue", "disabled"]),
                    C(It, {
                      modelValue: n.installmentNr,
                      "onUpdate:modelValue": se[9] || (se[9] = (Z) => n.installmentNr = Z),
                      step: "1",
                      min: m.minInstallment,
                      max: m.maxInstallment,
                      disabled: !m.isSalaryConfirmed,
                      ticks: u(g),
                      "show-ticks": "always",
                      "tick-size": "4"
                    }, {
                      "thumb-label": P(({ modelValue: Z }) => [
                        ne(E(u(s)("Components.InstallmentPlanComponent.InstallmentNumberPlural", {
                          count: Z
                        })), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "min", "max", "disabled", "ticks"])
                  ]),
                  m.isOverridenProduct ? (S(), N("div", Fv, E(m.overridenProductName) + " financiranje je na voljo do " + E(m.overridenMaxInstallments) + " obrokov. Pri daljši odplačilni dobi je na voljo obrestno financiranje. ", 1)) : x("", !0),
                  n.flowType === u(R).INFOCALC ? (S(), N("div", jv, [
                    se[17] || (se[17] = p("h2", { class: "section-heading" }, " Izbira produkta ", -1)),
                    p("div", zv, [
                      p("label", Uv, E(u(s)("Components.IdentificationDataComponent.ChooseProductType")), 1),
                      C(te, {
                        modelValue: n.selectedProductType,
                        "onUpdate:modelValue": se[10] || (se[10] = (Z) => n.selectedProductType = Z),
                        error: u(v).selectedProductType.error,
                        "error-messages": u(v).selectedProductType.$errors[0] != null ? u(v).selectedProductType.$errors[0].$message : "",
                        onFocus: u(v).selectedProductType.$reset
                      }, {
                        default: P(() => [
                          u(w)("OBR") ? (S(), K(B, {
                            key: 0,
                            class: "product-type__obrestni",
                            value: "OBR",
                            label: u(s)("Product.OBR")
                          }, null, 8, ["label"])) : x("", !0),
                          u(w)("BREZOBR") ? (S(), K(B, {
                            key: 1,
                            class: "product-type__brez-obresti",
                            value: "BREZOBR",
                            label: u(s)("Product.BREZOBR")
                          }, null, 8, ["label"])) : x("", !0),
                          u(w)("EOM0") ? (S(), K(B, {
                            key: 2,
                            class: "product-type__eom0",
                            value: "EOM0",
                            label: u(s)("Product.EOM0")
                          }, null, 8, ["label"])) : x("", !0),
                          u(w)("MOR") ? (S(), K(B, {
                            key: 3,
                            class: "product-type__moratorij",
                            value: "MOR",
                            label: u(s)("Product.MOR")
                          }, null, 8, ["label"])) : x("", !0),
                          n.specialProductList != null && n.specialProductList.length > 0 ? (S(), K(B, {
                            key: 4,
                            class: "product-type__posebne-akcije",
                            value: "SPECIAL",
                            label: u(s)("Product.SPECIAL")
                          }, null, 8, ["label"])) : x("", !0)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "error", "error-messages", "onFocus"])
                    ]),
                    n.selectedProductType === "SPECIAL" ? (S(), N("label", Bv, " Posebne akcije ")) : x("", !0),
                    n.selectedProductType === "SPECIAL" ? (S(), K(Ee, {
                      key: 1,
                      modelValue: n.selectedSpecialProduct,
                      "onUpdate:modelValue": se[11] || (se[11] = (Z) => n.selectedSpecialProduct = Z),
                      items: n.specialProductList,
                      error: u(v).selectedSpecialProduct.error,
                      "error-messages": u(v).selectedSpecialProduct.$errors[0] != null ? u(v).selectedSpecialProduct.$errors[0].$message : "",
                      onFocus: u(v).selectedSpecialProduct.$reset,
                      "return-object": !0,
                      "item-title": "productName",
                      "item-value": "productId",
                      variant: "outlined"
                    }, null, 8, ["modelValue", "items", "error", "error-messages", "onFocus"])) : x("", !0)
                  ])) : x("", !0)
                ])
              ]),
              _: 1
            }),
            C(Qe, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", Gv, [
                  p("div", qv, [
                    p("div", null, E(u(s)("Components.InstallmentPlanComponent.MonthlyInstallment")) + ":", 1),
                    p("div", Dv, [
                      ne(E(ae.$n(m.installmentVal == null || m.installmentVal.toString() == "" ? 0 : m.installmentVal, "decimal")) + " ", 1),
                      se[18] || (se[18] = p("div", null, [
                        p("div", { class: "installment-plan-calculation__installment_currency" }, " EUR "),
                        p("div", { class: "installment-plan-calculation__installment_period" }, "/mesec")
                      ], -1))
                    ]),
                    p("div", null, E(u(s)("Components.InstallmentPlanComponent.PurchaseAmount2")) + ":", 1),
                    p("div", null, E(ae.$n(n.creditAmount == null || n.creditAmount.toString() == "" ? 0 : n.creditAmount, "decimal")) + " EUR ", 1),
                    n.installmentNr != null ? (S(), N("div", Hv, E(u(s)("Components.InstallmentPlanComponent.InstallmentNumber")) + ":", 1)) : x("", !0),
                    n.installmentNr != null ? (S(), N("div", Yv, E(u(s)(
                      "Components.InstallmentPlanComponent.InstallmentNumberPlural",
                      n.installmentNr
                    )), 1)) : x("", !0),
                    p("div", null, E(u(s)("Components.InstallmentPlanComponent.DateOfFirstInstallment")) + ": ", 1),
                    p("div", null, E(m.dateOfFirstInstallment != "" ? u(i)(m.dateOfFirstInstallment) : "-"), 1),
                    p("div", null, E(u(s)("Components.InstallmentPlanComponent.DateOfLastInstallment")) + ": ", 1),
                    p("div", null, E(m.dateOfLastInstallment != "" ? u(i)(m.dateOfLastInstallment) : "-"), 1),
                    p("div", null, E(u(s)("Components.InstallmentPlanComponent.InterestRate")) + ":", 1),
                    p("div", null, E(m.interestNr != null ? ae.$n(m.interestNr, "decimal") + " %" : "-"), 1),
                    p("div", null, E(u(s)("Components.InstallmentPlanComponent.EOM")) + ":", 1),
                    p("div", null, E(m.EOM != null ? ae.$n(m.EOM, "decimal") + " %" : "-"), 1),
                    p("div", null, E(u(s)("Components.InstallmentPlanComponent.InsuranceCost")) + ":", 1),
                    p("div", null, E(m.insuranceVal != null ? ae.$n(
                      m.insuranceVal,
                      "decimal"
                    ) + " EUR" : "-"), 1),
                    p("div", null, E(u(s)("Components.InstallmentPlanComponent.ApprovalCost")) + ":", 1),
                    p("div", null, E(m.approvalVal != null ? ae.$n(m.approvalVal, "decimal") + " EUR" : "-"), 1),
                    p("div", null, E(u(s)("Components.InstallmentPlanComponent.CompleteCost")) + ":", 1),
                    p("div", null, E(m.amountTotal != null ? ae.$n(m.amountTotal, "decimal") + " EUR" : "0,00 EUR"), 1)
                  ]),
                  p("div", Zv, [
                    ne(E(u(s)("Components.InstallmentPlanComponent.AllCosts")) + " ", 1),
                    se[19] || (se[19] = p("br", null, null, -1)),
                    se[20] || (se[20] = p("br", null, null, -1)),
                    ne(" " + E(u(s)("Components.InstallmentPlanComponent.EOMDisclaimer")), 1)
                  ]),
                  n.isPreapproved && !u(h) && u(_) ? (S(), N("div", Wv, E(u(s)("Components.InstallmentPlanComponent.PreapprovedError")), 1)) : x("", !0)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        C(Ct, {
          display: m.showModal,
          showCloseXButton: !0,
          title: "Pošlji izračun",
          showAcceptButton: !0,
          acceptText: "Pošlji",
          closeText: "Prekliči",
          showDeclineButton: !0,
          onAccept: u(oe),
          onModalClosed: u(fe)
        }, {
          default: P(() => [
            m.modalErrorMessage ? (S(), N("div", Kv, E(m.modalErrorMessage), 1)) : x("", !0),
            se[21] || (se[21] = p("div", { class: "mb-6" }, "Vnesite e-mail naslov ali mobilno številko na katero želite poslati izračun.", -1)),
            C(ot, { class: "w-100" }, {
              default: P(() => [
                C(Qe, { class: "v-col-8" }, {
                  default: P(() => [
                    p("div", Qv, [
                      p("label", Xv, E(u(s)("Components.IdentificationDataComponent.Email")), 1),
                      p("div", Jv, [
                        C(pe, {
                          modelValue: n.email,
                          "onUpdate:modelValue": se[12] || (se[12] = (Z) => n.email = Z),
                          variant: "outlined",
                          "persistent-hint": "",
                          "error-messages": u(v).email.$errors[0] != null ? u(v).email.$errors[0].$message : "",
                          onFocus: u(v).email.$reset
                        }, null, 8, ["modelValue", "error-messages", "onFocus"])
                      ])
                    ]),
                    p("div", null, [
                      p("label", e1, E(u(s)("Components.IdentificationDataComponent.PhoneNumber")), 1),
                      p("div", t1, [
                        C(Ee, {
                          modelValue: n.prefix,
                          "onUpdate:modelValue": se[13] || (se[13] = (Z) => n.prefix = Z),
                          items: u(l).state.countryPhoneList,
                          variant: "outlined",
                          class: "control-phone-country",
                          "return-object": !0,
                          "item-title": "Value",
                          "item-value": "Key",
                          "persistent-hint": "",
                          "error-messages": u(v).prefix.$errors[0] != null ? u(v).prefix.$errors[0].$message : "",
                          onFocus: u(v).prefix.$reset
                        }, null, 8, ["modelValue", "items", "error-messages", "onFocus"]),
                        C(Te, {
                          modelValue: n.phoneNumber,
                          "onUpdate:modelValue": se[14] || (se[14] = (Z) => n.phoneNumber = Z),
                          variant: "outlined",
                          class: "control-phone-number",
                          "error-messages": u(v).phoneNumber.$errors[0] != null ? u(v).phoneNumber.$errors[0].$message : "",
                          onFocus: u(v).phoneNumber.$reset
                        }, null, 8, ["modelValue", "error-messages", "onFocus"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["display", "onAccept", "onModalClosed"]),
        m.calculationError != "" ? (S(), N("div", n1, E(u(s)(`GlobalErrors.${m.calculationError}`)), 1)) : x("", !0)
      ], 512);
    };
  }
}), o1 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M22%2012H18L15%2021L9%203L6%2012H2'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", r1 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12%2016C14.2091%2016%2016%2014.2091%2016%2012C16%209.79086%2014.2091%208%2012%208C9.79086%208%208%209.79086%208%2012C8%2014.2091%209.79086%2016%2012%2016Z'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M1.05078%2012H7.00078'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M17.0098%2012H22.9598'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", i1 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M6%209C7.65685%209%209%207.65685%209%206C9%204.34315%207.65685%203%206%203C4.34315%203%203%204.34315%203%206C3%207.65685%204.34315%209%206%209Z'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M6%2021C7.65685%2021%209%2019.6569%209%2018C9%2016.3431%207.65685%2015%206%2015C4.34315%2015%203%2016.3431%203%2018C3%2019.6569%204.34315%2021%206%2021Z'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M19.9991%204L8.11914%2015.88'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M14.4707%2014.4805L20.0007%2020.0005'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M8.11914%208.11914L11.9991%2011.9991'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Kr = {
  orderToken: "",
  partnerLink: "",
  firstname: "",
  surname: "",
  calculationId: void 0,
  creditAmount: 0,
  installmentNr: 0,
  installmentVal: 0,
  installmentValNoCost: 0,
  lastMonthsIncome: 0,
  lastMonthsIncome2: 0,
  lastMonthsIncome3: 0,
  flowType: void 0,
  isPreapproved: !1,
  preapprovedCreditAmount: 0,
  preapprovedInstallmentAmount: 0,
  numberOfPreapprovedSalaries: 0,
  employmentType: void 0,
  mustProvideThreeSalaries: !1,
  isSlovenianCitizen: !0,
  hasSlovenianIncome: !0,
  citizen: -1,
  selectedProduct: void 0,
  selectedSpecialProduct: void 0,
  msisdn: "",
  taxNumber: "",
  prefix: void 0,
  phoneNumber: void 0,
  emso: "",
  birthdate: null,
  headerTitle: "",
  headerSubtitle: "",
  isDocumentationNeeded: !1,
  isViewDataLoading: !1,
  selectedProductType: void 0,
  productList: [],
  specialProductList: [],
  sisbonResultId: -1,
  debtAmount: 0,
  debtInstallments: 0,
  contractDebtInstallments: 0,
  minSalary: 0,
  minCredit: 0,
  multipleContractAgreement: !1
}, a1 = {
  isDataLoading: !1,
  installmentVal: 0,
  installmentValNoCost: 0,
  interestNr: 0,
  EOM: 0,
  amountTotal: 0,
  insuranceVal: 0,
  approvalVal: 0,
  calculationError: "",
  showMore: !1,
  clientIncomeInsert: !1,
  printCalculation: !1,
  dateOfFirstInstallment: "",
  dateOfLastInstallment: "",
  isSalaryConfirmed: !1,
  minInstallment: 3,
  maxInstallment: 84,
  suggestedInstallment: 0,
  availableProducts: [],
  isUserDraggingSlider: !1
};
function s1(e, t) {
  const { t: o } = H();
  return F(() => ({
    lastMonthsIncome: {
      required: j.withMessage(o("GlobalErrors.FieldRequired"), he),
      minMinimalPay: j.withMessage(o("GlobalErrors.MinMinimalPay"), () => e.lastMonthsIncome !== void 0 && e.lastMonthsIncome > 100)
    },
    lastMonthsIncome2: {
      customRequired: j.withMessage(o("GlobalErrors.FieldRequired"), de(() => e.mustProvideThreeSalaries)),
      min100: j.withMessage(o("GlobalErrors.Min10Eur"), () => e.mustProvideThreeSalaries && e.lastMonthsIncome2 >= 1 || !e.mustProvideThreeSalaries)
    },
    lastMonthsIncome3: {
      customRequired: j.withMessage(o("GlobalErrors.FieldRequired"), de(() => e.mustProvideThreeSalaries)),
      min100: j.withMessage(o("GlobalErrors.Min10Eur"), () => e.mustProvideThreeSalaries && e.lastMonthsIncome3 >= 1 || !e.mustProvideThreeSalaries)
    },
    selectedProductType: {
      required: j.withMessage(o("GlobalErrors.ChoiceRequired"), de(() => e.flowType === R.INFOCALC))
    },
    selectedSpecialProduct: {
      required: j.withMessage(o("GlobalErrors.FIELD_REQUIRED"), de(() => e.selectedProductType === "SPECIAL"))
    },
    multipleContractAgreement: {
      required: j.withMessage(
        o("GlobalErrors.ChoiceRequired"),
        () => t.availableProducts.length <= 1 || e.multipleContractAgreement === !0
      )
    }
  }));
}
function l1(e, t, o) {
  const r = Q("navigationButtonsApi", null), d = Q("commClient");
  Q("showReport");
  const { copySharedProperties: f, scrollToFirstError: i } = Ie(), l = be(s1(e, t), F(() => e), { $autoDirty: !0 });
  async function s() {
    return l.value.$touch(), l.value.$validate();
  }
  let n;
  async function a(U) {
    e.installmentNr != U.installmentNr && (clearTimeout(n), n = setTimeout(async () => {
      await I().then((oe) => {
        oe != null && oe.name != null && o("navigation-event", oe.name);
      });
    }, 500));
  }
  const c = F(() => e.mustProvideThreeSalaries || e.isPreapproved && e.numberOfPreapprovedSalaries === 3 || e.lastMonthsIncome2 != null && e.lastMonthsIncome2 > 0 ? ((e.lastMonthsIncome ? e.lastMonthsIncome : 0) + (e.lastMonthsIncome2 ? e.lastMonthsIncome2 : 0) + (e.lastMonthsIncome3 ? e.lastMonthsIncome3 : 0)) / 3 : e.lastMonthsIncome ? e.lastMonthsIncome : 0), m = F(() => {
    const U = (/* @__PURE__ */ new Date()).getMonth();
    return {
      month0: U > 2 ? U - 3 : U + 9,
      month1: U > 1 ? U - 2 : U + 10,
      month2: U > 0 ? U - 1 : U + 11,
      month3: U
    };
  }), v = F(() => e.isPreapproved && (e.creditAmount == null || e.creditAmount <= e.preapprovedCreditAmount) && (t.installmentValNoCost == null || t.installmentValNoCost <= e.preapprovedInstallmentAmount)), h = F(() => e.isPreapproved && (e.creditAmount == null || e.creditAmount <= e.preapprovedCreditAmount)), _ = F(() => ({
    [t.minInstallment]: `${t.minInstallment} obrokov`,
    [t.minInstallment + Math.round((t.maxInstallment - t.minInstallment) / 2)]: `${t.minInstallment + Math.round((t.maxInstallment - t.minInstallment) / 2)} obrokov`,
    [t.maxInstallment]: `${t.maxInstallment} obrokov`
  }));
  async function b() {
    return e.isViewDataLoading = !0, new Promise((U) => {
      e.installmentNr > 2 && d.executeMethodAsync("ContractCalculationCreateMultiProduct", {
        OrderToken: e.orderToken,
        OrderType: e.flowType,
        Installments: e.installmentNr,
        Firstname: "",
        Surname: "",
        TaxNumber: e.taxNumber,
        Msisdn: e.msisdn,
        Birthdate: e.birthdate,
        Salary: c.value,
        minCredit: e.minCredit,
        ContractDebt: e.contractDebtInstallments,
        SlovenianCitizen: e.isSlovenianCitizen === void 0 ? e.citizen === 204 : e.isSlovenianCitizen,
        HasSlovenianIncome: e.hasSlovenianIncome,
        EmploymentType: e.employmentType
      }).then(async (oe) => {
        if (oe)
          if (oe.success === !0)
            f(e, oe), f(t, oe), await s() && (e.flowType === R.WEB || e.flowType === R.SKLENI_SAM ? e.isPreapproved && e.preapprovedCreditAmount >= e.creditAmount && e.preapprovedInstallmentAmount >= e.installmentValNoCost ? U({ name: "nextStepPreapproved" }) : U({ name: "nextStep" }) : U({ name: "nextStepCustomer" }));
          else
            switch (oe.calculationError) {
              case "TaxNrMsisdnMismatch":
              case "MaxRemainingCredit":
              case "SpNeustrezen":
                e.headerSubtitle = oe.calculationError, U({ name: "endFail" });
                break;
              case "NoSuitableProduct":
              case "InstallmentTooHigh":
              case "CreditErrorMaxAmount":
              case "CreditErrorMinAmount":
              case "InstallmentErrorMinAmount":
              case "InstallmentNrErrorMax":
              case "InstallmentNrErrorMin":
              case "CalculationFailed":
                t.calculationError = oe.calculationError, U(null);
                break;
              default:
                e.headerSubtitle = oe.calculationError, U({ name: "endFail" });
                break;
            }
        else
          U(null);
      }).catch((oe) => U({ name: "endFail" }));
    });
  }
  function y(U) {
    U && (console.log("UpdateCalculationData: ", U), U.success && f(e, U), f(t, U));
  }
  async function g() {
    return t.calculationError = "", e.isViewDataLoading = !0, new Promise(async (U, oe) => {
      e.flowType === R.WEB ? await d.executeMethodAsync("SalaryRequirementsMultiProduct", {
        OrderToken: e.orderToken,
        OrderType: e.flowType,
        TaxNumber: e.taxNumber,
        SlovenianCitizen: e.isSlovenianCitizen,
        EmploymentType: e.employmentType,
        Salary: c.value,
        minCredit: e.minCredit,
        ContractDebt: e.contractDebtInstallments,
        SisbonDebt: e.debtInstallments
      }).then(async (fe) => {
        y(fe), fe.success ? U(null) : (e.headerSubtitle = fe.errorId, U({ name: "endFail" }));
      }).catch((fe) => U({ name: "endFail" })) : console.log("invalid flow type for SalaryRequirements");
    });
  }
  async function I() {
    return t.calculationError = "", new Promise(async (U, oe) => {
      e.installmentNr >= 3 ? e.flowType === R.WEB ? await d.executeMethodAsync("GenericCalculationCreateMultiProduct", {
        OrderToken: e.orderToken,
        OrderType: e.flowType,
        TaxNumber: e.taxNumber,
        InstallmentNr: e.installmentNr,
        SlovenianCitizen: e.isSlovenianCitizen,
        EmploymentType: e.employmentType,
        Birthdate: e.birthdate,
        Salary: c.value,
        minCredit: e.minCredit,
        ContractDebt: e.contractDebtInstallments
      }).then(async (fe) => {
        if (y(fe), fe.success)
          U(null);
        else
          switch (fe.calculationError) {
            case "MaxRemainingCredit":
              e.headerSubtitle = fe.calculationError, U({ name: "endFail" });
              break;
            case "CreditDenied":
            case "NoSuitableProduct":
            case "InstallmentTooHigh":
            case "CreditErrorMaxAmount":
            case "CreditErrorMinAmount":
            case "InstallmentErrorMinAmount":
            case "InstallmentNrErrorMax":
            case "InstallmentNrErrorMin":
            case "CalculationFailed":
              t.calculationError = fe.calculationError, U(null);
              break;
          }
      }).catch((fe) => U({ name: "endFail" })) : console.log("invalid flow type for CreateInformativeCalculation") : U(null);
    });
  }
  async function T() {
    return new Promise(async (U, oe) => {
      await d.executeMethodAsync("ActionDataMultiProduct", {
        OrderToken: e.orderToken,
        OrderType: e.flowType,
        TaxNumber: e.taxNumber,
        IsSlovenianCitizen: e.isSlovenianCitizen,
        IsSP: e.employmentType === le.SP
      }).then((fe) => {
        const ve = M(fe);
        ve != "" ? U({ name: ve }) : U(null);
      }).catch((fe) => oe());
    });
  }
  function w() {
    e.creditAmount !== void 0 && e.creditAmount > 0 && (e.creditAmount < 1e3 ? e.installmentNr = 6 : e.creditAmount < 2e3 ? e.installmentNr = 12 : e.creditAmount < 5e3 ? e.installmentNr = 24 : e.creditAmount < 1e4 ? e.installmentNr = 48 : e.installmentNr = 60);
  }
  function M(U) {
    return U.Success ? (e.selectedProduct = {
      productId: "",
      productName: "",
      installmentMin: U.MinInstallment,
      installmentMax: U.MaxInstallment,
      amountMin: U.MinAmount,
      amountMax: U.MaxAmount,
      ageMin: 0,
      ageMax: 0
    }, t.minInstallment = U.MinInstallment, t.maxInstallment = U.MaxInstallment, U.CreditAmount != null && (e.creditAmount = U.CreditAmount), U.Installments != null ? e.installmentNr = U.Installments : w(), "") : (e.headerSubtitle = U.Error, "endFail");
  }
  function k() {
    e.isPreapproved && (t.isSalaryConfirmed = !0), r !== null && !e.isPreapproved && (r == null || r.setButtonDisabled("Next", !0));
  }
  async function L() {
    l.value.lastMonthsIncome.$touch(), l.value.lastMonthsIncome2.$touch(), l.value.lastMonthsIncome3.$touch(), (await Promise.all([
      l.value.lastMonthsIncome.$validate(),
      l.value.lastMonthsIncome2.$validate(),
      l.value.lastMonthsIncome3.$validate()
    ])).every((fe) => fe === !0) && await g().then(async (fe) => {
      fe !== null ? (e.isViewDataLoading = !1, o("navigation-event", fe.name)) : (t.suggestedInstallment > 0 ? e.installmentNr = t.suggestedInstallment : t.maxInstallment > 24 ? e.installmentNr = 24 : e.installmentNr = 10, t.isSalaryConfirmed = !0, r !== null && (r == null || r.setButtonDisabled("Next", !1)));
    }), e.isViewDataLoading = !1;
  }
  function $() {
    i(".installment-plan-component");
  }
  function q() {
    const U = document.querySelector("#calculation-error");
    U && U.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  async function J() {
    e.isViewDataLoading = !0;
    let U;
    switch (console.log("getting salary information for flow type: " + e.flowType), e.flowType) {
      case R.WEB:
      case R.SKLENI_SAM:
        if (console.log("executing GetSalaryInformationWebMultiProduct"), U = await d.executeMethodAsync("GetSalaryInformationWebMultiProduct", {
          OrderToken: e.orderToken,
          OrderType: e.flowType,
          TaxNumber: e.taxNumber,
          SlovenianCitizen: e.isSlovenianCitizen,
          EmploymentType: e.employmentType,
          Birthdate: e.birthdate
        }), U) {
          if (U.success === !0)
            return f(e, U), f(t, U), null;
          switch (U.error) {
            case "NoSuitableProduct":
            case "ProcessError":
              return e.headerSubtitle = U.error, { name: "endFail" };
          }
        }
        break;
    }
    return null;
  }
  async function X(U) {
    let oe = !1, fe = null;
    switch (U) {
      case "calculationAndExposure":
      case "webNext":
        if (oe = await s(), !oe) return null;
        fe || (t.calculationError !== "" ? q() : $()), fe = await b();
        break;
    }
    return fe;
  }
  return {
    getPreapprovedValidity: v,
    getPreapprovedAmountValidity: h,
    pastMonths: m,
    getSliderTicks: _,
    dataChanged: a,
    navigationAction: X,
    CreateInformativeCalculation: I,
    WebActionData: T,
    scrollToFirstErrorWrapper: $,
    confirmSalary: L,
    SetupInstallmentBasedOnAmount: w,
    initData: k,
    GetSalaryInformation: J,
    v$: l
  };
}
const u1 = {
  class: "installment-plan-component",
  ref: "rootRef"
}, d1 = { key: 0 }, c1 = { key: 0 }, m1 = { class: "section-heading mt-0" }, f1 = { class: "mb-4" }, p1 = { class: "form-label" }, v1 = { class: "control-income-wrapper" }, h1 = {
  key: 0,
  class: "mb-4"
}, y1 = { class: "form-label" }, _1 = {
  key: 1,
  class: "mb-4"
}, g1 = { class: "form-label" }, b1 = { class: "callout" }, C1 = { key: 0 }, I1 = { key: 1 }, E1 = { class: "mt-4" }, S1 = { class: "section-heading mt-0" }, P1 = { class: "form-label" }, T1 = { class: "form-label" }, w1 = { class: "installment-plan-calculation installment-plan-calculation--bg" }, k1 = { class: "installment-plan-calculation__grid" }, N1 = { class: "installment-plan-calculation__installment" }, A1 = { class: "installment-plan-calculation__grid" }, M1 = { key: 0 }, O1 = { key: 1 }, R1 = { class: "installment-plan-calculation__grid" }, $1 = { class: "installment-plan-calculation pa-4" }, x1 = { class: "installment-plan-calculation__title" }, L1 = {
  key: 0,
  src: o1,
  alt: "Obrestni produkt"
}, V1 = {
  key: 1,
  src: r1,
  alt: "Brezobrestni produkt"
}, F1 = {
  key: 2,
  src: i1,
  alt: "EOM 0 produkt"
}, j1 = { class: "installment-plan-calculation__grid" }, z1 = { class: "installment-plan-calculation__disclaimer" }, U1 = {
  key: 0,
  class: "notification notification--notice mt-8 mb-0"
}, B1 = {
  key: 4,
  class: "alert alert--error mb-5 mt-5 alert-predodobreno"
}, G1 = {
  key: 5,
  id: "calculation-error",
  class: "notification notification--warning mt-4"
}, wb = /* @__PURE__ */ ie({
  __name: "installment-plan-multi-product-component",
  props: {
    data: { default: () => ({
      ...Kr
    }) }
  },
  emits: ["update:data", "navigation-event", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o, { getDateCorrectedFormat: f } = Ie(), { t: i } = H(), l = W({ ...r.data });
    let s = { ...Kr }, n = re(!1);
    const a = W({ ...a1 }), {
      v$: c,
      getPreapprovedValidity: m,
      getPreapprovedAmountValidity: v,
      navigationAction: h,
      pastMonths: _,
      getSliderTicks: b,
      dataChanged: y,
      initData: g,
      CreateInformativeCalculation: I,
      WebActionData: T,
      scrollToFirstErrorWrapper: w,
      confirmSalary: M,
      GetSalaryInformation: k
    } = l1(l, a, d);
    G(
      () => r.data,
      // Watch for changes in the data
      ($) => {
        Object.assign(l, $);
      },
      { deep: !0 }
    ), G(
      l,
      async ($) => {
        await y(s), Object.assign(s, $), d("update:data", $);
      },
      { deep: !0 }
    ), me(async () => {
      g(), await T().then(async ($) => {
        if ($ != null && $.name != null)
          d("navigation-event", $.name);
        else {
          console.log("calling GetSalaryInformation() from onMounted()");
          const q = await k();
          q != null && q.name != null && d("navigation-event", q.name);
        }
      }).catch(), n.value = !0, d("componentReady");
    });
    const L = F(() => {
      const $ = l.isDocumentationNeeded;
      switch (l.employmentType) {
        case le.SP:
          return i("Components.InstallmentPlanComponent.MonthlyIncomeHintSPDoc");
        case le.Upokojenec:
          return i($ ? "Components.InstallmentPlanComponent.MonthlyIncomeHintUpokojenecDoc" : "Components.InstallmentPlanComponent.MonthlyIncomeHintUpokojenecNoDoc");
        case le.Zaposlen:
          return i($ ? "Components.InstallmentPlanComponent.MonthlyIncomeHintZaposleniDoc" : "Components.InstallmentPlanComponent.MonthlyIncomeHintZaposleniNoDoc");
        default:
          return "";
      }
    });
    return G(() => a.calculationError, ($) => {
      $ !== "" && on(() => {
        const q = document.querySelector("#calculation-error");
        q && q.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }), t({
      navigationAction: h,
      scrollToFirstErrorWrapper: w,
      componentReady: n
    }), ($, q) => {
      const J = V("v-col"), X = V("v-row"), U = V("v-btn"), oe = V("v-slider"), fe = V("v-checkbox");
      return S(), N("div", u1, [
        l.isPreapproved === !0 && l.creditAmount <= l.preapprovedCreditAmount && l.installmentValNoCost <= l.preapprovedInstallmentAmount && (l.flowType === u(R).WEB || l.flowType === u(R).SKLENI_SAM || l.flowType === u(R).POS) ? (S(), N("div", d1, q[9] || (q[9] = [
          p("div", { class: "notification notification--big" }, [
            p("div", { class: "d-flex ga-4" }, [
              p("img", {
                src: or,
                alt: "Predodobreno",
                class: ""
              }),
              p("div", null, [
                p("div", { class: "title" }, "Vnaprej odobreno plačilo na obroke"),
                p("div", null, "Imate vnaprej odobreno plačilo na obroke, zato bo sklenitev plačila na obroke izvedena po skrajšanem postopku. ")
              ])
            ])
          ], -1)
        ]))) : x("", !0),
        l.flowType != u(R).INFOCALC && l.flowType != u(R).WEB_INFOCALC && l.flowType != u(R).PORTAL_INFOCALC ? (S(), K(X, { key: 1 }, {
          default: P(() => [
            C(J, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                l.isPreapproved === !1 || l.mustProvideThreeSalaries === !0 && l.numberOfPreapprovedSalaries < 3 ? (S(), N("div", c1, [
                  p("h2", m1, E(u(i)("Components.InstallmentPlanComponent.MonthlyIncome")), 1),
                  p("div", f1, [
                    p("label", p1, E(l.employmentType == u(le).SP || l.mustProvideThreeSalaries ? u(i)("Components.InstallmentPlanComponent.MonthlyIncome") + "- " + u(i)("Components.InstallmentPlanComponent.Months." + u(_).month0.toString()) : u(i)("Components.InstallmentPlanComponent.LastMonthlyIncome")), 1),
                    p("div", v1, [
                      C(Te, {
                        modelValue: l.lastMonthsIncome,
                        "onUpdate:modelValue": q[0] || (q[0] = (ve) => l.lastMonthsIncome = ve),
                        "error-messages": u(c).lastMonthsIncome.$errors[0] != null ? u(c).lastMonthsIncome.$errors[0].$message : "",
                        disabled: a.isSalaryConfirmed,
                        onFocus: u(c).lastMonthsIncome.$reset,
                        variant: "outlined",
                        appendText: "EUR",
                        numberOfDecimals: 2,
                        hint: L.value,
                        "persistent-hint": ""
                      }, null, 8, ["modelValue", "error-messages", "disabled", "onFocus", "hint"])
                    ])
                  ]),
                  l.employmentType == u(le).SP || l.mustProvideThreeSalaries ? (S(), N("div", h1, [
                    p("label", y1, E(l.employmentType == u(le).SP || l.mustProvideThreeSalaries ? u(i)("Components.InstallmentPlanComponent.MonthlyIncome") + "- " + u(i)("Components.InstallmentPlanComponent.Months." + u(_).month1.toString()) : u(i)("Components.InstallmentPlanComponent.MonthlyIncome")), 1),
                    C(Te, {
                      modelValue: l.lastMonthsIncome2,
                      "onUpdate:modelValue": q[1] || (q[1] = (ve) => l.lastMonthsIncome2 = ve),
                      "error-messages": u(c).lastMonthsIncome2.$errors[0] != null ? u(c).lastMonthsIncome2.$errors[0].$message : "",
                      onFocus: u(c).lastMonthsIncome2.$reset,
                      variant: "outlined",
                      appendText: "EUR",
                      disabled: a.isSalaryConfirmed,
                      numberOfDecimals: 2,
                      hint: L.value,
                      "persistent-hint": ""
                    }, null, 8, ["modelValue", "error-messages", "onFocus", "disabled", "hint"])
                  ])) : x("", !0),
                  l.employmentType == u(le).SP || l.mustProvideThreeSalaries ? (S(), N("div", _1, [
                    p("label", g1, E(l.employmentType == u(le).SP || l.mustProvideThreeSalaries ? u(i)("Components.InstallmentPlanComponent.MonthlyIncome") + "- " + u(i)("Components.InstallmentPlanComponent.Months." + u(_).month2.toString()) : u(i)("Components.InstallmentPlanComponent.MonthlyIncome")), 1),
                    C(Te, {
                      modelValue: l.lastMonthsIncome3,
                      "onUpdate:modelValue": q[2] || (q[2] = (ve) => l.lastMonthsIncome3 = ve),
                      "error-messages": u(c).lastMonthsIncome3.$errors[0] != null ? u(c).lastMonthsIncome3.$errors[0].$message : "",
                      onFocus: u(c).lastMonthsIncome3.$reset,
                      variant: "outlined",
                      appendText: "EUR",
                      disabled: a.isSalaryConfirmed,
                      numberOfDecimals: 2,
                      hint: L.value,
                      "persistent-hint": ""
                    }, null, 8, ["modelValue", "error-messages", "onFocus", "disabled", "hint"])
                  ])) : x("", !0)
                ])) : x("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        !a.isSalaryConfirmed && l.flowType != u(R).INFOCALC && l.flowType != u(R).WEB_INFOCALC && l.flowType != u(R).PORTAL_INFOCALC ? (S(), K(X, { key: 2 }, {
          default: P(() => [
            C(J, null, {
              default: P(() => [
                p("div", b1, [
                  l.flowType === u(R).POS ? (S(), N("div", C1, " Preverite točnost vpisanih podatkov s stranko. ")) : (S(), N("div", I1, "Potrjujem, da so vpisani zneski mesečnih prihodkov točni in se ujemajo s podatki na plačilnih listah ali bančnih izpisih. ")),
                  p("div", E1, [
                    C(U, {
                      class: "btn btn--primary-fill",
                      onClick: q[3] || (q[3] = (ve) => u(M)())
                    }, {
                      default: P(() => q[10] || (q[10] = [
                        ne(" Potrjujem podatke ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        C(X, null, {
          default: P(() => [
            C(J, { class: "v-col-12" }, {
              default: P(() => [
                p("h2", S1, E(u(i)("Components.InstallmentPlanComponent.InfoCalculTitle")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        C(X, {
          class: Le([a.isSalaryConfirmed ? "" : "disabled", "mt-0"])
        }, {
          default: P(() => [
            C(J, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", P1, E(u(i)("Components.InstallmentPlanComponent.PurchaseAmountSum")), 1),
                  C(Te, {
                    ref: "creditAmountRef",
                    modelValue: l.creditAmount,
                    "onUpdate:modelValue": q[4] || (q[4] = (ve) => l.creditAmount = ve),
                    numberOfDecimals: 2,
                    onChange: q[5] || (q[5] = (ve) => u(I)()),
                    disabled: l.flowType != u(R).INFOCALC && l.flowType != u(R).WEB_INFOCALC && l.flowType != u(R).PORTAL_INFOCALC,
                    appendText: "EUR",
                    formatNumber: (ve, Re) => ve.toLocaleString("sl-SI", { minimumFractionDigits: Re, maximumFractionDigits: Re })
                  }, null, 8, ["modelValue", "disabled", "formatNumber"])
                ])
              ]),
              _: 1
            }),
            C(J, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", T1, E(u(i)("Components.InstallmentPlanComponent.InstallmentNumber")), 1),
                  C(Te, {
                    ref: "installmentNrRef",
                    modelValue: l.installmentNr,
                    "onUpdate:modelValue": q[6] || (q[6] = (ve) => l.installmentNr = ve),
                    minValue: a.minInstallment,
                    maxValue: a.maxInstallment,
                    disabled: !a.isSalaryConfirmed,
                    appendText: "obrokov"
                  }, null, 8, ["modelValue", "minValue", "maxValue", "disabled"]),
                  C(oe, {
                    modelValue: l.installmentNr,
                    "onUpdate:modelValue": q[7] || (q[7] = (ve) => l.installmentNr = ve),
                    step: "1",
                    min: a.minInstallment,
                    max: a.maxInstallment,
                    disabled: !a.isSalaryConfirmed,
                    ticks: u(b),
                    "show-ticks": "always",
                    "tick-size": "4"
                  }, {
                    "thumb-label": P(({ modelValue: ve }) => [
                      ne(E(u(i)("Components.InstallmentPlanComponent.InstallmentNumberPlural", {
                        count: ve
                      })), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "min", "max", "disabled", "ticks"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        a.calculationError == "" ? (S(), K(X, {
          key: 3,
          class: Le(["mt-4", a.isSalaryConfirmed ? "" : "disabled"])
        }, {
          default: P(() => [
            C(J, null, {
              default: P(() => {
                var ve, Re;
                return [
                  p("div", w1, [
                    C(X, null, {
                      default: P(() => [
                        C(J, { class: "v-col-12 v-col-md-6" }, {
                          default: P(() => [
                            p("div", k1, [
                              p("div", null, E(u(i)("Components.InstallmentPlanComponent.MonthlyInstallmentSum")) + ":", 1),
                              p("div", N1, E($.$n(a.installmentVal == null || a.installmentVal.toString() == "" ? 0 : a.installmentVal, "decimal")) + " EUR ", 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    C(X, { class: "mt-0" }, {
                      default: P(() => [
                        C(J, { class: "v-col-12 v-col-md-6" }, {
                          default: P(() => [
                            p("div", A1, [
                              p("div", null, E(u(i)("Components.InstallmentPlanComponent.PurchaseAmountSum")) + ":", 1),
                              p("div", null, E($.$n(l.creditAmount == null || l.creditAmount.toString() == "" ? 0 : l.creditAmount, "decimal")) + " EUR ", 1),
                              l.installmentNr != null ? (S(), N("div", M1, E(u(i)("Components.InstallmentPlanComponent.InstallmentNumber")) + ":", 1)) : x("", !0),
                              l.installmentNr != null ? (S(), N("div", O1, E(u(i)(
                                "Components.InstallmentPlanComponent.InstallmentNumberPlural",
                                l.installmentNr
                              )), 1)) : x("", !0),
                              p("div", null, E(u(i)("Components.InstallmentPlanComponent.DateOfFirstInstallment")) + ": ", 1),
                              p("div", null, E(a.dateOfFirstInstallment != "" ? u(f)(a.dateOfFirstInstallment) : "-"), 1),
                              p("div", null, E(u(i)("Components.InstallmentPlanComponent.DateOfLastInstallment")) + ": ", 1),
                              p("div", null, E(a.dateOfLastInstallment != "" ? u(f)(a.dateOfLastInstallment) : "-"), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        C(J, { class: "v-col-12 v-col-md-6" }, {
                          default: P(() => [
                            p("div", R1, [
                              p("div", null, E(u(i)("Components.InstallmentPlanComponent.InsuranceCostSum")) + ":", 1),
                              p("div", null, E(a.insuranceVal != null ? $.$n(
                                a.insuranceVal,
                                "decimal"
                              ) + " EUR" : "-"), 1),
                              p("div", null, E(u(i)("Components.InstallmentPlanComponent.ApprovalCostSum")) + ":", 1),
                              p("div", null, E(a.approvalVal != null ? $.$n(a.approvalVal, "decimal") + " EUR" : "-"), 1),
                              p("div", null, E(u(i)("Components.InstallmentPlanComponent.CompleteCost")) + ":", 1),
                              p("div", null, E(a.amountTotal != null ? $.$n(a.amountTotal, "decimal") + " EUR" : "0,00 EUR"), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    q[15] || (q[15] = p("div", { class: "divider-sm divider--horizontal mt-8 mb-8" }, null, -1)),
                    q[16] || (q[16] = p("div", { class: "mb-4" }, " Porazdelitev po finančnih produktih glede na izbrano število obrokov: ", -1)),
                    C(X, { class: "gutter-16" }, {
                      default: P(() => [
                        (S(!0), N(je, null, Mt(a.availableProducts, (ae) => (S(), K(J, { class: "v-col-12 v-col-md-4" }, {
                          default: P(() => [
                            p("div", $1, [
                              p("div", x1, [
                                ae.productType === "OBR" ? (S(), N("img", L1)) : ae.productType === "BREZOBR" ? (S(), N("img", V1)) : ae.productType === "EOM0" ? (S(), N("img", F1)) : x("", !0),
                                p("div", null, E(u(i)(`Components.InstallmentPlanComponent.${ae.productType}`)), 1)
                              ]),
                              q[11] || (q[11] = p("div", { class: "divider divider--horizontal my-4" }, null, -1)),
                              p("div", j1, [
                                p("div", null, E(u(i)("Components.InstallmentPlanComponent.MonthlyInstallment")) + ":", 1),
                                p("div", null, E($.$n(ae.installmentVal == null || ae.installmentVal.toString() == "" ? 0 : ae.installmentVal, "decimal")) + " EUR ", 1),
                                p("div", null, E(u(i)("Components.InstallmentPlanComponent.PurchaseAmount2")) + ":", 1),
                                p("div", null, E($.$n(ae.amountCalc == null || ae.amountCalc.toString() == "" ? 0 : ae.amountCalc, "decimal")) + " EUR ", 1),
                                p("div", null, E(u(i)("Components.InstallmentPlanComponent.InterestRate")) + ":", 1),
                                p("div", null, E(ae.interestNr != null ? $.$n(ae.interestNr, "decimal") + " %" : "-"), 1),
                                p("div", null, E(u(i)("Components.InstallmentPlanComponent.EOM")) + ":", 1),
                                p("div", null, E(ae.EOM != null ? $.$n(ae.EOM, "decimal") + " %" : "-"), 1),
                                p("div", null, E(u(i)("Components.InstallmentPlanComponent.InsuranceCost")) + ":", 1),
                                p("div", null, E(ae.insuranceVal != null ? $.$n(
                                  ae.insuranceVal,
                                  "decimal"
                                ) + " EUR" : "-"), 1),
                                p("div", null, E(u(i)("Components.InstallmentPlanComponent.ApprovalCost")) + ":", 1),
                                p("div", null, E(ae.approvalVal != null ? $.$n(ae.approvalVal, "decimal") + " EUR" : "-"), 1),
                                p("div", null, E(u(i)("Components.InstallmentPlanComponent.CompleteCost")) + ":", 1),
                                p("div", null, E(ae.amountTotal != null ? $.$n(ae.amountTotal, "decimal") + " EUR" : "0,00 EUR"), 1)
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1024))), 256))
                      ]),
                      _: 1
                    }),
                    p("div", z1, [
                      ne(E(u(i)("Components.InstallmentPlanComponent.AllCosts")) + " ", 1),
                      q[12] || (q[12] = p("br", null, null, -1)),
                      q[13] || (q[13] = p("br", null, null, -1)),
                      ne(" " + E(u(i)("Components.InstallmentPlanComponent.EOMDisclaimer")), 1)
                    ]),
                    ((ve = a.availableProducts) == null ? void 0 : ve.length) > 1 ? (S(), N("div", U1, q[14] || (q[14] = [
                      p("div", { class: "font-weight-600" }, "Vaš nakup vključuje izdelke, ki so del različnih akcijskih ponudb ali financirani po različnih obrestnih merah.", -1),
                      ne(" Glede na izbrano število obrokov je vaš nakup razdeljen med navedene finančne produkte, pri čemer je upoštevan najnižji možni mesečni obrok oziroma skupni strošek. Ob sklenitve nakupa na obroke boste podpisali več ločenih pogodb - po eno za vsako ponudbo. ")
                    ]))) : x("", !0),
                    ((Re = a.availableProducts) == null ? void 0 : Re.length) > 1 ? (S(), K(fe, {
                      key: 1,
                      modelValue: l.multipleContractAgreement,
                      "onUpdate:modelValue": q[8] || (q[8] = (ae) => l.multipleContractAgreement = ae),
                      "error-messages": u(c).multipleContractAgreement.$errors[0] != null ? u(c).multipleContractAgreement.$errors[0].$message : "",
                      onFocus: u(c).multipleContractAgreement.$reset,
                      label: "Razumem, da bo za vsak del financiranja potrebno podpisati ločeno pogodbo."
                    }, null, 8, ["modelValue", "error-messages", "onFocus"])) : x("", !0)
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])) : x("", !0),
        l.isPreapproved && !u(m) && u(v) ? (S(), N("div", B1, E(u(i)("Components.InstallmentPlanComponent.PreapprovedError")), 1)) : x("", !0),
        a.calculationError != "" ? (S(), N("div", G1, E(u(i)(`GlobalErrors.${a.calculationError}`)), 1)) : x("", !0)
      ], 512);
    };
  }
}), q1 = {
  prefix: void 0,
  phoneNumber: void 0,
  email: "",
  isEmailVerified: !1,
  creditAmount: void 0,
  selectedSpecialProduct: void 0,
  selectedProduct: void 0,
  selectedProductType: void 0,
  firstname: "",
  surname: "",
  birthCity: "",
  emso: void 0,
  citizen: void 0,
  address: "",
  postalCode: void 0,
  personalDocumentType: void 0,
  idNumber: "",
  documentIssuer: "",
  issueDate: void 0,
  validityDate: void 0,
  documentNumber: "",
  EOMInstallmentMax: void 0,
  taxNumber: void 0,
  flowType: void 0,
  employmentType: void 0,
  isSlovenianCitizen: !1,
  hasSlovenianIncome: !1,
  partnerDiyType: void 0,
  isViewDataLoading: !1,
  headerTitle: "",
  headerSubtitle: "",
  isExistingUser: !1,
  prefilledData: !1,
  contractSignatureType: void 0,
  sisbonResultId: -1,
  debtAmount: 0,
  debtInstallments: 0,
  bindingFiles: [],
  birthdate: null,
  isMale: !0,
  productList: [],
  specialProductList: [],
  isCustomerContinuing: !1,
  temporaryCitizen: void 0
}, D1 = {
  showPermanentValidity: !1,
  codeMatches: !1,
  isDataLoading: !1,
  externalResults: {},
  isCodeSent: !1,
  isEmailValidationSent: !1,
  ageError: "",
  creditAmountError: "",
  creditAmountPreapprovedError: "",
  showPodpis: !1,
  podpisUrl: "",
  emailVerificationSending: !1,
  vlogaId: void 0
};
function H1(e, t) {
  const { t: o } = H();
  function r(l) {
    if (l.length != 13)
      return !1;
    let s = parseInt(l.substring(0, 1)) * 7 + parseInt(l.substring(1, 2)) * 6 + parseInt(l.substring(2, 3)) * 5 + parseInt(l.substring(3, 4)) * 4 + parseInt(l.substring(4, 5)) * 3 + parseInt(l.substring(5, 6)) * 2 + parseInt(l.substring(6, 7)) * 7 + parseInt(l.substring(7, 8)) * 6 + parseInt(l.substring(8, 9)) * 5 + parseInt(l.substring(9, 10)) * 4 + parseInt(l.substring(10, 11)) * 3 + parseInt(l.substring(11, 12)) * 2;
    if (s = 11 - s % 11, s == 11 && (s = 0), s == parseInt(l.substring(12, 13))) {
      let n = parseInt(e.emso.substring(4, 7));
      n < 500 ? n += 2e3 : n += 1e3;
      let a = n.toString() + "-" + e.emso.substring(2, 4) + "-" + e.emso.substring(0, 2), c = Date.parse(a);
      if (isNaN(c))
        return !1;
      {
        let m = parseInt(e.emso.substring(4, 7));
        m < 500 ? m += 2e3 : m += 1e3, e.birthdate = new Date(m, parseInt(e.emso.substring(2, 4)) - 1, parseInt(e.emso.substring(0, 2))), console.log("componentData.birthdate: ", e.birthdate), parseInt(e.emso.substring(9, 12)) < 500 ? e.isMale = !0 : e.isMale = !1;
      }
      return console.log("componentData.birthdate2: ", e.birthdate), !0;
    }
    return !1;
  }
  let d = () => {
    if (e.flowType == R.POS || e.flowType == R.POS_STRANKA || e.flowType == R.POS_MOBILE) {
      let l = e.productList[0] ? e.productList[0].ageMin : 50, s = e.productList[0] ? e.productList[0].ageMax : 0, n = /* @__PURE__ */ new Date(), a = e.birthdate, c = n.getFullYear() - a.getFullYear(), m = n.getMonth() - a.getMonth();
      (m < 0 || m === 0 && n.getDate() < a.getDate()) && c--;
      for (let v = 0; v < e.productList.length; v++)
        e.productList[v].ageMin < l && (l = e.productList[v].ageMin);
      for (let v = 0; v < e.specialProductList.length; v++)
        e.specialProductList[v].ageMin < l && (l = e.specialProductList[v].ageMin);
      for (let v = 0; v < e.productList.length; v++)
        e.productList[v].ageMax > s && (s = e.productList[v].ageMax);
      for (let v = 0; v < e.specialProductList.length; v++)
        e.specialProductList[v].ageMax > s && (s = e.specialProductList[v].ageMax);
      if (c < l)
        return t.ageError = o("GlobalErrors.AgeLimit", { minimum: l, maximum: s - 1 }), !1;
      if (c >= s)
        return t.ageError = o("GlobalErrors.AgeLimit", { minimum: l, maximum: s - 1 }), !1;
    }
    return t.ageError = "", !0;
  };
  const f = () => e.flowType === R.POS || e.flowType === R.POS_STRANKA || e.flowType === R.POS_MOBILE;
  return {
    validationRules: F(() => ({
      firstname: {
        required: j.withMessage(o("GlobalErrors.FieldRequired"), he)
      },
      surname: {
        required: j.withMessage(o("GlobalErrors.FieldRequired"), he)
      },
      birthCity: {
        required: j.withMessage(o("GlobalErrors.FieldRequired"), he),
        minTwoLetters: j.withMessage(
          o("GlobalErrors.MinTwoLetters"),
          (l) => typeof l != "string" ? !1 : /.*[a-zA-ZčžšČŽŠ].*[a-zA-ZčžšČŽŠ]/.test(l)
        )
      },
      emso: {
        required: j.withMessage(o("GlobalErrors.FieldRequired"), de(f)),
        isValidNumber: j.withMessage(o("GlobalErrors.IS_VALID_EMSO"), j.withAsync(async (l) => f() ? r(l) : !0)),
        customAge: d
      },
      citizen: {
        required: j.withMessage(o("GlobalErrors.ChoiceRequired"), he)
        // notAllowed: helpers.withMessage("Državljan te države ne more skleniti kreditne pogodbe", () => { 
        //     return country.value!.AdditionalData!["TveganaDrzava"] == false
        // })
      },
      address: {
        required: j.withMessage(o("GlobalErrors.FieldRequired"), he)
      },
      postalCode: {
        required: j.withMessage(o("GlobalErrors.ChoiceRequired"), he)
      }
    }))
    // isRiskCountry
  };
}
function Y1(e, t, o) {
  const r = Q("commClient"), d = Q("generalStore"), { scrollToFirstError: f } = Ie(), { t: i } = H(), { validationRules: l } = H1(e, t), s = be(l, F(() => e), { $autoDirty: !0, $externalResults: t.externalResults }), n = F(() => {
    var k;
    return (k = d.state.countryList) == null ? void 0 : k.find((L) => e.citizen === L.Key);
  }), a = F(() => {
    var k;
    return (k = d.state.countryList) == null ? void 0 : k.find((L) => e.temporaryCitizen === L.Key);
  });
  async function c() {
    return s.value.$touch(), await s.value.$validate();
  }
  async function m() {
    return new Promise(async (k, L) => {
      await r.executeMethodAsync("PreverjanjeSuspectInsert", {
        DavcnaSt: e.taxNumber,
        Birthdate: e.birthdate,
        Ime: e.firstname,
        Priimek: e.surname
      }).then(async ($) => {
        $.Success && (e.headerSubtitle = "SuspectPersonError", k({ name: "endFail" }));
      });
    });
  }
  async function v(k) {
    if (k && k[0] && k[0].CallbackType == "SIGN" && k[0].Success)
      switch (k[0].Type) {
        case "vloga":
          k[0].Status == "complete" && (t.showPodpis = !1, t.podpisUrl = "", t.vlogaId = k[0].VlogaId, await _());
          break;
      }
    else if (k && k[0] && k[0].CallbackType == "SISBON")
      switch (k[0].Type) {
        case "vloga":
          k[0].Success ? (e.sisbonResultId = k[0].sisbonResultId, e.debtAmount = k[0].debt, e.debtInstallments = k[0].debtInstallments, e.isCustomerContinuing ? await h().then((L) => {
            L === !0 ? (e.headerTitle = i("EndSuccess.POSCustomer.Title"), e.headerSubtitle = i("EndSuccess.POSCustomer.Subtitle"), o("navigationEvent", "endSuccess")) : o("navigationEvent", "endFail");
          }) : o("navigationEvent", "nextStep")) : (e.headerSubtitle = k[0].errorText, o("navigationEvent", "endFail"));
          break;
      }
  }
  async function h() {
    return new Promise((k) => {
      var $, q;
      let L = "";
      e.bindingFiles.length > 0 && (L.length > 0 && (L += ";"), L += e.bindingFiles.map((J) => J.FileId).join(";")), r.executeMethodAsync("SendDataItYourselfLink", {
        SelectedProductId: ($ = e.selectedProduct) == null ? void 0 : $.productId,
        SpecialProductId: e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct !== void 0 ? parseInt(e.selectedSpecialProduct.productId) : -1,
        EOMInstallmentMax: e.EOMInstallmentMax ? e.EOMInstallmentMax : 0,
        TaxNumber: e.taxNumber,
        CountryCode: (q = e.prefix) == null ? void 0 : q.Key.toString().replace("+", "").trim(),
        PhoneNumber: e.phoneNumber.toString(),
        CreditAmount: e.creditAmount,
        Birthdate: e.birthdate,
        SlovenianCitizen: e.isSlovenianCitizen,
        ZaposlitevSlo: e.hasSlovenianIncome === void 0 ? !0 : e.hasSlovenianIncome,
        Employment: e.employmentType,
        Email: e.email,
        Ime: e.firstname,
        Priimek: e.surname,
        Ulica: e.address,
        Posta: e.postalCode,
        Drzava: e.citizen,
        KrajRojstva: e.birthCity,
        OsDokTip: e.personalDocumentType,
        OsDokIzdajatelj: e.documentIssuer,
        OsDokSt: e.idNumber,
        OsDokDatum: e.issueDate,
        OsDokDatumPotek: e.validityDate,
        SisbonResultId: e.sisbonResultId,
        StRacuna: e.documentNumber,
        Datoteke: L
      }).then(async (J) => {
        J && k(!0), k(!1);
      });
    });
  }
  async function _() {
    var k;
    e.isViewDataLoading = !0, await r.executeMethodAsync("CheckExposureIdentificationData", {
      flowType: e.flowType,
      CreditAmount: e.creditAmount,
      TaxNumber: e.taxNumber,
      Firstname: e.firstname,
      Surname: e.surname,
      Birthdate: e.birthdate,
      EmploymentType: e.employmentType,
      Msisdn: ((k = e.prefix) == null ? void 0 : k.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString(),
      isSlovenianCitizen: e.isSlovenianCitizen,
      isIncomeSlo: e.hasSlovenianIncome,
      VlogaId: t.vlogaId
    }).then(async (L) => {
      L && (console.log("Message je: ", L), L.success ? L.sisbonWasChecked ? (e.sisbonResultId = L.sisbonResultId, e.debtAmount = L.debt, e.debtInstallments = L.debtInstallments, e.isCustomerContinuing ? await h().then(($) => {
        $ === !0 ? (e.headerTitle = i("EndSuccess.POSCustomer.Title"), e.headerSubtitle = i("EndSuccess.POSCustomer.Subtitle"), o("navigationEvent", "endSuccess")) : o("navigationEvent", "endFail");
      }) : o("navigationEvent", "nextStep")) : (t.showPodpis = !0, t.podpisUrl = "/StaticLoaders/sisbon_process.html") : (e.headerSubtitle = L.errorText, o("navigationEvent", "endFail")));
    });
  }
  async function b() {
    return new Promise((k) => {
      var L;
      t.showPodpis = !0, t.podpisUrl = "/StaticLoaders/vloga_upload_wait.html", r.executeMethodAsync("UploadVloga", {
        IzracunId: -1,
        // should remove this later
        Ime: e.firstname,
        Priimek: e.surname,
        DavcnaSt: e.taxNumber,
        Telefon: ((L = e.prefix) == null ? void 0 : L.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString(),
        Ulica: e.address,
        Posta: e.postalCode,
        Birthdate: e.birthdate,
        VrstaOsDok: e.personalDocumentType,
        // popravi
        StOsDok: e.idNumber,
        DatumIzdajeOsDok: e.issueDate,
        DatumVeljavnostiOsDok: e.validityDate == null ? new Date(1753, 1, 1) : e.validityDate,
        // Drzava: componentData.citizen!.Key.toString(),
        Drzava: e.citizen.toString(),
        KrajRojstva: e.birthCity,
        IzdajateljOsDok: e.documentIssuer,
        Email: e.email,
        chkUseSMS: e.contractSignatureType === qt.SMS,
        redirectUrl: ""
      }).then(async ($) => {
        $ && $.Success && (t.showPodpis = !0, t.podpisUrl = $.Url), k(null);
      });
    });
  }
  const y = F(() => {
    if (e.isSlovenianCitizen != !0) {
      let k = JSON.parse(JSON.stringify(d.state.postalCodeList));
      return k.pop(), k;
    } else
      return d.state.postalCodeList;
  }), g = F(() => {
    var k;
    return e.isSlovenianCitizen == !0 ? (e.citizen = 204, d.state.countryList.slice(0, 1)) : (k = d.state.countryList) == null ? void 0 : k.slice(1);
  });
  function I() {
    f(".personal-info-component");
  }
  const T = F(() => {
    var k, L;
    return ((L = (k = n.value) == null ? void 0 : k.AdditionalData) == null ? void 0 : L.TveganaDrzava) === !0;
  }), w = F(() => {
    var k, L;
    return ((L = (k = a.value) == null ? void 0 : k.AdditionalData) == null ? void 0 : L.RiskDrzava) == !0;
  });
  async function M(k) {
    let L = !1, $ = null;
    switch (k) {
      case "posNext":
        if (L = await c(), L) {
          if (T.value)
            return e.headerSubtitle = i("EndFail.RiskCountry"), $ = { name: "endFail" };
          e.partnerDiyType == xt.POS_MOBILE ? (e.isViewDataLoading = !0, await h().then((q) => {
            q === !0 ? (e.headerTitle = i("EndSuccess.POSRemote.Title"), e.headerSubtitle = i("EndSuccess.POSRemote.Subtitle"), $ = { name: "endSuccess" }) : $ = { name: "endFail" };
          })) : $ = await b();
        }
        break;
      case "validate":
        L = await c(), L && ($ = { name: "valid" });
        break;
      case "webNext":
        if (L = await c(), L) {
          if (e.isViewDataLoading = !0, T.value)
            return e.headerSubtitle = i("EndFail.RiskCountry"), $ = { name: "endFail" };
          if (w.value)
            return e.headerSubtitle = i("EndFail.RiskCountry"), $ = { name: "endFail" };
          $ = { name: "nextStep" };
        }
        break;
      case "suspectPerson":
        s.value.emso.$touch(), await s.value.emso.$validate(), s.value.emso.$error ? I() : (e.isViewDataLoading = !0, $ = await m());
        break;
    }
    return $;
  }
  return {
    navigationAction: M,
    getPostCodeAddress: y,
    GetCountryCodeSloOnly: g,
    v$: s,
    scrollToFirstErrorWrapper: I,
    signComplete: v
  };
}
const Z1 = { class: "personal-info-component" }, W1 = {
  key: 0,
  class: "section-heading"
}, K1 = { class: "form-label" }, Q1 = { class: "form-label" }, X1 = { class: "form-label" }, J1 = { class: "form-label" }, eh = { class: "form-label" }, th = { class: "form-label" }, nh = { class: "form-label" }, kb = /* @__PURE__ */ ie({
  __name: "personal-info-component",
  props: {
    data: { default: () => ({
      ...q1
    }) }
  },
  emits: ["update:data", "navigationEvent", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o, i = W({ ...d.data }), l = Q("commClient");
    let s = re(!1);
    const n = W({ ...D1 }), { v$: a, navigationAction: c, getPostCodeAddress: m, GetCountryCodeSloOnly: v, scrollToFirstErrorWrapper: h, signComplete: _ } = Y1(i, n, f);
    return G(
      () => d.data,
      // Watch for changes in the data
      (b) => {
        Object.assign(i, b);
      },
      { deep: !0 }
    ), G(
      i,
      async (b) => {
        f("update:data", b);
      },
      { deep: !0 }
    ), me(async () => {
      l.OnStreamDataReceived.AddCallback(_), i.citizen === 204 && i.isSlovenianCitizen == !1 && (i.citizen = void 0, a.value.citizen.$dirty = !1), s.value = !0, f("componentReady");
    }), Lt(() => {
      l.OnStreamDataReceived.RemoveCallback(_);
    }), t({
      navigationAction: c,
      scrollToFirstErrorWrapper: h,
      componentReady: s
    }), (b, y) => {
      const g = V("v-col"), I = V("v-row"), T = V("v-autocomplete");
      return S(), N("div", Z1, [
        i.flowType != u(R).LIMIT ? (S(), N("h2", W1, E(u(r)("Components.IdentificationDataComponent.PersonalDataTitle")), 1)) : x("", !0),
        C(I, null, {
          default: P(() => [
            C(g, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", K1, E(u(r)("Components.IdentificationDataComponent.Firstname")), 1),
                C(Pe, {
                  modelValue: i.firstname,
                  "onUpdate:modelValue": y[0] || (y[0] = (w) => i.firstname = w),
                  error: u(a).firstname.error,
                  "error-messages": u(a).firstname.$errors[0] != null ? u(a).firstname.$errors[0].$message : "",
                  onFocus: u(a).firstname.$reset,
                  variant: "outlined"
                }, null, 8, ["modelValue", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            }),
            C(g, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", Q1, E(u(r)("Components.IdentificationDataComponent.Surname")), 1),
                C(Pe, {
                  modelValue: i.surname,
                  "onUpdate:modelValue": y[1] || (y[1] = (w) => i.surname = w),
                  error: u(a).surname.error,
                  "error-messages": u(a).surname.$errors[0] != null ? u(a).surname.$errors[0].$message : "",
                  onFocus: u(a).surname.$reset,
                  variant: "outlined"
                }, null, 8, ["modelValue", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        C(I, null, {
          default: P(() => [
            C(g, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", X1, E(u(r)("Components.IdentificationDataComponent.BirthCity")), 1),
                  C(Pe, {
                    modelValue: i.birthCity,
                    "onUpdate:modelValue": y[2] || (y[2] = (w) => i.birthCity = w),
                    error: u(a).birthCity.error,
                    "error-messages": u(a).birthCity.$errors[0] != null ? u(a).birthCity.$errors[0].$message : "",
                    onFocus: u(a).birthCity.$reset,
                    variant: "outlined"
                  }, null, 8, ["modelValue", "error", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            }),
            i.flowType == u(R).POS || i.flowType == u(R).POS_STRANKA || i.flowType == u(R).POS_MOBILE ? (S(), K(g, {
              key: 0,
              class: "v-col-12 v-col-md-6"
            }, {
              default: P(() => [
                p("div", null, [
                  p("label", J1, E(u(r)("Components.IdentificationDataComponent.Emso")), 1),
                  C(Pe, {
                    modelValue: i.emso,
                    "onUpdate:modelValue": y[3] || (y[3] = (w) => i.emso = w),
                    error: u(a).emso.error,
                    "error-messages": n.ageError != "" ? n.ageError : u(a).emso.$errors[0] != null ? u(a).emso.$errors[0].$message : "",
                    onFocus: u(a).emso.$reset,
                    variant: "outlined",
                    counter: 13,
                    maxLength: "13",
                    notPrefilled: !!((i.isExistingUser || i.prefilledData) && i.emso == null)
                  }, null, 8, ["modelValue", "error", "error-messages", "onFocus", "notPrefilled"])
                ])
              ]),
              _: 1
            })) : x("", !0),
            C(g, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", eh, E(u(r)("Components.IdentificationDataComponent.Citizen")), 1),
                  C(T, {
                    modelValue: i.citizen,
                    "onUpdate:modelValue": y[4] || (y[4] = (w) => i.citizen = w),
                    items: u(v),
                    autocomplete: "off",
                    error: u(a).citizen.error,
                    "error-messages": u(a).citizen.$errors[0] != null ? u(a).citizen.$errors[0].$message : "",
                    onFocus: u(a).citizen.$reset,
                    "item-title": "Value",
                    "item-value": "Key",
                    variant: "outlined"
                  }, null, 8, ["modelValue", "items", "error", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        C(I, null, {
          default: P(() => [
            C(g, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", th, E(u(r)("Components.IdentificationDataComponent.Address")), 1),
                  C(Pe, {
                    modelValue: i.address,
                    "onUpdate:modelValue": y[5] || (y[5] = (w) => i.address = w),
                    error: u(a).address.error,
                    "error-messages": u(a).address.$errors[0] != null ? u(a).address.$errors[0].$message : "",
                    onFocus: u(a).address.$reset,
                    variant: "outlined"
                  }, null, 8, ["modelValue", "error", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            }),
            C(g, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", nh, E(u(r)("Components.IdentificationDataComponent.PostalCode")), 1),
                C(T, {
                  modelValue: i.postalCode,
                  "onUpdate:modelValue": y[6] || (y[6] = (w) => i.postalCode = w),
                  items: u(m),
                  autocomplete: "off",
                  error: u(a).postalCode.error,
                  "error-messages": u(a).postalCode.$errors[0] != null ? u(a).postalCode.$errors[0].$message : "",
                  onFocus: u(a).postalCode.$reset,
                  "item-title": "Value",
                  "item-value": "Key",
                  variant: "outlined"
                }, null, 8, ["modelValue", "items", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        C(Ct, {
          display: n.showPodpis,
          onModalClosed: y[7] || (y[7] = (w) => n.showPodpis = !1),
          showAcceptButton: !1,
          showDeclineButton: !1,
          showCloseXButton: !0,
          title: u(r)("Components.IdentificationDataComponent.SignatureTitle"),
          class: "dialog-preview"
        }, {
          default: P(() => [
            C(fn, {
              url: n.podpisUrl,
              frameBorder: "0"
            }, null, 8, ["url"])
          ]),
          _: 1
        }, 8, ["display", "title"])
      ]);
    };
  }
});
function oh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var In = {}, Kt = {}, En = {}, Qr;
function Je() {
  if (Qr) return En;
  Qr = 1, Object.defineProperty(En, "__esModule", {
    value: !0
  });
  function e(o, r) {
    if (!(o instanceof r))
      throw new TypeError("Cannot call a class as a function");
  }
  var t = function o(r, d) {
    e(this, o), this.data = r, this.text = d.text || r, this.options = d;
  };
  return En.default = t, En;
}
var Xr;
function rh() {
  if (Xr) return Kt;
  Xr = 1, Object.defineProperty(Kt, "__esModule", {
    value: !0
  }), Kt.CODE39 = void 0;
  var e = /* @__PURE__ */ function() {
    function _(b, y) {
      for (var g = 0; g < y.length; g++) {
        var I = y[g];
        I.enumerable = I.enumerable || !1, I.configurable = !0, "value" in I && (I.writable = !0), Object.defineProperty(b, I.key, I);
      }
    }
    return function(b, y, g) {
      return y && _(b.prototype, y), g && _(b, g), b;
    };
  }(), t = Je(), o = r(t);
  function r(_) {
    return _ && _.__esModule ? _ : { default: _ };
  }
  function d(_, b) {
    if (!(_ instanceof b))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(_, b) {
    if (!_)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return b && (typeof b == "object" || typeof b == "function") ? b : _;
  }
  function i(_, b) {
    if (typeof b != "function" && b !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof b);
    _.prototype = Object.create(b && b.prototype, { constructor: { value: _, enumerable: !1, writable: !0, configurable: !0 } }), b && (Object.setPrototypeOf ? Object.setPrototypeOf(_, b) : _.__proto__ = b);
  }
  var l = function(_) {
    i(b, _);
    function b(y, g) {
      return d(this, b), y = y.toUpperCase(), g.mod43 && (y += m(h(y))), f(this, (b.__proto__ || Object.getPrototypeOf(b)).call(this, y, g));
    }
    return e(b, [{
      key: "encode",
      value: function() {
        for (var g = a("*"), I = 0; I < this.data.length; I++)
          g += a(this.data[I]) + "0";
        return g += a("*"), {
          data: g,
          text: this.text
        };
      }
    }, {
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/) !== -1;
      }
    }]), b;
  }(o.default), s = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", "*"], n = [20957, 29783, 23639, 30485, 20951, 29813, 23669, 20855, 29789, 23645, 29975, 23831, 30533, 22295, 30149, 24005, 21623, 29981, 23837, 22301, 30023, 23879, 30545, 22343, 30161, 24017, 21959, 30065, 23921, 22385, 29015, 18263, 29141, 17879, 29045, 18293, 17783, 29021, 18269, 17477, 17489, 17681, 20753, 35770];
  function a(_) {
    return c(v(_));
  }
  function c(_) {
    return n[_].toString(2);
  }
  function m(_) {
    return s[_];
  }
  function v(_) {
    return s.indexOf(_);
  }
  function h(_) {
    for (var b = 0, y = 0; y < _.length; y++)
      b += v(_[y]);
    return b = b % 43, b;
  }
  return Kt.CODE39 = l, Kt;
}
var et = {}, Sn = {}, Pn = {}, ke = {}, Jr;
function pn() {
  if (Jr) return ke;
  Jr = 1, Object.defineProperty(ke, "__esModule", {
    value: !0
  });
  var e;
  function t(s, n, a) {
    return n in s ? Object.defineProperty(s, n, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : s[n] = a, s;
  }
  var o = ke.SET_A = 0, r = ke.SET_B = 1, d = ke.SET_C = 2;
  ke.SHIFT = 98;
  var f = ke.START_A = 103, i = ke.START_B = 104, l = ke.START_C = 105;
  return ke.MODULO = 103, ke.STOP = 106, ke.FNC1 = 207, ke.SET_BY_CODE = (e = {}, t(e, f, o), t(e, i, r), t(e, l, d), e), ke.SWAP = {
    101: o,
    100: r,
    99: d
  }, ke.A_START_CHAR = "Ð", ke.B_START_CHAR = "Ñ", ke.C_START_CHAR = "Ò", ke.A_CHARS = "[\0-_È-Ï]", ke.B_CHARS = "[ -È-Ï]", ke.C_CHARS = "(Ï*[0-9]{2}Ï*)", ke.BARS = [11011001100, 11001101100, 11001100110, 10010011e3, 10010001100, 10001001100, 10011001e3, 10011000100, 10001100100, 11001001e3, 11001000100, 11000100100, 10110011100, 10011011100, 10011001110, 10111001100, 10011101100, 10011100110, 11001110010, 11001011100, 11001001110, 11011100100, 11001110100, 11101101110, 11101001100, 11100101100, 11100100110, 11101100100, 11100110100, 11100110010, 11011011e3, 11011000110, 11000110110, 10100011e3, 10001011e3, 10001000110, 10110001e3, 10001101e3, 10001100010, 11010001e3, 11000101e3, 11000100010, 10110111e3, 10110001110, 10001101110, 10111011e3, 10111000110, 10001110110, 11101110110, 11010001110, 11000101110, 11011101e3, 11011100010, 11011101110, 11101011e3, 11101000110, 11100010110, 11101101e3, 11101100010, 11100011010, 11101111010, 11001000010, 11110001010, 1010011e4, 10100001100, 1001011e4, 10010000110, 10000101100, 10000100110, 1011001e4, 10110000100, 1001101e4, 10011000010, 10000110100, 10000110010, 11000010010, 1100101e4, 11110111010, 11000010100, 10001111010, 10100111100, 10010111100, 10010011110, 10111100100, 10011110100, 10011110010, 11110100100, 11110010100, 11110010010, 11011011110, 11011110110, 11110110110, 10101111e3, 10100011110, 10001011110, 10111101e3, 10111100010, 11110101e3, 11110100010, 10111011110, 10111101110, 11101011110, 11110101110, 11010000100, 1101001e4, 11010011100, 1100011101011], ke;
}
var ei;
function _o() {
  if (ei) return Pn;
  ei = 1, Object.defineProperty(Pn, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function n(a, c) {
      for (var m = 0; m < c.length; m++) {
        var v = c[m];
        v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(a, v.key, v);
      }
    }
    return function(a, c, m) {
      return c && n(a.prototype, c), m && n(a, m), a;
    };
  }(), t = Je(), o = d(t), r = pn();
  function d(n) {
    return n && n.__esModule ? n : { default: n };
  }
  function f(n, a) {
    if (!(n instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(n, a) {
    if (!n)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a && (typeof a == "object" || typeof a == "function") ? a : n;
  }
  function l(n, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof a);
    n.prototype = Object.create(a && a.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), a && (Object.setPrototypeOf ? Object.setPrototypeOf(n, a) : n.__proto__ = a);
  }
  var s = function(n) {
    l(a, n);
    function a(c, m) {
      f(this, a);
      var v = i(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this, c.substring(1), m));
      return v.bytes = c.split("").map(function(h) {
        return h.charCodeAt(0);
      }), v;
    }
    return e(a, [{
      key: "valid",
      value: function() {
        return /^[\x00-\x7F\xC8-\xD3]+$/.test(this.data);
      }
      // The public encoding function
    }, {
      key: "encode",
      value: function() {
        var m = this.bytes, v = m.shift() - 105, h = r.SET_BY_CODE[v];
        if (h === void 0)
          throw new RangeError("The encoding does not start with a start character.");
        this.shouldEncodeAsEan128() === !0 && m.unshift(r.FNC1);
        var _ = a.next(m, 1, h);
        return {
          text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, "") : this.text,
          data: (
            // Add the start bits
            a.getBar(v) + // Add the encoded bits
            _.result + // Add the checksum
            a.getBar((_.checksum + v) % r.MODULO) + // Add the end bits
            a.getBar(r.STOP)
          )
        };
      }
      // GS1-128/EAN-128
    }, {
      key: "shouldEncodeAsEan128",
      value: function() {
        var m = this.options.ean128 || !1;
        return typeof m == "string" && (m = m.toLowerCase() === "true"), m;
      }
      // Get a bar symbol by index
    }], [{
      key: "getBar",
      value: function(m) {
        return r.BARS[m] ? r.BARS[m].toString() : "";
      }
      // Correct an index by a set and shift it from the bytes array
    }, {
      key: "correctIndex",
      value: function(m, v) {
        if (v === r.SET_A) {
          var h = m.shift();
          return h < 32 ? h + 64 : h - 32;
        } else return v === r.SET_B ? m.shift() - 32 : (m.shift() - 48) * 10 + m.shift() - 48;
      }
    }, {
      key: "next",
      value: function(m, v, h) {
        if (!m.length)
          return { result: "", checksum: 0 };
        var _ = void 0, b = void 0;
        if (m[0] >= 200) {
          b = m.shift() - 105;
          var y = r.SWAP[b];
          y !== void 0 ? _ = a.next(m, v + 1, y) : ((h === r.SET_A || h === r.SET_B) && b === r.SHIFT && (m[0] = h === r.SET_A ? m[0] > 95 ? m[0] - 96 : m[0] : m[0] < 32 ? m[0] + 96 : m[0]), _ = a.next(m, v + 1, h));
        } else
          b = a.correctIndex(m, h), _ = a.next(m, v + 1, h);
        var g = a.getBar(b), I = b * v;
        return {
          result: g + _.result,
          checksum: I + _.checksum
        };
      }
    }]), a;
  }(o.default);
  return Pn.default = s, Pn;
}
var Tn = {}, ti;
function ih() {
  if (ti) return Tn;
  ti = 1, Object.defineProperty(Tn, "__esModule", {
    value: !0
  });
  var e = pn(), t = function(l) {
    return l.match(new RegExp("^" + e.A_CHARS + "*"))[0].length;
  }, o = function(l) {
    return l.match(new RegExp("^" + e.B_CHARS + "*"))[0].length;
  }, r = function(l) {
    return l.match(new RegExp("^" + e.C_CHARS + "*"))[0];
  };
  function d(i, l) {
    var s = l ? e.A_CHARS : e.B_CHARS, n = i.match(new RegExp("^(" + s + "+?)(([0-9]{2}){2,})([^0-9]|$)"));
    if (n)
      return n[1] + "Ì" + f(i.substring(n[1].length));
    var a = i.match(new RegExp("^" + s + "+"))[0];
    return a.length === i.length ? i : a + String.fromCharCode(l ? 205 : 206) + d(i.substring(a.length), !l);
  }
  function f(i) {
    var l = r(i), s = l.length;
    if (s === i.length)
      return i;
    i = i.substring(s);
    var n = t(i) >= o(i);
    return l + String.fromCharCode(n ? 206 : 205) + d(i, n);
  }
  return Tn.default = function(i) {
    var l = void 0, s = r(i).length;
    if (s >= 2)
      l = e.C_START_CHAR + f(i);
    else {
      var n = t(i) > o(i);
      l = (n ? e.A_START_CHAR : e.B_START_CHAR) + d(i, n);
    }
    return l.replace(
      /[\xCD\xCE]([^])[\xCD\xCE]/,
      // Any sequence between 205 and 206 characters
      function(a, c) {
        return "Ë" + c;
      }
    );
  }, Tn;
}
var ni;
function ah() {
  if (ni) return Sn;
  ni = 1, Object.defineProperty(Sn, "__esModule", {
    value: !0
  });
  var e = _o(), t = d(e), o = ih(), r = d(o);
  function d(n) {
    return n && n.__esModule ? n : { default: n };
  }
  function f(n, a) {
    if (!(n instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(n, a) {
    if (!n)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a && (typeof a == "object" || typeof a == "function") ? a : n;
  }
  function l(n, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof a);
    n.prototype = Object.create(a && a.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), a && (Object.setPrototypeOf ? Object.setPrototypeOf(n, a) : n.__proto__ = a);
  }
  var s = function(n) {
    l(a, n);
    function a(c, m) {
      if (f(this, a), /^[\x00-\x7F\xC8-\xD3]+$/.test(c))
        var v = i(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this, (0, r.default)(c), m));
      else
        var v = i(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this, c, m));
      return i(v);
    }
    return a;
  }(t.default);
  return Sn.default = s, Sn;
}
var wn = {}, oi;
function sh() {
  if (oi) return wn;
  oi = 1, Object.defineProperty(wn, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function n(a, c) {
      for (var m = 0; m < c.length; m++) {
        var v = c[m];
        v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(a, v.key, v);
      }
    }
    return function(a, c, m) {
      return c && n(a.prototype, c), m && n(a, m), a;
    };
  }(), t = _o(), o = d(t), r = pn();
  function d(n) {
    return n && n.__esModule ? n : { default: n };
  }
  function f(n, a) {
    if (!(n instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(n, a) {
    if (!n)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a && (typeof a == "object" || typeof a == "function") ? a : n;
  }
  function l(n, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof a);
    n.prototype = Object.create(a && a.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), a && (Object.setPrototypeOf ? Object.setPrototypeOf(n, a) : n.__proto__ = a);
  }
  var s = function(n) {
    l(a, n);
    function a(c, m) {
      return f(this, a), i(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this, r.A_START_CHAR + c, m));
    }
    return e(a, [{
      key: "valid",
      value: function() {
        return new RegExp("^" + r.A_CHARS + "+$").test(this.data);
      }
    }]), a;
  }(o.default);
  return wn.default = s, wn;
}
var kn = {}, ri;
function lh() {
  if (ri) return kn;
  ri = 1, Object.defineProperty(kn, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function n(a, c) {
      for (var m = 0; m < c.length; m++) {
        var v = c[m];
        v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(a, v.key, v);
      }
    }
    return function(a, c, m) {
      return c && n(a.prototype, c), m && n(a, m), a;
    };
  }(), t = _o(), o = d(t), r = pn();
  function d(n) {
    return n && n.__esModule ? n : { default: n };
  }
  function f(n, a) {
    if (!(n instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(n, a) {
    if (!n)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a && (typeof a == "object" || typeof a == "function") ? a : n;
  }
  function l(n, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof a);
    n.prototype = Object.create(a && a.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), a && (Object.setPrototypeOf ? Object.setPrototypeOf(n, a) : n.__proto__ = a);
  }
  var s = function(n) {
    l(a, n);
    function a(c, m) {
      return f(this, a), i(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this, r.B_START_CHAR + c, m));
    }
    return e(a, [{
      key: "valid",
      value: function() {
        return new RegExp("^" + r.B_CHARS + "+$").test(this.data);
      }
    }]), a;
  }(o.default);
  return kn.default = s, kn;
}
var Nn = {}, ii;
function uh() {
  if (ii) return Nn;
  ii = 1, Object.defineProperty(Nn, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function n(a, c) {
      for (var m = 0; m < c.length; m++) {
        var v = c[m];
        v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(a, v.key, v);
      }
    }
    return function(a, c, m) {
      return c && n(a.prototype, c), m && n(a, m), a;
    };
  }(), t = _o(), o = d(t), r = pn();
  function d(n) {
    return n && n.__esModule ? n : { default: n };
  }
  function f(n, a) {
    if (!(n instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(n, a) {
    if (!n)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a && (typeof a == "object" || typeof a == "function") ? a : n;
  }
  function l(n, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof a);
    n.prototype = Object.create(a && a.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), a && (Object.setPrototypeOf ? Object.setPrototypeOf(n, a) : n.__proto__ = a);
  }
  var s = function(n) {
    l(a, n);
    function a(c, m) {
      return f(this, a), i(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this, r.C_START_CHAR + c, m));
    }
    return e(a, [{
      key: "valid",
      value: function() {
        return new RegExp("^" + r.C_CHARS + "+$").test(this.data);
      }
    }]), a;
  }(o.default);
  return Nn.default = s, Nn;
}
var ai;
function dh() {
  if (ai) return et;
  ai = 1, Object.defineProperty(et, "__esModule", {
    value: !0
  }), et.CODE128C = et.CODE128B = et.CODE128A = et.CODE128 = void 0;
  var e = ah(), t = s(e), o = sh(), r = s(o), d = lh(), f = s(d), i = uh(), l = s(i);
  function s(n) {
    return n && n.__esModule ? n : { default: n };
  }
  return et.CODE128 = t.default, et.CODE128A = r.default, et.CODE128B = f.default, et.CODE128C = l.default, et;
}
var Ge = {}, An = {}, st = {}, si;
function vn() {
  return si || (si = 1, Object.defineProperty(st, "__esModule", {
    value: !0
  }), st.SIDE_BIN = "101", st.MIDDLE_BIN = "01010", st.BINARIES = {
    L: [
      // The L (left) type of encoding
      "0001101",
      "0011001",
      "0010011",
      "0111101",
      "0100011",
      "0110001",
      "0101111",
      "0111011",
      "0110111",
      "0001011"
    ],
    G: [
      // The G type of encoding
      "0100111",
      "0110011",
      "0011011",
      "0100001",
      "0011101",
      "0111001",
      "0000101",
      "0010001",
      "0001001",
      "0010111"
    ],
    R: [
      // The R (right) type of encoding
      "1110010",
      "1100110",
      "1101100",
      "1000010",
      "1011100",
      "1001110",
      "1010000",
      "1000100",
      "1001000",
      "1110100"
    ],
    O: [
      // The O (odd) encoding for UPC-E
      "0001101",
      "0011001",
      "0010011",
      "0111101",
      "0100011",
      "0110001",
      "0101111",
      "0111011",
      "0110111",
      "0001011"
    ],
    E: [
      // The E (even) encoding for UPC-E
      "0100111",
      "0110011",
      "0011011",
      "0100001",
      "0011101",
      "0111001",
      "0000101",
      "0010001",
      "0001001",
      "0010111"
    ]
  }, st.EAN2_STRUCTURE = ["LL", "LG", "GL", "GG"], st.EAN5_STRUCTURE = ["GGLLL", "GLGLL", "GLLGL", "GLLLG", "LGGLL", "LLGGL", "LLLGG", "LGLGL", "LGLLG", "LLGLG"], st.EAN13_STRUCTURE = ["LLLLLL", "LLGLGG", "LLGGLG", "LLGGGL", "LGLLGG", "LGGLLG", "LGGGLL", "LGLGLG", "LGLGGL", "LGGLGL"]), st;
}
var Mn = {}, On = {}, li;
function hn() {
  if (li) return On;
  li = 1, Object.defineProperty(On, "__esModule", {
    value: !0
  });
  var e = vn(), t = function(r, d, f) {
    var i = r.split("").map(function(s, n) {
      return e.BINARIES[d[n]];
    }).map(function(s, n) {
      return s ? s[r[n]] : "";
    });
    if (f) {
      var l = r.length - 1;
      i = i.map(function(s, n) {
        return n < l ? s + f : s;
      });
    }
    return i.join("");
  };
  return On.default = t, On;
}
var ui;
function Ra() {
  if (ui) return Mn;
  ui = 1, Object.defineProperty(Mn, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function c(m, v) {
      for (var h = 0; h < v.length; h++) {
        var _ = v[h];
        _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(m, _.key, _);
      }
    }
    return function(m, v, h) {
      return v && c(m.prototype, v), h && c(m, h), m;
    };
  }(), t = vn(), o = hn(), r = i(o), d = Je(), f = i(d);
  function i(c) {
    return c && c.__esModule ? c : { default: c };
  }
  function l(c, m) {
    if (!(c instanceof m))
      throw new TypeError("Cannot call a class as a function");
  }
  function s(c, m) {
    if (!c)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return m && (typeof m == "object" || typeof m == "function") ? m : c;
  }
  function n(c, m) {
    if (typeof m != "function" && m !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof m);
    c.prototype = Object.create(m && m.prototype, { constructor: { value: c, enumerable: !1, writable: !0, configurable: !0 } }), m && (Object.setPrototypeOf ? Object.setPrototypeOf(c, m) : c.__proto__ = m);
  }
  var a = function(c) {
    n(m, c);
    function m(v, h) {
      l(this, m);
      var _ = s(this, (m.__proto__ || Object.getPrototypeOf(m)).call(this, v, h));
      return _.fontSize = !h.flat && h.fontSize > h.width * 10 ? h.width * 10 : h.fontSize, _.guardHeight = h.height + _.fontSize / 2 + h.textMargin, _;
    }
    return e(m, [{
      key: "encode",
      value: function() {
        return this.options.flat ? this.encodeFlat() : this.encodeGuarded();
      }
    }, {
      key: "leftText",
      value: function(h, _) {
        return this.text.substr(h, _);
      }
    }, {
      key: "leftEncode",
      value: function(h, _) {
        return (0, r.default)(h, _);
      }
    }, {
      key: "rightText",
      value: function(h, _) {
        return this.text.substr(h, _);
      }
    }, {
      key: "rightEncode",
      value: function(h, _) {
        return (0, r.default)(h, _);
      }
    }, {
      key: "encodeGuarded",
      value: function() {
        var h = { fontSize: this.fontSize }, _ = { height: this.guardHeight };
        return [{ data: t.SIDE_BIN, options: _ }, { data: this.leftEncode(), text: this.leftText(), options: h }, { data: t.MIDDLE_BIN, options: _ }, { data: this.rightEncode(), text: this.rightText(), options: h }, { data: t.SIDE_BIN, options: _ }];
      }
    }, {
      key: "encodeFlat",
      value: function() {
        var h = [t.SIDE_BIN, this.leftEncode(), t.MIDDLE_BIN, this.rightEncode(), t.SIDE_BIN];
        return {
          data: h.join(""),
          text: this.text
        };
      }
    }]), m;
  }(f.default);
  return Mn.default = a, Mn;
}
var di;
function ch() {
  if (di) return An;
  di = 1, Object.defineProperty(An, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function c(m, v) {
      for (var h = 0; h < v.length; h++) {
        var _ = v[h];
        _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(m, _.key, _);
      }
    }
    return function(m, v, h) {
      return v && c(m.prototype, v), h && c(m, h), m;
    };
  }(), t = function c(m, v, h) {
    m === null && (m = Function.prototype);
    var _ = Object.getOwnPropertyDescriptor(m, v);
    if (_ === void 0) {
      var b = Object.getPrototypeOf(m);
      return b === null ? void 0 : c(b, v, h);
    } else {
      if ("value" in _)
        return _.value;
      var y = _.get;
      return y === void 0 ? void 0 : y.call(h);
    }
  }, o = vn(), r = Ra(), d = f(r);
  function f(c) {
    return c && c.__esModule ? c : { default: c };
  }
  function i(c, m) {
    if (!(c instanceof m))
      throw new TypeError("Cannot call a class as a function");
  }
  function l(c, m) {
    if (!c)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return m && (typeof m == "object" || typeof m == "function") ? m : c;
  }
  function s(c, m) {
    if (typeof m != "function" && m !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof m);
    c.prototype = Object.create(m && m.prototype, { constructor: { value: c, enumerable: !1, writable: !0, configurable: !0 } }), m && (Object.setPrototypeOf ? Object.setPrototypeOf(c, m) : c.__proto__ = m);
  }
  var n = function(m) {
    var v = m.substr(0, 12).split("").map(function(h) {
      return +h;
    }).reduce(function(h, _, b) {
      return b % 2 ? h + _ * 3 : h + _;
    }, 0);
    return (10 - v % 10) % 10;
  }, a = function(c) {
    s(m, c);
    function m(v, h) {
      i(this, m), v.search(/^[0-9]{12}$/) !== -1 && (v += n(v));
      var _ = l(this, (m.__proto__ || Object.getPrototypeOf(m)).call(this, v, h));
      return _.lastChar = h.lastChar, _;
    }
    return e(m, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === n(this.data);
      }
    }, {
      key: "leftText",
      value: function() {
        return t(m.prototype.__proto__ || Object.getPrototypeOf(m.prototype), "leftText", this).call(this, 1, 6);
      }
    }, {
      key: "leftEncode",
      value: function() {
        var h = this.data.substr(1, 6), _ = o.EAN13_STRUCTURE[this.data[0]];
        return t(m.prototype.__proto__ || Object.getPrototypeOf(m.prototype), "leftEncode", this).call(this, h, _);
      }
    }, {
      key: "rightText",
      value: function() {
        return t(m.prototype.__proto__ || Object.getPrototypeOf(m.prototype), "rightText", this).call(this, 7, 6);
      }
    }, {
      key: "rightEncode",
      value: function() {
        var h = this.data.substr(7, 6);
        return t(m.prototype.__proto__ || Object.getPrototypeOf(m.prototype), "rightEncode", this).call(this, h, "RRRRRR");
      }
      // The "standard" way of printing EAN13 barcodes with guard bars
    }, {
      key: "encodeGuarded",
      value: function() {
        var h = t(m.prototype.__proto__ || Object.getPrototypeOf(m.prototype), "encodeGuarded", this).call(this);
        return this.options.displayValue && (h.unshift({
          data: "000000000000",
          text: this.text.substr(0, 1),
          options: { textAlign: "left", fontSize: this.fontSize }
        }), this.options.lastChar && (h.push({
          data: "00"
        }), h.push({
          data: "00000",
          text: this.options.lastChar,
          options: { fontSize: this.fontSize }
        }))), h;
      }
    }]), m;
  }(d.default);
  return An.default = a, An;
}
var Rn = {}, ci;
function mh() {
  if (ci) return Rn;
  ci = 1, Object.defineProperty(Rn, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function a(c, m) {
      for (var v = 0; v < m.length; v++) {
        var h = m[v];
        h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(c, h.key, h);
      }
    }
    return function(c, m, v) {
      return m && a(c.prototype, m), v && a(c, v), c;
    };
  }(), t = function a(c, m, v) {
    c === null && (c = Function.prototype);
    var h = Object.getOwnPropertyDescriptor(c, m);
    if (h === void 0) {
      var _ = Object.getPrototypeOf(c);
      return _ === null ? void 0 : a(_, m, v);
    } else {
      if ("value" in h)
        return h.value;
      var b = h.get;
      return b === void 0 ? void 0 : b.call(v);
    }
  }, o = Ra(), r = d(o);
  function d(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function f(a, c) {
    if (!(a instanceof c))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(a, c) {
    if (!a)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return c && (typeof c == "object" || typeof c == "function") ? c : a;
  }
  function l(a, c) {
    if (typeof c != "function" && c !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof c);
    a.prototype = Object.create(c && c.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), c && (Object.setPrototypeOf ? Object.setPrototypeOf(a, c) : a.__proto__ = c);
  }
  var s = function(c) {
    var m = c.substr(0, 7).split("").map(function(v) {
      return +v;
    }).reduce(function(v, h, _) {
      return _ % 2 ? v + h : v + h * 3;
    }, 0);
    return (10 - m % 10) % 10;
  }, n = function(a) {
    l(c, a);
    function c(m, v) {
      return f(this, c), m.search(/^[0-9]{7}$/) !== -1 && (m += s(m)), i(this, (c.__proto__ || Object.getPrototypeOf(c)).call(this, m, v));
    }
    return e(c, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]{8}$/) !== -1 && +this.data[7] === s(this.data);
      }
    }, {
      key: "leftText",
      value: function() {
        return t(c.prototype.__proto__ || Object.getPrototypeOf(c.prototype), "leftText", this).call(this, 0, 4);
      }
    }, {
      key: "leftEncode",
      value: function() {
        var v = this.data.substr(0, 4);
        return t(c.prototype.__proto__ || Object.getPrototypeOf(c.prototype), "leftEncode", this).call(this, v, "LLLL");
      }
    }, {
      key: "rightText",
      value: function() {
        return t(c.prototype.__proto__ || Object.getPrototypeOf(c.prototype), "rightText", this).call(this, 4, 4);
      }
    }, {
      key: "rightEncode",
      value: function() {
        var v = this.data.substr(4, 4);
        return t(c.prototype.__proto__ || Object.getPrototypeOf(c.prototype), "rightEncode", this).call(this, v, "RRRR");
      }
    }]), c;
  }(r.default);
  return Rn.default = n, Rn;
}
var $n = {}, mi;
function fh() {
  if (mi) return $n;
  mi = 1, Object.defineProperty($n, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function m(v, h) {
      for (var _ = 0; _ < h.length; _++) {
        var b = h[_];
        b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(v, b.key, b);
      }
    }
    return function(v, h, _) {
      return h && m(v.prototype, h), _ && m(v, _), v;
    };
  }(), t = vn(), o = hn(), r = i(o), d = Je(), f = i(d);
  function i(m) {
    return m && m.__esModule ? m : { default: m };
  }
  function l(m, v) {
    if (!(m instanceof v))
      throw new TypeError("Cannot call a class as a function");
  }
  function s(m, v) {
    if (!m)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return v && (typeof v == "object" || typeof v == "function") ? v : m;
  }
  function n(m, v) {
    if (typeof v != "function" && v !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof v);
    m.prototype = Object.create(v && v.prototype, { constructor: { value: m, enumerable: !1, writable: !0, configurable: !0 } }), v && (Object.setPrototypeOf ? Object.setPrototypeOf(m, v) : m.__proto__ = v);
  }
  var a = function(v) {
    var h = v.split("").map(function(_) {
      return +_;
    }).reduce(function(_, b, y) {
      return y % 2 ? _ + b * 9 : _ + b * 3;
    }, 0);
    return h % 10;
  }, c = function(m) {
    n(v, m);
    function v(h, _) {
      return l(this, v), s(this, (v.__proto__ || Object.getPrototypeOf(v)).call(this, h, _));
    }
    return e(v, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]{5}$/) !== -1;
      }
    }, {
      key: "encode",
      value: function() {
        var _ = t.EAN5_STRUCTURE[a(this.data)];
        return {
          data: "1011" + (0, r.default)(this.data, _, "01"),
          text: this.text
        };
      }
    }]), v;
  }(f.default);
  return $n.default = c, $n;
}
var xn = {}, fi;
function ph() {
  if (fi) return xn;
  fi = 1, Object.defineProperty(xn, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function c(m, v) {
      for (var h = 0; h < v.length; h++) {
        var _ = v[h];
        _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(m, _.key, _);
      }
    }
    return function(m, v, h) {
      return v && c(m.prototype, v), h && c(m, h), m;
    };
  }(), t = vn(), o = hn(), r = i(o), d = Je(), f = i(d);
  function i(c) {
    return c && c.__esModule ? c : { default: c };
  }
  function l(c, m) {
    if (!(c instanceof m))
      throw new TypeError("Cannot call a class as a function");
  }
  function s(c, m) {
    if (!c)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return m && (typeof m == "object" || typeof m == "function") ? m : c;
  }
  function n(c, m) {
    if (typeof m != "function" && m !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof m);
    c.prototype = Object.create(m && m.prototype, { constructor: { value: c, enumerable: !1, writable: !0, configurable: !0 } }), m && (Object.setPrototypeOf ? Object.setPrototypeOf(c, m) : c.__proto__ = m);
  }
  var a = function(c) {
    n(m, c);
    function m(v, h) {
      return l(this, m), s(this, (m.__proto__ || Object.getPrototypeOf(m)).call(this, v, h));
    }
    return e(m, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]{2}$/) !== -1;
      }
    }, {
      key: "encode",
      value: function() {
        var h = t.EAN2_STRUCTURE[parseInt(this.data) % 4];
        return {
          // Start bits + Encode the two digits with 01 in between
          data: "1011" + (0, r.default)(this.data, h, "01"),
          text: this.text
        };
      }
    }]), m;
  }(f.default);
  return xn.default = a, xn;
}
var Qt = {}, pi;
function $a() {
  if (pi) return Qt;
  pi = 1, Object.defineProperty(Qt, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function c(m, v) {
      for (var h = 0; h < v.length; h++) {
        var _ = v[h];
        _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(m, _.key, _);
      }
    }
    return function(m, v, h) {
      return v && c(m.prototype, v), h && c(m, h), m;
    };
  }();
  Qt.checksum = a;
  var t = hn(), o = f(t), r = Je(), d = f(r);
  function f(c) {
    return c && c.__esModule ? c : { default: c };
  }
  function i(c, m) {
    if (!(c instanceof m))
      throw new TypeError("Cannot call a class as a function");
  }
  function l(c, m) {
    if (!c)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return m && (typeof m == "object" || typeof m == "function") ? m : c;
  }
  function s(c, m) {
    if (typeof m != "function" && m !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof m);
    c.prototype = Object.create(m && m.prototype, { constructor: { value: c, enumerable: !1, writable: !0, configurable: !0 } }), m && (Object.setPrototypeOf ? Object.setPrototypeOf(c, m) : c.__proto__ = m);
  }
  var n = function(c) {
    s(m, c);
    function m(v, h) {
      i(this, m), v.search(/^[0-9]{11}$/) !== -1 && (v += a(v));
      var _ = l(this, (m.__proto__ || Object.getPrototypeOf(m)).call(this, v, h));
      return _.displayValue = h.displayValue, h.fontSize > h.width * 10 ? _.fontSize = h.width * 10 : _.fontSize = h.fontSize, _.guardHeight = h.height + _.fontSize / 2 + h.textMargin, _;
    }
    return e(m, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == a(this.data);
      }
    }, {
      key: "encode",
      value: function() {
        return this.options.flat ? this.flatEncoding() : this.guardedEncoding();
      }
    }, {
      key: "flatEncoding",
      value: function() {
        var h = "";
        return h += "101", h += (0, o.default)(this.data.substr(0, 6), "LLLLLL"), h += "01010", h += (0, o.default)(this.data.substr(6, 6), "RRRRRR"), h += "101", {
          data: h,
          text: this.text
        };
      }
    }, {
      key: "guardedEncoding",
      value: function() {
        var h = [];
        return this.displayValue && h.push({
          data: "00000000",
          text: this.text.substr(0, 1),
          options: { textAlign: "left", fontSize: this.fontSize }
        }), h.push({
          data: "101" + (0, o.default)(this.data[0], "L"),
          options: { height: this.guardHeight }
        }), h.push({
          data: (0, o.default)(this.data.substr(1, 5), "LLLLL"),
          text: this.text.substr(1, 5),
          options: { fontSize: this.fontSize }
        }), h.push({
          data: "01010",
          options: { height: this.guardHeight }
        }), h.push({
          data: (0, o.default)(this.data.substr(6, 5), "RRRRR"),
          text: this.text.substr(6, 5),
          options: { fontSize: this.fontSize }
        }), h.push({
          data: (0, o.default)(this.data[11], "R") + "101",
          options: { height: this.guardHeight }
        }), this.displayValue && h.push({
          data: "00000000",
          text: this.text.substr(11, 1),
          options: { textAlign: "right", fontSize: this.fontSize }
        }), h;
      }
    }]), m;
  }(d.default);
  function a(c) {
    var m = 0, v;
    for (v = 1; v < 11; v += 2)
      m += parseInt(c[v]);
    for (v = 0; v < 11; v += 2)
      m += parseInt(c[v]) * 3;
    return (10 - m % 10) % 10;
  }
  return Qt.default = n, Qt;
}
var Ln = {}, vi;
function vh() {
  if (vi) return Ln;
  vi = 1, Object.defineProperty(Ln, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function h(_, b) {
      for (var y = 0; y < b.length; y++) {
        var g = b[y];
        g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(_, g.key, g);
      }
    }
    return function(_, b, y) {
      return b && h(_.prototype, b), y && h(_, y), _;
    };
  }(), t = hn(), o = i(t), r = Je(), d = i(r), f = $a();
  function i(h) {
    return h && h.__esModule ? h : { default: h };
  }
  function l(h, _) {
    if (!(h instanceof _))
      throw new TypeError("Cannot call a class as a function");
  }
  function s(h, _) {
    if (!h)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return _ && (typeof _ == "object" || typeof _ == "function") ? _ : h;
  }
  function n(h, _) {
    if (typeof _ != "function" && _ !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof _);
    h.prototype = Object.create(_ && _.prototype, { constructor: { value: h, enumerable: !1, writable: !0, configurable: !0 } }), _ && (Object.setPrototypeOf ? Object.setPrototypeOf(h, _) : h.__proto__ = _);
  }
  var a = ["XX00000XXX", "XX10000XXX", "XX20000XXX", "XXX00000XX", "XXXX00000X", "XXXXX00005", "XXXXX00006", "XXXXX00007", "XXXXX00008", "XXXXX00009"], c = [["EEEOOO", "OOOEEE"], ["EEOEOO", "OOEOEE"], ["EEOOEO", "OOEEOE"], ["EEOOOE", "OOEEEO"], ["EOEEOO", "OEOOEE"], ["EOOEEO", "OEEOOE"], ["EOOOEE", "OEEEOO"], ["EOEOEO", "OEOEOE"], ["EOEOOE", "OEOEEO"], ["EOOEOE", "OEEOEO"]], m = function(h) {
    n(_, h);
    function _(b, y) {
      l(this, _);
      var g = s(this, (_.__proto__ || Object.getPrototypeOf(_)).call(this, b, y));
      if (g.isValid = !1, b.search(/^[0-9]{6}$/) !== -1)
        g.middleDigits = b, g.upcA = v(b, "0"), g.text = y.text || "" + g.upcA[0] + b + g.upcA[g.upcA.length - 1], g.isValid = !0;
      else if (b.search(/^[01][0-9]{7}$/) !== -1)
        if (g.middleDigits = b.substring(1, b.length - 1), g.upcA = v(g.middleDigits, b[0]), g.upcA[g.upcA.length - 1] === b[b.length - 1])
          g.isValid = !0;
        else
          return s(g);
      else
        return s(g);
      return g.displayValue = y.displayValue, y.fontSize > y.width * 10 ? g.fontSize = y.width * 10 : g.fontSize = y.fontSize, g.guardHeight = y.height + g.fontSize / 2 + y.textMargin, g;
    }
    return e(_, [{
      key: "valid",
      value: function() {
        return this.isValid;
      }
    }, {
      key: "encode",
      value: function() {
        return this.options.flat ? this.flatEncoding() : this.guardedEncoding();
      }
    }, {
      key: "flatEncoding",
      value: function() {
        var y = "";
        return y += "101", y += this.encodeMiddleDigits(), y += "010101", {
          data: y,
          text: this.text
        };
      }
    }, {
      key: "guardedEncoding",
      value: function() {
        var y = [];
        return this.displayValue && y.push({
          data: "00000000",
          text: this.text[0],
          options: { textAlign: "left", fontSize: this.fontSize }
        }), y.push({
          data: "101",
          options: { height: this.guardHeight }
        }), y.push({
          data: this.encodeMiddleDigits(),
          text: this.text.substring(1, 7),
          options: { fontSize: this.fontSize }
        }), y.push({
          data: "010101",
          options: { height: this.guardHeight }
        }), this.displayValue && y.push({
          data: "00000000",
          text: this.text[7],
          options: { textAlign: "right", fontSize: this.fontSize }
        }), y;
      }
    }, {
      key: "encodeMiddleDigits",
      value: function() {
        var y = this.upcA[0], g = this.upcA[this.upcA.length - 1], I = c[parseInt(g)][parseInt(y)];
        return (0, o.default)(this.middleDigits, I);
      }
    }]), _;
  }(d.default);
  function v(h, _) {
    for (var b = parseInt(h[h.length - 1]), y = a[b], g = "", I = 0, T = 0; T < y.length; T++) {
      var w = y[T];
      w === "X" ? g += h[I++] : g += w;
    }
    return g = "" + _ + g, "" + g + (0, f.checksum)(g);
  }
  return Ln.default = m, Ln;
}
var hi;
function hh() {
  if (hi) return Ge;
  hi = 1, Object.defineProperty(Ge, "__esModule", {
    value: !0
  }), Ge.UPCE = Ge.UPC = Ge.EAN2 = Ge.EAN5 = Ge.EAN8 = Ge.EAN13 = void 0;
  var e = ch(), t = m(e), o = mh(), r = m(o), d = fh(), f = m(d), i = ph(), l = m(i), s = $a(), n = m(s), a = vh(), c = m(a);
  function m(v) {
    return v && v.__esModule ? v : { default: v };
  }
  return Ge.EAN13 = t.default, Ge.EAN8 = r.default, Ge.EAN5 = f.default, Ge.EAN2 = l.default, Ge.UPC = n.default, Ge.UPCE = c.default, Ge;
}
var wt = {}, Vn = {}, zt = {}, yi;
function yh() {
  return yi || (yi = 1, Object.defineProperty(zt, "__esModule", {
    value: !0
  }), zt.START_BIN = "1010", zt.END_BIN = "11101", zt.BINARIES = ["00110", "10001", "01001", "11000", "00101", "10100", "01100", "00011", "10010", "01010"]), zt;
}
var _i;
function xa() {
  if (_i) return Vn;
  _i = 1, Object.defineProperty(Vn, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function n(a, c) {
      for (var m = 0; m < c.length; m++) {
        var v = c[m];
        v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(a, v.key, v);
      }
    }
    return function(a, c, m) {
      return c && n(a.prototype, c), m && n(a, m), a;
    };
  }(), t = yh(), o = Je(), r = d(o);
  function d(n) {
    return n && n.__esModule ? n : { default: n };
  }
  function f(n, a) {
    if (!(n instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(n, a) {
    if (!n)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a && (typeof a == "object" || typeof a == "function") ? a : n;
  }
  function l(n, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof a);
    n.prototype = Object.create(a && a.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), a && (Object.setPrototypeOf ? Object.setPrototypeOf(n, a) : n.__proto__ = a);
  }
  var s = function(n) {
    l(a, n);
    function a() {
      return f(this, a), i(this, (a.__proto__ || Object.getPrototypeOf(a)).apply(this, arguments));
    }
    return e(a, [{
      key: "valid",
      value: function() {
        return this.data.search(/^([0-9]{2})+$/) !== -1;
      }
    }, {
      key: "encode",
      value: function() {
        var m = this, v = this.data.match(/.{2}/g).map(function(h) {
          return m.encodePair(h);
        }).join("");
        return {
          data: t.START_BIN + v + t.END_BIN,
          text: this.text
        };
      }
      // Calculate the data of a number pair
    }, {
      key: "encodePair",
      value: function(m) {
        var v = t.BINARIES[m[1]];
        return t.BINARIES[m[0]].split("").map(function(h, _) {
          return (h === "1" ? "111" : "1") + (v[_] === "1" ? "000" : "0");
        }).join("");
      }
    }]), a;
  }(r.default);
  return Vn.default = s, Vn;
}
var Fn = {}, gi;
function _h() {
  if (gi) return Fn;
  gi = 1, Object.defineProperty(Fn, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function n(a, c) {
      for (var m = 0; m < c.length; m++) {
        var v = c[m];
        v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(a, v.key, v);
      }
    }
    return function(a, c, m) {
      return c && n(a.prototype, c), m && n(a, m), a;
    };
  }(), t = xa(), o = r(t);
  function r(n) {
    return n && n.__esModule ? n : { default: n };
  }
  function d(n, a) {
    if (!(n instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(n, a) {
    if (!n)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a && (typeof a == "object" || typeof a == "function") ? a : n;
  }
  function i(n, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof a);
    n.prototype = Object.create(a && a.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), a && (Object.setPrototypeOf ? Object.setPrototypeOf(n, a) : n.__proto__ = a);
  }
  var l = function(a) {
    var c = a.substr(0, 13).split("").map(function(m) {
      return parseInt(m, 10);
    }).reduce(function(m, v, h) {
      return m + v * (3 - h % 2 * 2);
    }, 0);
    return Math.ceil(c / 10) * 10 - c;
  }, s = function(n) {
    i(a, n);
    function a(c, m) {
      return d(this, a), c.search(/^[0-9]{13}$/) !== -1 && (c += l(c)), f(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this, c, m));
    }
    return e(a, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]{14}$/) !== -1 && +this.data[13] === l(this.data);
      }
    }]), a;
  }(o.default);
  return Fn.default = s, Fn;
}
var bi;
function gh() {
  if (bi) return wt;
  bi = 1, Object.defineProperty(wt, "__esModule", {
    value: !0
  }), wt.ITF14 = wt.ITF = void 0;
  var e = xa(), t = d(e), o = _h(), r = d(o);
  function d(f) {
    return f && f.__esModule ? f : { default: f };
  }
  return wt.ITF = t.default, wt.ITF14 = r.default, wt;
}
var Ze = {}, jn = {}, Ci;
function yn() {
  if (Ci) return jn;
  Ci = 1, Object.defineProperty(jn, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function n(a, c) {
      for (var m = 0; m < c.length; m++) {
        var v = c[m];
        v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(a, v.key, v);
      }
    }
    return function(a, c, m) {
      return c && n(a.prototype, c), m && n(a, m), a;
    };
  }(), t = Je(), o = r(t);
  function r(n) {
    return n && n.__esModule ? n : { default: n };
  }
  function d(n, a) {
    if (!(n instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(n, a) {
    if (!n)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a && (typeof a == "object" || typeof a == "function") ? a : n;
  }
  function i(n, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof a);
    n.prototype = Object.create(a && a.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), a && (Object.setPrototypeOf ? Object.setPrototypeOf(n, a) : n.__proto__ = a);
  }
  var l = function(n) {
    i(a, n);
    function a(c, m) {
      return d(this, a), f(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this, c, m));
    }
    return e(a, [{
      key: "encode",
      value: function() {
        for (var m = "110", v = 0; v < this.data.length; v++) {
          var h = parseInt(this.data[v]), _ = h.toString(2);
          _ = s(_, 4 - _.length);
          for (var b = 0; b < _.length; b++)
            m += _[b] == "0" ? "100" : "110";
        }
        return m += "1001", {
          data: m,
          text: this.text
        };
      }
    }, {
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]+$/) !== -1;
      }
    }]), a;
  }(o.default);
  function s(n, a) {
    for (var c = 0; c < a; c++)
      n = "0" + n;
    return n;
  }
  return jn.default = l, jn;
}
var zn = {}, Xt = {}, Ii;
function go() {
  if (Ii) return Xt;
  Ii = 1, Object.defineProperty(Xt, "__esModule", {
    value: !0
  }), Xt.mod10 = e, Xt.mod11 = t;
  function e(o) {
    for (var r = 0, d = 0; d < o.length; d++) {
      var f = parseInt(o[d]);
      (d + o.length) % 2 === 0 ? r += f : r += f * 2 % 10 + Math.floor(f * 2 / 10);
    }
    return (10 - r % 10) % 10;
  }
  function t(o) {
    for (var r = 0, d = [2, 3, 4, 5, 6, 7], f = 0; f < o.length; f++) {
      var i = parseInt(o[o.length - 1 - f]);
      r += d[f % d.length] * i;
    }
    return (11 - r % 11) % 11;
  }
  return Xt;
}
var Ei;
function bh() {
  if (Ei) return zn;
  Ei = 1, Object.defineProperty(zn, "__esModule", {
    value: !0
  });
  var e = yn(), t = r(e), o = go();
  function r(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function d(s, n) {
    if (!(s instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(s, n) {
    if (!s)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n && (typeof n == "object" || typeof n == "function") ? n : s;
  }
  function i(s, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof n);
    s.prototype = Object.create(n && n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(s, n) : s.__proto__ = n);
  }
  var l = function(s) {
    i(n, s);
    function n(a, c) {
      return d(this, n), f(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, a + (0, o.mod10)(a), c));
    }
    return n;
  }(t.default);
  return zn.default = l, zn;
}
var Un = {}, Si;
function Ch() {
  if (Si) return Un;
  Si = 1, Object.defineProperty(Un, "__esModule", {
    value: !0
  });
  var e = yn(), t = r(e), o = go();
  function r(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function d(s, n) {
    if (!(s instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(s, n) {
    if (!s)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n && (typeof n == "object" || typeof n == "function") ? n : s;
  }
  function i(s, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof n);
    s.prototype = Object.create(n && n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(s, n) : s.__proto__ = n);
  }
  var l = function(s) {
    i(n, s);
    function n(a, c) {
      return d(this, n), f(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, a + (0, o.mod11)(a), c));
    }
    return n;
  }(t.default);
  return Un.default = l, Un;
}
var Bn = {}, Pi;
function Ih() {
  if (Pi) return Bn;
  Pi = 1, Object.defineProperty(Bn, "__esModule", {
    value: !0
  });
  var e = yn(), t = r(e), o = go();
  function r(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function d(s, n) {
    if (!(s instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(s, n) {
    if (!s)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n && (typeof n == "object" || typeof n == "function") ? n : s;
  }
  function i(s, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof n);
    s.prototype = Object.create(n && n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(s, n) : s.__proto__ = n);
  }
  var l = function(s) {
    i(n, s);
    function n(a, c) {
      return d(this, n), a += (0, o.mod10)(a), a += (0, o.mod10)(a), f(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, a, c));
    }
    return n;
  }(t.default);
  return Bn.default = l, Bn;
}
var Gn = {}, Ti;
function Eh() {
  if (Ti) return Gn;
  Ti = 1, Object.defineProperty(Gn, "__esModule", {
    value: !0
  });
  var e = yn(), t = r(e), o = go();
  function r(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function d(s, n) {
    if (!(s instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(s, n) {
    if (!s)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n && (typeof n == "object" || typeof n == "function") ? n : s;
  }
  function i(s, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof n);
    s.prototype = Object.create(n && n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(s, n) : s.__proto__ = n);
  }
  var l = function(s) {
    i(n, s);
    function n(a, c) {
      return d(this, n), a += (0, o.mod11)(a), a += (0, o.mod10)(a), f(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, a, c));
    }
    return n;
  }(t.default);
  return Gn.default = l, Gn;
}
var wi;
function Sh() {
  if (wi) return Ze;
  wi = 1, Object.defineProperty(Ze, "__esModule", {
    value: !0
  }), Ze.MSI1110 = Ze.MSI1010 = Ze.MSI11 = Ze.MSI10 = Ze.MSI = void 0;
  var e = yn(), t = a(e), o = bh(), r = a(o), d = Ch(), f = a(d), i = Ih(), l = a(i), s = Eh(), n = a(s);
  function a(c) {
    return c && c.__esModule ? c : { default: c };
  }
  return Ze.MSI = t.default, Ze.MSI10 = r.default, Ze.MSI11 = f.default, Ze.MSI1010 = l.default, Ze.MSI1110 = n.default, Ze;
}
var Jt = {}, ki;
function Ph() {
  if (ki) return Jt;
  ki = 1, Object.defineProperty(Jt, "__esModule", {
    value: !0
  }), Jt.pharmacode = void 0;
  var e = /* @__PURE__ */ function() {
    function s(n, a) {
      for (var c = 0; c < a.length; c++) {
        var m = a[c];
        m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(n, m.key, m);
      }
    }
    return function(n, a, c) {
      return a && s(n.prototype, a), c && s(n, c), n;
    };
  }(), t = Je(), o = r(t);
  function r(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function d(s, n) {
    if (!(s instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(s, n) {
    if (!s)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n && (typeof n == "object" || typeof n == "function") ? n : s;
  }
  function i(s, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof n);
    s.prototype = Object.create(n && n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(s, n) : s.__proto__ = n);
  }
  var l = function(s) {
    i(n, s);
    function n(a, c) {
      d(this, n);
      var m = f(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, a, c));
      return m.number = parseInt(a, 10), m;
    }
    return e(n, [{
      key: "encode",
      value: function() {
        for (var c = this.number, m = ""; !isNaN(c) && c != 0; )
          c % 2 === 0 ? (m = "11100" + m, c = (c - 2) / 2) : (m = "100" + m, c = (c - 1) / 2);
        return m = m.slice(0, -2), {
          data: m,
          text: this.text
        };
      }
    }, {
      key: "valid",
      value: function() {
        return this.number >= 3 && this.number <= 131070;
      }
    }]), n;
  }(o.default);
  return Jt.pharmacode = l, Jt;
}
var en = {}, Ni;
function Th() {
  if (Ni) return en;
  Ni = 1, Object.defineProperty(en, "__esModule", {
    value: !0
  }), en.codabar = void 0;
  var e = /* @__PURE__ */ function() {
    function s(n, a) {
      for (var c = 0; c < a.length; c++) {
        var m = a[c];
        m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(n, m.key, m);
      }
    }
    return function(n, a, c) {
      return a && s(n.prototype, a), c && s(n, c), n;
    };
  }(), t = Je(), o = r(t);
  function r(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function d(s, n) {
    if (!(s instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(s, n) {
    if (!s)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n && (typeof n == "object" || typeof n == "function") ? n : s;
  }
  function i(s, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof n);
    s.prototype = Object.create(n && n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(s, n) : s.__proto__ = n);
  }
  var l = function(s) {
    i(n, s);
    function n(a, c) {
      d(this, n), a.search(/^[0-9\-\$\:\.\+\/]+$/) === 0 && (a = "A" + a + "A");
      var m = f(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, a.toUpperCase(), c));
      return m.text = m.options.text || m.text.replace(/[A-D]/g, ""), m;
    }
    return e(n, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/) !== -1;
      }
    }, {
      key: "encode",
      value: function() {
        for (var c = [], m = this.getEncodings(), v = 0; v < this.data.length; v++)
          c.push(m[this.data.charAt(v)]), v !== this.data.length - 1 && c.push("0");
        return {
          text: this.text,
          data: c.join("")
        };
      }
    }, {
      key: "getEncodings",
      value: function() {
        return {
          0: "101010011",
          1: "101011001",
          2: "101001011",
          3: "110010101",
          4: "101101001",
          5: "110101001",
          6: "100101011",
          7: "100101101",
          8: "100110101",
          9: "110100101",
          "-": "101001101",
          $: "101100101",
          ":": "1101011011",
          "/": "1101101011",
          ".": "1101101101",
          "+": "1011011011",
          A: "1011001001",
          B: "1001001011",
          C: "1010010011",
          D: "1010011001"
        };
      }
    }]), n;
  }(o.default);
  return en.codabar = l, en;
}
var tn = {}, Ai;
function wh() {
  if (Ai) return tn;
  Ai = 1, Object.defineProperty(tn, "__esModule", {
    value: !0
  }), tn.GenericBarcode = void 0;
  var e = /* @__PURE__ */ function() {
    function s(n, a) {
      for (var c = 0; c < a.length; c++) {
        var m = a[c];
        m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(n, m.key, m);
      }
    }
    return function(n, a, c) {
      return a && s(n.prototype, a), c && s(n, c), n;
    };
  }(), t = Je(), o = r(t);
  function r(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function d(s, n) {
    if (!(s instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(s, n) {
    if (!s)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n && (typeof n == "object" || typeof n == "function") ? n : s;
  }
  function i(s, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof n);
    s.prototype = Object.create(n && n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(s, n) : s.__proto__ = n);
  }
  var l = function(s) {
    i(n, s);
    function n(a, c) {
      return d(this, n), f(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, a, c));
    }
    return e(n, [{
      key: "encode",
      value: function() {
        return {
          data: "10101010101010101010101010101010101010101",
          text: this.text
        };
      }
      // Resturn true/false if the string provided is valid for this encoder
    }, {
      key: "valid",
      value: function() {
        return !0;
      }
    }]), n;
  }(o.default);
  return tn.GenericBarcode = l, tn;
}
var Mi;
function kh() {
  if (Mi) return In;
  Mi = 1, Object.defineProperty(In, "__esModule", {
    value: !0
  });
  var e = rh(), t = dh(), o = hh(), r = gh(), d = Sh(), f = Ph(), i = Th(), l = wh();
  return In.default = {
    CODE39: e.CODE39,
    CODE128: t.CODE128,
    CODE128A: t.CODE128A,
    CODE128B: t.CODE128B,
    CODE128C: t.CODE128C,
    EAN13: o.EAN13,
    EAN8: o.EAN8,
    EAN5: o.EAN5,
    EAN2: o.EAN2,
    UPC: o.UPC,
    UPCE: o.UPCE,
    ITF14: r.ITF14,
    ITF: r.ITF,
    MSI: d.MSI,
    MSI10: d.MSI10,
    MSI11: d.MSI11,
    MSI1010: d.MSI1010,
    MSI1110: d.MSI1110,
    pharmacode: f.pharmacode,
    codabar: i.codabar,
    GenericBarcode: l.GenericBarcode
  }, In;
}
var qn = {}, Oi;
function bo() {
  if (Oi) return qn;
  Oi = 1, Object.defineProperty(qn, "__esModule", {
    value: !0
  });
  var e = Object.assign || function(t) {
    for (var o = 1; o < arguments.length; o++) {
      var r = arguments[o];
      for (var d in r)
        Object.prototype.hasOwnProperty.call(r, d) && (t[d] = r[d]);
    }
    return t;
  };
  return qn.default = function(t, o) {
    return e({}, t, o);
  }, qn;
}
var Dn = {}, Ri;
function Nh() {
  if (Ri) return Dn;
  Ri = 1, Object.defineProperty(Dn, "__esModule", {
    value: !0
  }), Dn.default = e;
  function e(t) {
    var o = [];
    function r(d) {
      if (Array.isArray(d))
        for (var f = 0; f < d.length; f++)
          r(d[f]);
      else
        d.text = d.text || "", d.data = d.data || "", o.push(d);
    }
    return r(t), o;
  }
  return Dn;
}
var Hn = {}, $i;
function Ah() {
  if ($i) return Hn;
  $i = 1, Object.defineProperty(Hn, "__esModule", {
    value: !0
  }), Hn.default = e;
  function e(t) {
    return t.marginTop = t.marginTop || t.margin, t.marginBottom = t.marginBottom || t.margin, t.marginRight = t.marginRight || t.margin, t.marginLeft = t.marginLeft || t.margin, t;
  }
  return Hn;
}
var Yn = {}, Zn = {}, Wn = {}, xi;
function La() {
  if (xi) return Wn;
  xi = 1, Object.defineProperty(Wn, "__esModule", {
    value: !0
  }), Wn.default = e;
  function e(t) {
    var o = ["width", "height", "textMargin", "fontSize", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight"];
    for (var r in o)
      o.hasOwnProperty(r) && (r = o[r], typeof t[r] == "string" && (t[r] = parseInt(t[r], 10)));
    return typeof t.displayValue == "string" && (t.displayValue = t.displayValue != "false"), t;
  }
  return Wn;
}
var Kn = {}, Li;
function Va() {
  if (Li) return Kn;
  Li = 1, Object.defineProperty(Kn, "__esModule", {
    value: !0
  });
  var e = {
    width: 2,
    height: 100,
    format: "auto",
    displayValue: !0,
    fontOptions: "",
    font: "monospace",
    text: void 0,
    textAlign: "center",
    textPosition: "bottom",
    textMargin: 2,
    fontSize: 20,
    background: "#ffffff",
    lineColor: "#000000",
    margin: 10,
    marginTop: void 0,
    marginBottom: void 0,
    marginLeft: void 0,
    marginRight: void 0,
    valid: function() {
    }
  };
  return Kn.default = e, Kn;
}
var Vi;
function Mh() {
  if (Vi) return Zn;
  Vi = 1, Object.defineProperty(Zn, "__esModule", {
    value: !0
  });
  var e = La(), t = d(e), o = Va(), r = d(o);
  function d(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function f(i) {
    var l = {};
    for (var s in r.default)
      r.default.hasOwnProperty(s) && (i.hasAttribute("jsbarcode-" + s.toLowerCase()) && (l[s] = i.getAttribute("jsbarcode-" + s.toLowerCase())), i.hasAttribute("data-" + s.toLowerCase()) && (l[s] = i.getAttribute("data-" + s.toLowerCase())));
    return l.value = i.getAttribute("jsbarcode-value") || i.getAttribute("data-value"), l = (0, t.default)(l), l;
  }
  return Zn.default = f, Zn;
}
var Qn = {}, Xn = {}, We = {}, Fi;
function Fa() {
  if (Fi) return We;
  Fi = 1, Object.defineProperty(We, "__esModule", {
    value: !0
  }), We.getTotalWidthOfEncodings = We.calculateEncodingAttributes = We.getBarcodePadding = We.getEncodingHeight = We.getMaximumHeightOfEncodings = void 0;
  var e = bo(), t = o(e);
  function o(n) {
    return n && n.__esModule ? n : { default: n };
  }
  function r(n, a) {
    return a.height + (a.displayValue && n.text.length > 0 ? a.fontSize + a.textMargin : 0) + a.marginTop + a.marginBottom;
  }
  function d(n, a, c) {
    if (c.displayValue && a < n) {
      if (c.textAlign == "center")
        return Math.floor((n - a) / 2);
      if (c.textAlign == "left")
        return 0;
      if (c.textAlign == "right")
        return Math.floor(n - a);
    }
    return 0;
  }
  function f(n, a, c) {
    for (var m = 0; m < n.length; m++) {
      var v = n[m], h = (0, t.default)(a, v.options), _;
      h.displayValue ? _ = s(v.text, h, c) : _ = 0;
      var b = v.data.length * h.width;
      v.width = Math.ceil(Math.max(_, b)), v.height = r(v, h), v.barcodePadding = d(_, b, h);
    }
  }
  function i(n) {
    for (var a = 0, c = 0; c < n.length; c++)
      a += n[c].width;
    return a;
  }
  function l(n) {
    for (var a = 0, c = 0; c < n.length; c++)
      n[c].height > a && (a = n[c].height);
    return a;
  }
  function s(n, a, c) {
    var m;
    if (c)
      m = c;
    else if (typeof document < "u")
      m = document.createElement("canvas").getContext("2d");
    else
      return 0;
    m.font = a.fontOptions + " " + a.fontSize + "px " + a.font;
    var v = m.measureText(n);
    if (!v)
      return 0;
    var h = v.width;
    return h;
  }
  return We.getMaximumHeightOfEncodings = l, We.getEncodingHeight = r, We.getBarcodePadding = d, We.calculateEncodingAttributes = f, We.getTotalWidthOfEncodings = i, We;
}
var ji;
function Oh() {
  if (ji) return Xn;
  ji = 1, Object.defineProperty(Xn, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function l(s, n) {
      for (var a = 0; a < n.length; a++) {
        var c = n[a];
        c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(s, c.key, c);
      }
    }
    return function(s, n, a) {
      return n && l(s.prototype, n), a && l(s, a), s;
    };
  }(), t = bo(), o = d(t), r = Fa();
  function d(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function f(l, s) {
    if (!(l instanceof s))
      throw new TypeError("Cannot call a class as a function");
  }
  var i = function() {
    function l(s, n, a) {
      f(this, l), this.canvas = s, this.encodings = n, this.options = a;
    }
    return e(l, [{
      key: "render",
      value: function() {
        if (!this.canvas.getContext)
          throw new Error("The browser does not support canvas.");
        this.prepareCanvas();
        for (var n = 0; n < this.encodings.length; n++) {
          var a = (0, o.default)(this.options, this.encodings[n].options);
          this.drawCanvasBarcode(a, this.encodings[n]), this.drawCanvasText(a, this.encodings[n]), this.moveCanvasDrawing(this.encodings[n]);
        }
        this.restoreCanvas();
      }
    }, {
      key: "prepareCanvas",
      value: function() {
        var n = this.canvas.getContext("2d");
        n.save(), (0, r.calculateEncodingAttributes)(this.encodings, this.options, n);
        var a = (0, r.getTotalWidthOfEncodings)(this.encodings), c = (0, r.getMaximumHeightOfEncodings)(this.encodings);
        this.canvas.width = a + this.options.marginLeft + this.options.marginRight, this.canvas.height = c, n.clearRect(0, 0, this.canvas.width, this.canvas.height), this.options.background && (n.fillStyle = this.options.background, n.fillRect(0, 0, this.canvas.width, this.canvas.height)), n.translate(this.options.marginLeft, 0);
      }
    }, {
      key: "drawCanvasBarcode",
      value: function(n, a) {
        var c = this.canvas.getContext("2d"), m = a.data, v;
        n.textPosition == "top" ? v = n.marginTop + n.fontSize + n.textMargin : v = n.marginTop, c.fillStyle = n.lineColor;
        for (var h = 0; h < m.length; h++) {
          var _ = h * n.width + a.barcodePadding;
          m[h] === "1" ? c.fillRect(_, v, n.width, n.height) : m[h] && c.fillRect(_, v, n.width, n.height * m[h]);
        }
      }
    }, {
      key: "drawCanvasText",
      value: function(n, a) {
        var c = this.canvas.getContext("2d"), m = n.fontOptions + " " + n.fontSize + "px " + n.font;
        if (n.displayValue) {
          var v, h;
          n.textPosition == "top" ? h = n.marginTop + n.fontSize - n.textMargin : h = n.height + n.textMargin + n.marginTop + n.fontSize, c.font = m, n.textAlign == "left" || a.barcodePadding > 0 ? (v = 0, c.textAlign = "left") : n.textAlign == "right" ? (v = a.width - 1, c.textAlign = "right") : (v = a.width / 2, c.textAlign = "center"), c.fillText(a.text, v, h);
        }
      }
    }, {
      key: "moveCanvasDrawing",
      value: function(n) {
        var a = this.canvas.getContext("2d");
        a.translate(n.width, 0);
      }
    }, {
      key: "restoreCanvas",
      value: function() {
        var n = this.canvas.getContext("2d");
        n.restore();
      }
    }]), l;
  }();
  return Xn.default = i, Xn;
}
var Jn = {}, zi;
function Rh() {
  if (zi) return Jn;
  zi = 1, Object.defineProperty(Jn, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function s(n, a) {
      for (var c = 0; c < a.length; c++) {
        var m = a[c];
        m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(n, m.key, m);
      }
    }
    return function(n, a, c) {
      return a && s(n.prototype, a), c && s(n, c), n;
    };
  }(), t = bo(), o = d(t), r = Fa();
  function d(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function f(s, n) {
    if (!(s instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  var i = "http://www.w3.org/2000/svg", l = function() {
    function s(n, a, c) {
      f(this, s), this.svg = n, this.encodings = a, this.options = c, this.document = c.xmlDocument || document;
    }
    return e(s, [{
      key: "render",
      value: function() {
        var a = this.options.marginLeft;
        this.prepareSVG();
        for (var c = 0; c < this.encodings.length; c++) {
          var m = this.encodings[c], v = (0, o.default)(this.options, m.options), h = this.createGroup(a, v.marginTop, this.svg);
          this.setGroupOptions(h, v), this.drawSvgBarcode(h, v, m), this.drawSVGText(h, v, m), a += m.width;
        }
      }
    }, {
      key: "prepareSVG",
      value: function() {
        for (; this.svg.firstChild; )
          this.svg.removeChild(this.svg.firstChild);
        (0, r.calculateEncodingAttributes)(this.encodings, this.options);
        var a = (0, r.getTotalWidthOfEncodings)(this.encodings), c = (0, r.getMaximumHeightOfEncodings)(this.encodings), m = a + this.options.marginLeft + this.options.marginRight;
        this.setSvgAttributes(m, c), this.options.background && this.drawRect(0, 0, m, c, this.svg).setAttribute("style", "fill:" + this.options.background + ";");
      }
    }, {
      key: "drawSvgBarcode",
      value: function(a, c, m) {
        var v = m.data, h;
        c.textPosition == "top" ? h = c.fontSize + c.textMargin : h = 0;
        for (var _ = 0, b = 0, y = 0; y < v.length; y++)
          b = y * c.width + m.barcodePadding, v[y] === "1" ? _++ : _ > 0 && (this.drawRect(b - c.width * _, h, c.width * _, c.height, a), _ = 0);
        _ > 0 && this.drawRect(b - c.width * (_ - 1), h, c.width * _, c.height, a);
      }
    }, {
      key: "drawSVGText",
      value: function(a, c, m) {
        var v = this.document.createElementNS(i, "text");
        if (c.displayValue) {
          var h, _;
          v.setAttribute("style", "font:" + c.fontOptions + " " + c.fontSize + "px " + c.font), c.textPosition == "top" ? _ = c.fontSize - c.textMargin : _ = c.height + c.textMargin + c.fontSize, c.textAlign == "left" || m.barcodePadding > 0 ? (h = 0, v.setAttribute("text-anchor", "start")) : c.textAlign == "right" ? (h = m.width - 1, v.setAttribute("text-anchor", "end")) : (h = m.width / 2, v.setAttribute("text-anchor", "middle")), v.setAttribute("x", h), v.setAttribute("y", _), v.appendChild(this.document.createTextNode(m.text)), a.appendChild(v);
        }
      }
    }, {
      key: "setSvgAttributes",
      value: function(a, c) {
        var m = this.svg;
        m.setAttribute("width", a + "px"), m.setAttribute("height", c + "px"), m.setAttribute("x", "0px"), m.setAttribute("y", "0px"), m.setAttribute("viewBox", "0 0 " + a + " " + c), m.setAttribute("xmlns", i), m.setAttribute("version", "1.1"), m.setAttribute("style", "transform: translate(0,0)");
      }
    }, {
      key: "createGroup",
      value: function(a, c, m) {
        var v = this.document.createElementNS(i, "g");
        return v.setAttribute("transform", "translate(" + a + ", " + c + ")"), m.appendChild(v), v;
      }
    }, {
      key: "setGroupOptions",
      value: function(a, c) {
        a.setAttribute("style", "fill:" + c.lineColor + ";");
      }
    }, {
      key: "drawRect",
      value: function(a, c, m, v, h) {
        var _ = this.document.createElementNS(i, "rect");
        return _.setAttribute("x", a), _.setAttribute("y", c), _.setAttribute("width", m), _.setAttribute("height", v), h.appendChild(_), _;
      }
    }]), s;
  }();
  return Jn.default = l, Jn;
}
var eo = {}, Ui;
function $h() {
  if (Ui) return eo;
  Ui = 1, Object.defineProperty(eo, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function r(d, f) {
      for (var i = 0; i < f.length; i++) {
        var l = f[i];
        l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(d, l.key, l);
      }
    }
    return function(d, f, i) {
      return f && r(d.prototype, f), i && r(d, i), d;
    };
  }();
  function t(r, d) {
    if (!(r instanceof d))
      throw new TypeError("Cannot call a class as a function");
  }
  var o = function() {
    function r(d, f, i) {
      t(this, r), this.object = d, this.encodings = f, this.options = i;
    }
    return e(r, [{
      key: "render",
      value: function() {
        this.object.encodings = this.encodings;
      }
    }]), r;
  }();
  return eo.default = o, eo;
}
var Bi;
function xh() {
  if (Bi) return Qn;
  Bi = 1, Object.defineProperty(Qn, "__esModule", {
    value: !0
  });
  var e = Oh(), t = i(e), o = Rh(), r = i(o), d = $h(), f = i(d);
  function i(l) {
    return l && l.__esModule ? l : { default: l };
  }
  return Qn.default = { CanvasRenderer: t.default, SVGRenderer: r.default, ObjectRenderer: f.default }, Qn;
}
var Ut = {}, Gi;
function ja() {
  if (Gi) return Ut;
  Gi = 1, Object.defineProperty(Ut, "__esModule", {
    value: !0
  });
  function e(i, l) {
    if (!(i instanceof l))
      throw new TypeError("Cannot call a class as a function");
  }
  function t(i, l) {
    if (!i)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return l && (typeof l == "object" || typeof l == "function") ? l : i;
  }
  function o(i, l) {
    if (typeof l != "function" && l !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof l);
    i.prototype = Object.create(l && l.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), l && (Object.setPrototypeOf ? Object.setPrototypeOf(i, l) : i.__proto__ = l);
  }
  var r = function(i) {
    o(l, i);
    function l(s, n) {
      e(this, l);
      var a = t(this, (l.__proto__ || Object.getPrototypeOf(l)).call(this));
      return a.name = "InvalidInputException", a.symbology = s, a.input = n, a.message = '"' + a.input + '" is not a valid input for ' + a.symbology, a;
    }
    return l;
  }(Error), d = function(i) {
    o(l, i);
    function l() {
      e(this, l);
      var s = t(this, (l.__proto__ || Object.getPrototypeOf(l)).call(this));
      return s.name = "InvalidElementException", s.message = "Not supported type to render on", s;
    }
    return l;
  }(Error), f = function(i) {
    o(l, i);
    function l() {
      e(this, l);
      var s = t(this, (l.__proto__ || Object.getPrototypeOf(l)).call(this));
      return s.name = "NoElementException", s.message = "No element to render on.", s;
    }
    return l;
  }(Error);
  return Ut.InvalidInputException = r, Ut.InvalidElementException = d, Ut.NoElementException = f, Ut;
}
var qi;
function Lh() {
  if (qi) return Yn;
  qi = 1, Object.defineProperty(Yn, "__esModule", {
    value: !0
  });
  var e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
    return typeof a;
  } : function(a) {
    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, t = Mh(), o = i(t), r = xh(), d = i(r), f = ja();
  function i(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function l(a) {
    if (typeof a == "string")
      return s(a);
    if (Array.isArray(a)) {
      for (var c = [], m = 0; m < a.length; m++)
        c.push(l(a[m]));
      return c;
    } else {
      if (typeof HTMLCanvasElement < "u" && a instanceof HTMLImageElement)
        return n(a);
      if (a && a.nodeName && a.nodeName.toLowerCase() === "svg" || typeof SVGElement < "u" && a instanceof SVGElement)
        return {
          element: a,
          options: (0, o.default)(a),
          renderer: d.default.SVGRenderer
        };
      if (typeof HTMLCanvasElement < "u" && a instanceof HTMLCanvasElement)
        return {
          element: a,
          options: (0, o.default)(a),
          renderer: d.default.CanvasRenderer
        };
      if (a && a.getContext)
        return {
          element: a,
          renderer: d.default.CanvasRenderer
        };
      if (a && (typeof a > "u" ? "undefined" : e(a)) === "object" && !a.nodeName)
        return {
          element: a,
          renderer: d.default.ObjectRenderer
        };
      throw new f.InvalidElementException();
    }
  }
  function s(a) {
    var c = document.querySelectorAll(a);
    if (c.length !== 0) {
      for (var m = [], v = 0; v < c.length; v++)
        m.push(l(c[v]));
      return m;
    }
  }
  function n(a) {
    var c = document.createElement("canvas");
    return {
      element: c,
      options: (0, o.default)(a),
      renderer: d.default.CanvasRenderer,
      afterRender: function() {
        a.setAttribute("src", c.toDataURL());
      }
    };
  }
  return Yn.default = l, Yn;
}
var to = {}, Di;
function Vh() {
  if (Di) return to;
  Di = 1, Object.defineProperty(to, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function r(d, f) {
      for (var i = 0; i < f.length; i++) {
        var l = f[i];
        l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(d, l.key, l);
      }
    }
    return function(d, f, i) {
      return f && r(d.prototype, f), i && r(d, i), d;
    };
  }();
  function t(r, d) {
    if (!(r instanceof d))
      throw new TypeError("Cannot call a class as a function");
  }
  var o = function() {
    function r(d) {
      t(this, r), this.api = d;
    }
    return e(r, [{
      key: "handleCatch",
      value: function(f) {
        if (f.name === "InvalidInputException")
          if (this.api._options.valid !== this.api._defaults.valid)
            this.api._options.valid(!1);
          else
            throw f.message;
        else
          throw f;
        this.api.render = function() {
        };
      }
    }, {
      key: "wrapBarcodeCall",
      value: function(f) {
        try {
          var i = f.apply(void 0, arguments);
          return this.api._options.valid(!0), i;
        } catch (l) {
          return this.handleCatch(l), this.api;
        }
      }
    }]), r;
  }();
  return to.default = o, to;
}
var ko, Hi;
function Fh() {
  if (Hi) return ko;
  Hi = 1;
  var e = kh(), t = y(e), o = bo(), r = y(o), d = Nh(), f = y(d), i = Ah(), l = y(i), s = Lh(), n = y(s), a = La(), c = y(a), m = Vh(), v = y(m), h = ja(), _ = Va(), b = y(_);
  function y($) {
    return $ && $.__esModule ? $ : { default: $ };
  }
  var g = function() {
  }, I = function(q, J, X) {
    var U = new g();
    if (typeof q > "u")
      throw Error("No element to render on was provided.");
    return U._renderProperties = (0, n.default)(q), U._encodings = [], U._options = b.default, U._errorHandler = new v.default(U), typeof J < "u" && (X = X || {}, X.format || (X.format = k()), U.options(X)[X.format](J, X).render()), U;
  };
  I.getModule = function($) {
    return t.default[$];
  };
  for (var T in t.default)
    t.default.hasOwnProperty(T) && w(t.default, T);
  function w($, q) {
    g.prototype[q] = g.prototype[q.toUpperCase()] = g.prototype[q.toLowerCase()] = function(J, X) {
      var U = this;
      return U._errorHandler.wrapBarcodeCall(function() {
        X.text = typeof X.text > "u" ? void 0 : "" + X.text;
        var oe = (0, r.default)(U._options, X);
        oe = (0, c.default)(oe);
        var fe = $[q], ve = M(J, fe, oe);
        return U._encodings.push(ve), U;
      });
    };
  }
  function M($, q, J) {
    $ = "" + $;
    var X = new q($, J);
    if (!X.valid())
      throw new h.InvalidInputException(X.constructor.name, $);
    var U = X.encode();
    U = (0, f.default)(U);
    for (var oe = 0; oe < U.length; oe++)
      U[oe].options = (0, r.default)(J, U[oe].options);
    return U;
  }
  function k() {
    return t.default.CODE128 ? "CODE128" : Object.keys(t.default)[0];
  }
  g.prototype.options = function($) {
    return this._options = (0, r.default)(this._options, $), this;
  }, g.prototype.blank = function($) {
    var q = new Array($ + 1).join("0");
    return this._encodings.push({ data: q }), this;
  }, g.prototype.init = function() {
    if (this._renderProperties) {
      Array.isArray(this._renderProperties) || (this._renderProperties = [this._renderProperties]);
      var $;
      for (var q in this._renderProperties) {
        $ = this._renderProperties[q];
        var J = (0, r.default)(this._options, $.options);
        J.format == "auto" && (J.format = k()), this._errorHandler.wrapBarcodeCall(function() {
          var X = J.value, U = t.default[J.format.toUpperCase()], oe = M(X, U, J);
          L($, oe, J);
        });
      }
    }
  }, g.prototype.render = function() {
    if (!this._renderProperties)
      throw new h.NoElementException();
    if (Array.isArray(this._renderProperties))
      for (var $ = 0; $ < this._renderProperties.length; $++)
        L(this._renderProperties[$], this._encodings, this._options);
    else
      L(this._renderProperties, this._encodings, this._options);
    return this;
  }, g.prototype._defaults = b.default;
  function L($, q, J) {
    q = (0, f.default)(q);
    for (var X = 0; X < q.length; X++)
      q[X].options = (0, r.default)(J, q[X].options), (0, l.default)(q[X].options);
    (0, l.default)(J);
    var U = $.renderer, oe = new U($.element, q, J);
    oe.render(), $.afterRender && $.afterRender();
  }
  return typeof window < "u" && (window.JsBarcode = I), typeof jQuery < "u" && (jQuery.fn.JsBarcode = function($, q) {
    var J = [];
    return jQuery(this).each(function() {
      J.push(this);
    }), I(J, $, q);
  }), ko = I, ko;
}
var jh = Fh();
const zh = /* @__PURE__ */ oh(jh);
function Uh() {
  const e = Q("commClient");
  console.log(e);
  async function t(o, r) {
    return new Promise(async (d, f) => {
      console.log("Loading barcode with ID:", r), await e.executeMethodAsync("sw.PetrolBarcodeGet", {
        CodeId: r
      }).then(async (i) => {
        o && zh(o, i.BarcodeValue, {
          format: "CODE128",
          displayValue: !0,
          fontSize: 16,
          height: 60
        }), d(!0);
      }).catch((i) => {
        f(!1);
      });
    });
  }
  return {
    loadAndRenderBarcode: t
  };
}
const Bh = {
  class: "petrol-bar-code-component",
  ref: "rootRef"
}, Nb = /* @__PURE__ */ ie({
  __name: "petrol-barcode-component",
  props: {
    id: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, o = re(null), { loadAndRenderBarcode: r } = Uh();
    return me(async () => {
      console.log("Petrol barcode component mounted with ID:", t.id), await r(o.value, t.id);
    }), (d, f) => (S(), N("div", Bh, [
      (S(), N("svg", {
        ref_key: "barcode",
        ref: o
      }, null, 512))
    ], 512));
  }
}), Gh = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_41_5426)'%3e%3cpath%20d='M8.00004%2014.6666C11.6819%2014.6666%2014.6667%2011.6819%2014.6667%207.99998C14.6667%204.31808%2011.6819%201.33331%208.00004%201.33331C4.31814%201.33331%201.33337%204.31808%201.33337%207.99998C1.33337%2011.6819%204.31814%2014.6666%208.00004%2014.6666Z'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M8%2010.6667V8'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M8%205.33331H8.00667'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_41_5426'%3e%3crect%20width='16'%20height='16'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Yi = {
  isPoliticallyExposedPerson: void 0,
  politicalFunction: "",
  pioSourceFunds: "",
  pioFundsStatus: "",
  flowType: void 0
};
function qh(e) {
  const { t } = H();
  return F(() => ({
    isPoliticallyExposedPerson: {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), he)
    },
    pioSourceFunds: {
      required: j.withMessage(t("GlobalErrors.FieldRequired"), de(e.isPoliticallyExposedPerson))
    },
    pioFundsStatus: {
      required: j.withMessage(t("GlobalErrors.FieldRequired"), de(e.isPoliticallyExposedPerson))
    },
    politicalFunction: {
      required: j.withMessage(t("GlobalErrors.FieldRequired"), de(e.isPoliticallyExposedPerson))
    }
  }));
}
function Dh(e) {
  const { scrollToFirstError: t } = Ie(), o = be(qh(e), F(() => e), { $autoDirty: !0 });
  async function r() {
    return o.value.$touch(), o.value.$validate();
  }
  async function d(l) {
    e.isPoliticallyExposedPerson != l.isPoliticallyExposedPerson && (e.politicalFunction = "", e.pioSourceFunds = "", e.pioFundsStatus = "", o.value.politicalFunction.$reset(), o.value.pioSourceFunds.$reset(), o.value.pioFundsStatus.$reset());
  }
  function f() {
    t(".politically-exposed-person-component");
  }
  async function i(l) {
    let s = !1, n = null;
    switch (l) {
      case "validate":
        s = await r(), s && (n = { name: "valid" });
        break;
    }
    return n;
  }
  return {
    v$: o,
    dataChanged: d,
    navigationAction: i,
    scrollToFirstErrorWrapper: f
  };
}
const Hh = {
  class: "politically-exposed-person-component",
  ref: "rootRef"
}, Yh = { class: "form-label form-label--text d-flex align-center" }, Zh = { class: "form-label" }, Wh = { class: "form-label" }, Kh = { class: "form-label" }, Ab = /* @__PURE__ */ ie({
  __name: "politically-exposed-person-component",
  props: {
    data: { default: () => ({
      ...Yi
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o, i = W({ ...d.data });
    let l = { ...Yi }, s = re(!1);
    const {
      v$: n,
      navigationAction: a,
      dataChanged: c,
      scrollToFirstErrorWrapper: m
    } = Dh(i);
    return G(
      () => d.data,
      // Watch for changes in the data
      (v) => {
        Object.assign(i, v);
      },
      { deep: !0 }
    ), G(
      i,
      async (v) => {
        await c(l), Object.assign(l, v), f("update:data", v);
      },
      { deep: !0 }
    ), me(async () => {
      s.value = !0, f("componentReady");
    }), t({
      navigationAction: a,
      scrollToFirstErrorWrapper: m,
      componentReady: s
    }), (v, h) => {
      const _ = V("v-tooltip"), b = V("v-radio"), y = V("v-radio-group"), g = V("v-col"), I = V("v-row");
      return S(), N("div", Hh, [
        C(I, null, {
          default: P(() => [
            C(g, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", Yh, [
                    p("div", null, E(u(r)("Components.EmplymentInfoComponent.PoliticallyExposedPerson")), 1),
                    C(_, {
                      text: v.$t("Components.EmplymentInfoComponent.PoliticallyExposedPersonInfo"),
                      location: "bottom",
                      "close-on-content-click": !0,
                      "open-on-click": ""
                    }, {
                      activator: P(({ props: T }) => [
                        p("span", Ot({ class: "tag tag--white tag--icon ml-2" }, T), h[4] || (h[4] = [
                          p("img", {
                            src: Gh,
                            alt: "Info icon"
                          }, null, -1)
                        ]), 16)
                      ]),
                      _: 1
                    }, 8, ["text"])
                  ]),
                  C(y, {
                    modelValue: i.isPoliticallyExposedPerson,
                    "onUpdate:modelValue": h[0] || (h[0] = (T) => i.isPoliticallyExposedPerson = T),
                    error: u(n).isPoliticallyExposedPerson.error,
                    "error-messages": u(n).isPoliticallyExposedPerson.$errors[0] != null ? u(n).isPoliticallyExposedPerson.$errors[0].$message : "",
                    onFocus: u(n).isPoliticallyExposedPerson.$reset
                  }, {
                    default: P(() => [
                      C(b, {
                        label: u(r)("GeneralButtons.Yes"),
                        value: !0
                      }, null, 8, ["label"]),
                      C(b, {
                        label: u(r)("GeneralButtons.No"),
                        value: !1
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "error", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        i.isPoliticallyExposedPerson == !0 ? (S(), K(I, { key: 0 }, {
          default: P(() => [
            C(g, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", Zh, E(u(r)("Components.EmplymentInfoComponent.PoliticalFunction")), 1),
                  C(Pe, {
                    ref: "politicalFunctionRef",
                    modelValue: i.politicalFunction,
                    "onUpdate:modelValue": h[1] || (h[1] = (T) => i.politicalFunction = T),
                    "error-messages": u(n).politicalFunction.$errors[0] != null ? u(n).politicalFunction.$errors[0].$message : "",
                    onFocus: u(n).politicalFunction.$reset,
                    variant: "outlined"
                  }, null, 8, ["modelValue", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        i.isPoliticallyExposedPerson == !0 ? (S(), K(I, { key: 1 }, {
          default: P(() => [
            C(g, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", Wh, E(u(r)("Components.EmplymentInfoComponent.PIOSourceFunds")), 1),
                  C(Pe, {
                    ref: "pioSourceFundsRef",
                    modelValue: i.pioSourceFunds,
                    "onUpdate:modelValue": h[2] || (h[2] = (T) => i.pioSourceFunds = T),
                    "error-messages": u(n).pioSourceFunds.$errors[0] != null ? u(n).pioSourceFunds.$errors[0].$message : "",
                    onFocus: u(n).pioSourceFunds.$reset,
                    variant: "outlined",
                    hint: u(r)("Components.EmplymentInfoComponent.PIOSourceFundsInfo"),
                    "persistent-hint": ""
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "hint"])
                ])
              ]),
              _: 1
            }),
            C(g, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", Kh, E(u(r)("Components.EmplymentInfoComponent.PIOFundsStatus")), 1),
                  C(Pe, {
                    ref: "pioFundsStatusRef",
                    modelValue: i.pioFundsStatus,
                    "onUpdate:modelValue": h[3] || (h[3] = (T) => i.pioFundsStatus = T),
                    "error-messages": u(n).pioFundsStatus.$errors[0] != null ? u(n).pioFundsStatus.$errors[0].$message : "",
                    onFocus: u(n).pioFundsStatus.$reset,
                    variant: "outlined",
                    hint: u(r)("Components.EmplymentInfoComponent.PIOFundsStatusInfo"),
                    "persistent-hint": ""
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "hint"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0)
      ], 512);
    };
  }
}), Qh = {
  documentNumber: "",
  bindingFiles: [],
  flowType: void 0,
  partnerDiyType: void 0,
  contractSignatureType: void 0,
  isExistingUser: !1,
  prefilledData: !1
};
function Xh(e) {
  const { t } = H();
  return F(() => ({
    documentNumber: {
      customRequired: j.withMessage(t("GlobalErrors.FieldRequired"), de(e.flowType == R.POS))
    },
    bindingFiles: {
      customRequired: j.withMessage(t("GlobalErrors.FileAdd"), de(e.partnerDiyType == xt.POS_MOBILE && e.bindingFiles.length == 0))
    },
    contractSignatureType: {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), de(e.partnerDiyType !== xt.POS_MOBILE))
    }
  }));
}
function Jh(e) {
  const { scrollToFirstError: t } = Ie(), o = be(Xh(e), F(() => e), { $autoDirty: !0 });
  async function r() {
    return o.value.$touch(), await o.value.$validate();
  }
  function d() {
    t(".pos-info-component");
  }
  async function f(i) {
    let l = !1, s = null;
    switch (i) {
      case "validatecustomer":
      case "validate":
        l = await r(), l && (s = { name: "valid" });
        break;
    }
    return s;
  }
  return {
    navigationAction: f,
    scrollToFirstErrorWrapper: d,
    v$: o
  };
}
const e2 = {
  class: "pos-info-component",
  ref: "rootRef"
}, t2 = { class: "section-heading" }, n2 = { class: "form-label" }, o2 = { class: "form-label" }, r2 = { class: "form-label" }, Mb = /* @__PURE__ */ ie({
  __name: "pos-info-component",
  props: {
    data: { default: () => ({
      ...Qh
    }) }
  },
  emits: ["update:data", "navigationEvent", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o, i = W({ ...d.data }), { v$: l, navigationAction: s, scrollToFirstErrorWrapper: n } = Jh(i);
    let a = re(!1);
    return G(
      () => d.data,
      // Watch for changes in the data
      (c) => {
        Object.assign(i, c);
      },
      { deep: !0 }
    ), G(
      i,
      (c) => {
        f("update:data", c);
      },
      { deep: !0 }
    ), me(async () => {
      a.value = !0, f("componentReady");
    }), t({
      navigationAction: s,
      scrollToFirstErrorWrapper: n,
      componentReady: a
    }), (c, m) => {
      const v = V("v-col"), h = V("v-row"), _ = V("v-radio"), b = V("v-radio-group");
      return S(), N("div", e2, [
        p("h2", t2, E(u(r)("Components.PosInfoComponent.PosInfoTitle")), 1),
        C(h, null, {
          default: P(() => [
            C(v, null, {
              default: P(() => m[3] || (m[3] = [
                p("div", { class: "notification notification--notice" }, " Vnesite številko računa, predračuna ali naročila. Dokument lahko priložite tudi naknadno, v seznamu pogodb. ", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        C(h, null, {
          default: P(() => [
            C(v, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", n2, E(u(r)("Components.PosInfoComponent.InputTitle")), 1),
                  C(Pe, {
                    ref: "documentNumberRef",
                    modelValue: i.documentNumber,
                    "onUpdate:modelValue": m[0] || (m[0] = (y) => i.documentNumber = y),
                    "error-messages": u(l).documentNumber.$errors[0] != null ? u(l).documentNumber.$errors[0].$message : "",
                    onFocus: u(l).documentNumber.$reset,
                    variant: "outlined",
                    notPrefilled: !!((i.isExistingUser || i.prefilledData) && i.documentNumber == "")
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "notPrefilled"])
                ])
              ]),
              _: 1
            }),
            C(v, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", o2, E(u(r)("Components.PosInfoComponent.FormUploadTitle")), 1),
                  C(yo, {
                    ref: "fileUploadRef",
                    modelValue: i.bindingFiles,
                    "onUpdate:modelValue": m[1] || (m[1] = (y) => i.bindingFiles = y),
                    error: u(l).bindingFiles.$error,
                    errorText: u(l).bindingFiles.$errors[0] != null ? u(l).bindingFiles.$errors : [],
                    infoText: u(r)("Components.PosInfoComponent.FormUploadInfo")
                  }, null, 8, ["modelValue", "error", "errorText", "infoText"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        i.partnerDiyType !== u(xt).POS_MOBILE ? (S(), K(h, { key: 0 }, {
          default: P(() => [
            C(v, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", r2, E(u(r)("Components.PosInfoComponent.ContractSignature")), 1),
                  C(b, {
                    modelValue: i.contractSignatureType,
                    "onUpdate:modelValue": m[2] || (m[2] = (y) => i.contractSignatureType = y),
                    error: u(l).contractSignatureType.error,
                    "error-messages": u(l).contractSignatureType.$errors[0] != null ? u(l).contractSignatureType.$errors[0].$message : "",
                    onFocus: u(l).contractSignatureType.$reset
                  }, {
                    default: P(() => [
                      C(_, {
                        label: u(r)("Components.PosInfoComponent.SMS"),
                        value: u(qt).SMS
                      }, null, 8, ["label", "value"]),
                      C(_, {
                        label: u(r)("Components.PosInfoComponent.Tablet"),
                        value: u(qt).PodpisnaTablica
                      }, null, 8, ["label", "value"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "error", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0)
      ], 512);
    };
  }
}), i2 = {
  hasPermanentResidenceInSlovenia: void 0,
  isSlovenianCitizen: void 0,
  hasSlovenianIncome: void 0,
  hasSlovenianBankAccount: void 0,
  taxNumber: void 0,
  isCompanyTaxNumber: !1,
  headerTitle: "",
  headerSubtitle: "",
  summitDebt: 0,
  contractDebt: 0,
  contractDebtInstallments: 0,
  maxTriglavAmount: void 0,
  maxHitri: void 0,
  minSalary: void 0,
  minCredit: void 0,
  employmentType: void 0,
  isViewDataLoading: !1,
  flowType: void 0,
  //ni  na POSU
  orderToken: "",
  //ni  na POSU
  isExistingUser: !1,
  //ni  na POSU
  // isPreapproved: false,
  birthdate: void 0,
  employmentSubType: void 0,
  hasMultipleProducts: !1,
  showEmploymentType: !1,
  //dodano za createnewuserlimit
  msisdn: "",
  email: "",
  password: "",
  marketingSummit: !1
}, a2 = {
  currentCheckedTaxNumber: void 0,
  ageError: ""
};
function s2(e, t) {
  const { t: o } = H();
  function r() {
    if (e.taxNumber != null) {
      let s = e.taxNumber.toString();
      if (s.length == 8 && /^\d+$/.test(s) && s[0] != "0") {
        var l = parseInt(s[0]) * 8 + parseInt(s[1]) * 7 + parseInt(s[2]) * 6 + parseInt(s[3]) * 5 + parseInt(s[4]) * 4 + parseInt(s[5]) * 3 + parseInt(s[6]) * 2;
        if (l = l % 11, l = (11 - l) % 10, parseInt(s[7]) == l)
          return !0;
      }
    }
    return !1;
  }
  let d = () => {
    let l = /* @__PURE__ */ new Date(), s = new Date(e.birthdate), n = l.getFullYear() - s.getFullYear();
    return l.getMonth() > s.getMonth() || l.getMonth() === s.getMonth() && l.getDate() >= s.getDate() || n--, n < 18 ? (t.ageError = o("GlobalErrors.Age_limit"), !1) : (t.ageError = "", !0);
  };
  const f = () => e.flowType === R.SKLENI_SAM || e.flowType === R.WEB || e.flowType === R.LIMIT;
  return {
    validationRules: F(() => ({
      hasPermanentResidenceInSlovenia: {
        required: j.withMessage(o("GlobalErrors.ChoiceRequired"), he)
      },
      isSlovenianCitizen: {
        required: j.withMessage(o("GlobalErrors.ChoiceRequired"), he)
      },
      hasSlovenianIncome: {
        required: j.withMessage(o("GlobalErrors.ChoiceRequired"), he)
      },
      hasSlovenianBankAccount: {
        required: j.withMessage(o("GlobalErrors.ChoiceRequired"), de(e.isSlovenianCitizen == !1))
      },
      taxNumber: {
        required: j.withMessage(o("GlobalErrors.FieldRequired"), he),
        minPhoneNumberLength: j.withMessage(o("GlobalErrors.MinLength"), Ft(8)),
        maxPhoneNumberLength: j.withMessage(o("GlobalErrors.MaxLength"), Vt(8)),
        isValidNumber: j.withMessage(o("GlobalErrors.IsValidTaxNumber"), r)
      },
      birthdate: {
        required: j.withMessage(o("GlobalErrors.FieldRequired"), de(f)),
        customAge: j.withMessage(o("GlobalErrors.Age_limit"), () => f() ? d() : !0)
      }
    })),
    checkTaxNumber: r
  };
}
function l2(e, t) {
  const o = Q("commClient"), { scrollToFirstError: r } = Ie(), d = Q("navigationButtonsApi", null), { t: f } = H(), { validationRules: i } = s2(e, t), l = be(i, F(() => e), { $autoDirty: !0 });
  async function s() {
    return l.value.$touch(), l.value.$validate();
  }
  const n = F(() => [
    R.WEB,
    R.POS_MOBILE,
    R.SKLENI_SAM,
    R.POS_STRANKA,
    R.LIMIT
  ].includes(e.flowType) && e.isExistingUser);
  async function a() {
    return e.isViewDataLoading = !0, new Promise(async (b) => {
      await o.executeMethodAsync("IzpostavljenostCheckTaxNumber", {
        OrderToken: e.orderToken,
        DavcnaSt: e.taxNumber,
        EmploymentType: e.employmentType
      }).then(async (y) => {
        y ? y.ErrorText !== "" ? (e.headerSubtitle = y.ErrorText, b({ name: "endFail" })) : (t.currentCheckedTaxNumber = e.taxNumber, e.isCompanyTaxNumber = y.IsCompanyTax, e.maxHitri = y.MaxHitri, e.maxTriglavAmount = y.MaxTriglavAmount, e.minSalary = y.MinSalary, e.minCredit = y.MinCredit, e.summitDebt = y.Debt, e.contractDebt = y.ContractDebt, e.contractDebtInstallments = y.ContractDebtInstallments, !e.isExistingUser && e.flowType == R.LIMIT && await o.executeMethodAsync("CreateNewUserLimit", {
          OrderToken: e.orderToken,
          PhoneNumber: e.msisdn,
          Email: e.email,
          TaxNumber: e.taxNumber,
          Password: e.password,
          MarketingSummit: e.marketingSummit,
          Birthdate: e.birthdate
        }).then(async (g) => {
          g.Success || (e.headerTitle = "LimitPrecheckErrorTitle", e.headerSubtitle = g.Error, b({ name: "endFail" }));
        }), e.hasMultipleProducts ? (console.log("multi product flow"), b({ name: "nextStepMulti" })) : (console.log("single product flow"), b({ name: "nextStep" }))) : (e.headerSubtitle = "InternalError", b({ name: "endFail" }));
      });
    });
  }
  async function c() {
    return new Promise(async (b) => {
      await o.executeMethodAsync("DavcnaPravna", {
        OrderToken: e.orderToken,
        DavcnaSt: e.taxNumber
      }).then(async (y) => {
        y ? (e.showEmploymentType = !0, y.ErrorText !== "" ? (e.headerSubtitle = "InternalError", b({ name: "endFail" })) : e.isCompanyTaxNumber = y.IsCompanyTax) : (e.headerSubtitle = "InternalError", b({ name: "endFail" }));
      });
    });
  }
  function m() {
    var b;
    e.isCompanyTaxNumber = !1, e.showEmploymentType = !1, e.employmentType = void 0, e.employmentSubType = void 0, ((b = e.taxNumber) == null ? void 0 : b.toString().length) === 8 && c();
  }
  const v = F(() => {
    let b = "";
    return e.hasPermanentResidenceInSlovenia == !1 ? b = f("GlobalErrors.NoPermanentResidenceInSlovenia") : e.isSlovenianCitizen == !1 && e.hasSlovenianIncome == !1 && e.hasSlovenianBankAccount == !1 ? b = f("GlobalErrors.IsNotSlovenianCitizen") : e.isSlovenianCitizen == !1 && e.hasSlovenianIncome == !1 ? b = f("GlobalErrors.IsNotSlovenianCitizenAndNotEmployedInSlovenia") : e.isSlovenianCitizen == !1 && e.hasSlovenianBankAccount == !1 && (b = f("GlobalErrors.IsNotSlovenianCitizenAndHasNoSlovenianBankAccount")), b !== "" && d !== null ? d == null || d.setButtonDisabled("Next", !0) : d == null || d.setButtonDisabled("Next", !1), b;
  });
  function h() {
    r(".precheck-component");
  }
  async function _(b) {
    let y = !1, g = null;
    switch (b) {
      case "validate":
        y = await s(), y && (g = { name: "valid" });
        break;
      case "executePrecheck":
        y = await s(), y && (g = await a());
        break;
    }
    return g;
  }
  return {
    v$: l,
    precheckValidation: v,
    navigationAction: _,
    scrollToFirstErrorWrapper: h,
    checkCompanyTaxNumber: c,
    onTaxNumberChanged: m,
    shouldBeDisabled: n
  };
}
const u2 = {
  class: "precheck-component",
  ref: "rootRef"
}, d2 = { class: "form-label" }, c2 = { class: "form-label" }, m2 = { class: "form-label" }, f2 = { class: "form-label" }, p2 = {
  key: 0,
  class: "notification notification--warning"
}, v2 = { class: "form-label" }, h2 = { key: 0 }, y2 = { class: "form-label" }, _2 = {
  key: 0,
  class: "v-input--error"
}, g2 = { class: "v-input__details" }, b2 = { class: "v-messages" }, C2 = { class: "v-messages__message" }, Ob = /* @__PURE__ */ ie({
  __name: "precheck-component",
  props: {
    data: { default: () => ({
      ...i2
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o;
    let i = re(!1);
    const l = W({ ...d.data }), s = W({ ...a2 }), { v$: n, navigationAction: a, scrollToFirstErrorWrapper: c, precheckValidation: m, onTaxNumberChanged: v, shouldBeDisabled: h } = l2(l, s);
    return G(
      () => d.data,
      // Watch for changes in the data
      (_) => {
        Object.assign(l, _);
      },
      { deep: !0 }
    ), G(
      l,
      async (_) => {
        f("update:data", _);
      },
      { deep: !0 }
    ), G(() => l.employmentSubType, (_) => {
      _ === ut.SP ? l.employmentType = le.SP : _ !== ut.AfternoonSP && (l.employmentType = void 0);
    }), G(() => l.isCompanyTaxNumber, () => {
      l.flowType != R.WEB && !l.isExistingUser && (l.employmentSubType = void 0, l.employmentType = void 0);
    }), me(() => {
      v(), i.value = !0, f("componentReady");
    }), t({
      navigationAction: a,
      scrollToFirstErrorWrapper: c,
      componentReady: i
    }), (_, b) => {
      const y = V("v-radio"), g = V("v-radio-group"), I = V("v-col"), T = V("v-row"), w = V("Datepicker");
      return S(), N("div", u2, [
        C(T, null, {
          default: P(() => [
            C(I, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", d2, E(u(r)("Components.PrecheckComponent.HasPermanentResidenceInSlovenia")), 1),
                C(g, {
                  modelValue: l.hasPermanentResidenceInSlovenia,
                  "onUpdate:modelValue": b[0] || (b[0] = (M) => l.hasPermanentResidenceInSlovenia = M),
                  error: u(n).hasPermanentResidenceInSlovenia.error,
                  "error-messages": u(n).hasPermanentResidenceInSlovenia.$errors[0] != null ? u(n).hasPermanentResidenceInSlovenia.$errors[0].$message : "",
                  onFocus: u(n).hasPermanentResidenceInSlovenia.$reset
                }, {
                  default: P(() => [
                    C(y, {
                      label: u(r)("GeneralButtons.Yes"),
                      value: !0
                    }, null, 8, ["label"]),
                    C(y, {
                      label: u(r)("GeneralButtons.No"),
                      value: !1
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            }),
            C(I, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", c2, E(u(r)("Components.PrecheckComponent.IsSlovenianCitizen")), 1),
                C(g, {
                  modelValue: l.isSlovenianCitizen,
                  "onUpdate:modelValue": b[3] || (b[3] = (M) => l.isSlovenianCitizen = M),
                  error: u(n).isSlovenianCitizen.error,
                  "error-messages": u(n).isSlovenianCitizen.$errors[0] != null ? u(n).isSlovenianCitizen.$errors[0].$message : "",
                  onFocus: u(n).isSlovenianCitizen.$reset
                }, {
                  default: P(() => [
                    C(y, {
                      label: u(r)("GeneralButtons.Yes"),
                      value: !0,
                      onClick: b[1] || (b[1] = (M) => l.hasSlovenianBankAccount = void 0)
                    }, null, 8, ["label"]),
                    C(y, {
                      label: u(r)("GeneralButtons.No"),
                      value: !1,
                      onClick: b[2] || (b[2] = (M) => l.employmentType = void 0)
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        C(T, null, {
          default: P(() => [
            C(I, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", m2, E(u(r)("Components.PrecheckComponent.HasSlovenianIncome")), 1),
                C(g, {
                  modelValue: l.hasSlovenianIncome,
                  "onUpdate:modelValue": b[4] || (b[4] = (M) => l.hasSlovenianIncome = M),
                  error: u(n).hasSlovenianIncome.error,
                  "error-messages": u(n).hasSlovenianIncome.$errors[0] != null ? u(n).hasSlovenianIncome.$errors[0].$message : "",
                  onFocus: u(n).hasSlovenianIncome.$reset
                }, {
                  default: P(() => [
                    C(y, {
                      label: u(r)("GeneralButtons.Yes"),
                      value: !0
                    }, null, 8, ["label"]),
                    C(y, {
                      label: u(r)("GeneralButtons.No"),
                      value: !1
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            }),
            l.isSlovenianCitizen == !1 ? (S(), K(I, {
              key: 0,
              class: "v-col-12 v-col-md-6"
            }, {
              default: P(() => [
                p("div", null, [
                  p("label", f2, E(u(r)("Components.PrecheckComponent.HasSlovenianBankAccount")), 1),
                  C(g, {
                    modelValue: l.hasSlovenianBankAccount,
                    "onUpdate:modelValue": b[5] || (b[5] = (M) => l.hasSlovenianBankAccount = M),
                    error: u(n).hasSlovenianBankAccount.error,
                    "error-messages": u(n).hasSlovenianBankAccount.$errors[0] != null ? u(n).hasSlovenianBankAccount.$errors[0].$message : "",
                    onFocus: u(n).hasSlovenianBankAccount.$reset
                  }, {
                    default: P(() => [
                      C(y, {
                        label: u(r)("GeneralButtons.Yes"),
                        value: !0
                      }, null, 8, ["label"]),
                      C(y, {
                        label: u(r)("GeneralButtons.No"),
                        value: !1
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "error", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            })) : x("", !0)
          ]),
          _: 1
        }),
        u(m) != "" ? (S(), N("div", p2, E(u(m)), 1)) : x("", !0),
        b[8] || (b[8] = p("hr", { class: "mb-8 mt-4 hr" }, null, -1)),
        C(T, null, {
          default: P(() => [
            C(I, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", v2, E(u(r)("Components.PrecheckComponent.TaxNumber")), 1),
                C(Te, {
                  ref: "taxNumberRef",
                  modelValue: l.taxNumber,
                  "onUpdate:modelValue": b[6] || (b[6] = (M) => l.taxNumber = M),
                  error: u(n).taxNumber.error,
                  maxLength: 8,
                  "error-messages": u(n).taxNumber.$errors[0] != null ? u(n).taxNumber.$errors[0].$message : "",
                  onInput: u(v),
                  disabled: u(h),
                  variant: "outlined"
                }, null, 8, ["modelValue", "error", "error-messages", "onInput", "disabled"])
              ]),
              _: 1
            }),
            C(I, null, {
              default: P(() => [
                l.flowType === u(R).SKLENI_SAM || l.flowType === u(R).WEB || l.flowType === u(R).LIMIT ? (S(), N("div", h2, [
                  p("label", y2, E(u(r)("Components.IdentificationDataComponent.Birthdate")), 1),
                  C(w, {
                    modelValue: l.birthdate,
                    "onUpdate:modelValue": b[7] || (b[7] = (M) => l.birthdate = M),
                    maxDate: /* @__PURE__ */ new Date(),
                    enableTimePicker: !1,
                    autoApply: "",
                    position: "right",
                    locale: "sl",
                    textInput: "",
                    format: "d.M.yyyy",
                    class: Le(u(n).birthdate.$errors[0] ? "v-input--error" : "")
                  }, null, 8, ["modelValue", "maxDate", "class"]),
                  u(n).birthdate.$errors[0] || s.ageError != "" ? (S(), N("div", _2, [
                    p("div", g2, [
                      p("div", b2, [
                        p("div", C2, E(s.ageError != "" ? s.ageError : u(n).birthdate.$errors[0].$message), 1)
                      ])
                    ])
                  ])) : x("", !0)
                ])) : x("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 512);
    };
  }
}), I2 = {
  creditAmount: null,
  proformaFile: [],
  isVehiclesFinancing: !1,
  flowType: void 0,
  proformaPartnerType: "",
  headerSubtitle: "",
  isViewDataLoading: !1
}, E2 = {
  PartnerName: "",
  AvtoBroker: !1
};
function S2(e, t) {
  const { t: o } = H();
  return F(() => ({
    creditAmount: {
      required: j.withMessage(o("GlobalErrors.FieldRequired"), he),
      minValue: j.withMessage(o("GlobalErrors.MinValue", { value: "100,00" }), id(100)),
      maxValue: j.withMessage(o("GlobalErrors.MaxValue", { value: "15.000,00" }), sd(15e3))
    },
    proformaFile: {
      required: j.withMessage(o("GlobalErrors.FileAdd"), () => e.proformaFile.length > 0)
    },
    isVehiclesFinancing: {
      custom: j.withMessage(o("GlobalErrors.ChoiceRequired"), (r) => !t.AvtoBroker || r === !0)
    }
  }));
}
function P2(e, t) {
  const o = Q("commClient"), r = be(S2(e, t), F(() => e), { $autoDirty: !0 }), { scrollToFirstError: d } = Ie();
  async function f() {
    return r.value.$touch(), r.value.$validate();
  }
  function i() {
    d(".proforma-payment-component");
  }
  async function l() {
    e.isViewDataLoading = !0;
    let a = "";
    e.proformaFile.length > 0 && (a.length > 0 && (a += ";"), a += e.proformaFile.map((m) => m.FileId).join(";"));
    const c = await o.executeMethodAsync("CreateWebOrderSupplier", {
      ProformaInvoice: a,
      Amount: e.creditAmount,
      DobType: e.proformaPartnerType
    });
    return c.Success === !0 ? { name: "nextStep", params: { id: c.OrderToken } } : (e.headerSubtitle = "InternalError", { name: "endFail" });
  }
  async function s() {
    if (console.log("Loading proforma data for partner type:", e.proformaPartnerType), e.proformaPartnerType != null && e.proformaPartnerType !== "") {
      e.isViewDataLoading = !0;
      const a = await o.executeMethodAsync("sw.ProformaDataLoad", {
        DobType: e.proformaPartnerType
      });
      a && (console.log("Proforma data loaded:", a), t.PartnerName = a.PartnerName, t.AvtoBroker = a.AvtoBroker);
    } else
      t.PartnerName = "", t.AvtoBroker = !0;
    return !0;
  }
  async function n(a) {
    let c = !1, m = null;
    switch (a) {
      case "webNext":
        c = await f(), c && (m = await l());
        break;
    }
    return m;
  }
  return {
    v$: r,
    navigationAction: n,
    loadProformaData: s,
    scrollToFirstErrorWrapper: i
  };
}
const T2 = {
  class: "proforma-invoice-component",
  ref: "rootRef"
}, w2 = { class: "form-label" }, k2 = { class: "form-label" }, N2 = { class: "" }, Rb = /* @__PURE__ */ ie({
  __name: "proforma-payment-component",
  props: {
    data: { default: () => ({
      ...I2
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o;
    let i = re(!1);
    const l = W({ ...E2 }), s = W({ ...d.data }), { v$: n, navigationAction: a, loadProformaData: c, scrollToFirstErrorWrapper: m } = P2(s, l);
    return G(
      () => d.data,
      // Watch for changes in the data
      (v) => {
        Object.assign(s, v);
      },
      { deep: !0 }
    ), G(
      s,
      (v) => {
        f("update:data", v);
      },
      { deep: !0 }
    ), me(async () => {
      await c(), i.value = !0, f("componentReady");
    }), t({
      navigationAction: a,
      scrollToFirstErrorWrapper: m,
      componentReady: i
    }), (v, h) => {
      const _ = V("v-col"), b = V("v-row"), y = V("v-checkbox");
      return S(), N("div", T2, [
        C(b, null, {
          default: P(() => [
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", w2, E(u(r)("Components.ProformaPaymentComponent.CreditAmount")), 1),
                C(Te, {
                  ref: "creditAmountRef",
                  modelValue: s.creditAmount,
                  "onUpdate:modelValue": h[0] || (h[0] = (g) => s.creditAmount = g),
                  numberOfDecimals: 2,
                  appendText: "EUR",
                  "error-messages": u(n).creditAmount.$errors[0] != null ? u(n).creditAmount.$errors[0].$message : "",
                  formatNumber: (g, I) => g.toLocaleString("sl-SI", { minimumFractionDigits: I, maximumFractionDigits: I })
                }, null, 8, ["modelValue", "error-messages", "formatNumber"])
              ]),
              _: 1
            }),
            C(_, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", k2, E(u(r)("Components.ProformaPaymentComponent.FileUpload")), 1),
                C(yo, {
                  modelValue: s.proformaFile,
                  "onUpdate:modelValue": h[1] || (h[1] = (g) => s.proformaFile = g),
                  error: u(n).proformaFile.$error,
                  errorText: u(n).proformaFile.$errors[0] != null ? u(n).proformaFile.$errors : [],
                  infoText: v.$t("Components.ProformaPaymentComponent.Files")
                }, null, 8, ["modelValue", "error", "errorText", "infoText"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        l.AvtoBroker ? (S(), K(b, { key: 0 }, {
          default: P(() => [
            C(_, null, {
              default: P(() => [
                p("div", N2, [
                  C(y, {
                    modelValue: s.isVehiclesFinancing,
                    "onUpdate:modelValue": h[2] || (h[2] = (g) => s.isVehiclesFinancing = g),
                    "error-messages": u(n).isVehiclesFinancing.$errors[0] != null ? u(n).isVehiclesFinancing.$errors[0].$message : "",
                    onFocus: u(n).isVehiclesFinancing.$reset,
                    label: u(r)("Components.ProformaPaymentComponent.VechilesFinancing")
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "label"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0)
      ], 512);
    };
  }
}), A2 = {
  temporaryCitizen: void 0,
  countrySourceFunds: "",
  countryFundsStatus: "",
  flowType: void 0,
  isViewDataLoading: !1,
  citizen: void 0,
  hasTemporaryResidence: void 0
}, M2 = {
  riskCountryType: ""
};
function O2(e, t) {
  const { t: o } = H(), r = Q("generalStore"), d = F(() => {
    if (t.riskCountryType == "temporary" && e.temporaryCitizen != null) {
      const l = r.state.countryList.find((s) => e.temporaryCitizen == s.Key);
      return l != null && l.AdditionalData != null && l.AdditionalData != null && l.AdditionalData.RiskDrzava == !0;
    }
    return !1;
  }), f = F(() => t.riskCountryType == "permanent" && e.citizen != null && i.value != null && i.value.AdditionalData.RiskDrzava == !0), i = F(() => {
    var l;
    return (l = r.state.countryList) == null ? void 0 : l.find((s) => e.citizen === s.Key);
  });
  return F(() => ({
    countrySourceFunds: {
      required: j.withMessage(o("GlobalErrors.FIELD_REQUIRED"), de(() => d.value || f.value))
    },
    countryFundsStatus: {
      required: j.withMessage(o("GlobalErrors.FIELD_REQUIRED"), de(() => d.value || f.value))
    }
  }));
}
function R2(e, t) {
  const o = Q("generalStore"), { scrollToFirstError: r } = Ie(), d = be(O2(e, t), F(() => e), { $autoDirty: !0 });
  async function f() {
    return d.value.$touch(), await d.value.$validate();
  }
  const i = F(() => {
    if (t.riskCountryType == "temporary" && e.temporaryCitizen != null) {
      const c = o.state.countryList.find((m) => e.temporaryCitizen == m.Key);
      return c != null && c.AdditionalData != null && c.AdditionalData != null && c.AdditionalData.RiskDrzava == !0;
    }
    return !1;
  }), l = F(() => t.riskCountryType == "permanent" && e.citizen != null && s.value != null && s.value.AdditionalData.RiskDrzava == !0), s = F(() => {
    var c;
    return (c = o.state.countryList) == null ? void 0 : c.find((m) => e.citizen === m.Key);
  });
  function n() {
    r(".risk-country-component");
  }
  async function a(c) {
    let m = !1, v = null;
    switch (c) {
      case "validate":
        m = await f(), m && (v = { name: "valid" });
        break;
    }
    return v;
  }
  return {
    v$: d,
    getIsRiskCountry: i,
    navigationAction: a,
    scrollToFirstErrorWrapper: n,
    isRiskCountry: l
  };
}
const $2 = { class: "form-label" }, x2 = { class: "form-label" }, $b = /* @__PURE__ */ ie({
  __name: "risk-country-component",
  props: {
    data: { default: () => ({
      ...A2
    }) },
    riskCountryType: { default: "" }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o, i = W({ ...d.data }), l = re(null);
    let s = re(!1);
    const n = W({ ...M2 });
    n.riskCountryType = d.riskCountryType;
    const { v$: a, navigationAction: c, getIsRiskCountry: m, scrollToFirstErrorWrapper: v, isRiskCountry: h } = R2(i, n);
    return G(
      i,
      (_) => {
        f("update:data", { ..._ });
      },
      { deep: !0 }
    ), G(
      () => d.data,
      // Watch for changes in the data
      (_) => {
        Object.assign(i, _);
      },
      { deep: !0 }
    ), me(async () => {
      s.value = !0, f("componentReady");
    }), t({
      navigationAction: c,
      scrollToFirstErrorWrapper: v,
      componentReady: s
    }), (_, b) => {
      const y = V("v-col"), g = V("v-row");
      return S(), N("div", {
        class: "risk-country-component",
        ref_key: "rootRef",
        ref: l
      }, [
        u(h) || u(m) ? (S(), K(g, { key: 0 }, {
          default: P(() => [
            C(y, null, {
              default: P(() => b[2] || (b[2] = [
                p("div", { class: "notification notification--notice" }, [
                  p("span", { class: "font-weight-600" }, "Tvegane države (države z visokim tveganjem ter države s povečanim tveganjem)"),
                  ne(" so države, ki so jih bodisi Evropska komisija bodisi različne mednarodne organizacije uvrstile na seznam zaradi zaznanega visokega in povečanega tveganja za pojav pranja denarja ali financiranja terorizma. Seznam teh držav je objavljen na spletni strani Urada za preprečevanje pranja denarja. Za državljane teh držav oz. osebe s stalnim ali začasnim prebivališčem v teh državah smo zavezanci po ZPPDFT dolžni izvajati t.i. poglobljen pregled. ")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        u(h) || u(m) ? (S(), K(g, { key: 1 }, {
          default: P(() => [
            C(y, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", $2, E(u(r)("Components.AdditionalContactInfoComponent.CountrySourceFunds")), 1),
                  C(Pe, {
                    ref: "countrySourceFundsRef",
                    modelValue: i.countrySourceFunds,
                    "onUpdate:modelValue": b[0] || (b[0] = (I) => i.countrySourceFunds = I),
                    "error-messages": u(a).countrySourceFunds.$errors[0] != null ? u(a).countrySourceFunds.$errors[0].$message : "",
                    onFocus: u(a).countrySourceFunds.$reset,
                    variant: "outlined",
                    hint: u(r)("Components.AdditionalContactInfoComponent.CountrySourceFundsInfo"),
                    "persistent-hint": ""
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "hint"])
                ])
              ]),
              _: 1
            }),
            C(y, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", x2, E(u(r)("Components.AdditionalContactInfoComponent.CountryFundsStatus")), 1),
                  C(Pe, {
                    ref: "countryFundsStatusRef",
                    modelValue: i.countryFundsStatus,
                    "onUpdate:modelValue": b[1] || (b[1] = (I) => i.countryFundsStatus = I),
                    "error-messages": u(a).countryFundsStatus.$errors[0] != null ? u(a).countryFundsStatus.$errors[0].$message : "",
                    onFocus: u(a).countryFundsStatus.$reset,
                    variant: "outlined",
                    hint: u(r)("Components.AdditionalContactInfoComponent.CountryFundsStatusInfo"),
                    "persistent-hint": ""
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "hint"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0)
      ], 512);
    };
  }
}), Zi = {
  hasTemporaryResidence: void 0,
  temporaryCitizen: void 0,
  temporaryPostalCode: void 0,
  temporaryForeignPostalCode: "",
  temporaryAddress: "",
  flowType: void 0,
  isViewDataLoading: !1
};
function L2(e) {
  const { t } = H(), o = Q("generalStore");
  return F(() => ({
    hasTemporaryResidence: {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), he)
    },
    // temporaryCitizen: {
    //     customRequired: helpers.withMessage(t("GlobalErrors.ChoiceRequired"), requiredIf(componentData.hasTemporaryResidence == true)),
    // },
    // temporaryPostalCode: {
    //     customRequired: helpers.withMessage(t("GlobalErrors.ChoiceRequired"), requiredIf(componentData.hasTemporaryResidence == true)),
    // },
    // temporaryForeignPostalCode: {
    //     customRequired: helpers.withMessage(t("GlobalErrors.FIELD_REQUIRED"), requiredIf(componentData.hasTemporaryResidence == true && componentData.temporaryCitizen != generalStore.state.countryList![0].Key)),
    // },
    // temporaryAddress: {
    //     customRequired: helpers.withMessage(t("GlobalErrors.FIELD_REQUIRED"), requiredIf(componentData.hasTemporaryResidence == true)),
    // },
    temporaryCitizen: {
      customRequired: j.withMessage(t("GlobalErrors.ChoiceRequired"), de(() => e.hasTemporaryResidence === !0))
    },
    temporaryPostalCode: {
      customRequired: j.withMessage(t("GlobalErrors.ChoiceRequired"), de(() => e.hasTemporaryResidence === !0))
    },
    temporaryForeignPostalCode: {
      customRequired: j.withMessage(t("GlobalErrors.FIELD_REQUIRED"), de(() => e.hasTemporaryResidence === !0 && e.temporaryCitizen !== o.state.countryList[0].Key))
    },
    temporaryAddress: {
      customRequired: j.withMessage(t("GlobalErrors.FIELD_REQUIRED"), de(() => e.hasTemporaryResidence === !0))
    }
  }));
}
function V2(e) {
  const t = Q("generalStore"), { scrollToFirstError: o } = Ie(), r = be(L2(e), F(() => e), { $autoDirty: !0 });
  async function d() {
    return r.value.$touch(), await r.value.$validate();
  }
  const f = F(() => ![
    R.WEB,
    R.SKLENI_SAM,
    R.LIMIT
  ].includes(e.flowType));
  async function i(a) {
    e.hasTemporaryResidence != a.hasTemporaryResidence && e.hasTemporaryResidence == !1 && (e.temporaryAddress = "", e.temporaryPostalCode = void 0, e.temporaryCitizen = void 0, r.value.temporaryAddress.$reset(), r.value.temporaryPostalCode.$reset(), r.value.temporaryCitizen.$reset());
  }
  function l() {
    e.temporaryPostalCode == "9999" && e.temporaryCitizen == t.state.countryList[0].Key ? (e.temporaryPostalCode = void 0, r.value.TemporaryPostalCode.$reset()) : e.temporaryCitizen != t.state.countryList[0].Key && (e.temporaryPostalCode = t.state.postalCodeList[t.state.postalCodeList.length - 1].Key);
  }
  function s() {
    o(".temporary-residence-component");
  }
  async function n(a) {
    let c = !1, m = null;
    switch (a) {
      case "validate":
        console.log("Si v validate V temporary residence"), c = await d(), console.log("is VALID V temporary residence: ", c), c && (m = { name: "valid" });
        break;
      case "webNext":
        c = await d(), c && (e.isViewDataLoading = !0, m = { name: "nextStep" });
        break;
    }
    return m;
  }
  return {
    v$: r,
    dataChanged: i,
    navigationAction: n,
    CheckIfSloOrAbroad: l,
    scrollToFirstErrorWrapper: s,
    showHeading: f
  };
}
const F2 = {
  key: 0,
  class: "section-heading"
}, j2 = { class: "form-label form-label--text" }, z2 = { key: 0 }, U2 = { class: "form-label" }, B2 = { key: 0 }, G2 = { class: "form-label" }, q2 = { class: "form-label" }, D2 = { class: "form-label" }, xb = /* @__PURE__ */ ie({
  __name: "temporary-residence-component",
  props: {
    data: { default: () => ({
      ...Zi
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o, i = W({ ...d.data });
    let l = { ...Zi };
    const s = re(null);
    let n = re(!1);
    const { v$: a, navigationAction: c, dataChanged: m, CheckIfSloOrAbroad: v, scrollToFirstErrorWrapper: h, showHeading: _ } = V2(i);
    G(
      () => d.data,
      // Watch for changes in the data
      (y) => {
        Object.assign(i, y);
      },
      { deep: !0 }
    ), G(
      i,
      async (y) => {
        await m(l), Object.assign(l, y), f("update:data", y);
      },
      { deep: !0 }
    ), me(async () => {
      n.value = !0, f("componentReady");
    });
    const b = Q("generalStore");
    return t({
      navigationAction: c,
      scrollToFirstErrorWrapper: h,
      componentReady: n
    }), (y, g) => {
      const I = V("v-radio"), T = V("v-radio-group"), w = V("v-col"), M = V("v-row"), k = V("v-autocomplete");
      return S(), N("div", {
        class: "temporary-residence-component",
        ref_key: "rootRef",
        ref: s
      }, [
        u(_) ? (S(), N("h2", F2, E(u(r)("Components.AdditionalContactInfoComponent.AdditionalInfoTitle")), 1)) : x("", !0),
        C(M, null, {
          default: P(() => [
            C(w, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", j2, E(u(r)("Components.AdditionalContactInfoComponent.HasTemporaryResidence")), 1),
                  C(T, {
                    modelValue: i.hasTemporaryResidence,
                    "onUpdate:modelValue": g[0] || (g[0] = (L) => i.hasTemporaryResidence = L),
                    error: u(a).hasTemporaryResidence.error,
                    "error-messages": u(a).hasTemporaryResidence.$errors[0] != null ? u(a).hasTemporaryResidence.$errors[0].$message : "",
                    onFocus: u(a).hasTemporaryResidence.$reset
                  }, {
                    default: P(() => [
                      C(I, {
                        label: u(r)("GeneralButtons.Yes"),
                        value: !0
                      }, null, 8, ["label"]),
                      C(I, {
                        label: u(r)("GeneralButtons.No"),
                        value: !1
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "error", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        i.hasTemporaryResidence == !0 ? (S(), K(M, { key: 1 }, {
          default: P(() => [
            C(w, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                i.hasTemporaryResidence == !0 ? (S(), N("div", z2, [
                  p("label", U2, E(u(r)("Components.AdditionalContactInfoComponent.CountryTemporaryCitizen")), 1),
                  C(k, {
                    modelValue: i.temporaryCitizen,
                    "onUpdate:modelValue": [
                      g[1] || (g[1] = (L) => i.temporaryCitizen = L),
                      u(v)
                    ],
                    items: u(b).state.countryList,
                    "item-title": "Value",
                    "item-value": "Key",
                    variant: "outlined",
                    "error-messages": u(a).temporaryCitizen.$errors[0] != null ? u(a).temporaryCitizen.$errors[0].$message : "",
                    onFocus: u(a).temporaryCitizen.$reset
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "error-messages", "onFocus"])
                ])) : x("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        i.hasTemporaryResidence == !0 ? (S(), K(M, { key: 2 }, {
          default: P(() => [
            C(w, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                i.hasTemporaryResidence == !0 ? (S(), N("div", B2, [
                  p("label", G2, E(u(r)("Components.AdditionalContactInfoComponent.AddressTemporaryResidence")), 1),
                  C(Pe, {
                    ref: "temporaryAddressRef",
                    modelValue: i.temporaryAddress,
                    "onUpdate:modelValue": g[2] || (g[2] = (L) => i.temporaryAddress = L),
                    "error-messages": u(a).temporaryAddress.$errors[0] != null ? u(a).temporaryAddress.$errors[0].$message : "",
                    onFocus: u(a).temporaryAddress.$reset,
                    variant: "outlined"
                  }, null, 8, ["modelValue", "error-messages", "onFocus"])
                ])) : x("", !0)
              ]),
              _: 1
            }),
            i.temporaryCitizen == u(b).state.countryList[0].Key || i.temporaryCitizen == null ? (S(), K(w, {
              key: 0,
              class: "v-col-12 v-col-md-6"
            }, {
              default: P(() => [
                p("div", null, [
                  p("label", q2, E(u(r)("Components.AdditionalContactInfoComponent.PostalCodeTemporaryResidence")), 1),
                  C(k, {
                    modelValue: i.temporaryPostalCode,
                    "onUpdate:modelValue": g[3] || (g[3] = (L) => i.temporaryPostalCode = L),
                    items: u(b).state.postalCodeList,
                    "item-title": "Value",
                    "item-value": "Key",
                    variant: "outlined",
                    "error-messages": u(a).temporaryPostalCode.$errors[0] != null ? u(a).temporaryPostalCode.$errors[0].$message : "",
                    onFocus: u(a).temporaryPostalCode.$reset
                  }, null, 8, ["modelValue", "items", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            })) : (S(), K(w, {
              key: 1,
              class: "v-col-12 v-col-md-6"
            }, {
              default: P(() => [
                p("div", null, [
                  p("label", D2, E(u(r)("Components.AdditionalContactInfoComponent.PostalCodeTemporaryResidence")), 1),
                  C(Pe, {
                    ref: "temporaryForeignPostalCodeRef",
                    modelValue: i.temporaryForeignPostalCode,
                    "onUpdate:modelValue": g[4] || (g[4] = (L) => i.temporaryForeignPostalCode = L),
                    "error-messages": u(a).temporaryForeignPostalCode.$errors[0] != null ? u(a).temporaryForeignPostalCode.$errors[0].$message : "",
                    onFocus: u(a).temporaryForeignPostalCode.$reset,
                    variant: "outlined"
                  }, null, 8, ["modelValue", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            }))
          ]),
          _: 1
        })) : x("", !0)
      ], 512);
    };
  }
}), qo = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20%206L9%2017L4%2012'%20stroke='%2373A300'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", H2 = {
  contractSending: void 0,
  documentationSendType: void 0,
  flowType: void 0,
  hasTemporaryResidence: void 0,
  email: "",
  isEmailVerified: !1,
  taxNumber: void 0
}, Y2 = {
  externalResults: {},
  isEmailValidationSent: !1,
  emailVerificationSending: !1,
  emailVerifiedAtLoad: !1
};
function Z2(e) {
  const { t } = H();
  return {
    validationRules: F(() => ({
      contractSending: {
        required: j.withMessage(t("GlobalErrors.ChoiceRequired"), he)
      },
      documentationSendType: {
        customRequired: j.withMessage(t("GlobalErrors.FieldRequired"), de(e.contractSending == it.Posta && e.hasTemporaryResidence == !0))
      },
      email: {
        customEmail: j.withMessage(t("GlobalErrors.CorrectEmail"), nr),
        requiredIf: j.withMessage(t("GlobalErrors.FieldRequired"), de(e.contractSending == it.Elektronsko))
      }
    }))
  };
}
function W2(e, t) {
  const o = Q("commClient"), { scrollToFirstError: r } = Ie(), { validationRules: d } = Z2(e), f = be(d, F(() => e), { $autoDirty: !0, $externalResults: t.externalResults }), { t: i } = H();
  t.emailVerifiedAtLoad = e.isEmailVerified;
  async function l() {
    f.value.$touch(), t.externalResults.email = [];
    let v = await f.value.$validate();
    return v && e.contractSending === it.Elektronsko && (e.isEmailVerified || (v = !1, t.externalResults.email = [i("GlobalErrors.EmailNotVerified")])), v;
  }
  async function s() {
    return new Promise(async (v) => {
      t.emailVerificationSending = !0, await o.executeMethodAsync("SendEmailValidation", {
        Email: e.email,
        TaxNumber: e.taxNumber
      }).then(async (h) => {
        h && (t.isEmailValidationSent = !0, v(h.Success));
      }), t.emailVerificationSending = !1;
    });
  }
  async function n() {
    f.value.email.$touch(), t.externalResults.email = [], e.isEmailVerified || (e.email.length > 0 ? await f.value.email.$validate() && await s().then((h) => (h || (t.externalResults.email = ["Unknown error."]), h)) : t.externalResults.email = [i("GlobalErrors.FieldRequired")]);
  }
  async function a() {
    t.isEmailValidationSent = !1;
  }
  function c() {
    r(".signature-details-component");
  }
  async function m(v) {
    let h = !1, _ = null;
    switch (v) {
      case "validate":
        h = await l(), h && (_ = { name: "valid" });
        break;
    }
    return _;
  }
  return {
    v$: f,
    navigationAction: m,
    SendEmailValidationInternal: s,
    SendEmailValidation: n,
    ResetEmailValidation: a,
    scrollToFirstErrorWrapper: c
    // EmailVerified
  };
}
const K2 = {
  class: "signature-details-component",
  ref: "rootRef"
}, Q2 = { class: "section-heading" }, X2 = { class: "mb-2" }, J2 = { class: "form-label" }, ey = { class: "form-label" }, ty = { class: "control-email-wrapper" }, ny = { key: 2 }, oy = { class: "loader-small loader-sent" }, ry = { class: "loader-small mt-8" }, iy = { class: "mb-2" }, ay = { class: "form-label form-label--text" }, Lb = /* @__PURE__ */ ie({
  __name: "signature-details-component",
  props: {
    data: { default: () => ({
      ...H2
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o;
    let i = re(!1);
    const l = W({ ...d.data }), s = W({ ...Y2 }), { v$: n, navigationAction: a, SendEmailValidation: c, ResetEmailValidation: m, scrollToFirstErrorWrapper: v } = W2(l, s);
    return G(
      () => d.data,
      // Watch for changes in the data
      (h) => {
        Object.assign(l, h);
      },
      { deep: !0 }
    ), me(() => {
      i.value = !0, f("componentReady");
    }), G(
      l,
      (h) => {
        f("update:data", h);
      },
      { deep: !0 }
    ), t({
      navigationAction: a,
      componentReady: i,
      scrollToFirstErrorWrapper: v
    }), (h, _) => {
      const b = V("v-radio"), y = V("v-radio-group"), g = V("v-text-field"), I = V("v-btn"), T = V("v-tooltip"), w = V("v-col"), M = V("v-row");
      return S(), N("div", K2, [
        p("h2", Q2, E(u(r)("Components.SignatureDetailsComponent.SignatureDetailsTitle")), 1),
        p("div", X2, [
          p("label", J2, E(u(r)("Components.SignatureDetailsComponent.ContractSending")), 1),
          C(y, {
            modelValue: l.contractSending,
            "onUpdate:modelValue": _[0] || (_[0] = (k) => l.contractSending = k),
            error: u(n).contractSending.error,
            "error-messages": u(n).contractSending.$errors[0] != null ? u(n).contractSending.$errors[0].$message : "",
            onFocus: u(n).contractSending.$reset
          }, {
            default: P(() => [
              C(b, {
                label: u(r)("Components.SignatureDetailsComponent.ElectronicSignatureBtn"),
                value: u(it).Elektronsko
              }, null, 8, ["label", "value"]),
              C(b, {
                label: u(r)("Components.SignatureDetailsComponent.SendByPosteBtn"),
                value: u(it).Posta
              }, null, 8, ["label", "value"])
            ]),
            _: 1
          }, 8, ["modelValue", "error", "error-messages", "onFocus"])
        ]),
        l.contractSending == u(it).Elektronsko && !s.emailVerifiedAtLoad ? (S(), K(M, { key: 0 }, {
          default: P(() => [
            C(w, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", ey, E(u(r)("Components.IdentificationDataComponent.Email")), 1),
                p("div", ty, [
                  C(g, {
                    modelValue: l.email,
                    "onUpdate:modelValue": _[1] || (_[1] = (k) => l.email = k),
                    "error-messages": u(n).email.$errors[0] != null ? u(n).email.$errors[0].$message : "",
                    onFocus: u(n).email.$reset,
                    disabled: s.isEmailValidationSent || l.isEmailVerified,
                    variant: "outlined",
                    hint: s.isEmailValidationSent ? h.$t("Components.IdentificationDataComponent.EmailText") : "E-mail naslov je obvezen podatek, če želi stranka z vnosom nadaljevati sama.",
                    "persistent-hint": ""
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "disabled", "hint"]),
                  !s.isEmailValidationSent || l.isEmailVerified ? (S(), K(T, {
                    key: 0,
                    text: "Ob kliku na gumb Pošlji bo stranka prejela e-mail sporočilo s povezavo za verificiranje e-mail naslova.",
                    class: "",
                    location: "right",
                    "close-on-content-click": !0
                  }, {
                    activator: P(({ props: k }) => [
                      C(I, Ot(k, {
                        onClick: _[2] || (_[2] = (L) => u(c)()),
                        class: "btn btn--primary-outline btn--sm",
                        variant: "flat",
                        disabled: l.isEmailVerified
                      }), {
                        default: P(() => [
                          ne(E(u(r)("GeneralButtons.Send")), 1)
                        ]),
                        _: 2
                      }, 1040, ["disabled"])
                    ]),
                    _: 1
                  })) : (S(), K(I, Ot({ key: 1 }, d, {
                    onClick: _[3] || (_[3] = (k) => u(m)()),
                    class: "btn btn--primary-outline btn--sm",
                    variant: "flat",
                    disabled: l.isEmailVerified
                  }), {
                    default: P(() => [
                      ne(E(u(r)("GeneralButtons.EditEmail")), 1)
                    ]),
                    _: 1
                  }, 16, ["disabled"])),
                  (s.isEmailValidationSent || l.isEmailVerified) && !s.emailVerificationSending ? (S(), N("span", ny, _[5] || (_[5] = [
                    p("img", {
                      src: qo,
                      alt: "Success",
                      class: "icon-sent"
                    }, null, -1)
                  ]))) : x("", !0),
                  He(p("span", oy, _[6] || (_[6] = [
                    p("img", {
                      src: cn,
                      alt: "Loader"
                    }, null, -1)
                  ]), 512), [
                    [Ye, s.emailVerificationSending]
                  ])
                ])
              ]),
              _: 1
            }),
            C(w, null, {
              default: P(() => [
                He(p("span", ry, _[7] || (_[7] = [
                  p("img", {
                    src: cn,
                    alt: "Loader"
                  }, null, -1),
                  p("div", null, [
                    p("div", null, "Preverjamo, ali je stranka potrdila svoj e-mail naslov.")
                  ], -1)
                ]), 512), [
                  [Ye, s.isEmailValidationSent && !l.isEmailVerified]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        l.contractSending == u(it).Posta && l.hasTemporaryResidence == !0 ? (S(), K(M, {
          key: 1,
          justify: "space-between",
          "no-gutters": ""
        }, {
          default: P(() => [
            C(w, null, {
              default: P(() => [
                p("div", iy, [
                  p("label", ay, E(h.$t("Components.SignatureDetailsComponent.SendAddress")), 1),
                  C(y, {
                    modelValue: l.documentationSendType,
                    "onUpdate:modelValue": _[4] || (_[4] = (k) => l.documentationSendType = k),
                    error: u(n).documentationSendType.error,
                    "error-messages": u(n).documentationSendType.$errors[0] != null ? u(n).documentationSendType.$errors[0].$message : "",
                    onFocus: u(n).documentationSendType.$reset
                  }, {
                    default: P(() => [
                      C(b, {
                        label: u(r)("Components.SignatureDetailsComponent.PermanentBtn"),
                        value: u(Bo).PermanentResidence
                      }, null, 8, ["label", "value"]),
                      C(b, {
                        label: u(r)("Components.SignatureDetailsComponent.TemporaryBtn"),
                        value: u(Bo).TemporaryResidence
                      }, null, 8, ["label", "value"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "error", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            }),
            C(w, { class: "v-col-1 d-none d-md-block" }),
            C(w)
          ]),
          _: 1
        })) : x("", !0)
      ], 512);
    };
  }
}), sy = {
  email: void 0,
  phoneNumber: void 0,
  prefix: void 0,
  msisdn: void 0
}, ly = {
  showModal: !1,
  modalErrorMessage: null
};
function uy(e) {
  const { t } = H();
  return F(() => ({
    email: {
      emailOrPhoneRequired: j.withMessage(t("GlobalErrors.FieldRequired"), () => {
        const o = e.email != null && e.email !== "", r = e.prefix != null && e.phoneNumber != null;
        return o || r;
      }),
      emailFormat: j.withMessage(t("GlobalErrors.CorrectEmail"), () => e.email === void 0 || e.email === "" ? !0 : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.email))
    },
    prefix: {
      emailOrPhoneRequired: j.withMessage(t("GlobalErrors.FieldRequired"), () => {
        const o = e.email != null && e.email !== "", r = e.prefix != null && e.phoneNumber != null;
        return o || r;
      })
    },
    phoneNumber: {
      emailOrPhoneRequired: j.withMessage(t("GlobalErrors.FieldRequired"), () => {
        const o = e.email != null && e.email !== "", r = e.prefix != null && e.phoneNumber != null;
        return o || r;
      }),
      minLength: j.withMessage(t("GlobalErrors.CorrectPhoneNumber"), Ft(8)),
      maxLength: j.withMessage(t("GlobalErrors.CorrectPhoneNumber"), Vt(12))
    }
  }));
}
function dy(e, t, o) {
  const r = be(uy(e), F(() => e), { $autoDirty: !0 }), d = Q("commClient");
  function f() {
    r.value.email.$reset(), r.value.prefix.$reset(), r.value.phoneNumber.$reset(), t.modalErrorMessage = null, t.showModal = !0;
  }
  function i() {
    t.showModal = !1, t.modalErrorMessage = null, e.email = void 0, e.prefix = void 0, e.phoneNumber = void 0;
  }
  async function l() {
    var n;
    r.value.email.$touch(), r.value.prefix.$touch(), r.value.phoneNumber.$touch(), !(r.value.email.$invalid || r.value.prefix.$invalid || r.value.phoneNumber.$invalid) && (t.modalErrorMessage = null, e.email != null && e.email !== "" && await d.executeMethodAsync("SendLimitLinkEmail", {
      Email: e.email
    }).then((a) => {
      a.Success ? i() : t.modalErrorMessage = a.Error;
    }), e.phoneNumber != null && e.prefix != null && await d.executeMethodAsync("SendLimitLinkPhone", {
      PhoneNumber: ((n = e.prefix) == null ? void 0 : n.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString()
    }).then((a) => {
      a.Success ? i() : t.modalErrorMessage = a.Error;
    }), i());
  }
  async function s(n) {
    return n === "sendCalculation" && f(), null;
  }
  return {
    v$: r,
    sendCalculation: f,
    closeModalDialog: i,
    sendEmailOrPhone: l,
    navigationAction: s
  };
}
const cy = { class: "limit-calculation-send-component" }, my = {
  key: 0,
  class: "notification notification--warning mb-4"
}, fy = { class: "mb-4" }, py = { class: "form-label" }, vy = { class: "control-email-wrapper" }, hy = { class: "form-label" }, yy = { class: "control-phone-wrapper" }, Vb = /* @__PURE__ */ ie({
  __name: "limit-calculation-send-component",
  props: {
    data: { default: () => ({
      ...sy
    }) }
  },
  emits: ["update:data", "send"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o, { t: f } = H(), i = Q("generalStore"), l = W({ ...ly }), s = W({ ...r.data }), { v$: n, closeModalDialog: a, sendEmailOrPhone: c, navigationAction: m } = dy(s, l);
    return G(
      () => r.data,
      (v) => {
        Object.assign(s, v);
      },
      { deep: !0 }
    ), G(
      s,
      (v) => {
        d("update:data", v);
      },
      { deep: !0 }
    ), t({ navigationAction: m }), (v, h) => {
      const _ = V("v-text-field"), b = V("v-autocomplete"), y = V("v-col"), g = V("v-row");
      return S(), N("div", cy, [
        C(Ct, {
          display: l.showModal,
          showCloseXButton: !0,
          title: "Pošlji povezavo",
          showAcceptButton: !0,
          acceptText: "Pošlji",
          closeText: "Prekliči",
          showDeclineButton: !0,
          onAccept: u(c),
          onModalClosed: u(a)
        }, {
          default: P(() => [
            l.modalErrorMessage ? (S(), N("div", my, E(l.modalErrorMessage), 1)) : x("", !0),
            h[3] || (h[3] = p("div", { class: "mb-6" }, " Vnesite e-mail naslov ali mobilno številko na katero želite poslati povezavo za izračun limita. ", -1)),
            C(g, { class: "w-100" }, {
              default: P(() => [
                C(y, { class: "v-col-8" }, {
                  default: P(() => [
                    p("div", fy, [
                      p("label", py, E(u(f)("Components.IdentificationDataComponent.Email")), 1),
                      p("div", vy, [
                        C(_, {
                          modelValue: s.email,
                          "onUpdate:modelValue": h[0] || (h[0] = (I) => s.email = I),
                          variant: "outlined",
                          "persistent-hint": "",
                          "error-messages": u(n).email.$errors[0] != null ? u(n).email.$errors[0].$message : "",
                          onFocus: u(n).email.$reset
                        }, null, 8, ["modelValue", "error-messages", "onFocus"])
                      ])
                    ]),
                    p("div", null, [
                      p("label", hy, E(u(f)("Components.IdentificationDataComponent.PhoneNumber")), 1),
                      p("div", yy, [
                        C(b, {
                          modelValue: s.prefix,
                          "onUpdate:modelValue": h[1] || (h[1] = (I) => s.prefix = I),
                          items: u(i).state.countryPhoneList,
                          variant: "outlined",
                          class: "control-phone-country",
                          "return-object": !0,
                          "item-title": "Value",
                          "item-value": "Key",
                          "persistent-hint": "",
                          "error-messages": u(n).prefix.$errors[0] != null ? u(n).prefix.$errors[0].$message : "",
                          onFocus: u(n).prefix.$reset
                        }, null, 8, ["modelValue", "items", "error-messages", "onFocus"]),
                        C(Te, {
                          modelValue: s.phoneNumber,
                          "onUpdate:modelValue": h[2] || (h[2] = (I) => s.phoneNumber = I),
                          variant: "outlined",
                          class: "control-phone-number",
                          "error-messages": u(n).phoneNumber.$errors[0] != null ? u(n).phoneNumber.$errors[0].$message : "",
                          onFocus: u(n).phoneNumber.$reset
                        }, null, 8, ["modelValue", "error-messages", "onFocus"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["display", "onAccept", "onModalClosed"])
      ]);
    };
  }
}), _y = "data:image/png;base64,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", gy = {
  processEndTitle: "",
  processEndSubtitle: "",
  processEndIcon: ""
}, by = { class: "mt-16 text-center" }, Cy = { class: "section-heading mt-4 mb-4" }, Iy = { class: "section-heading__text" }, Fb = /* @__PURE__ */ ie({
  __name: "process-end-screen-component",
  props: {
    data: { default: () => ({
      ...gy
    }) }
  },
  emits: ["update:data", "navigation-event"],
  setup(e, { emit: t }) {
    const o = e, r = t, d = W({ ...o.data });
    return G(
      () => o.data,
      // Watch for changes in the data
      (f) => {
        Object.assign(d, f);
      },
      { deep: !0 }
    ), G(
      d,
      (f) => {
        r("update:data", f);
      },
      { deep: !0 }
    ), (f, i) => {
      const l = V("v-app-bar"), s = V("v-icon"), n = V("v-col"), a = V("v-row"), c = V("v-container"), m = V("v-main"), v = V("v-app");
      return S(), K(v, null, {
        default: P(() => [
          C(l, null, {
            default: P(() => i[0] || (i[0] = [
              p("div", null, [
                p("img", {
                  src: _y,
                  alt: "NLB Buy&Go logo",
                  class: "logo"
                })
              ], -1)
            ])),
            _: 1
          }),
          C(m, { class: "no-navigation-drawer" }, {
            default: P(() => [
              C(c, { class: "content-container" }, {
                default: P(() => [
                  C(a, null, {
                    default: P(() => [
                      C(n, { class: "d-flex justify-center" }, {
                        default: P(() => [
                          p("div", by, [
                            C(s, {
                              icon: d.processEndIcon != "" ? d.processEndIcon : "custom:iconContractEndFail"
                            }, null, 8, ["icon"]),
                            p("div", Cy, E(d.processEndTitle), 1),
                            p("div", Iy, E(d.processEndSubtitle), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), Ey = {
  flowType: void 0,
  isViewDataLoading: !1,
  headerTitle: "",
  headerSubtitle: "",
  errorPage: ""
};
function Sy(e) {
  async function t(o) {
    return o == "backToStoreError" && window.location.replace(e.errorPage), null;
  }
  return {
    navigationAction: t
  };
}
const Py = { class: "contract-end-fail-component" }, jb = /* @__PURE__ */ ie({
  __name: "contract-end-fail-component",
  props: {
    data: { default: () => ({
      ...Ey
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = Q("navigationButtonsApi", null), { t: d } = H(), f = e, i = W({ ...f.data }), l = o;
    let s = re(!1);
    r !== null && (r == null || r.setButtonVisible("BackToStoreError", i.errorPage != ""));
    const { navigationAction: n } = Sy(i);
    return G(
      () => f.data,
      // Watch for changes in the data
      (a) => {
        Object.assign(i, a);
      },
      { deep: !0 }
    ), G(i, async (a) => {
      l("update:data", a);
    }, { deep: !0 }), me(async () => {
      s.value = !0, i.isViewDataLoading = !1, l("componentReady");
    }), t({
      navigationAction: n,
      componentReady: s
    }), (a, c) => (S(), N("div", Py));
  }
}), Ty = {
  flowType: void 0,
  isViewDataLoading: !1,
  successPage: ""
};
function wy(e) {
  async function t(o) {
    return o == "backToStore" && window.location.replace(e.successPage), null;
  }
  return {
    navigationAction: t
  };
}
const ky = { class: "contract-end-success-component" }, zb = /* @__PURE__ */ ie({
  __name: "contract-end-success-component",
  props: {
    data: { default: () => ({
      ...Ty
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = Q("navigationButtonsApi", null), { t: d } = H(), f = e, i = W({ ...f.data }), l = o;
    let s = re(!1);
    r !== null && (r == null || r.setButtonVisible("BackToStore", i.successPage != ""));
    const { navigationAction: n } = wy(i);
    return G(
      () => f.data,
      // Watch for changes in the data
      (a) => {
        Object.assign(i, a);
      },
      { deep: !0 }
    ), G(i, async (a) => {
      l("update:data", a);
    }, { deep: !0 }), me(async () => {
      s.value = !0, i.isViewDataLoading = !1, l("componentReady");
    }), t({
      navigationAction: n,
      componentReady: s
    }), (a, c) => (S(), N("div", ky));
  }
}), Ny = {
  orderToken: "",
  password: "",
  firstPassword: "",
  repeatPassword: "",
  status: wa.Success,
  flowType: void 0,
  needsToChangePassword: !1,
  isExistingUser: !1,
  linkPasswordReset: "",
  linkParamsId: "",
  headerTitle: "",
  headerSubtitle: "",
  isViewDataLoading: !1,
  hasPermanentResidenceInSlovenia: void 0,
  isSlovenianCitizen: void 0,
  hasSlovenianIncome: void 0,
  hasSlovenianBankAccount: void 0,
  msisdn: void 0,
  email: void 0,
  taxNumber: void 0,
  firstname: "",
  surname: "",
  address: "",
  postalCode: void 0,
  isMale: !1,
  birthdate: null,
  birthCity: "",
  citizen: void 0,
  hasTemporaryResidence: void 0,
  temporaryCitizen: void 0,
  temporaryPostalCode: void 0,
  temporaryForeignPostalCode: "",
  temporaryAddress: "",
  countrySourceFunds: "",
  countryFundsStatus: "",
  isIdentified: !1,
  personalDocumentType: void 0,
  idNumber: "",
  idNumberCheck: "",
  documentIssuer: "",
  issueDate: void 0,
  validityDate: void 0,
  permanentValidity: void 0,
  employmentType: void 0,
  employerName: "",
  employerAddress: "",
  employerPostCode: "",
  isPoliticallyExposedPerson: void 0,
  politicalFunction: "",
  pioSourceFunds: "",
  pioFundsStatus: "",
  isMarketingPreselected: !1,
  marketingSummit: !1,
  isPreapproved: !1,
  preapprovedCreditAmount: 0,
  preapprovedInstallmentAmount: 0,
  lastMonthsIncome: void 0,
  lastMonthsIncome2: void 0,
  lastMonthsIncome3: void 0,
  minCredit: void 0,
  hasMultipleProducts: !1,
  isDataChecked: !1
}, Ay = {
  serverError: "",
  isTaxNumberCompany: !1,
  externalResults: {}
};
function My(e) {
  const { t } = H();
  return F(() => ({
    password: {
      requiredIf: j.withMessage(t("GlobalErrors.FieldRequired"), de(() => e.isExistingUser))
    },
    firstPassword: {
      requiredIf: j.withMessage(t("GlobalErrors.FieldRequired"), de(() => !e.isExistingUser)),
      complexPassword: j.withMessage(t("GlobalErrors.PasswordComplex"), () => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(e.firstPassword) || e.isExistingUser)
    },
    repeatPassword: {
      requiredIf: j.withMessage(t("GlobalErrors.FieldRequired"), de(() => !e.isExistingUser)),
      matches: j.withMessage(t("GlobalErrors.PasswordNotMatch"), () => e.firstPassword == e.repeatPassword || e.isExistingUser)
    }
  }));
}
function Oy(e, t, o) {
  const { t: r } = H(), d = Q("commClient"), { copySharedProperties: f, scrollToFirstError: i } = Ie(), l = be(My(e), F(() => e), { $autoDirty: !0, $externalResults: t.externalResults });
  async function s() {
    return l.value.$touch(), l.value.$validate();
  }
  async function n() {
    return new Promise(async (b, y) => {
      var I;
      e.isViewDataLoading = !0;
      const g = await d.executeMethodAsync("Login", {
        PhoneNumber: e.msisdn,
        Password: e.password,
        OrderToken: e.orderToken
      });
      if (g.Success)
        g.UserData.birthdate != null && g.UserData.birthdate != "" && (g.UserData.birthdate = new Date(g.UserData.birthdate)), g.UserData.issueDate != null && g.UserData.issueDate != "" && (g.UserData.issueDate = new Date(g.UserData.issueDate)), g.UserData.validityDate != null && g.UserData.validityDate != "" && (g.UserData.validityDate = new Date(g.UserData.validityDate)), f(e, g.UserData), e.taxNumber != null && await v(), e.isPreapproved && (e.hasMultipleProducts ? (console.log("multi product flow"), b({ name: "installmentPlanMulti" })) : (console.log("single product flow"), b({ name: "installmentPlan" }))), (I = e.flowType) != null && I.startsWith("diy") ? b({ name: "idCheck" }) : b({ name: "precheck" });
      else
        switch (g.Error) {
          case "InvalidLogin":
            t.externalResults.password = r(`GlobalErrors.${g.Error}`), e.isViewDataLoading = !1, b(null);
            break;
          case "MsisdnMoreThanOneTaxNumber":
          case "MsisdnNotExists":
          case "ProcessError":
            e.headerSubtitle = g.Error, b({ name: "endFail" });
            break;
        }
    });
  }
  async function a() {
    return new Promise(async (b, y) => {
      e.isViewDataLoading = !0;
      const g = await d.executeMethodAsync("Check2FAAuth", {
        OrderToken: e.orderToken
      });
      g.Success || (e.headerSubtitle = g.Error, b({ name: "endFail" })), b(null);
    });
  }
  async function c() {
    return new Promise(async (b, y) => {
      e.isViewDataLoading = !0, await d.executeMethodAsync("sw.DIYDataLoad", {
        OrderToken: e.orderToken
      }).then(async (g) => {
        g.Success && (g.birthdate != null && g.birthdate != "" && (g.birthdate = new Date(g.birthdate)), g.issueDate != null && g.issueDate != "" && (g.issueDate = new Date(g.issueDate)), g.validityDate != null && g.validityDate != "" && (g.validityDate = new Date(g.validityDate)), f(e, g), e.taxNumber != null && await v(), e.isPreapproved && b({ name: "installmentPlan" }), b({ name: "idCheck" }));
      }).catch((g) => {
        b({ name: "endFail" });
      });
    });
  }
  async function m() {
    await _("login").then((b) => {
      b != null && b.name != null && o("navigation-event", b.name);
    }).catch((b) => console.log(b));
  }
  async function v() {
    return new Promise(async (b, y) => {
      await d.executeMethodAsync("DavcnaPravna", {
        OrderToken: e.orderToken,
        DavcnaSt: e.taxNumber
      }).then(async (g) => {
        g != null && (t.isTaxNumberCompany = g.IsCompanyTax, !t.isTaxNumberCompany && e.employmentType === le.SP && (e.employmentType = void 0)), b(!0);
      });
    });
  }
  function h() {
    i(".password-component");
  }
  async function _(b) {
    var g;
    let y = null;
    return b == "login" && await s() && (e.isExistingUser ? await n().then((T) => {
      y = T, console.log("DoLogin result:", T);
    }) : (g = e.flowType) != null && g.startsWith("diy") ? await c().then((T) => {
      y = T;
    }) : y = { name: "precheck" }), y;
  }
  return {
    v$: l,
    navigationAction: _,
    DoLoginWithEnter: m,
    Check2FAAuth: a,
    scrollToFirstErrorWrapper: h
  };
}
const Ry = {
  class: "password-component",
  ref: "rootRef"
}, $y = { class: "form-label" }, xy = {
  key: 0,
  class: "v-input__details"
}, Ly = { class: "v-messages" }, Vy = { class: "v-messages__message error" }, Fy = {
  key: 1,
  class: "panel__footer mt-10"
}, jy = { class: "panel__footer-text d-sm-flex" }, zy = { key: 1 }, Uy = { class: "mb-4" }, By = { class: "form-label" }, Gy = { class: "form-label" }, Ub = /* @__PURE__ */ ie({
  __name: "password-component",
  props: {
    data: { default: () => ({
      ...Ny
    }) }
  },
  emits: ["update:data", "navigation-event", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o;
    let f = re(!1);
    const i = W({ ...r.data }), { t: l } = H(), s = W({ ...Ay }), { v$: n, navigationAction: a, DoLoginWithEnter: c, Check2FAAuth: m, scrollToFirstErrorWrapper: v } = Oy(i, s, d);
    G(
      () => r.data,
      // Watch for changes in the data
      (_) => {
        Object.assign(i, _);
      },
      { deep: !0 }
    ), G(
      i,
      (_) => {
        d("update:data", _);
      },
      { deep: !0 }
    ), me(async () => {
      const _ = await m();
      f.value = !0, d("componentReady"), _ != null && d("navigation-event", _.name);
    }), t({
      navigationAction: a,
      componentReady: f,
      scrollToFirstErrorWrapper: v
    });
    const h = re(!1);
    return (_, b) => {
      const y = V("v-text-field"), g = V("router-link"), I = V("v-col"), T = V("v-row");
      return S(), N("div", Ry, [
        i.isExistingUser ? (S(), K(T, { key: 0 }, {
          default: P(() => [
            C(I, {
              onKeydown: b[2] || (b[2] = Ao((w) => u(c)(), ["enter"])),
              class: "v-col-12 v-col-md-6"
            }, {
              default: P(() => [
                p("div", null, [
                  p("label", $y, E(u(l)("Components.PasswordComponent.Password")), 1),
                  C(y, {
                    modelValue: i.password,
                    "onUpdate:modelValue": b[0] || (b[0] = (w) => i.password = w),
                    "error-messages": u(n).password.$errors[0] != null ? u(n).password.$errors[0].$message : "",
                    onFocus: u(n).password.$reset,
                    autofocus: "",
                    variant: "outlined",
                    "append-inner-icon": h.value ? "custom:iconPasswordVisible" : "custom:iconPasswordNotVisible",
                    type: h.value ? "text" : "password",
                    "onClick:appendInner": b[1] || (b[1] = (w) => h.value = !h.value)
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "append-inner-icon", "type"])
                ]),
                s.serverError !== "" ? (S(), N("div", xy, [
                  p("div", Ly, [
                    p("div", Vy, E(s.serverError), 1)
                  ])
                ])) : x("", !0),
                i.flowType == u(R).WEB || i.flowType == u(R).SKLENI_SAM || i.flowType == u(R).POS_STRANKA || i.flowType == u(R).POS_MOBILE || i.flowType == u(R).LIMIT ? (S(), N("div", Fy, [
                  p("div", jy, [
                    i.flowType == u(R).LIMIT ? (S(), K(g, {
                      key: 0,
                      to: { name: "LimitPassworResetTaxNum" }
                    }, {
                      default: P(() => b[7] || (b[7] = [
                        p("div", { class: "btn-link mr-6" }, " Ste pozabili svoje geslo? ", -1)
                      ])),
                      _: 1
                    })) : (S(), K(g, {
                      key: 1,
                      to: { name: "PassworResetTaxNum" }
                    }, {
                      default: P(() => b[8] || (b[8] = [
                        p("div", { class: "btn-link mr-6" }, " Ste pozabili svoje geslo? ", -1)
                      ])),
                      _: 1
                    }))
                  ])
                ])) : x("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : (S(), N("div", zy, [
          C(T, null, {
            default: P(() => [
              C(I, { class: "v-col-12 v-col-md-6" }, {
                default: P(() => [
                  p("div", Uy, [
                    p("label", By, E(u(l)("Components.PasswordComponent.NewPassword")), 1),
                    C(y, {
                      modelValue: i.firstPassword,
                      "onUpdate:modelValue": b[3] || (b[3] = (w) => i.firstPassword = w),
                      variant: "outlined",
                      hint: u(l)("Components.PasswordComponent.PasswordHint"),
                      "persistent-hint": "",
                      "error-messages": u(n).firstPassword.$errors[0] != null ? u(n).firstPassword.$errors[0].$message : "",
                      onFocus: u(n).firstPassword.$reset,
                      "append-inner-icon": h.value ? "custom:iconPasswordVisible" : "custom:iconPasswordNotVisible",
                      type: h.value ? "text" : "password",
                      "onClick:appendInner": b[4] || (b[4] = (w) => h.value = !h.value)
                    }, null, 8, ["modelValue", "hint", "error-messages", "onFocus", "append-inner-icon", "type"])
                  ]),
                  p("div", null, [
                    p("label", Gy, E(u(l)("Components.PasswordComponent.RepeatPassword")), 1),
                    C(y, {
                      modelValue: i.repeatPassword,
                      "onUpdate:modelValue": b[5] || (b[5] = (w) => i.repeatPassword = w),
                      "error-messages": u(n).repeatPassword.$errors[0] != null ? u(n).repeatPassword.$errors[0].$message : "",
                      onFocus: u(n).repeatPassword.$reset,
                      variant: "outlined",
                      "append-inner-icon": h.value ? "custom:iconPasswordVisible" : "custom:iconPasswordNotVisible",
                      type: h.value ? "text" : "password",
                      "onClick:appendInner": b[6] || (b[6] = (w) => h.value = !h.value)
                    }, null, 8, ["modelValue", "error-messages", "onFocus", "append-inner-icon", "type"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      ], 512);
    };
  }
}), qy = {
  newPassword: void 0,
  repeatPassword: void 0,
  passwordResetId: void 0,
  msisdn: void 0,
  email: void 0,
  orderToken: void 0,
  isFromPasswordReset: !1,
  headerTitle: "",
  headerSubtitle: "",
  isViewDataLoading: !1
}, Dy = {
  serverError: "",
  externalResults: {}
};
function Hy(e) {
  const { t } = H();
  return F(() => ({
    newPassword: {
      required: j.withMessage(t("GlobalErrors.FieldRequired"), he),
      complexPassword: j.withMessage("Geslo mora biti dolgo vsaj 8 znakov in vsebovati vsaj eno veliko črko, malo črko, številko in poseben znak", () => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(e.newPassword))
    },
    repeatPassword: {
      required: j.withMessage(t("GlobalErrors.FieldRequired"), he),
      matches: j.withMessage("Gesli se ne ujemata", () => e.newPassword == e.repeatPassword)
    }
  }));
}
function Yy(e, t) {
  const o = be(Hy(e), F(() => e), { $autoDirty: !0, $externalResults: t.externalResults }), r = Q("commClient");
  async function d() {
    return t.serverError = "", e.isViewDataLoading = !0, new Promise(async (l, s) => {
      await r.executeMethodAsync("PasswordReset", {
        PasswordResetId: e.passwordResetId,
        NewPassword: e.newPassword
      }).then((n) => {
        n.Success ? (e.msisdn = n.Msisdn, e.email = n.Email, e.orderToken = n.OrderToken, e.isFromPasswordReset = !0, l({ name: "endSuccess" })) : (e.headerSubtitle = "PasswordResetExpired", l({ name: "endFail" }));
      }).catch((n) => {
        e.isViewDataLoading = !1, l(null);
      });
    });
  }
  async function f() {
    return o.value.$touch(), o.value.$validate();
  }
  async function i(l) {
    let s = null;
    return l == "nextStep" && await f() && (s = await d()), s;
  }
  return {
    v$: o,
    navigationAction: i
  };
}
const Zy = { class: "form-label" }, Wy = { class: "form-label" }, Ky = {
  key: 0,
  class: "v-input__details"
}, Qy = { class: "v-messages" }, Xy = { class: "v-messages__message error" }, Bb = /* @__PURE__ */ ie({
  __name: "password-reset-set-component",
  props: {
    data: { default: () => ({
      ...qy
    }) }
  },
  emits: ["update:data", "navigation-event", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o;
    let f = re(!1);
    const i = W({ ...r.data }), { t: l } = H(), s = W({ ...Dy }), { v$: n, navigationAction: a } = Yy(i, s);
    return G(
      () => r.data,
      // Watch for changes in the data
      (c) => {
        Object.assign(i, c);
      },
      { deep: !0 }
    ), G(
      i,
      (c) => {
        d("update:data", c);
      },
      { deep: !0 }
    ), me(async () => {
      f.value = !0, d("componentReady");
    }), t({
      navigationAction: a,
      componentReady: f
    }), (c, m) => {
      const v = V("v-text-field"), h = V("v-col"), _ = V("v-row");
      return S(), N(je, null, [
        C(_, null, {
          default: P(() => [
            C(h, null, {
              default: P(() => [
                p("label", Zy, E(u(l)("Components.PasswordResetSet.NewPassword")), 1),
                C(v, {
                  modelValue: i.newPassword,
                  "onUpdate:modelValue": m[0] || (m[0] = (b) => i.newPassword = b),
                  "error-messages": u(n).newPassword.$errors[0] != null ? u(n).newPassword.$errors[0].$message : "",
                  onFocus: u(n).newPassword.$reset,
                  variant: "outlined",
                  type: "password"
                }, null, 8, ["modelValue", "error-messages", "onFocus"])
              ]),
              _: 1
            }),
            C(h, null, {
              default: P(() => [
                p("label", Wy, E(u(l)("Components.PasswordResetSet.RepeatPassword")), 1),
                C(v, {
                  modelValue: i.repeatPassword,
                  "onUpdate:modelValue": m[1] || (m[1] = (b) => i.repeatPassword = b),
                  "error-messages": u(n).repeatPassword.$errors[0] != null ? u(n).repeatPassword.$errors[0].$message : "",
                  onFocus: u(n).repeatPassword.$reset,
                  variant: "outlined",
                  type: "password"
                }, null, 8, ["modelValue", "error-messages", "onFocus"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        s.serverError !== "" ? (S(), N("div", Ky, [
          p("div", Qy, [
            p("div", Xy, E(s.serverError), 1)
          ])
        ])) : x("", !0)
      ], 64);
    };
  }
}), Jy = {
  taxNumber: void 0,
  msisdn: void 0,
  orderToken: "",
  processEndTitle: "",
  processEndSubtitle: "",
  processEndIcon: "",
  isViewDataLoading: !1,
  flowType: void 0
}, e_ = {
  serverError: "",
  externalResults: {}
};
function t_(e) {
  const { t } = H();
  function o() {
    if (e.taxNumber != null) {
      let d = e.taxNumber.toString();
      if (d.length == 8 && /^\d+$/.test(d) && d[0] != "0") {
        var r = parseInt(d[0]) * 8 + parseInt(d[1]) * 7 + parseInt(d[2]) * 6 + parseInt(d[3]) * 5 + parseInt(d[4]) * 4 + parseInt(d[5]) * 3 + parseInt(d[6]) * 2;
        if (r = r % 11, r = (11 - r) % 10, parseInt(d[7]) == r)
          return !0;
      }
    }
    return !1;
  }
  return F(() => ({
    taxNumber: {
      required: j.withMessage(t("GlobalErrors.FieldRequired"), he),
      minPhoneNumberLength: j.withMessage(t("GlobalErrors.MinLength"), Ft(8)),
      maxPhoneNumberLength: j.withMessage(t("GlobalErrors.MaxLength"), Vt(8)),
      isValidNumber: j.withMessage(t("GlobalErrors.IsValidTaxNumber"), o)
    }
  }));
}
function n_(e, t) {
  const o = be(t_(e), F(() => e), { $autoDirty: !0, $externalResults: t.externalResults }), r = Q("commClient"), { t: d } = H();
  async function f() {
    return o.value.$touch(), o.value.$validate();
  }
  async function i() {
    return new Promise(async (s, n) => {
      t.serverError = "", e.isViewDataLoading = !0, await r.executeMethodAsync("PasswordResetRequest", {
        OrderToken: e.orderToken,
        Msisdn: e.msisdn,
        TaxNumber: e.taxNumber,
        FlowType: e.flowType
      }).then((a) => {
        if (a.Success)
          e.processEndTitle = d("Components.ProcessEnd.PasswordResetRequest.Title"), e.processEndSubtitle = d("Components.ProcessEnd.PasswordResetRequest.Subtitle", { email: a.Email }), e.processEndIcon = "custom:iconSuccess", s({ name: "end" });
        else
          switch (a.Error) {
            case "DataNotMatchedPassReset":
              t.externalResults.taxNumber = d(`GlobalErrors.${a.Error}`), e.isViewDataLoading = !1, s(null);
              break;
            case "MsisdnCodeInvalid":
              e.processEndTitle = d("GlobalErrors.Error"), e.processEndSubtitle = d("GlobalErrors.MsisdnCodeInvalid"), s({ name: "end" });
              break;
            case "ProcessError":
              e.processEndTitle = d("GlobalErrors.Error"), e.processEndSubtitle = d("GlobalErrors.ProcessError"), s({ name: "end" });
              break;
          }
      }).catch((a) => {
        e.isViewDataLoading = !1, s(null);
      });
    });
  }
  async function l(s) {
    let n = null;
    return s == "Back" ? n = { name: "login" } : s == "passwordResetRequest" && await f() && (n = await i()), n;
  }
  return {
    v$: o,
    navigationAction: l
  };
}
const o_ = { class: "form-label" }, r_ = {
  key: 0,
  class: "v-input__details"
}, i_ = { class: "v-messages" }, a_ = { class: "v-messages__message error" }, Gb = /* @__PURE__ */ ie({
  __name: "password-reset--tax-num-component",
  props: {
    data: { default: () => ({
      ...Jy
    }) }
  },
  emits: ["update:data", "navigation-event", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o;
    let f = re(!1);
    const i = W({ ...r.data }), { t: l } = H(), s = W({ ...e_ }), { v$: n, navigationAction: a } = n_(i, s);
    return G(
      () => r.data,
      // Watch for changes in the data
      (c) => {
        Object.assign(i, c);
      },
      { deep: !0 }
    ), G(
      i,
      (c) => {
        d("update:data", c);
      },
      { deep: !0 }
    ), me(async () => {
      f.value = !0, d("componentReady");
    }), t({
      navigationAction: a,
      componentReady: f
    }), (c, m) => {
      const v = V("v-col"), h = V("v-row");
      return S(), N(je, null, [
        C(h, null, {
          default: P(() => [
            C(v, null, {
              default: P(() => [
                p("label", o_, E(u(l)("Components.PasswordResetTaxNum.TaxNumber")), 1),
                C(Te, {
                  modelValue: i.taxNumber,
                  "onUpdate:modelValue": m[0] || (m[0] = (_) => i.taxNumber = _),
                  "error-messages": u(n).taxNumber.$errors[0] != null ? u(n).taxNumber.$errors[0].$message : "",
                  onFocus: u(n).taxNumber.$reset,
                  variant: "outlined"
                }, null, 8, ["modelValue", "error-messages", "onFocus"])
              ]),
              _: 1
            }),
            C(v)
          ]),
          _: 1
        }),
        s.serverError !== "" ? (S(), N("div", r_, [
          p("div", i_, [
            p("div", a_, E(s.serverError), 1)
          ])
        ])) : x("", !0)
      ], 64);
    };
  }
}), Wi = {
  flowType: void 0,
  prefix: void 0,
  phoneNumber: void 0,
  email: "",
  isEmailVerified: !1,
  code: "",
  isPreapproved: !1,
  taxNumber: void 0,
  citizen: void 0,
  headerSubtitle: "",
  isCustomerContinuing: !1,
  firstname: "",
  surname: "",
  address: "",
  postalCode: void 0,
  birthdate: null,
  isMale: !0,
  birthCity: "",
  hasTemporaryResidence: void 0,
  temporaryAddress: "",
  temporaryPostalCode: void 0,
  temporaryForeignPostalCode: "",
  countrySourceFunds: "",
  countryFundsStatus: "",
  temporaryCitizen: void 0,
  contractSending: void 0,
  employerName: "",
  employerAddress: "",
  employerPostCode: "",
  isPoliticallyExposedPerson: void 0,
  politicalFunction: "",
  pioSourceFunds: "",
  pioFundsStatus: "",
  personalDocumentType: void 0,
  idNumber: "",
  documentIssuer: "",
  issueDate: null,
  validityDate: null,
  idNumberCheck: "",
  permanentValidity: void 0,
  numberOfPreapprovedSalaries: 0,
  lastMonthsIncome: void 0,
  lastMonthsIncome2: void 0,
  lastMonthsIncome3: void 0,
  isExistingUser: !1,
  prefilledData: !1,
  preapprovedType: "",
  preapprovedCreditAmount: 0,
  preapprovedInstallmentAmount: 0
}, s_ = {
  isCodeSent: !1,
  isEmailValidationSent: !1,
  emailVerificationSending: !1,
  externalResults: {},
  codeMatches: !1
};
function l_(e) {
  const { t } = H(), o = () => e.flowType === R.POS || e.flowType === R.POS_STRANKA || e.flowType === R.POS_MOBILE;
  function r() {
    return o() ? e.code.length == 4 : !0;
  }
  return {
    validationRules: F(() => ({
      prefix: {
        requiredIf: j.withMessage(t("GlobalErrors.FieldRequired"), de(o))
      },
      phoneNumber: {
        requiredIf: j.withMessage(t("GlobalErrors.FieldRequired"), de(o)),
        minLength: e.flowType == R.POS || e.flowType == R.POS_STRANKA || e.flowType == R.POS_MOBILE ? j.withMessage(t("GlobalErrors.CorrectPhoneNumber"), Ft(8)) : j.withMessage("", () => !0),
        maxLength: e.flowType == R.POS || e.flowType == R.POS_STRANKA || e.flowType == R.POS_MOBILE ? j.withMessage(t("GlobalErrors.CorrectPhoneNumber"), Vt(12)) : j.withMessage("", () => !0)
      },
      email: {
        customEmail: j.withMessage(t("GlobalErrors.CorrectEmail"), nr),
        requiredIf: j.withMessage(t("GlobalErrors.FieldRequired"), de(e.isCustomerContinuing))
      },
      code: {
        requiredIf: j.withMessage(t("GlobalErrors.FieldRequired"), de(o)),
        customRequired: j.withMessage(t("GlobalErrors.FieldRequired"), r)
      }
    }))
  };
}
function u_(e, t) {
  const o = Q("commClient"), r = Q("generalStore"), { t: d } = H(), { copySharedProperties: f, scrollToFirstError: i } = Ie(), { validationRules: l } = l_(e), s = be(l, F(() => e), { $autoDirty: !0, $externalResults: t.externalResults }), n = F(() => {
    var k;
    return (k = r.state.countryList) == null ? void 0 : k.find((L) => e.citizen === L.Key);
  });
  async function a() {
    return s.value.$touch(), s.value.$validate();
  }
  async function c(k) {
    e.email != k.email && (e.email = e.email.trim());
  }
  async function m() {
    s.value.prefix.$touch(), s.value.phoneNumber.$touch(), t.externalResults.phoneNumber = [];
    let k = await s.value.prefix.$validate(), L = await s.value.phoneNumber.$validate();
    k && L && await v().then(($) => ($ ? t.isCodeSent = !0 : t.externalResults.phoneNumber = ["Presegli ste omejitev pošiljanja sms sporočil. Poskusite ponovno kasneje."], $));
  }
  async function v() {
    return new Promise((k) => {
      o.executeMethodAsync("SendConfirmationCode", {
        Msisdn: e.prefix.Key.toString().replace("+", "").trim() + e.phoneNumber.toString()
      }).then(async (L) => {
        L && k(L.Success);
      });
    });
  }
  async function h() {
    return t.codeMatches = !1, t.externalResults.code = [], s.value.code.$touch(), e.phoneNumber != null && e.code.length == 4 ? await I().then(async (k) => (k.Success || (t.externalResults.code = [d(`GlobalErrors.${k.Error}`)]), k.Success && await g(), k.Success)) : !0;
  }
  async function _() {
    return new Promise(async (k) => {
      t.emailVerificationSending = !0, await o.executeMethodAsync("SendEmailValidation", {
        Email: e.email,
        TaxNumber: e.taxNumber
      }).then(async (L) => {
        L && (t.isEmailValidationSent = !0, k(L.Success));
      }), t.emailVerificationSending = !1;
    });
  }
  async function b() {
    s.value.email.$touch(), t.externalResults.email = [], e.email.length > 0 ? await s.value.email.$validate() && await _().then((L) => (L || (t.externalResults.email = ["Unknown error."]), L)) : t.externalResults.email = [d("GlobalErrors.FieldRequired")];
  }
  async function y() {
    t.isEmailValidationSent = !1;
  }
  async function g() {
    return new Promise((k) => {
      var L;
      o.executeMethodAsync("sf.PrefillCustomerData", {
        TaxNumber: e.taxNumber,
        Msisdn: ((L = e.prefix) == null ? void 0 : L.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString()
      }).then(async ($) => {
        $ && ($.birthdate != null && $.birthdate != "" && ($.birthdate = new Date($.birthdate)), $.issueDate != null && $.issueDate != "" && ($.issueDate = new Date($.issueDate)), $.validityDate != null && $.validityDate != "" && ($.validityDate = new Date($.validityDate)), f(e, $), k($));
      });
    });
  }
  async function I() {
    return new Promise((k) => {
      var $;
      let L = (($ = e.prefix) == null ? void 0 : $.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString();
      o.executeMethodAsync("sf.ConfirmationCodeCheck", {
        Msisdn: L,
        //OTP
        Code: e.code
      }).then(async (q) => {
        q && (t.codeMatches = q.Success, k(q));
      });
    });
  }
  const T = F(() => {
    var k, L;
    return ((L = (k = n.value) == null ? void 0 : k.AdditionalData) == null ? void 0 : L.TveganaDrzava) === !0;
  });
  function w() {
    i(".verification-component");
  }
  async function M(k) {
    let L = !1, $ = null;
    switch (k) {
      case "validatecustomer":
        if (e.isCustomerContinuing = !0, e.isEmailVerified == !0 && (t.externalResults.email = []), L = await a(), L) {
          if (e.isEmailVerified !== !0)
            return t.externalResults.email = [d("GlobalErrors.EmailNotVerified")], w(), null;
          if (T.value)
            return e.headerSubtitle = d("EndFail.RiskCountry"), $ = { name: "endFail" };
          $ = { name: "valid" };
        }
        break;
      case "validate":
        e.isCustomerContinuing = !1, L = await a(), L && ($ = { name: "valid" });
        break;
    }
    return $;
  }
  return {
    v$: s,
    SendPhoneConfirmationCode: m,
    CodeMatches: h,
    SendEmailValidation: b,
    ResetEmailValidation: y,
    navigationAction: M,
    scrollToFirstErrorWrapper: w,
    dataChanged: c
  };
}
function nn() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  if (nn.cache.has(e)) return nn.cache.get(e);
  const t = e.replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase();
  return nn.cache.set(e, t), t;
}
nn.cache = /* @__PURE__ */ new Map();
function d_(e, t) {
  const o = mn();
  if (!o)
    throw new Error(`[Vuetify] ${e} must be called from inside a setup function`);
  return o;
}
function c_() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "composables";
  const t = d_(e).type;
  return nn((t == null ? void 0 : t.aliasName) || (t == null ? void 0 : t.name));
}
const m_ = Symbol.for("vuetify:display");
function rr() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    mobile: null
  }, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c_();
  const o = Q(m_);
  if (!o) throw new Error("Could not find Vuetify display injection");
  const r = F(() => e.mobile ? !0 : typeof e.mobileBreakpoint == "number" ? o.width.value < e.mobileBreakpoint : e.mobileBreakpoint ? o.width.value < o.thresholds.value[e.mobileBreakpoint] : e.mobile === null ? o.mobile.value : !1), d = F(() => t ? {
    [`${t}--mobile`]: r.value
  } : {});
  return {
    ...o,
    displayClasses: d,
    mobile: r
  };
}
const f_ = {
  class: "verification-component",
  ref: "rootRef"
}, p_ = {
  key: 0,
  class: "section-heading"
}, v_ = { class: "form-label" }, h_ = { class: "control-phone-wrapper" }, y_ = { key: 0 }, __ = { class: "form-label" }, g_ = {
  key: 0,
  class: "v-input--error"
}, b_ = { class: "v-input__details" }, C_ = { class: "v-messages" }, I_ = { class: "v-messages__message" }, E_ = { class: "form-label" }, S_ = { class: "control-email-wrapper" }, P_ = { key: 2 }, T_ = { class: "loader-small loader-sent" }, w_ = { class: "loader-small mt-8" }, qb = /* @__PURE__ */ ie({
  __name: "verification-component",
  props: {
    data: { default: () => ({
      ...Wi
    }) }
  },
  emits: ["update:data", "navigation-event", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o;
    Q("commClient");
    let f = re(!1);
    const i = re(null), l = W({ ...r.data });
    let s = { ...Wi };
    const { t: n } = H(), a = W({ ...s_ }), { v$: c, navigationAction: m, SendEmailValidation: v, ResetEmailValidation: h, SendPhoneConfirmationCode: _, CodeMatches: b, scrollToFirstErrorWrapper: y, dataChanged: g } = u_(l, a);
    G(
      () => r.data,
      // Watch for changes in the data
      (w) => {
        Object.assign(l, w);
      },
      { deep: !0 }
    ), G(
      l,
      async (w) => {
        await g(s), Object.assign(s, w), d("update:data", w);
      },
      { deep: !0 }
    );
    const I = Q("generalStore");
    rr(), me(async () => {
      f.value = !0, d("componentReady");
    }), G(() => a.isCodeSent, async (w) => {
      w && (await on(), T());
    });
    function T() {
      var w, M;
      (M = (w = i.value) == null ? void 0 : w.focus) == null || M.call(w);
    }
    return t({
      navigationAction: m,
      componentReady: f,
      scrollToFirstErrorWrapper: y
    }), (w, M) => {
      const k = V("v-autocomplete"), L = V("v-btn"), $ = V("v-col"), q = V("v-otp-input"), J = V("v-row"), X = V("v-text-field"), U = V("v-tooltip");
      return S(), N("div", f_, [
        l.flowType === u(R).POS || l.flowType === u(R).POS_STRANKA || l.flowType === u(R).POS_MOBILE ? (S(), N("h2", p_, E(u(n)("Components.IdentificationDataComponent.VerificationTitle")), 1)) : x("", !0),
        l.flowType === u(R).POS || l.flowType === u(R).POS_STRANKA || l.flowType === u(R).POS_MOBILE ? (S(), K(J, { key: 1 }, {
          default: P(() => [
            C($, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", v_, E(u(n)("Components.IdentificationDataComponent.PhoneNumber")), 1),
                p("div", h_, [
                  C(k, {
                    modelValue: l.prefix,
                    "onUpdate:modelValue": M[0] || (M[0] = (oe) => l.prefix = oe),
                    items: u(I).state.countryPhoneList,
                    onFocus: u(c).prefix.$reset,
                    variant: "outlined",
                    class: "control-phone-country",
                    "return-object": !0,
                    disabled: a.isCodeSent,
                    "item-title": "Value",
                    "item-value": "Key",
                    "error-messages": u(c).prefix.$errors[0] || u(c).phoneNumber.$errors[0] ? u(c).prefix.$errors[0] ? u(c).prefix.$errors[0].$message : u(c).phoneNumber.$errors[0].$message : "",
                    hint: a.isCodeSent ? w.$t("Components.IdentificationDataComponent.CodeText") : "",
                    "persistent-hint": ""
                  }, null, 8, ["modelValue", "items", "onFocus", "disabled", "error-messages", "hint"]),
                  C(Te, {
                    modelValue: l.phoneNumber,
                    "onUpdate:modelValue": M[1] || (M[1] = (oe) => l.phoneNumber = oe),
                    "error-messages": u(c).prefix.$errors[0] || u(c).phoneNumber.$errors[0] ? u(c).prefix.$errors[0] ? u(c).prefix.$errors[0].$message : u(c).phoneNumber.$errors[0].$message : "",
                    onFocus: u(c).phoneNumber.$reset,
                    disabled: a.isCodeSent,
                    variant: "outlined",
                    class: "control-phone-number"
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "disabled"]),
                  C(L, {
                    onClick: M[2] || (M[2] = (oe) => u(_)()),
                    class: "btn btn--primary-outline btn--sm",
                    variant: "flat",
                    disabled: a.isCodeSent
                  }, {
                    default: P(() => [
                      ne(E(u(n)("GeneralButtons.Send")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  a.isCodeSent ? (S(), N("span", y_, M[8] || (M[8] = [
                    p("img", {
                      src: qo,
                      alt: "Success",
                      class: "icon-sent"
                    }, null, -1)
                  ]))) : x("", !0)
                ])
              ]),
              _: 1
            }),
            C($, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("div", null, [
                  p("label", __, E(u(n)("Components.IdentificationDataComponent.Code")), 1),
                  C(q, {
                    ref_key: "otpRef",
                    ref: i,
                    modelValue: l.code,
                    "onUpdate:modelValue": M[3] || (M[3] = (oe) => l.code = oe),
                    length: 4,
                    autofocus: "",
                    onFinish: M[4] || (M[4] = (oe) => u(b)()),
                    disabled: !a.isCodeSent
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                u(c).code.$errors[0] ? (S(), N("div", g_, [
                  p("div", b_, [
                    p("div", C_, [
                      p("div", I_, E(u(c).code.$errors[0].$message), 1)
                    ])
                  ])
                ])) : x("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0),
        l.flowType === u(R).POS || l.flowType === u(R).POS_STRANKA || l.flowType === u(R).POS_MOBILE ? (S(), K(J, { key: 2 }, {
          default: P(() => [
            C($, { class: "v-col-12 v-col-md-6" }, {
              default: P(() => [
                p("label", E_, E(u(n)("Components.IdentificationDataComponent.Email")), 1),
                p("div", S_, [
                  C(X, {
                    modelValue: l.email,
                    "onUpdate:modelValue": M[5] || (M[5] = (oe) => l.email = oe),
                    "error-messages": u(c).email.$errors[0] != null ? u(c).email.$errors[0].$message : "",
                    onFocus: u(c).email.$reset,
                    disabled: a.isEmailValidationSent || l.isEmailVerified,
                    variant: "outlined",
                    hint: a.isEmailValidationSent ? w.$t("Components.IdentificationDataComponent.EmailText") : "",
                    "persistent-hint": ""
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "disabled", "hint"]),
                  !a.isEmailValidationSent || l.isEmailVerified ? (S(), K(U, {
                    key: 0,
                    text: "Ob kliku na gumb Pošlji bo stranka prejela e-mail sporočilo s povezavo za verificiranje e-mail naslova.",
                    class: "",
                    location: "right",
                    "close-on-content-click": !0
                  }, {
                    activator: P(({ props: oe }) => [
                      C(L, Ot(oe, {
                        onClick: M[6] || (M[6] = (fe) => u(v)()),
                        class: "btn btn--primary-outline btn--sm",
                        variant: "flat",
                        disabled: l.isEmailVerified
                      }), {
                        default: P(() => [
                          ne(E(u(n)("GeneralButtons.Send")), 1)
                        ]),
                        _: 2
                      }, 1040, ["disabled"])
                    ]),
                    _: 1
                  })) : (S(), K(L, Ot({ key: 1 }, r, {
                    onClick: M[7] || (M[7] = (oe) => u(h)()),
                    class: "btn btn--primary-outline btn--sm",
                    variant: "flat",
                    disabled: l.isEmailVerified
                  }), {
                    default: P(() => [
                      ne(E(u(n)("GeneralButtons.EditEmail")), 1)
                    ]),
                    _: 1
                  }, 16, ["disabled"])),
                  (a.isEmailValidationSent || l.isEmailVerified) && !a.emailVerificationSending ? (S(), N("span", P_, M[9] || (M[9] = [
                    p("img", {
                      src: qo,
                      alt: "Success",
                      class: "icon-sent"
                    }, null, -1)
                  ]))) : x("", !0),
                  He(p("span", T_, M[10] || (M[10] = [
                    p("img", {
                      src: cn,
                      alt: "Loader"
                    }, null, -1)
                  ]), 512), [
                    [Ye, a.emailVerificationSending]
                  ])
                ])
              ]),
              _: 1
            }),
            C($, null, {
              default: P(() => [
                He(p("span", w_, M[11] || (M[11] = [
                  p("img", {
                    src: cn,
                    alt: "Loader"
                  }, null, -1),
                  p("div", null, [
                    p("div", null, "Preverjamo, ali je stranka potrdila svoj e-mail naslov."),
                    p("div", null, "Medtem lahko nadaljujete s postopkom vnosa.")
                  ], -1)
                ]), 512), [
                  [Ye, a.isEmailValidationSent && !l.isEmailVerified]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : x("", !0)
      ], 512);
    };
  }
}), k_ = {
  orderToken: "",
  msisdn: "",
  email: "",
  isEmailVerified: !1,
  flowType: void 0,
  headerTitle: "",
  headerSubtitle: "",
  processEndTitle: "",
  processEndSubtitle: "",
  processEndIcon: "",
  isViewDataLoading: !1,
  marketingSummit: !1
}, N_ = {
  serverError: "",
  externalResults: {}
};
function A_(e) {
  const { t } = H();
  return F(() => ({
    email: {
      required: j.withMessage(t("GlobalErrors.FieldRequired"), he),
      customEmail: j.withMessage(t("GlobalErrors.CorrectEmail"), nr)
    }
  }));
}
function M_(e, t, o) {
  const r = Q("commClient"), { t: d } = H(), f = be(A_(), F(() => e), { $autoDirty: !0, $externalResults: t.externalResults });
  async function i() {
    return f.value.$touch(), f.value.$validate();
  }
  async function l() {
    return new Promise(async (n, a) => {
      e.isViewDataLoading = !0;
      const c = await r.executeMethodAsync(
        "SendVerificationEmail",
        {
          PhoneNumber: e.msisdn,
          Email: e.email,
          OrderToken: e.orderToken,
          FlowType: e.flowType,
          MarketingSummit: e.marketingSummit
        }
      );
      c.Success ? (e.processEndTitle = d("Components.ProcessEnd.EmailVerification.Title"), e.processEndSubtitle = d("Components.ProcessEnd.EmailVerification.Subtitle"), e.processEndIcon = "custom:iconSuccess", n("end")) : (e.headerSubtitle = c.ErrorType, n("endFail"));
    });
  }
  async function s(n) {
    let a = null;
    return n == "sendVerificationEmail" && await i() && await l().then((m) => {
      a = { name: m };
    }), a;
  }
  return {
    v$: f,
    navigationAction: s
  };
}
const O_ = {
  class: "verification-email-component",
  ref: "rootRef"
}, R_ = { class: "form-label" }, Db = /* @__PURE__ */ ie({
  __name: "verification-email-component",
  props: {
    data: { default: () => ({
      ...k_
    }) }
  },
  emits: ["update:data", "navigation-event", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o;
    let f = re(!1);
    const i = W({ ...r.data }), l = W({ ...N_ }), { v$: s, navigationAction: n } = M_(i, l);
    return G(
      () => r.data,
      // Watch for changes in the data
      (a) => {
        Object.assign(i, a);
      },
      { deep: !0 }
    ), G(
      i,
      (a) => {
        d("update:data", a);
      },
      { deep: !0 }
    ), rr(), me(async () => {
      f.value = !0, d("componentReady");
    }), t({
      navigationAction: n,
      componentReady: f
    }), (a, c) => {
      const m = V("v-text-field"), v = V("v-col"), h = V("v-row");
      return S(), N("div", O_, [
        p("div", null, [
          C(h, null, {
            default: P(() => [
              C(v, { class: "v-col-12 v-col-md-6" }, {
                default: P(() => [
                  p("label", R_, E(a.$t("Components.VerificationComponent.Email")), 1),
                  C(m, {
                    modelValue: i.email,
                    "onUpdate:modelValue": c[0] || (c[0] = (_) => i.email = _),
                    "error-messages": u(s).email.$errors[0] != null ? u(s).email.$errors[0].$message : "",
                    onFocus: u(s).email.$reset,
                    variant: "outlined"
                  }, null, 8, ["modelValue", "error-messages", "onFocus"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ], 512);
    };
  }
}), $_ = {
  orderToken: "",
  prefix: void 0,
  phoneNumber: void 0,
  msisdn: void 0,
  code: "",
  email: "",
  isEmailVerified: !1,
  flowType: void 0,
  documentationId: "",
  isExistingUser: !1,
  headerTitle: "",
  headerSubtitle: "",
  isViewDataLoading: !1,
  codeSent: !1
}, x_ = {
  serverError: "",
  externalResults: {},
  phoneValidated: !1
};
function L_(e, t) {
  const { t: o } = H();
  return F(() => ({
    prefix: {
      requiredIf: j.withMessage(o("GlobalErrors.CorrectPhoneNumber"), de(e.flowType != null && !e.flowType.startsWith("diy") && !e.codeSent))
    },
    phoneNumber: {
      requiredIf: j.withMessage(o("GlobalErrors.CorrectPhoneNumber"), de(e.flowType != null && !e.flowType.startsWith("diy") && !e.codeSent)),
      minPhoneNumberLength: j.withMessage(o("GlobalErrors.CorrectPhoneNumber"), Ft(4)),
      maxPhoneNumberLength: j.withMessage(o("GlobalErrors.CorrectPhoneNumber"), Vt(12))
    },
    code: {
      requiredIf: j.withMessage(o("GlobalErrors.FieldRequired"), de(e.codeSent))
    }
  }));
}
function V_(e, t, o) {
  const r = Q("commClient"), d = Q("navigationButtonsApi"), { t: f } = H(), { scrollToFirstError: i } = Ie(), l = be(L_(e), F(() => e), { $autoDirty: !0, $externalResults: t.externalResults });
  async function s() {
    return l.value.$touch(), l.value.$validate();
  }
  function n() {
    d == null || d.setButtonVisible("ConfirmPin", !1);
  }
  function a() {
    l.value.$clearExternalResults(), m();
  }
  function c() {
    e.codeSent = !1, e.phoneNumber = void 0, e.msisdn = void 0, e.code = "", l.value.phoneNumber.$touch(), l.value.code.$reset(), d == null || d.setButtonVisible("ConfirmPin", !1), d == null || d.setButtonVisible("SendPin", !0);
  }
  async function m() {
    return new Promise(async (y, g) => {
      l.value.prefix.$touch(), l.value.phoneNumber.$touch(), await l.value.prefix.$validate(), await l.value.phoneNumber.$validate(), !l.value.prefix.$error && !l.value.phoneNumber.$error ? (e.msisdn = e.prefix.Key.toString().replace("+", "").trim() + e.phoneNumber.toString(), await r.executeMethodAsync("SendPin", {
        OrderToken: e.orderToken,
        Msisdn: e.msisdn
      }).then(async (I) => {
        I.Success ? (e.codeSent = !0, e.code = "", l.value.code.$reset(), d == null || d.setButtonVisible("SendPin", !1), d == null || d.setButtonVisible("ConfirmPin", !0), y("")) : (t.externalResults.phoneNumber = f(`GlobalErrors.${I.Error}`), e.codeSent = !1, e.code = "", l.value.code.$reset(), d == null || d.setButtonVisible("ConfirmPin", !1), d == null || d.setButtonVisible("SendPin", !0), y(""));
      })) : y("");
    });
  }
  async function v() {
    return new Promise(async (y, g) => {
      e.isViewDataLoading = !0, e.msisdn = e.prefix.Key.toString().replace("+", "").trim() + e.phoneNumber.toString();
      const I = await r.executeMethodAsync("UserVerify", {
        OrderToken: e.orderToken,
        PhoneNumber: e.msisdn,
        Code: e.code
      });
      if (I.Success)
        e.flowType == R.DOKUMENTACIJA ? y("DocumentationSubmit") : I.IsEmailVerified ? (e.isEmailVerified = I.IsEmailVerified, e.email = I.Email, e.isExistingUser = I.UserExists, y("login")) : (t.phoneValidated = !0, y("verifyEmail"));
      else
        switch (I.Error) {
          case "CodeInvalid":
          case "MaxRetriesExceeded":
            t.externalResults.code = [f(`GlobalErrors.${I.Error}`)], e.isViewDataLoading = !1, y("");
            break;
          case "CodeExpired":
            e.headerSubtitle = I.Error, y("endFail");
            break;
        }
    });
  }
  async function h(y) {
    return new Promise((g, I) => {
      r.executeMethodAsync("sw.DocumentationTypeCheck", {
        DocumentationId: y
      }).then(async (T) => {
        T.Error != "" ? (e.headerSubtitle = T.Error, g("endFail")) : T.SkipVerification ? g("DocumentationSubmit") : g("");
      });
    });
  }
  function _() {
    i(".verification-phone-component");
  }
  async function b(y) {
    let g = !1, I = null;
    switch (y) {
      case "validate":
        g = await s(), g && (I = { name: "valid" });
        break;
      case "sendPinCode":
        l.value.$clearExternalResults(), g = await s(), g && await m().then((T) => {
          I = { name: T };
        });
        break;
      case "confirmPinCode":
        l.value.$clearExternalResults(), g = await s(), g && await v().then((T) => {
          I = { name: T };
        });
        break;
    }
    return I;
  }
  return {
    v$: l,
    ConfirmPinCode: v,
    navigationAction: b,
    CheckDocumentationType: h,
    onFormActive: n,
    scrollToFirstErrorWrapper: _,
    handleResendCode: a,
    correctPhoneNumber: c
  };
}
const F_ = {
  class: "verification-phone-component",
  ref: "rootRef"
}, j_ = { class: "form-label" }, z_ = { class: "form-label" }, U_ = { class: "v-input--error" }, B_ = { class: "v-input__details" }, G_ = { class: "v-messages" }, q_ = {
  key: 0,
  class: "v-messages__message"
}, D_ = { class: "panel__footer mt-10" }, H_ = { class: "panel__footer-text" }, Hb = /* @__PURE__ */ ie({
  __name: "verification-phone-component",
  props: {
    data: { default: () => ({
      ...$_
    }) }
  },
  emits: ["update:data", "navigation-event", "componentReady", "enterPressed"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o;
    let f = re(!1);
    const i = W({ ...r.data }), l = W({ ...x_ }), {
      v$: s,
      navigationAction: n,
      onFormActive: a,
      CheckDocumentationType: c,
      // SendValidationCodeEnter, ConfirmPinCodeEnter, 
      handleResendCode: m,
      correctPhoneNumber: v,
      scrollToFirstErrorWrapper: h
    } = V_(i, l);
    G(
      () => r.data,
      // Watch for changes in the data
      (b) => {
        Object.assign(i, b);
      },
      { deep: !0 }
    ), G(
      i,
      (b) => {
        d("update:data", b);
      },
      { deep: !0 }
    ), me(async () => {
      i.flowType === R.DOKUMENTACIJA ? (a(), await c(i.documentationId).then((b) => {
        d("navigation-event", b);
      }).catch((b) => {
        d("navigation-event", b);
      })) : i.flowType === R.POS_STRANKA || i.flowType === R.POS_MOBILE ? d("navigation-event", "login") : a(), f.value = !0, d("componentReady");
    });
    const _ = Q("generalStore");
    return rr(), t({
      navigationAction: n,
      componentReady: f,
      scrollToFirstErrorWrapper: h
    }), (b, y) => {
      const g = V("v-autocomplete"), I = V("v-col"), T = V("v-row"), w = V("v-otp-input");
      return S(), N("div", F_, [
        p("div", null, [
          i.flowType != null && !i.flowType.startsWith("diy") && !i.codeSent ? (S(), K(T, {
            key: 0,
            onKeydown: y[2] || (y[2] = Ao((M) => d("enterPressed", "sendPinCode"), ["enter"]))
          }, {
            default: P(() => [
              C(I, { class: "v-col-12 v-col-md-6" }, {
                default: P(() => [
                  p("label", j_, E(b.$t("Components.VerificationComponent.PhoneNumber")), 1),
                  C(g, {
                    modelValue: i.prefix,
                    "onUpdate:modelValue": y[0] || (y[0] = (M) => i.prefix = M),
                    items: u(_).state.countryPhoneList,
                    onFocus: u(s).prefix.$reset,
                    variant: "outlined",
                    class: "control-phone-country",
                    "return-object": !0,
                    "item-title": "Value",
                    "item-value": "Key",
                    "error-messages": u(s).prefix.$errors[0] || u(s).phoneNumber.$errors[0] ? u(s).prefix.$errors[0] ? u(s).prefix.$errors[0].$message : u(s).phoneNumber.$errors[0].$message : ""
                  }, null, 8, ["modelValue", "items", "onFocus", "error-messages"]),
                  C(Te, {
                    modelValue: i.phoneNumber,
                    "onUpdate:modelValue": y[1] || (y[1] = (M) => i.phoneNumber = M),
                    "error-messages": u(s).prefix.$errors[0] || u(s).phoneNumber.$errors[0] ? u(s).prefix.$errors[0] ? u(s).prefix.$errors[0].$message : u(s).phoneNumber.$errors[0].$message : "",
                    onFocus: u(s).phoneNumber.$reset,
                    variant: "outlined",
                    class: "control-phone-number"
                  }, null, 8, ["modelValue", "error-messages", "onFocus"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : x("", !0),
          i.codeSent ? (S(), K(T, {
            key: 1,
            onKeydown: y[6] || (y[6] = Ao((M) => d("enterPressed", "confirmPinCode"), ["enter"]))
          }, {
            default: P(() => [
              C(I, { class: "v-col-12 v-col-md-6" }, {
                default: P(() => [
                  p("label", z_, E(b.$t("Components.VerificationComponent.Code")), 1),
                  C(w, {
                    modelValue: i.code,
                    "onUpdate:modelValue": y[3] || (y[3] = (M) => i.code = M),
                    length: 4,
                    autofocus: "",
                    class: "pb-0"
                  }, null, 8, ["modelValue"]),
                  p("div", U_, [
                    p("div", B_, [
                      p("div", G_, [
                        u(s).code.$errors[0] ? (S(), N("div", q_, E(u(s).code.$errors[0].$message), 1)) : x("", !0)
                      ])
                    ])
                  ]),
                  p("div", D_, [
                    p("div", H_, [
                      p("div", {
                        class: "link mb-4",
                        onClick: y[4] || (y[4] = //@ts-ignore
                        (...M) => u(m) && u(m)(...M))
                      }, " Ponovno pošlji kodo "),
                      p("div", {
                        class: "link",
                        onClick: y[5] || (y[5] = //@ts-ignore
                        (...M) => u(v) && u(v)(...M))
                      }, " Popravi mobilno številko ")
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : x("", !0)
        ])
      ], 512);
    };
  }
}), Y_ = {
  marketingSummit: !1,
  marketingCreditBroker: !1,
  flowType: void 0
};
function Z_(e) {
  const { t } = H();
  return F(() => ({}));
}
function W_(e) {
  const t = be(Z_(), F(() => e), { $autoDirty: !0 });
  async function o(r) {
    return { name: "valid" };
  }
  return {
    v$: t,
    navigationAction: o
  };
}
const K_ = {
  class: "marketing-consent-component",
  ref: "rootRef"
}, Q_ = {
  key: 0,
  class: "section-heading"
}, X_ = { class: "v-input__details" }, J_ = { class: "v-messages__message" }, eg = {
  href: "https://www.nlbleasego.si/pravna-vsebina/varstvo-osebnih-podatkov/splosne-informacije-o-varstvu-osebnih-podatkov",
  target: "_blank"
}, Yb = /* @__PURE__ */ ie({
  __name: "marketing-consent-component",
  props: {
    data: { default: () => ({
      ...Y_
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o;
    let f = re(!1);
    const i = W({ ...r.data }), { t: l } = H(), { navigationAction: s } = W_(i);
    return G(
      () => r.data,
      // Watch for changes in the data
      (n) => {
        Object.assign(i, n);
      },
      { deep: !0 }
    ), G(
      i,
      (n) => {
        d("update:data", n);
      },
      { deep: !0 }
    ), me(async () => {
      f.value = !0, d("componentReady");
    }), t({
      navigationAction: s,
      componentReady: f
    }), (n, a) => {
      const c = V("v-checkbox");
      return S(), N("div", K_, [
        i.flowType != u(R).LIMIT ? (S(), N("h2", Q_, E(u(l)("Components.MarketingConsentComponent.MarketingConsentTitle")), 1)) : x("", !0),
        C(c, {
          modelValue: i.marketingSummit,
          "onUpdate:modelValue": a[0] || (a[0] = (m) => i.marketingSummit = m),
          label: u(l)("Components.MarketingConsentComponent.MarketingSummit")
        }, null, 8, ["modelValue", "label"]),
        p("div", X_, [
          p("div", J_, [
            ne(E(u(l)("Components.MarketingConsentComponent.GeneralInformation")) + " ", 1),
            p("a", eg, E(u(l)("Components.MarketingConsentComponent.GeneralInformationLink")), 1),
            a[1] || (a[1] = ne(". "))
          ])
        ])
      ], 512);
    };
  }
});
function tg(e) {
  const { t } = H();
  return F(() => ({
    termsConditions: {
      required: j.withMessage(t("GlobalErrors.ChoiceRequired"), ho(!0))
    }
  }));
}
function ng(e) {
  const t = be(tg(), F(() => e), { $autoDirty: !0 }), { scrollToFirstError: o } = Ie();
  async function r() {
    return t.value.$touch(), await t.value.$validate();
  }
  function d() {
    o(".terms-conditions-component");
  }
  async function f(i) {
    let l = !1, s = null;
    switch (i) {
      case "validate":
        l = await r(), l && (s = { name: "valid" });
    }
    return s;
  }
  return {
    v$: t,
    navigationAction: f,
    scrollToFirstErrorWrapper: d
  };
}
const og = {
  termsConditions: !1,
  flowType: void 0,
  codeSent: !1
}, rg = {
  key: 0,
  class: "terms-conditions-component",
  ref: "rootRef"
}, ig = {
  key: 0,
  class: "section-heading"
}, ag = { class: "" }, sg = { class: "" }, lg = {
  target: "_blank",
  href: "https://nlbleasego.si/pravna-vsebina/pogoji-uporabe"
}, ug = {
  target: "_blank",
  href: "https://nlbleasego.si/pravna-vsebina/varstvo-osebnih-podatkov"
}, Zb = /* @__PURE__ */ ie({
  __name: "terms-conditions-component",
  props: {
    data: { default: () => ({
      ...og
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o;
    let f = re(!1);
    const i = W({ ...r.data }), { t: l } = H(), { navigationAction: s, scrollToFirstErrorWrapper: n, v$: a } = ng(i);
    return G(
      () => r.data,
      // Watch for changes in the data
      (c) => {
        Object.assign(i, c);
      },
      { deep: !0 }
    ), G(
      i,
      (c) => {
        d("update:data", c);
      },
      { deep: !0 }
    ), me(async () => {
      f.value = !0, d("componentReady");
    }), t({
      navigationAction: s,
      scrollToFirstErrorWrapper: n,
      componentReady: f
    }), (c, m) => {
      const v = V("v-checkbox"), h = V("v-col"), _ = V("v-row");
      return i.codeSent && i.termsConditions ? x("", !0) : (S(), N("div", rg, [
        i.flowType != u(R).LIMIT ? (S(), N("h2", ig, E(u(l)("Components.TermsConditionsComponent.TermsConditionsTitle")), 1)) : x("", !0),
        C(_, null, {
          default: P(() => [
            C(h, null, {
              default: P(() => [
                C(v, {
                  modelValue: i.termsConditions,
                  "onUpdate:modelValue": m[0] || (m[0] = (b) => i.termsConditions = b),
                  "error-messages": u(a).termsConditions.$errors[0] != null ? u(a).termsConditions.$errors[0].$message : "",
                  onFocus: u(a).termsConditions.$reset
                }, {
                  label: P(() => [
                    p("div", ag, [
                      p("span", sg, E(u(l)("Components.DataConfirmationComponent.TermsAgreement1")), 1),
                      p("a", lg, E(u(l)("Components.DataConfirmationComponent.TermsAgreement2")), 1),
                      ne(" " + E(u(l)("Components.DataConfirmationComponent.TermsAgreement3")) + " ", 1),
                      p("a", ug, E(u(l)("Components.DataConfirmationComponent.TermsAgreement4")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "error-messages", "onFocus"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 512));
    };
  }
}), za = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M3.33325%208H12.6666'%20stroke='%23A1A3A6'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", dg = {
  flowType: void 0,
  headerTitle: "",
  headerSubtitle: ""
}, cg = { class: "breadcrumbs-component" }, mg = { class: "d-flex justify-space-between align-center" }, fg = { class: "breadcrumbs" }, pg = ["innerHTML"], vg = ["innerHTML"], hg = {
  key: 1,
  class: "",
  src: za
}, yg = ["innerHTML"], Wb = /* @__PURE__ */ ie({
  __name: "contract-breadcrumbs-component",
  props: {
    data: { default: () => ({
      ...dg
    }) },
    routeName: { default: "" }
  },
  emits: ["update:data", "close"],
  setup(e, { emit: t }) {
    const { t: o } = H(), r = e, d = t, f = W({ ...r.data });
    G(
      () => r.data,
      // Watch for changes in the data
      (n) => {
        Object.assign(f, n);
      },
      { deep: !0 }
    ), G(
      f,
      (n) => {
        d("update:data", n);
      },
      { deep: !0 }
    );
    const i = F(() => o(`Components.ContractBreadcrumbsComponent.${r.routeName}.Parent1`)), l = F(() => o(`Components.ContractBreadcrumbsComponent.${r.routeName}.Parent2`)), s = F(() => o(`Components.ContractBreadcrumbsComponent.${r.routeName}.Child`));
    return (n, a) => {
      const c = V("v-btn");
      return S(), N("div", cg, [
        p("div", mg, [
          p("div", fg, [
            p("div", {
              class: "breadcrumbs__parent",
              innerHTML: i.value
            }, null, 8, pg),
            a[1] || (a[1] = p("img", {
              class: "",
              src: za
            }, null, -1)),
            l.value != "" ? (S(), N("div", {
              key: 0,
              class: "breadcrumbs__parent",
              innerHTML: l.value
            }, null, 8, vg)) : x("", !0),
            l.value != "" ? (S(), N("img", hg)) : x("", !0),
            p("div", {
              class: "breadcrumbs__child",
              innerHTML: s.value
            }, null, 8, yg)
          ]),
          C(c, {
            onClick: a[0] || (a[0] = (m) => n.$emit("close")),
            class: "btn btn--default-fill btn--round btn--sm ml-auto"
          }, {
            default: P(() => a[2] || (a[2] = [
              p("img", {
                src: Oa,
                alt: "Close"
              }, null, -1)
            ])),
            _: 1
          })
        ])
      ]);
    };
  }
}), _g = {
  headerTitle: "",
  headerSubtitle: "",
  headerParameter: "",
  HTMLBody: "",
  flowType: void 0
}, gg = { class: "contract-heading-component" }, bg = { class: "contract-heading" }, Cg = { class: "contract-heading__pictogram" }, Ig = { class: "flex-fill" }, Eg = ["innerHTML"], Sg = ["innerHTML"], Pg = ["innerHTML"], Tg = ["innerHTML"], Kb = /* @__PURE__ */ ie({
  __name: "heading-component",
  props: {
    data: { default: () => ({
      ..._g
    }) },
    routeName: { default: "" }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const { t: r } = H(), d = e, f = o, i = W({ ...d.data });
    let l = re(!1);
    G(
      () => d.data,
      // Watch for changes in the data
      (n) => {
        Object.assign(i, n);
      },
      { deep: !0 }
    ), G(
      i,
      (n) => {
        f("update:data", n);
      },
      { deep: !0 }
    );
    const s = F(() => "custom:" + r(`Components.HeadingComponent.${d.routeName}.Icon`));
    return F(
      () => r(`Components.HeadingComponent.${d.routeName}.Step`)
    ), me(async () => {
      l.value = !0, f("componentReady");
    }), t({
      componentReady: l
    }), (n, a) => {
      const c = V("v-icon");
      return S(), N("div", gg, [
        p("div", bg, [
          p("div", Cg, [
            C(c, { icon: s.value }, null, 8, ["icon"])
          ]),
          p("div", Ig, [
            p("h1", {
              class: "contract-heading__heading",
              innerHTML: i.headerTitle != "" ? u(r)(`GlobalErrors.${i.headerTitle}`) : u(r)(`Components.HeadingComponent.${d.routeName}.Title`)
            }, null, 8, Eg),
            i.headerParameter != "" ? (S(), N("div", {
              key: 0,
              class: "contract-heading__text",
              innerHTML: i.headerSubtitle != "" ? u(r)(`GlobalErrors.${i.headerSubtitle}`, { parameter: i.headerParameter }) : u(r)(`Components.HeadingComponent.${d.routeName}.Subtitle`, { parameter: i.headerParameter })
            }, null, 8, Sg)) : (S(), N("div", {
              key: 1,
              class: "contract-heading__text",
              innerHTML: i.headerSubtitle != "" ? u(r)(`GlobalErrors.${i.headerSubtitle}`) : u(r)(`Components.HeadingComponent.${d.routeName}.Subtitle`)
            }, null, 8, Pg)),
            p("div", {
              innerHTML: i.HTMLBody
            }, null, 8, Tg)
          ])
        ])
      ]);
    };
  }
}), wg = "data:image/svg+xml;base64,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", kg = {
  isDataLoading: !1,
  loaderType: ""
}, Qb = /* @__PURE__ */ ie({
  __name: "loader-component",
  props: {
    data: { default: () => ({
      ...kg
    }) }
  },
  setup(e) {
    const { t } = H(), o = e, r = F({
      get: () => o.data,
      set: () => {
      }
    });
    return (d, f) => r.value.isDataLoading ? (S(), N("div", {
      key: 0,
      class: Le(["view-loader-component", r.value.loaderType])
    }, f[0] || (f[0] = [
      p("div", { class: "loader-overlay" }, [
        p("div", { class: "loader-large" }, [
          p("img", {
            src: wg,
            alt: "Loader"
          }),
          p("div", null, "Nalagam")
        ])
      ], -1)
    ]), 2)) : x("", !0);
  }
}), Ng = "data:image/svg+xml,%3csvg%20width='64'%20height='64'%20viewBox='0%200%2064%2064'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_1273_21232)'%3e%3cg%20clip-path='url(%23clip1_1273_21232)'%3e%3cpath%20d='M50.4008%2054.3988C49.9741%2054.3988%2049.6008%2054.0255%2049.6008%2053.5988V32.7988C49.6008%2031.4655%2048.5341%2030.3988%2047.2008%2030.3988H16.8008C15.4674%2030.3988%2014.4008%2031.4655%2014.4008%2032.7988V50.3988C14.4008%2051.7322%2015.4674%2052.7988%2016.8008%2052.7988H39.2008C40.5341%2052.7988%2041.6008%2051.7322%2041.6008%2050.3988V35.9988C41.6008%2035.5722%2041.9741%2035.1988%2042.4008%2035.1988C42.8274%2035.1988%2043.2008%2035.5722%2043.2008%2035.9988V50.3988C43.2008%2052.5855%2041.3874%2054.3988%2039.2008%2054.3988H16.8008C14.6141%2054.3988%2012.8008%2052.5855%2012.8008%2050.3988V32.7988C12.8008%2030.6122%2014.6141%2028.7988%2016.8008%2028.7988H47.2008C49.3875%2028.7988%2051.2008%2030.6122%2051.2008%2032.7988V53.5988C51.2008%2054.0255%2050.8274%2054.3988%2050.4008%2054.3988Z'%20fill='white'/%3e%3cpath%20d='M32%2011.1996C35.52%2011.1996%2038.4%2014.0796%2038.4%2017.5996C38.4%2021.1196%2035.52%2023.9996%2032%2023.9996C28.48%2023.9996%2025.6%2021.1196%2025.6%2017.5996C25.6%2014.0796%2028.48%2011.1996%2032%2011.1996ZM32%209.59961C27.5733%209.59961%2024%2013.1729%2024%2017.5996C24%2022.0263%2027.5733%2025.5996%2032%2025.5996C36.4267%2025.5996%2040%2022.0263%2040%2017.5996C40%2013.1729%2036.4267%209.59961%2032%209.59961Z'%20fill='white'/%3e%3cpath%20d='M20.2667%2048H22.9333C23.5224%2048%2024%2047.5224%2024%2046.9333V36.2667C24%2035.6776%2023.5224%2035.2%2022.9333%2035.2H20.2667C19.6776%2035.2%2019.2%2035.6776%2019.2%2036.2667V46.9333C19.2%2047.5224%2019.6776%2048%2020.2667%2048Z'%20fill='%2384BD00'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1273_21232'%3e%3crect%20width='64'%20height='64'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_1273_21232'%3e%3crect%20width='64'%20height='64'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Ki = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20%200.75C30.6315%200.75%2039.25%209.36852%2039.25%2020C39.25%2030.6315%2030.6315%2039.25%2020%2039.25C9.36852%2039.25%200.75%2030.6315%200.75%2020C0.75%209.36852%209.36852%200.75%2020%200.75Z'%20stroke='white'%20stroke-width='1.5'/%3e%3cpath%20d='M13%2020H27'%20stroke='white'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M20%2013L27%2020L20%2027'%20stroke='white'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Ag = "data:image/svg+xml,%3csvg%20width='64'%20height='64'%20viewBox='0%200%2064%2064'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_1273_16926)'%3e%3cpath%20d='M32.0008%2047.9996C33.7681%2047.9996%2035.2008%2046.5669%2035.2008%2044.7996C35.2008%2043.0323%2033.7681%2041.5996%2032.0008%2041.5996C30.2335%2041.5996%2028.8008%2043.0323%2028.8008%2044.7996C28.8008%2046.5669%2030.2335%2047.9996%2032.0008%2047.9996Z'%20fill='%2384BD00'/%3e%3cpath%20d='M56.8004%2056H7.20039C6.77372%2056%206.40039%2056.3733%206.40039%2056.8C6.40039%2057.2267%206.77372%2057.6%207.20039%2057.6H56.8004C57.2271%2057.6%2057.6004%2057.2267%2057.6004%2056.8C57.6004%2056.3733%2057.2271%2056%2056.8004%2056Z'%20fill='white'/%3e%3cpath%20d='M17.6%2035.1992C16.6933%2035.1992%2016%2035.8926%2016%2036.7992V52.7992C16%2053.7059%2016.6933%2054.3992%2017.6%2054.3992H46.4C47.3067%2054.3992%2048%2053.7059%2048%2052.7992V36.7992C48%2035.8926%2047.3067%2035.1992%2046.4%2035.1992H17.6ZM46.4%2052.7992H17.6V36.7992H46.4V52.7992Z'%20fill='white'/%3e%3cpath%20d='M13.0139%2050.9869C13.1739%2051.1469%2013.3872%2051.2002%2013.6005%2051.2002C13.8139%2051.2002%2014.0272%2051.1469%2014.1872%2050.9869C14.5072%2050.6668%2014.5072%2050.1869%2014.1872%2049.8669L9.7072%2045.3869C8.80053%2044.4802%208.53387%2043.0402%209.0672%2041.8669L12.4805%2034.2402C13.4939%2031.9468%2015.7872%2030.4535%2018.2939%2030.4535H45.7605C48.2672%2030.4535%2050.5605%2031.9468%2051.5739%2034.2402L54.9872%2041.8669C55.5205%2043.0402%2055.2539%2044.4802%2054.3472%2045.3869L49.8672%2049.8669C49.5472%2050.1869%2049.5472%2050.6668%2049.8672%2050.9869C50.0272%2051.1469%2050.2405%2051.2002%2050.4539%2051.2002C50.6672%2051.2002%2050.8805%2051.1469%2051.0405%2050.9869L55.5205%2046.5068C56.9072%2045.1202%2057.2805%2042.9869%2056.4805%2041.2269L53.0672%2033.6002C51.7872%2030.7202%2048.9072%2028.8535%2045.7605%2028.8535H18.2939C15.1472%2028.8535%2012.2672%2030.7202%2010.9872%2033.6002L7.57387%2041.2269C6.77387%2042.9869%207.1472%2045.1202%208.53387%2046.5068L13.0139%2050.9869Z'%20fill='white'/%3e%3cpath%20d='M32%2025.5996C36.4267%2025.5996%2040%2022.0263%2040%2017.5996C40%2013.1729%2036.4267%209.59961%2032%209.59961C27.5733%209.59961%2024%2013.1729%2024%2017.5996C24%2022.0263%2027.5733%2025.5996%2032%2025.5996ZM32%2011.1996C35.52%2011.1996%2038.4%2014.0796%2038.4%2017.5996C38.4%2021.1196%2035.52%2023.9996%2032%2023.9996C28.48%2023.9996%2025.6%2021.1196%2025.6%2017.5996C25.6%2014.0796%2028.48%2011.1996%2032%2011.1996Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1273_16926'%3e%3crect%20width='64'%20height='64'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Mg = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13%202L3%2014H12L11%2022L21%2010H12L13%202Z'%20stroke='%23230078'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Og = {
  key: 0,
  class: "d-flex justify-space-between align-end my-8 my-md-14"
}, Rg = { key: 0 }, $g = { key: 1 }, xg = ["src"], Lg = { key: 1 }, Xb = /* @__PURE__ */ ie({
  __name: "navigation-buttons-component",
  props: {
    buttons: {},
    icons: {},
    hasDiy: { type: Boolean, default: !1 },
    onAction: {},
    onNavigation: {}
  },
  setup(e) {
    const { t } = H(), o = e, r = (d, f) => {
      d != null ? o.onAction ? o.onAction(d) : console.warn("No onAction handler provided for NavigationButtons") : f != null ? o.onNavigation ? o.onNavigation(f) : console.warn("No onNavigation handler provided for NavigationButtons") : console.warn("No action or navigation provided for NavigationButtons");
    };
    return (d, f) => {
      const i = V("v-btn"), l = V("v-col"), s = V("v-row");
      return o.hasDiy ? (S(), N("div", Lg, [
        C(s, { class: "py-14" }, {
          default: P(() => [
            C(l, null, {
              default: P(() => [
                C(i, {
                  class: "btn btn--primary-fill btn--selection",
                  block: "",
                  onClick: f[0] || (f[0] = (n) => r("validatecustomer", void 0))
                }, {
                  default: P(() => f[3] || (f[3] = [
                    p("div", { class: "d-flex justify-space-between" }, [
                      p("div", { class: "d-flex align-center ga-4" }, [
                        p("img", { src: Ng }),
                        p("div", null, "Nadaljuje stranka")
                      ]),
                      p("img", { src: Ki })
                    ], -1)
                  ])),
                  _: 1
                }),
                f[4] || (f[4] = p("div", { class: "v-input__details" }, [
                  p("div", { class: "v-messages" }, [
                    p("div", { class: "v-messages__message" }, " Po podpisu vloge za sklenitev financiranja bo stranka prejela SMS s povezavo za nadaljevanje postopka. Za vas je postopek vnosa s tem zaključen. ")
                  ])
                ], -1))
              ]),
              _: 1
            }),
            C(l, { class: "position-relative" }, {
              default: P(() => [
                C(i, {
                  class: "btn btn--primary-fill btn--selection",
                  block: "",
                  onClick: f[1] || (f[1] = (n) => r("validate", void 0))
                }, {
                  default: P(() => f[5] || (f[5] = [
                    p("div", { class: "d-flex justify-space-between" }, [
                      p("div", { class: "d-flex align-center ga-4" }, [
                        p("img", { src: Ag }),
                        p("div", null, "Nadaljuje prodajalec")
                      ]),
                      p("img", { src: Ki })
                    ], -1)
                  ])),
                  _: 1
                }),
                f[6] || (f[6] = p("div", { class: "v-input__details" }, [
                  p("div", { class: "v-messages" }, [
                    p("div", { class: "v-messages__message" }, " Po podpisu vloge za sklenitev financiranja boste z vnosom podatkov stranke nadaljevali na prodajnem mestu. ")
                  ])
                ], -1))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        C(i, {
          class: "btn btn--primary-outline btn--round btn-suspicious-person",
          onClick: f[2] || (f[2] = (n) => r("suspectPerson", void 0))
        }, {
          default: P(() => f[7] || (f[7] = [
            p("img", { src: Mg }, null, -1)
          ])),
          _: 1
        })
      ])) : (S(), N("div", Og, [
        d.buttons ? (S(), N("div", Rg, [
          (S(!0), N(je, null, Mt(o.buttons, (n) => He((S(), K(i, {
            key: n.name,
            disabled: n.disabled === !0,
            onClick: (a) => r(n.action, n.navigateTo),
            class: Le(["btn", n.class || "btn--primary-fill", "mr-4"])
          }, {
            default: P(() => [
              ne(E(u(t)("GeneralButtons." + n.name)), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick", "class"])), [
            [Ye, n.visible]
          ])), 128))
        ])) : x("", !0),
        d.icons ? (S(), N("div", $g, [
          (S(!0), N(je, null, Mt(o.icons, (n) => He((S(), K(i, {
            key: n.name,
            disabled: n.disabled === !0,
            onClick: (a) => r(n.action, n.navigateTo),
            class: Le(n.class)
          }, {
            default: P(() => [
              p("img", {
                src: n.image
              }, null, 8, xg)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick", "class"])), [
            [Ye, n.visible]
          ])), 128))
        ])) : x("", !0)
      ]));
    };
  }
}), Qi = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.875%207.875V19.125H19.125'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M5.25%2016.125V5.25H21.75V16.125H5.25Z'%20stroke='%23404245'%20stroke-width='2'%20stroke-linejoin='round'/%3e%3ccircle%20cx='13.5'%20cy='10.5'%20r='2'%20stroke='%23404245'%20stroke-width='2'/%3e%3c/svg%3e", Vg = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9%2022C9.55228%2022%2010%2021.5523%2010%2021C10%2020.4477%209.55228%2020%209%2020C8.44772%2020%208%2020.4477%208%2021C8%2021.5523%208.44772%2022%209%2022Z'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M20%2022C20.5523%2022%2021%2021.5523%2021%2021C21%2020.4477%2020.5523%2020%2020%2020C19.4477%2020%2019%2020.4477%2019%2021C19%2021.5523%2019.4477%2022%2020%2022Z'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M1%201H5L7.68%2014.39C7.77144%2014.8504%208.02191%2015.264%208.38755%2015.5583C8.75318%2015.8526%209.2107%2016.009%209.68%2016H19.4C19.8693%2016.009%2020.3268%2015.8526%2020.6925%2015.5583C21.0581%2015.264%2021.3086%2014.8504%2021.4%2014.39L23%206H6'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Fg = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M21%204H3C1.89543%204%201%204.89543%201%206V18C1%2019.1046%201.89543%2020%203%2020H21C22.1046%2020%2023%2019.1046%2023%2018V6C23%204.89543%2022.1046%204%2021%204Z'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M1%2010H23'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", jg = {
  flowType: void 0,
  creditAmount: void 0,
  storeUrl: "",
  storeName: ""
}, zg = {
  class: "order-summary-component",
  ref: "rootRef"
}, Ug = { class: "order-summary" }, Bg = { class: "pa-6" }, Gg = {
  key: 0,
  class: "order-summary__section"
}, qg = { class: "order-summary__value" }, Dg = {
  key: 1,
  class: "order-summary__section"
}, Hg = { class: "order-summary__value" }, Yg = ["href"], Zg = {
  key: 2,
  class: "hr-sm"
}, Wg = {
  key: 3,
  class: "order-summary__section"
}, Kg = { class: "order-summary__value" }, Qg = { class: "pa-6" }, Xg = { class: "order-summary__footnotes" }, Jg = { key: 0 }, eb = { key: 1 }, Jb = /* @__PURE__ */ ie({
  __name: "order-summary-component",
  props: {
    data: { default: () => ({
      ...jg
    }) }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: o }) {
    const r = e, d = o;
    let f = re(!1);
    const i = W({ ...r.data });
    return G(
      () => r.data,
      // Watch for changes in the data
      (l) => {
        Object.assign(i, l);
      },
      { deep: !0 }
    ), me(async () => {
      f.value = !0, d("componentReady");
    }), t({
      componentReady: f
    }), (l, s) => (S(), N("div", zg, [
      p("div", Ug, [
        p("div", Bg, [
          s[6] || (s[6] = p("h1", { class: "order-summary__heading" }, "Povzetek naročila", -1)),
          i.flowType === u(R).SKLENI_SAM && i.creditAmount != null && i.creditAmount > 0 ? (S(), N("div", Gg, [
            s[1] || (s[1] = p("div", { class: "order-summary__label" }, " Vrednost predračuna ", -1)),
            p("div", qg, [
              s[0] || (s[0] = p("img", {
                src: Qi,
                alt: "Vrednost nakupa"
              }, null, -1)),
              p("div", null, E(i.creditAmount != null ? l.$n(i.creditAmount, "decimal") + " EUR" : ""), 1)
            ])
          ])) : x("", !0),
          i.flowType === u(R).WEB && i.storeUrl != "" ? (S(), N("div", Dg, [
            s[3] || (s[3] = p("div", { class: "order-summary__label" }, " Trgovec ", -1)),
            p("div", Hg, [
              s[2] || (s[2] = p("img", {
                src: Vg,
                alt: "Trgovec"
              }, null, -1)),
              p("div", null, [
                p("a", {
                  href: i.storeUrl,
                  target: "_blank",
                  class: ""
                }, E(i.storeName), 9, Yg)
              ])
            ])
          ])) : x("", !0),
          i.flowType === u(R).WEB && i.storeUrl != "" ? (S(), N("hr", Zg)) : x("", !0),
          i.flowType === u(R).WEB ? (S(), N("div", Wg, [
            s[5] || (s[5] = p("div", { class: "order-summary__label" }, " Vrednost nakupa ", -1)),
            p("div", Kg, [
              s[4] || (s[4] = p("img", {
                src: Qi,
                alt: "Vrednost nakupa"
              }, null, -1)),
              p("div", null, E(i.creditAmount != null ? l.$n(i.creditAmount, "decimal") + " EUR" : ""), 1)
            ])
          ])) : x("", !0),
          s[7] || (s[7] = Qa('<hr class="hr-sm"><div class="order-summary__section"><div class="order-summary__label"> Izbrani način plačila </div><div class="order-summary__value"><img src="' + Fg + '" alt="Način plačila"><div>NLB Buy&amp;Go</div></div></div>', 2))
        ]),
        s[10] || (s[10] = p("hr", null, null, -1)),
        p("div", Qg, [
          p("div", Xg, [
            i.flowType === u(R).WEB ? (S(), N("div", Jg, s[8] || (s[8] = [
              ne(" Na tej strani se nahajate, ker ste v spletni trgovini izbrali plačilo na obroke. V primeru težav smo vam na voljo na e-mail naslovu "),
              p("a", { href: "mailto:info@nlbbuygo.si" }, "info@nlbbuygo.si", -1),
              ne(". ")
            ]))) : (S(), N("div", eb, s[9] || (s[9] = [
              ne(" V primeru težav smo vam na voljo na e-mail naslovu "),
              p("a", { href: "mailto:info@nlbbuygo.si" }, "info@nlbbuygo.si", -1),
              ne(". ")
            ])))
          ])
        ])
      ])
    ], 512));
  }
});
function tb() {
  const e = Q("commClient");
  async function t(o, r) {
    r != null && o != null && o != "" && await e.executeMethodAsync(
      "sw.WebOrderStepInsert",
      {
        OrderToken: o,
        StepId: r
      }
    );
  }
  return {
    SaveStepData: t
  };
}
const eC = /* @__PURE__ */ ie({
  __name: "weborder-step-component",
  props: {
    orderToken: {},
    stepId: {}
  },
  setup(e) {
    const t = e, { SaveStepData: o } = tb();
    return G(() => t.orderToken, async () => {
      await o(t.orderToken, t.stepId);
    }), G(() => t.stepId, async () => {
      await o(t.orderToken, t.stepId);
    }), (r, d) => null;
  }
});
export {
  vb as AmountInsertComponent,
  Wb as BreadcrumbsComponent,
  fb as CalculationResultComponent,
  cb as ContractCreateComponent,
  jb as ContractFailComponent,
  zb as ContractSuccessComponent,
  hb as DataConfirmationComponent,
  ob as DemoComponent,
  yb as DocumentationComponent,
  pb as DocumentationCreditAmountPickerComponent,
  ib as EmailVerificationComponent,
  bb as EmploymentInfoComponent,
  Cb as EmploymentTypeComponent,
  lt as EnumCollectionPointType,
  it as EnumContractSending,
  qt as EnumContractSignatureType,
  xt as EnumDiyType,
  Bo as EnumDocumentationSendType,
  le as EnumEmploymentType,
  R as EnumFlowType,
  yt as EnumIdentificationType,
  cu as EnumLimitType,
  wa as EnumPasswordStatus,
  At as EnumPersonalDocumentType,
  fu as EnumPreapprovedType,
  mu as EnumProductType,
  pu as EnumWebOrderStep,
  yo as FileUpload,
  G0 as FinApiBankSelectionPopup,
  _b as FinApiContentComponent,
  gb as FinApiDataGetComponent,
  Ib as FinancialConditionsComponent,
  Eb as FinancialDataComponent,
  Sb as FinancingOptionsComponent,
  Kb as HeadingComponent,
  Pb as IdDocumentComponent,
  rb as IdentificationDataComponent,
  ub as IdentificationPlaceComponent,
  ab as IdentificationSelectionComponent,
  wb as InstallmentPlanMultiProductComponent,
  Tb as InstalmentPlanComponent,
  Vb as LimitCalculationSendComponent,
  Qb as LoaderComponent,
  Yb as MarketingConsentComponent,
  Xb as NavigationButtonsComponent,
  Jb as OrderSummaryComponent,
  Ub as PasswordComponent,
  Bb as PasswordResetSetComponent,
  Gb as PasswordResetTaxNumComponent,
  kb as PersonalInfoComponent,
  Nb as PetrolBarCodeComponent,
  Ab as PoliticallyExposedPersonComponent,
  Mb as PosInfoComponent,
  db as PostIdentificationComponent,
  mb as PreapprovedCreateComponent,
  Ob as PrecheckComponent,
  Fb as ProcessEndScreenComponent,
  Rb as ProformaPaymentComponent,
  sb as RekonoIdentificationComponent,
  lb as RekonoIdentificationStartComponent,
  $b as RiskCountryComponent,
  Lb as SignatureDetailsComponent,
  xb as TemporaryResidenceComponent,
  Zb as TermsConditionsComponent,
  qb as VerificationComponent,
  Db as VerificationEmailComponent,
  Hb as VerificationPhoneComponent,
  eC as WebOrderStepComponent,
  Ie as useUtilities
};
//# sourceMappingURL=nlb-buy-go-library.es.js.map
